const proj4List: Record<string, string[]> = {
    "EPSG:4326": ["EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs "],
    "EPSG:3857": [
        "EPSG:3857",
        "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs",
    ],
    "EPSG:5514": [
        "EPSG:5514",
        "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27700": [
        "EPSG:27700",
        "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +datum=OSGB36 +units=m +no_defs ",
    ],
    "EPSG:28992": [
        "EPSG:28992",
        "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.4171,50.3319,465.5524,-0.398957,0.343988,-1.87740,4.0725 +units=m +no_defs ",
    ],
    "EPSG:31300": [
        "EPSG:31300",
        "+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=90 +lon_0=4.356939722222222 +x_0=150000.01256 +y_0=5400088.4378 +ellps=intl +towgs84=-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747 +units=m +no_defs ",
    ],
    "EPSG:3044": [
        "EPSG:3044",
        "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3395": [
        "EPSG:3395",
        "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3785": [
        "EPSG:3785",
        "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs",
    ],
    "EPSG:32646": [
        "EPSG:32646",
        "+proj=utm +zone=46 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3006": [
        "EPSG:3006",
        "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32640": [
        "EPSG:32640",
        "+proj=utm +zone=40 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:28354": [
        "EPSG:28354",
        "+proj=utm +zone=54 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32632": [
        "EPSG:32632",
        "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4269": ["EPSG:4269", "+proj=longlat +datum=NAD83 +no_defs "],
    "EPSG:32633": [
        "EPSG:32633",
        "+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32616": [
        "EPSG:32616",
        "+proj=utm +zone=16 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3070": [
        "EPSG:3070",
        "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:2261": [
        "EPSG:2261",
        "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=249999.9998983998 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:32039": [
        "EPSG:32039",
        "+proj=lcc +lat_1=30.11666666666667 +lat_2=31.88333333333333 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32748": [
        "EPSG:32748",
        "+proj=utm +zone=48 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32618": [
        "EPSG:32618",
        "+proj=utm +zone=18 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3045": [
        "EPSG:3045",
        "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4283": [
        "EPSG:4283",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:31258": [
        "EPSG:31258",
        "+proj=tmerc +lat_0=0 +lon_0=13.33333333333333 +k=1 +x_0=450000 +y_0=-5000000 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:2154": [
        "EPSG:2154",
        "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32635": [
        "EPSG:32635",
        "+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4471": [
        "EPSG:4471",
        "+proj=utm +zone=38 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25832": [
        "EPSG:25832",
        "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4203": [
        "EPSG:4203",
        "+proj=longlat +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +no_defs ",
    ],
    "EPSG:2180": [
        "EPSG:2180",
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3047": [
        "EPSG:3047",
        "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26712": [
        "EPSG:26712",
        "+proj=utm +zone=12 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32617": [
        "EPSG:32617",
        "+proj=utm +zone=17 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:7405": [
        "EPSG:7405",
        "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +datum=OSGB36 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:32116": [
        "EPSG:32116",
        "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=250000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32637": [
        "EPSG:32637",
        "+proj=utm +zone=37 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32719": [
        "EPSG:32719",
        "+proj=utm +zone=19 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32736": [
        "EPSG:32736",
        "+proj=utm +zone=36 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32638": [
        "EPSG:32638",
        "+proj=utm +zone=38 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:21781": [
        "EPSG:21781",
        "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=674.4,15.1,405.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32614": [
        "EPSG:32614",
        "+proj=utm +zone=14 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4817": [
        "EPSG:4817",
        "+proj=longlat +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +no_defs ",
    ],
    "EPSG:32643": [
        "EPSG:32643",
        "+proj=utm +zone=43 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26911": [
        "EPSG:26911",
        "+proj=utm +zone=11 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:2385": [
        "EPSG:2385",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:4617": [
        "EPSG:4617",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:32630": [
        "EPSG:32630",
        "+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32631": [
        "EPSG:32631",
        "+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3043": [
        "EPSG:3043",
        "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26711": [
        "EPSG:26711",
        "+proj=utm +zone=11 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:4277": ["EPSG:4277", "+proj=longlat +datum=OSGB36 +no_defs "],
    "EPSG:32610": [
        "EPSG:32610",
        "+proj=utm +zone=10 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3064": [
        "EPSG:3064",
        "+proj=utm +zone=32 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32645": [
        "EPSG:32645",
        "+proj=utm +zone=45 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:20438": [
        "EPSG:20438",
        "+proj=utm +zone=38 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3159": [
        "EPSG:3159",
        "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4978": ["EPSG:4978", "+proj=geocent +datum=WGS84 +units=m +no_defs "],
    "EPSG:3035": [
        "EPSG:3035",
        "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25831": [
        "EPSG:25831",
        "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32651": [
        "EPSG:32651",
        "+proj=utm +zone=51 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32722": [
        "EPSG:32722",
        "+proj=utm +zone=22 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32662": [
        "EPSG:32662",
        "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5513": [
        "EPSG:5513",
        "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2227": [
        "EPSG:2227",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:32644": [
        "EPSG:32644",
        "+proj=utm +zone=44 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32639": [
        "EPSG:32639",
        "+proj=utm +zone=39 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2290": [
        "EPSG:2290",
        "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=700000 +y_0=400000 +a=6378135 +b=6356750.304921594 +units=m +no_defs ",
    ],
    "EPSG:3879": [
        "EPSG:3879",
        "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=25500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2077": [
        "EPSG:2077",
        "+proj=utm +zone=32 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32613": [
        "EPSG:32613",
        "+proj=utm +zone=13 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32636": [
        "EPSG:32636",
        "+proj=utm +zone=36 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:23700": [
        "EPSG:23700",
        "+proj=somerc +lat_0=47.14439372222222 +lon_0=19.04857177777778 +k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +towgs84=52.17,-71.82,-14.9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32611": [
        "EPSG:32611",
        "+proj=utm +zone=11 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26713": [
        "EPSG:26713",
        "+proj=utm +zone=13 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:2149": [
        "EPSG:2149",
        "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32650": [
        "EPSG:32650",
        "+proj=utm +zone=50 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32718": [
        "EPSG:32718",
        "+proj=utm +zone=18 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5551": [
        "EPSG:5551",
        "+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4901": [
        "EPSG:4901",
        "+proj=longlat +a=6376523 +b=6355862.933255573 +pm=2.337208333333333 +no_defs ",
    ],
    "EPSG:4258": [
        "EPSG:4258",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:2100": [
        "EPSG:2100",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +datum=GGRS87 +units=m +no_defs ",
    ],
    "EPSG:32735": [
        "EPSG:32735",
        "+proj=utm +zone=35 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26912": [
        "EPSG:26912",
        "+proj=utm +zone=12 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32620": [
        "EPSG:32620",
        "+proj=utm +zone=20 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:31700": [
        "EPSG:31700",
        "+proj=sterea +lat_0=46 +lon_0=25 +k=0.99975 +x_0=500000 +y_0=500000 +ellps=krass +towgs84=28,-121,-77,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26958": [
        "EPSG:26958",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:4954": ["EPSG:4954", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32749": [
        "EPSG:32749",
        "+proj=utm +zone=49 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2153": [
        "EPSG:2153",
        "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32615": [
        "EPSG:32615",
        "+proj=utm +zone=15 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32634": [
        "EPSG:32634",
        "+proj=utm +zone=34 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:28351": [
        "EPSG:28351",
        "+proj=utm +zone=51 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4267": ["EPSG:4267", "+proj=longlat +datum=NAD27 +no_defs "],
    "EPSG:2193": [
        "EPSG:2193",
        "+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:28356": [
        "EPSG:28356",
        "+proj=utm +zone=56 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4197": ["EPSG:4197", "+proj=longlat +ellps=clrk80 +no_defs "],
    "EPSG:3832": [
        "EPSG:3832",
        "+proj=merc +lon_0=150 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26914": [
        "EPSG:26914",
        "+proj=utm +zone=14 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:31370": [
        "EPSG:31370",
        "+proj=lcc +lat_1=51.16666723333333 +lat_2=49.8333339 +lat_0=90 +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747 +units=m +no_defs ",
    ],
    "EPSG:3577": [
        "EPSG:3577",
        "+proj=aea +lat_1=-18 +lat_2=-36 +lat_0=0 +lon_0=132 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32648": [
        "EPSG:32648",
        "+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3042": [
        "EPSG:3042",
        "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4230": [
        "EPSG:4230",
        "+proj=longlat +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +no_defs ",
    ],
    "EPSG:3300": [
        "EPSG:3300",
        "+proj=lcc +lat_1=59.33333333333334 +lat_2=58 +lat_0=57.51755393055556 +lon_0=24 +x_0=500000 +y_0=6375000 +ellps=GRS80 +towgs84=0.055,-0.541,-0.185,0.0183,-0.0003,-0.007,-0.014 +units=m +no_defs ",
    ],
    "EPSG:3765": [
        "EPSG:3765",
        "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31468": [
        "EPSG:31468",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:31467": [
        "EPSG:31467",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:32721": [
        "EPSG:32721",
        "+proj=utm +zone=21 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26710": [
        "EPSG:26710",
        "+proj=utm +zone=10 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:2829": [
        "EPSG:2829",
        "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2845": [
        "EPSG:2845",
        "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23884": [
        "EPSG:23884",
        "+proj=utm +zone=54 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4824": ["EPSG:4824", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:32642": [
        "EPSG:32642",
        "+proj=utm +zone=42 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3005": [
        "EPSG:3005",
        "+proj=aea +lat_1=50 +lat_2=58.5 +lat_0=45 +lon_0=-126 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26915": [
        "EPSG:26915",
        "+proj=utm +zone=15 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:28355": [
        "EPSG:28355",
        "+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32647": [
        "EPSG:32647",
        "+proj=utm +zone=47 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26719": [
        "EPSG:26719",
        "+proj=utm +zone=19 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:5070": [
        "EPSG:5070",
        "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26910": [
        "EPSG:26910",
        "+proj=utm +zone=10 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:5534": [
        "EPSG:5534",
        "+proj=utm +zone=24 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4037": [
        "EPSG:4037",
        "+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26918": [
        "EPSG:26918",
        "+proj=utm +zone=18 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3065": [
        "EPSG:3065",
        "+proj=utm +zone=33 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2090": [
        "EPSG:2090",
        "+proj=utm +zone=39 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2037": [
        "EPSG:2037",
        "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26913": [
        "EPSG:26913",
        "+proj=utm +zone=13 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:23030": [
        "EPSG:23030",
        "+proj=utm +zone=30 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23879": [
        "EPSG:23879",
        "+proj=utm +zone=49 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5552": [
        "EPSG:5552",
        "+proj=utm +zone=56 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:28350": [
        "EPSG:28350",
        "+proj=utm +zone=50 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23032": [
        "EPSG:23032",
        "+proj=utm +zone=32 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3067": [
        "EPSG:3067",
        "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4055": [
        "EPSG:4055",
        "+proj=longlat +a=6378137 +b=6378137 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:2039": [
        "EPSG:2039",
        "+proj=tmerc +lat_0=31.73439361111111 +lon_0=35.20451694444445 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +towgs84=-48,55,52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4265": [
        "EPSG:4265",
        "+proj=longlat +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +no_defs ",
    ],
    "EPSG:26714": [
        "EPSG:26714",
        "+proj=utm +zone=14 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26717": [
        "EPSG:26717",
        "+proj=utm +zone=17 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32652": [
        "EPSG:32652",
        "+proj=utm +zone=52 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32619": [
        "EPSG:32619",
        "+proj=utm +zone=19 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32750": [
        "EPSG:32750",
        "+proj=utm +zone=50 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3349": [
        "EPSG:3349",
        "+proj=merc +lon_0=-150 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32737": [
        "EPSG:32737",
        "+proj=utm +zone=37 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:31984": [
        "EPSG:31984",
        "+proj=utm +zone=24 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32756": [
        "EPSG:32756",
        "+proj=utm +zone=56 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:31287": [
        "EPSG:31287",
        "+proj=lcc +lat_1=49 +lat_2=46 +lat_0=47.5 +lon_0=13.33333333333333 +x_0=400000 +y_0=400000 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:25833": [
        "EPSG:25833",
        "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3003": [
        "EPSG:3003",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +units=m +no_defs ",
    ],
    "EPSG:32724": [
        "EPSG:32724",
        "+proj=utm +zone=24 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32723": [
        "EPSG:32723",
        "+proj=utm +zone=23 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5531": [
        "EPSG:5531",
        "+proj=utm +zone=21 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4328": ["EPSG:4328", "+proj=geocent +datum=WGS84 +units=m +no_defs "],
    "EPSG:2151": [
        "EPSG:2151",
        "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4807": [
        "EPSG:4807",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +no_defs ",
    ],
    "EPSG:32629": [
        "EPSG:32629",
        "+proj=utm +zone=29 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26916": [
        "EPSG:26916",
        "+proj=utm +zone=16 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26894": [
        "EPSG:26894",
        "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27393": [
        "EPSG:27393",
        "+proj=tmerc +lat_0=58 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs ",
    ],
    "EPSG:7415": [
        "EPSG:7415",
        "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.4171,50.3319,465.5524,-0.398957,0.343988,-1.87740,4.0725 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:2400": [
        "EPSG:2400",
        "+proj=tmerc +lat_0=0 +lon_0=15.80827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs ",
    ],
    "EPSG:3111": [
        "EPSG:3111",
        "+proj=lcc +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145 +x_0=2500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:28353": [
        "EPSG:28353",
        "+proj=utm +zone=53 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2230": [
        "EPSG:2230",
        "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:27040": [
        "EPSG:27040",
        "+proj=utm +zone=40 +ellps=clrk80 +towgs84=-249,-156,381,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2815": [
        "EPSG:2815",
        "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29101": [
        "EPSG:29101",
        "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4618": [
        "EPSG:4618",
        "+proj=longlat +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +no_defs ",
    ],
    "EPSG:2989": [
        "EPSG:2989",
        "+proj=utm +zone=20 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32757": [
        "EPSG:32757",
        "+proj=utm +zone=57 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2089": [
        "EPSG:2089",
        "+proj=utm +zone=38 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2220": [
        "EPSG:2220",
        "+proj=utm +zone=20 +a=6378135 +b=6356750.304921594 +units=m +no_defs ",
    ],
    "EPSG:3310": [
        "EPSG:3310",
        "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3132": [
        "EPSG:3132",
        "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2163": [
        "EPSG:2163",
        "+proj=laea +lat_0=45 +lon_0=-100 +x_0=0 +y_0=0 +a=6370997 +b=6370997 +units=m +no_defs ",
    ],
    "EPSG:32754": [
        "EPSG:32754",
        "+proj=utm +zone=54 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26331": [
        "EPSG:26331",
        "+proj=utm +zone=31 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32213": [
        "EPSG:32213",
        "+proj=utm +zone=13 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:5533": [
        "EPSG:5533",
        "+proj=utm +zone=23 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4180": [
        "EPSG:4180",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:3734": [
        "EPSG:3734",
        "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3821": ["EPSG:3821", "+proj=longlat +ellps=aust_SA +no_defs "],
    "EPSG:3301": [
        "EPSG:3301",
        "+proj=lcc +lat_1=59.33333333333334 +lat_2=58 +lat_0=57.51755393055556 +lon_0=24 +x_0=500000 +y_0=6375000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3763": [
        "EPSG:3763",
        "+proj=tmerc +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31983": [
        "EPSG:31983",
        "+proj=utm +zone=23 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4214": [
        "EPSG:4214",
        "+proj=longlat +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +no_defs ",
    ],
    "EPSG:32755": [
        "EPSG:32755",
        "+proj=utm +zone=55 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2905": [
        "EPSG:2905",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2906": [
        "EPSG:2906",
        "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=249999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2260": [
        "EPSG:2260",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2263": [
        "EPSG:2263",
        "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000.0000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:32621": [
        "EPSG:32621",
        "+proj=utm +zone=21 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:23033": [
        "EPSG:23033",
        "+proj=utm +zone=33 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32655": [
        "EPSG:32655",
        "+proj=utm +zone=55 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3160": [
        "EPSG:3160",
        "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3452": [
        "EPSG:3452",
        "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=999999.9999898402 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:23029": [
        "EPSG:23029",
        "+proj=utm +zone=29 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3397": [
        "EPSG:3397",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:31464": [
        "EPSG:31464",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:3978": [
        "EPSG:3978",
        "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=49 +lon_0=-95 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3011": [
        "EPSG:3011",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3098": [
        "EPSG:3098",
        "+proj=utm +zone=52 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25830": [
        "EPSG:25830",
        "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2812": [
        "EPSG:2812",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4313": [
        "EPSG:4313",
        "+proj=longlat +ellps=intl +towgs84=-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747 +no_defs ",
    ],
    "EPSG:2169": [
        "EPSG:2169",
        "+proj=tmerc +lat_0=49.83333333333334 +lon_0=6.166666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +towgs84=-189.6806,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598 +units=m +no_defs ",
    ],
    "EPSG:29872": [
        "EPSG:29872",
        "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +k=0.99984 +x_0=590476.8727431979 +y_0=442857.6545573985 +gamma=53.13010236111111 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +to_meter=0.3047994715386762 +no_defs ",
    ],
    "EPSG:4128": ["EPSG:4128", "+proj=longlat +ellps=clrk66 +no_defs "],
    "EPSG:3855": ["EPSG:3855", "undefined"],
    "EPSG:26716": [
        "EPSG:26716",
        "+proj=utm +zone=16 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3449": [
        "EPSG:3449",
        "+proj=utm +zone=17 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32649": [
        "EPSG:32649",
        "+proj=utm +zone=49 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2274": [
        "EPSG:2274",
        "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3112": [
        "EPSG:3112",
        "+proj=lcc +lat_1=-18 +lat_2=-36 +lat_0=0 +lon_0=134 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32612": [
        "EPSG:32612",
        "+proj=utm +zone=12 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5072": [
        "EPSG:5072",
        "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2393": [
        "EPSG:2393",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs ",
    ],
    "EPSG:32720": [
        "EPSG:32720",
        "+proj=utm +zone=20 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:31285": [
        "EPSG:31285",
        "+proj=tmerc +lat_0=0 +lon_0=13.33333333333333 +k=1 +x_0=450000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:28352": [
        "EPSG:28352",
        "+proj=utm +zone=52 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3049": [
        "EPSG:3049",
        "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32045": [
        "EPSG:32045",
        "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:3071": [
        "EPSG:3071",
        "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3338": [
        "EPSG:3338",
        "+proj=aea +lat_1=55 +lat_2=65 +lat_0=50 +lon_0=-154 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32751": [
        "EPSG:32751",
        "+proj=utm +zone=51 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:27493": [
        "EPSG:27493",
        "+proj=tmerc +lat_0=39.66666666666666 +lon_0=-8.131906111111112 +k=1 +x_0=180.598 +y_0=-86.98999999999999 +ellps=intl +towgs84=-223.237,110.193,36.649,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3943": [
        "EPSG:3943",
        "+proj=lcc +lat_1=42.25 +lat_2=43.75 +lat_0=43 +lon_0=3 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4815": [
        "EPSG:4815",
        "+proj=longlat +ellps=bessel +pm=athens +no_defs ",
    ],
    "EPSG:4619": [
        "EPSG:4619",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:2228": [
        "EPSG:2228",
        "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2157": [
        "EPSG:2157",
        "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=0.99982 +x_0=600000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2229": [
        "EPSG:2229",
        "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4289": [
        "EPSG:4289",
        "+proj=longlat +ellps=bessel +towgs84=565.4171,50.3319,465.5524,-0.398957,0.343988,-1.87740,4.0725 +no_defs ",
    ],
    "EPSG:3113": [
        "EPSG:3113",
        "+proj=tmerc +lat_0=-28 +lon_0=153 +k=0.99999 +x_0=50000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2152": [
        "EPSG:2152",
        "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4171": [
        "EPSG:4171",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4317": [
        "EPSG:4317",
        "+proj=longlat +ellps=krass +towgs84=28,-121,-77,0,0,0,0 +no_defs ",
    ],
    "EPSG:4956": ["EPSG:4956", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32623": [
        "EPSG:32623",
        "+proj=utm +zone=23 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:24719": [
        "EPSG:24719",
        "+proj=utm +zone=19 +ellps=intl +towgs84=-273.5,110.6,-357.9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3157": [
        "EPSG:3157",
        "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2900": [
        "EPSG:2900",
        "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26718": [
        "EPSG:26718",
        "+proj=utm +zone=18 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32628": [
        "EPSG:32628",
        "+proj=utm +zone=28 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4938": ["EPSG:4938", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:29193": [
        "EPSG:29193",
        "+proj=utm +zone=23 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4025": ["EPSG:4025", "+proj=longlat +ellps=WGS66 +no_defs "],
    "EPSG:31276": [
        "EPSG:31276",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=6500000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:4322": [
        "EPSG:4322",
        "+proj=longlat +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +no_defs ",
    ],
    "EPSG:4826": [
        "EPSG:4826",
        "+proj=lcc +lat_1=15 +lat_2=16.66666666666667 +lat_0=15.83333333333333 +lon_0=-24 +x_0=161587.83 +y_0=128511.202 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2262": [
        "EPSG:2262",
        "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2264": [
        "EPSG:2264",
        "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2811": [
        "EPSG:2811",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3116": [
        "EPSG:3116",
        "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-74.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4940": ["EPSG:4940", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:3975": [
        "EPSG:3975",
        "+proj=cea +lon_0=0 +lat_ts=30 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26715": [
        "EPSG:26715",
        "+proj=utm +zone=15 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:2956": [
        "EPSG:2956",
        "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26917": [
        "EPSG:26917",
        "+proj=utm +zone=17 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26920": [
        "EPSG:26920",
        "+proj=utm +zone=20 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:4806": [
        "EPSG:4806",
        "+proj=longlat +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +pm=rome +no_defs ",
    ],
    "EPSG:32622": [
        "EPSG:32622",
        "+proj=utm +zone=22 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3413": [
        "EPSG:3413",
        "+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3009": [
        "EPSG:3009",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5256": [
        "EPSG:5256",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:28991": [
        "EPSG:28991",
        "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=0 +y_0=0 +ellps=bessel +towgs84=565.4171,50.3319,465.5524,-0.398957,0.343988,-1.87740,4.0725 +units=m +no_defs ",
    ],
    "EPSG:32747": [
        "EPSG:32747",
        "+proj=utm +zone=47 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4148": [
        "EPSG:4148",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:2004": [
        "EPSG:2004",
        "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=174,359,365,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4210": [
        "EPSG:4210",
        "+proj=longlat +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +no_defs ",
    ],
    "EPSG:31254": [
        "EPSG:31254",
        "+proj=tmerc +lat_0=0 +lon_0=10.33333333333333 +k=1 +x_0=0 +y_0=-5000000 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:29902": [
        "EPSG:29902",
        "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +datum=ire65 +units=m +no_defs ",
    ],
    "EPSG:3828": [
        "EPSG:3828",
        "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=aust_SA +units=m +no_defs ",
    ],
    "EPSG:3578": [
        "EPSG:3578",
        "+proj=aea +lat_1=61.66666666666666 +lat_2=68 +lat_0=59 +lon_0=-132.5 +x_0=500000 +y_0=500000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:4483": [
        "EPSG:4483",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:31463": [
        "EPSG:31463",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:23036": [
        "EPSG:23036",
        "+proj=utm +zone=36 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5550": [
        "EPSG:5550",
        "+proj=utm +zone=54 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3158": [
        "EPSG:3158",
        "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32717": [
        "EPSG:32717",
        "+proj=utm +zone=17 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2285": [
        "EPSG:2285",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:24048": [
        "EPSG:24048",
        "+proj=utm +zone=48 +a=6377276.345 +b=6356075.41314024 +towgs84=210,814,289,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27572": [
        "EPSG:27572",
        "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:26996": [
        "EPSG:26996",
        "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3027": [
        "EPSG:3027",
        "+proj=tmerc +lat_0=0 +lon_0=15.80827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:27562": [
        "EPSG:27562",
        "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:3553": [
        "EPSG:3553",
        "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3034": [
        "EPSG:3034",
        "+proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5799": ["EPSG:5799", "undefined"],
    "EPSG:26778": [
        "EPSG:26778",
        "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:31297": [
        "EPSG:31297",
        "+proj=lcc +lat_1=49 +lat_2=46 +lat_0=47.5 +lon_0=13.33333333333333 +x_0=400000 +y_0=400000 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:4274": [
        "EPSG:4274",
        "+proj=longlat +ellps=intl +towgs84=-223.237,110.193,36.649,0,0,0,0 +no_defs ",
    ],
    "EPSG:3046": [
        "EPSG:3046",
        "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4896": ["EPSG:4896", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3008": [
        "EPSG:3008",
        "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2907": [
        "EPSG:2907",
        "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26591": [
        "EPSG:26591",
        "+proj=tmerc +lat_0=0 +lon_0=-3.45233333333333 +k=0.9996 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +pm=rome +units=m +no_defs ",
    ],
    "EPSG:23035": [
        "EPSG:23035",
        "+proj=utm +zone=35 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5367": [
        "EPSG:5367",
        "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21892": [
        "EPSG:21892",
        "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-74.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2226": [
        "EPSG:2226",
        "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:20790": [
        "EPSG:20790",
        "+proj=tmerc +lat_0=39.66666666666666 +lon_0=1 +k=1 +x_0=200000 +y_0=300000 +ellps=intl +towgs84=-304.046,-60.576,103.64,0,0,0,0 +pm=lisbon +units=m +no_defs ",
    ],
    "EPSG:2902": [
        "EPSG:2902",
        "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2176": [
        "EPSG:2176",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29180": [
        "EPSG:29180",
        "+proj=utm +zone=20 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5764": ["EPSG:5764", "undefined"],
    "EPSG:3163": [
        "EPSG:3163",
        "+proj=lcc +lat_1=-20.66666666666667 +lat_2=-22.33333333333333 +lat_0=-21.5 +lon_0=166 +x_0=400000 +y_0=300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24047": [
        "EPSG:24047",
        "+proj=utm +zone=47 +a=6377276.345 +b=6356075.41314024 +towgs84=210,814,289,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4479": ["EPSG:4479", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:27563": [
        "EPSG:27563",
        "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:3057": [
        "EPSG:3057",
        "+proj=lcc +lat_1=64.25 +lat_2=65.75 +lat_0=65 +lon_0=-19 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29191": [
        "EPSG:29191",
        "+proj=utm +zone=21 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2177": [
        "EPSG:2177",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32139": [
        "EPSG:32139",
        "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3616": [
        "EPSG:3616",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2223": [
        "EPSG:2223",
        "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:32019": [
        "EPSG:32019",
        "+proj=lcc +lat_1=34.33333333333334 +lat_2=36.16666666666666 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26753": [
        "EPSG:26753",
        "+proj=lcc +lat_1=39.71666666666667 +lat_2=40.78333333333333 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32654": [
        "EPSG:32654",
        "+proj=utm +zone=54 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26904": [
        "EPSG:26904",
        "+proj=utm +zone=4 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:5018": [
        "EPSG:5018",
        "+proj=tmerc +lat_0=39.66666666666666 +lon_0=-8.131906111111112 +k=1 +x_0=0 +y_0=0 +ellps=intl +towgs84=-304.046,-60.576,103.64,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21096": [
        "EPSG:21096",
        "+proj=utm +zone=36 +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3822": ["EPSG:3822", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3457": [
        "EPSG:3457",
        "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:30800": [
        "EPSG:30800",
        "+proj=tmerc +lat_0=0 +lon_0=15.80827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:2065": [
        "EPSG:2065",
        "+proj=krovak +lat_0=49.5 +lon_0=42.5 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=570.8,85.7,462.8,4.998,1.587,5.261,3.56 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:3346": [
        "EPSG:3346",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3432": [
        "EPSG:3432",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3290": [
        "EPSG:3290",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=30 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:26967": [
        "EPSG:26967",
        "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:2326": [
        "EPSG:2326",
        "+proj=tmerc +lat_0=22.31213333333334 +lon_0=114.1785555555556 +k=1 +x_0=836694.05 +y_0=819069.8 +ellps=intl +towgs84=-162.619,-276.959,-161.764,0.067753,-2.243649,-1.158827,-1.094246 +units=m +no_defs ",
    ],
    "EPSG:2927": [
        "EPSG:2927",
        "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3153": [
        "EPSG:3153",
        "+proj=aea +lat_1=50 +lat_2=58.5 +lat_0=45 +lon_0=-126 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4162": ["EPSG:4162", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:25829": [
        "EPSG:25829",
        "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4936": ["EPSG:4936", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4385": ["EPSG:4385", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:25828": [
        "EPSG:25828",
        "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3004": [
        "EPSG:3004",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=2520000 +y_0=0 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +units=m +no_defs ",
    ],
    "EPSG:2828": [
        "EPSG:2828",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5069": [
        "EPSG:5069",
        "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:4149": [
        "EPSG:4149",
        "+proj=longlat +ellps=bessel +towgs84=674.4,15.1,405.3,0,0,0,0 +no_defs ",
    ],
    "EPSG:4156": [
        "EPSG:4156",
        "+proj=longlat +ellps=bessel +towgs84=589,76,480,0,0,0,0 +no_defs ",
    ],
    "EPSG:4181": [
        "EPSG:4181",
        "+proj=longlat +ellps=intl +towgs84=-189.6806,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598 +no_defs ",
    ],
    "EPSG:2231": [
        "EPSG:2231",
        "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4587": [
        "EPSG:4587",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4348": ["EPSG:4348", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:22184": [
        "EPSG:22184",
        "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3826": [
        "EPSG:3826",
        "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2034": [
        "EPSG:2034",
        "+proj=utm +zone=20 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:29900": [
        "EPSG:29900",
        "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +datum=ire65 +units=m +no_defs ",
    ],
    "EPSG:3331": [
        "EPSG:3331",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:2768": [
        "EPSG:2768",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3812": [
        "EPSG:3812",
        "+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=50.797815 +lon_0=4.359215833333333 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3815": [
        "EPSG:3815",
        "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2525": [
        "EPSG:2525",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:4794": [
        "EPSG:4794",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4797": [
        "EPSG:4797",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4674": [
        "EPSG:4674",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4897": ["EPSG:4897", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:32520": [
        "EPSG:32520",
        "+proj=utm +zone=20 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:4839": [
        "EPSG:4839",
        "+proj=lcc +lat_1=48.66666666666666 +lat_2=53.66666666666666 +lat_0=51 +lon_0=10.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26771": [
        "EPSG:26771",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:3347": [
        "EPSG:3347",
        "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=63.390675 +lon_0=-91.86666666666666 +x_0=6200000 +y_0=3000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:4612": [
        "EPSG:4612",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:3571": [
        "EPSG:3571",
        "+proj=laea +lat_0=90 +lon_0=180 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4913": ["EPSG:4913", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2272": [
        "EPSG:2272",
        "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4189": [
        "EPSG:4189",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:3575": [
        "EPSG:3575",
        "+proj=laea +lat_0=90 +lon_0=10 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2926": [
        "EPSG:2926",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:31252": [
        "EPSG:31252",
        "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:20356": [
        "EPSG:20356",
        "+proj=utm +zone=56 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31255": [
        "EPSG:31255",
        "+proj=tmerc +lat_0=0 +lon_0=13.33333333333333 +k=1 +x_0=0 +y_0=-5000000 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:26785": [
        "EPSG:26785",
        "+proj=lcc +lat_1=38.3 +lat_2=39.45 +lat_0=37.83333333333334 +lon_0=-77 +x_0=243840.4876809754 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4004": ["EPSG:4004", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:31267": [
        "EPSG:31267",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:2276": [
        "EPSG:2276",
        "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000.0001016 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2277": [
        "EPSG:2277",
        "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=699999.9998983998 +y_0=3000000 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2278": [
        "EPSG:2278",
        "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=3999999.9998984 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4015": [
        "EPSG:4015",
        "+proj=longlat +a=6377276.345 +b=6356075.41314024 +no_defs ",
    ],
    "EPSG:3155": [
        "EPSG:3155",
        "+proj=utm +zone=8 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32624": [
        "EPSG:32624",
        "+proj=utm +zone=24 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5214": ["EPSG:5214", "undefined"],
    "EPSG:4986": ["EPSG:4986", "+proj=geocent +ellps=WGS72 +units=m +no_defs "],
    "EPSG:5048": [
        "EPSG:5048",
        "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2790": [
        "EPSG:2790",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3907": [
        "EPSG:3907",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=5500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3908": [
        "EPSG:3908",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3375": [
        "EPSG:3375",
        "+proj=omerc +lat_0=4 +lonc=102.25 +alpha=323.0257964666666 +k=0.99984 +x_0=804671 +y_0=0 +no_uoff +gamma=323.1301023611111 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3995": [
        "EPSG:3995",
        "+proj=stere +lat_0=90 +lat_ts=71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3007": [
        "EPSG:3007",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4005": [
        "EPSG:4005",
        "+proj=longlat +a=6377492.018 +b=6356173.508712696 +no_defs ",
    ],
    "EPSG:4024": ["EPSG:4024", "+proj=longlat +ellps=krass +no_defs "],
    "EPSG:4052": ["EPSG:4052", "+proj=longlat +a=6370997 +b=6370997 +no_defs "],
    "EPSG:32734": [
        "EPSG:32734",
        "+proj=utm +zone=34 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32602": [
        "EPSG:32602",
        "+proj=utm +zone=2 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4225": [
        "EPSG:4225",
        "+proj=longlat +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +no_defs ",
    ],
    "EPSG:2953": [
        "EPSG:2953",
        "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=2500000 +y_0=7500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31981": [
        "EPSG:31981",
        "+proj=utm +zone=21 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31985": [
        "EPSG:31985",
        "+proj=utm +zone=25 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2174": [
        "EPSG:2174",
        "+proj=sterea +lat_0=51.67083333333333 +lon_0=16.67222222222222 +k=0.9998 +x_0=3703000 +y_0=5627000 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3182": [
        "EPSG:3182",
        "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2175": [
        "EPSG:2175",
        "+proj=tmerc +lat_0=0 +lon_0=18.95833333333333 +k=0.999983 +x_0=237000 +y_0=-4700000 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:31992": [
        "EPSG:31992",
        "+proj=utm +zone=17 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5773": ["EPSG:5773", "undefined"],
    "EPSG:2958": [
        "EPSG:2958",
        "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2434": [
        "EPSG:2434",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4331": ["EPSG:4331", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32606": [
        "EPSG:32606",
        "+proj=utm +zone=6 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2178": [
        "EPSG:2178",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32005": [
        "EPSG:32005",
        "+proj=lcc +lat_1=41.85 +lat_2=42.81666666666667 +lat_0=41.33333333333334 +lon_0=-100 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4917": ["EPSG:4917", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:26895": [
        "EPSG:26895",
        "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26896": [
        "EPSG:26896",
        "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21897": [
        "EPSG:21897",
        "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-74.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3403": [
        "EPSG:3403",
        "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3630": [
        "EPSG:3630",
        "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:5524": ["EPSG:5524", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:32031": [
        "EPSG:32031",
        "+proj=lcc +lat_1=33.76666666666667 +lat_2=34.96666666666667 +lat_0=33 +lon_0=-81 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:2816": [
        "EPSG:2816",
        "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4481": ["EPSG:4481", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32036": [
        "EPSG:32036",
        "+proj=lcc +lat_1=35.25 +lat_2=36.41666666666666 +lat_0=34.66666666666666 +lon_0=-86 +x_0=30480.06096012192 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:2817": [
        "EPSG:2817",
        "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4083": [
        "EPSG:4083",
        "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2819": [
        "EPSG:2819",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5243": [
        "EPSG:5243",
        "+proj=lcc +lat_1=48.66666666666666 +lat_2=53.66666666666666 +lat_0=51 +lon_0=10.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22185": [
        "EPSG:22185",
        "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4094": [
        "EPSG:4094",
        "+proj=tmerc +lat_0=0 +lon_0=10 +k=0.99998 +x_0=400000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32601": [
        "EPSG:32601",
        "+proj=utm +zone=1 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32049": [
        "EPSG:32049",
        "+proj=lcc +lat_1=45.83333333333334 +lat_2=47.33333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:2321": [
        "EPSG:2321",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26943": [
        "EPSG:26943",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:4229": [
        "EPSG:4229",
        "+proj=longlat +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +no_defs ",
    ],
    "EPSG:4231": [
        "EPSG:4231",
        "+proj=longlat +ellps=intl +towgs84=-83.11,-97.38,-117.22,0.005693,-0.044698,0.044285,0.1218 +no_defs ",
    ],
    "EPSG:5272": [
        "EPSG:5272",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3651": [
        "EPSG:3651",
        "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3652": [
        "EPSG:3652",
        "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3423": [
        "EPSG:3423",
        "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000.0000101599 +y_0=3999999.99998984 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2450": [
        "EPSG:2450",
        "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22391": [
        "EPSG:22391",
        "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=9.9 +k_0=0.999625544 +x_0=500000 +y_0=300000 +datum=carthage +units=m +no_defs ",
    ],
    "EPSG:4027": [
        "EPSG:4027",
        "+proj=longlat +a=6376523 +b=6355862.933255573 +no_defs ",
    ],
    "EPSG:22523": [
        "EPSG:22523",
        "+proj=utm +zone=23 +south +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22524": [
        "EPSG:22524",
        "+proj=utm +zone=24 +south +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32100": [
        "EPSG:32100",
        "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:4312": ["EPSG:4312", "+proj=longlat +datum=hermannskogel +no_defs "],
    "EPSG:3437": [
        "EPSG:3437",
        "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000.0000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4314": ["EPSG:4314", "+proj=longlat +datum=potsdam +no_defs "],
    "EPSG:32118": [
        "EPSG:32118",
        "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32119": [
        "EPSG:32119",
        "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.22 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:23031": [
        "EPSG:23031",
        "+proj=utm +zone=31 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3518": [
        "EPSG:3518",
        "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3021": [
        "EPSG:3021",
        "+proj=tmerc +lat_0=0 +lon_0=15.80827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs ",
    ],
    "EPSG:3022": [
        "EPSG:3022",
        "+proj=tmerc +lat_0=0 +lon_0=18.05827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs ",
    ],
    "EPSG:3447": [
        "EPSG:3447",
        "+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=50.797815 +lon_0=4.359215833333333 +x_0=150328 +y_0=166262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32130": [
        "EPSG:32130",
        "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26992": [
        "EPSG:26992",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:4920": ["EPSG:4920", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:23834": [
        "EPSG:23834",
        "+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3453": [
        "EPSG:3453",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.5 +lon_0=-91.33333333333333 +x_0=999999.9999898402 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:27200": [
        "EPSG:27200",
        "+proj=nzmg +lat_0=-41 +lon_0=173 +x_0=2510000 +y_0=6023150 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:4272": [
        "EPSG:4272",
        "+proj=longlat +datum=nzgd49 +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:4001": ["EPSG:4001", "+proj=longlat +ellps=airy +no_defs "],
    "EPSG:3690": [
        "EPSG:3690",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3036": [
        "EPSG:3036",
        "+proj=utm +zone=36 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4455": [
        "EPSG:4455",
        "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4324": [
        "EPSG:4324",
        "+proj=longlat +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +no_defs ",
    ],
    "EPSG:2345": [
        "EPSG:2345",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2852": [
        "EPSG:2852",
        "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2050": [
        "EPSG:2050",
        "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4487": [
        "EPSG:4487",
        "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2051": [
        "EPSG:2051",
        "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2053": [
        "EPSG:2053",
        "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2219": [
        "EPSG:2219",
        "+proj=utm +zone=19 +a=6378135 +b=6356750.304921594 +units=m +no_defs ",
    ],
    "EPSG:4497": [
        "EPSG:4497",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7408": [
        "EPSG:7408",
        "+proj=longlat +ellps=bessel +towgs84=565.4171,50.3319,465.5524,-0.398957,0.343988,-1.87740,4.0725 +vunits=m +no_defs ",
    ],
    "EPSG:32195": [
        "EPSG:32195",
        "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32196": [
        "EPSG:32196",
        "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:7416": [
        "EPSG:7416",
        "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:3059": [
        "EPSG:3059",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27391": [
        "EPSG:27391",
        "+proj=tmerc +lat_0=58 +lon_0=-4.666666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs ",
    ],
    "EPSG:3717": [
        "EPSG:3717",
        "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3062": [
        "EPSG:3062",
        "+proj=utm +zone=26 +ellps=intl +towgs84=-204.619,140.176,55.226,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4508": [
        "EPSG:4508",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:27492": [
        "EPSG:27492",
        "+proj=tmerc +lat_0=39.66666666666666 +lon_0=-8.131906111111112 +k=1 +x_0=180.598 +y_0=-86.98999999999999 +ellps=intl +towgs84=-223.237,110.193,36.649,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5532": [
        "EPSG:5532",
        "+proj=utm +zone=22 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27561": [
        "EPSG:27561",
        "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:23948": [
        "EPSG:23948",
        "+proj=utm +zone=48 +a=6377276.345 +b=6356075.41314024 +towgs84=217,823,299,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27573": [
        "EPSG:27573",
        "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:27582": [
        "EPSG:27582",
        "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:5538": [
        "EPSG:5538",
        "+proj=utm +zone=23 +south +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:3725": [
        "EPSG:3725",
        "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32242": [
        "EPSG:32242",
        "+proj=utm +zone=42 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32609": [
        "EPSG:32609",
        "+proj=utm +zone=9 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4658": [
        "EPSG:4658",
        "+proj=longlat +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +no_defs ",
    ],
    "EPSG:3491": [
        "EPSG:3491",
        "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3496": [
        "EPSG:3496",
        "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2872": [
        "EPSG:2872",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2873": [
        "EPSG:2873",
        "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3740": [
        "EPSG:3740",
        "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2875": [
        "EPSG:2875",
        "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3742": [
        "EPSG:3742",
        "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2237": [
        "EPSG:2237",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:24571": [
        "EPSG:24571",
        "+proj=omerc +lat_0=4 +lonc=102.25 +alpha=323.0257905 +k=0.99984 +x_0=804671.2997750348 +y_0=0 +no_uoff +gamma=323.1301023611111 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +to_meter=20.11678249437587 +no_defs ",
    ],
    "EPSG:2238": [
        "EPSG:2238",
        "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4976": ["EPSG:4976", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3745": [
        "EPSG:3745",
        "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4278": ["EPSG:4278", "+proj=longlat +ellps=airy +no_defs "],
    "EPSG:4207": [
        "EPSG:4207",
        "+proj=longlat +ellps=intl +towgs84=-304.046,-60.576,103.64,0,0,0,0 +no_defs ",
    ],
    "EPSG:3511": [
        "EPSG:3511",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5713": ["EPSG:5713", "undefined"],
    "EPSG:4209": [
        "EPSG:4209",
        "+proj=longlat +a=6378249.145 +b=6356514.966398753 +towgs84=-143,-90,-294,0,0,0,0 +no_defs ",
    ],
    "EPSG:3517": [
        "EPSG:3517",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3824": [
        "EPSG:3824",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4121": ["EPSG:4121", "+proj=longlat +datum=GGRS87 +no_defs "],
    "EPSG:32337": [
        "EPSG:32337",
        "+proj=utm +zone=37 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:4728": [
        "EPSG:4728",
        "+proj=longlat +ellps=intl +towgs84=-307,-92,127,0,0,0,0 +no_defs ",
    ],
    "EPSG:25835": [
        "EPSG:25835",
        "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3015": [
        "EPSG:3015",
        "+proj=tmerc +lat_0=0 +lon_0=18.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2253": [
        "EPSG:2253",
        "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=3999999.999984 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:26191": [
        "EPSG:26191",
        "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=-5.4 +k_0=0.999625769 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26192": [
        "EPSG:26192",
        "+proj=lcc +lat_1=29.7 +lat_0=29.7 +lon_0=-5.4 +k_0=0.9996155960000001 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4247": [
        "EPSG:4247",
        "+proj=longlat +ellps=intl +towgs84=-273.5,110.6,-357.9,0,0,0,0 +no_defs ",
    ],
    "EPSG:2257": [
        "EPSG:2257",
        "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:29100": [
        "EPSG:29100",
        "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4926": ["EPSG:4926", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:26705": [
        "EPSG:26705",
        "+proj=utm +zone=5 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:2903": [
        "EPSG:2903",
        "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:29182": [
        "EPSG:29182",
        "+proj=utm +zone=22 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3973": [
        "EPSG:3973",
        "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:29184": [
        "EPSG:29184",
        "+proj=utm +zone=24 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3786": [
        "EPSG:3786",
        "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6371007 +b=6371007 +units=m +no_defs ",
    ],
    "EPSG:3115": [
        "EPSG:3115",
        "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-77.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4928": ["EPSG:4928", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:26730": [
        "EPSG:26730",
        "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:2911": [
        "EPSG:2911",
        "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:4364": ["EPSG:4364", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2112": [
        "EPSG:2112",
        "+proj=tmerc +lat_0=-40.92527777777777 +lon_0=175.6472222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2113": [
        "EPSG:2113",
        "+proj=tmerc +lat_0=-41.3011111111111 +lon_0=174.7763888888889 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2114": [
        "EPSG:2114",
        "+proj=tmerc +lat_0=-40.71472222222223 +lon_0=172.6719444444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2115": [
        "EPSG:2115",
        "+proj=tmerc +lat_0=-41.27444444444444 +lon_0=173.2991666666667 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2116": [
        "EPSG:2116",
        "+proj=tmerc +lat_0=-41.28972222222222 +lon_0=172.1088888888889 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2117": [
        "EPSG:2117",
        "+proj=tmerc +lat_0=-41.81055555555555 +lon_0=171.5811111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2118": [
        "EPSG:2118",
        "+proj=tmerc +lat_0=-42.33361111111111 +lon_0=171.5497222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2119": [
        "EPSG:2119",
        "+proj=tmerc +lat_0=-42.68888888888888 +lon_0=173.01 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2120": [
        "EPSG:2120",
        "+proj=tmerc +lat_0=-41.54444444444444 +lon_0=173.8019444444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4366": ["EPSG:4366", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2121": [
        "EPSG:2121",
        "+proj=tmerc +lat_0=-42.88611111111111 +lon_0=170.9797222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2122": [
        "EPSG:2122",
        "+proj=tmerc +lat_0=-43.11 +lon_0=170.2608333333333 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2123": [
        "EPSG:2123",
        "+proj=tmerc +lat_0=-43.97777777777778 +lon_0=168.6061111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2124": [
        "EPSG:2124",
        "+proj=tmerc +lat_0=-43.59055555555556 +lon_0=172.7269444444445 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2125": [
        "EPSG:2125",
        "+proj=tmerc +lat_0=-43.74861111111111 +lon_0=171.3605555555555 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2126": [
        "EPSG:2126",
        "+proj=tmerc +lat_0=-44.40194444444445 +lon_0=171.0572222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2127": [
        "EPSG:2127",
        "+proj=tmerc +lat_0=-44.735 +lon_0=169.4675 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2128": [
        "EPSG:2128",
        "+proj=tmerc +lat_0=-45.13277777777778 +lon_0=168.3986111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2129": [
        "EPSG:2129",
        "+proj=tmerc +lat_0=-45.56361111111111 +lon_0=167.7386111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4368": ["EPSG:4368", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2130": [
        "EPSG:2130",
        "+proj=tmerc +lat_0=-45.81611111111111 +lon_0=170.6283333333333 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2131": [
        "EPSG:2131",
        "+proj=tmerc +lat_0=-45.86138888888889 +lon_0=170.2825 +k=0.99996 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2132": [
        "EPSG:2132",
        "+proj=tmerc +lat_0=-46.6 +lon_0=168.3427777777778 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2133": [
        "EPSG:2133",
        "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2134": [
        "EPSG:2134",
        "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2135": [
        "EPSG:2135",
        "+proj=utm +zone=60 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2136": [
        "EPSG:2136",
        "+proj=tmerc +lat_0=4.666666666666667 +lon_0=-1 +k=0.99975 +x_0=274319.7391633579 +y_0=0 +a=6378300 +b=6356751.689189189 +towgs84=-199,32,322,0,0,0,0 +to_meter=0.3047997101815088 +no_defs ",
    ],
    "EPSG:2137": [
        "EPSG:2137",
        "+proj=tmerc +lat_0=0 +lon_0=-1 +k=0.9996 +x_0=500000 +y_0=0 +a=6378300 +b=6356751.689189189 +towgs84=-199,32,322,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2138": [
        "EPSG:2138",
        "+proj=lcc +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2312": [
        "EPSG:2312",
        "+proj=utm +zone=33 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:2139": [
        "EPSG:2139",
        "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2140": [
        "EPSG:2140",
        "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2141": [
        "EPSG:2141",
        "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2142": [
        "EPSG:2142",
        "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2143": [
        "EPSG:2143",
        "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2144": [
        "EPSG:2144",
        "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2145": [
        "EPSG:2145",
        "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2146": [
        "EPSG:2146",
        "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2147": [
        "EPSG:2147",
        "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4370": ["EPSG:4370", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2148": [
        "EPSG:2148",
        "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2150": [
        "EPSG:2150",
        "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2155": [
        "EPSG:2155",
        "+proj=lcc +lat_1=-14.26666666666667 +lat_0=-14.26666666666667 +lon_0=170 +k_0=1 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=-115,118,426,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2156": [
        "EPSG:2156",
        "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3994": [
        "EPSG:3994",
        "+proj=merc +lon_0=100 +lat_ts=-41 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2158": [
        "EPSG:2158",
        "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2159": [
        "EPSG:2159",
        "+proj=tmerc +lat_0=6.666666666666667 +lon_0=-12 +k=1 +x_0=152399.8550907544 +y_0=0 +a=6378300 +b=6356751.689189189 +to_meter=0.3047997101815088 +no_defs ",
    ],
    "EPSG:2160": [
        "EPSG:2160",
        "+proj=tmerc +lat_0=6.666666666666667 +lon_0=-12 +k=1 +x_0=243839.7681452071 +y_0=182879.8261089053 +a=6378300 +b=6356751.689189189 +to_meter=0.3047997101815088 +no_defs ",
    ],
    "EPSG:2161": [
        "EPSG:2161",
        "+proj=utm +zone=28 +ellps=clrk80 +towgs84=-88,4,101,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2162": [
        "EPSG:2162",
        "+proj=utm +zone=29 +ellps=clrk80 +towgs84=-88,4,101,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2164": [
        "EPSG:2164",
        "+proj=tmerc +lat_0=0 +lon_0=-5 +k=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +towgs84=-125,53,467,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2165": [
        "EPSG:2165",
        "+proj=tmerc +lat_0=0 +lon_0=-5 +k=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +towgs84=-124.76,53,466.79,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2313": [
        "EPSG:2313",
        "+proj=utm +zone=33 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:2166": [
        "EPSG:2166",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2167": [
        "EPSG:2167",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2168": [
        "EPSG:2168",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2170": [
        "EPSG:2170",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:2171": [
        "EPSG:2171",
        "+proj=sterea +lat_0=50.625 +lon_0=21.08333333333333 +k=0.9998 +x_0=4637000 +y_0=5647000 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:2172": [
        "EPSG:2172",
        "+proj=sterea +lat_0=53.00194444444445 +lon_0=21.50277777777778 +k=0.9998 +x_0=4603000 +y_0=5806000 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:2173": [
        "EPSG:2173",
        "+proj=sterea +lat_0=53.58333333333334 +lon_0=17.00833333333333 +k=0.9998 +x_0=3501000 +y_0=5999000 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:2179": [
        "EPSG:2179",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2188": [
        "EPSG:2188",
        "+proj=utm +zone=25 +ellps=intl +towgs84=-425,-169,81,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2189": [
        "EPSG:2189",
        "+proj=utm +zone=26 +ellps=intl +towgs84=-104,167,-38,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2190": [
        "EPSG:2190",
        "+proj=utm +zone=26 +ellps=intl +towgs84=-203,141,53,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2191": [
        "EPSG:2191",
        "+proj=utm +zone=28 +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:2192": [
        "EPSG:2192",
        "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=2.337229166666667 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2194": [
        "EPSG:2194",
        "+proj=lcc +lat_1=-14.26666666666667 +lat_0=-14.26666666666667 +lon_0=-170 +k_0=1 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=-115,118,426,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2195": [
        "EPSG:2195",
        "+proj=utm +zone=2 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2196": [
        "EPSG:2196",
        "+proj=tmerc +lat_0=0 +lon_0=9.5 +k=0.99995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2197": [
        "EPSG:2197",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.99995 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2198": [
        "EPSG:2198",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2199": [
        "EPSG:2199",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=-44.183,-0.58,-38.489,-2.3867,-2.7072,3.5196,-8.2703 +units=m +no_defs ",
    ],
    "EPSG:2200": [
        "EPSG:2200",
        "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=300000 +y_0=800000 +a=6378135 +b=6356750.304921594 +units=m +no_defs ",
    ],
    "EPSG:4372": ["EPSG:4372", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2201": [
        "EPSG:2201",
        "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2202": [
        "EPSG:2202",
        "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2203": [
        "EPSG:2203",
        "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2204": [
        "EPSG:2204",
        "+proj=lcc +lat_1=35.25 +lat_2=36.41666666666666 +lat_0=34.66666666666666 +lon_0=-86 +x_0=609601.2192024384 +y_0=30480.06096012192 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:2205": [
        "EPSG:2205",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:2206": [
        "EPSG:2206",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2207": [
        "EPSG:2207",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2208": [
        "EPSG:2208",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2209": [
        "EPSG:2209",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2210": [
        "EPSG:2210",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2211": [
        "EPSG:2211",
        "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2212": [
        "EPSG:2212",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2213": [
        "EPSG:2213",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2214": [
        "EPSG:2214",
        "+proj=tmerc +lat_0=0 +lon_0=10.5 +k=0.999 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=-206.1,-174.7,-87.7,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2215": [
        "EPSG:2215",
        "+proj=utm +zone=32 +a=6378249.2 +b=6356515 +towgs84=-70.9,-151.8,-41.4,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2216": [
        "EPSG:2216",
        "+proj=utm +zone=22 +ellps=intl +towgs84=164,138,-189,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2217": [
        "EPSG:2217",
        "+proj=utm +zone=23 +ellps=intl +towgs84=164,138,-189,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2222": [
        "EPSG:2222",
        "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2224": [
        "EPSG:2224",
        "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2225": [
        "EPSG:2225",
        "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4374": ["EPSG:4374", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2232": [
        "EPSG:2232",
        "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2233": [
        "EPSG:2233",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2234": [
        "EPSG:2234",
        "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096012192 +y_0=152400.3048006096 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2235": [
        "EPSG:2235",
        "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000.0001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2236": [
        "EPSG:2236",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2334": [
        "EPSG:2334",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2239": [
        "EPSG:2239",
        "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000.0001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2240": [
        "EPSG:2240",
        "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=699999.9998983998 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2241": [
        "EPSG:2241",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000.0001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2242": [
        "EPSG:2242",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2243": [
        "EPSG:2243",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2244": [
        "EPSG:2244",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249364.9987299975 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2245": [
        "EPSG:2245",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249364.9987299975 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2246": [
        "EPSG:2246",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2247": [
        "EPSG:2247",
        "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000.0001016001 +y_0=500000.0001016001 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2248": [
        "EPSG:2248",
        "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=399999.9998983998 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2249": [
        "EPSG:2249",
        "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000.0001016002 +y_0=750000 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2250": [
        "EPSG:2250",
        "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2251": [
        "EPSG:2251",
        "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=7999999.999968001 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2252": [
        "EPSG:2252",
        "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=5999999.999976001 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2254": [
        "EPSG:2254",
        "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000.0000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2255": [
        "EPSG:2255",
        "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=699999.9998983998 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2335": [
        "EPSG:2335",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2256": [
        "EPSG:2256",
        "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2258": [
        "EPSG:2258",
        "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2259": [
        "EPSG:2259",
        "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2265": [
        "EPSG:2265",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2266": [
        "EPSG:2266",
        "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2267": [
        "EPSG:2267",
        "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2268": [
        "EPSG:2268",
        "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2269": [
        "EPSG:2269",
        "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000.0001424 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2270": [
        "EPSG:2270",
        "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000.0001464 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2271": [
        "EPSG:2271",
        "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4376": ["EPSG:4376", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2273": [
        "EPSG:2273",
        "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2275": [
        "EPSG:2275",
        "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000.0001016002 +y_0=999999.9998983998 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2279": [
        "EPSG:2279",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000.0000000001 +y_0=5000000.0001016 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2280": [
        "EPSG:2280",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=999999.9999960001 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2281": [
        "EPSG:2281",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=1999999.999992 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2282": [
        "EPSG:2282",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.0001504 +y_0=2999999.999988 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2283": [
        "EPSG:2283",
        "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=2000000.0001016 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2284": [
        "EPSG:2284",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=999999.9998983998 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2286": [
        "EPSG:2286",
        "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000.0001016001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2287": [
        "EPSG:2287",
        "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2288": [
        "EPSG:2288",
        "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4378": ["EPSG:4378", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2289": [
        "EPSG:2289",
        "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2291": [
        "EPSG:2291",
        "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +a=6378135 +b=6356750.304921594 +units=m +no_defs ",
    ],
    "EPSG:2292": [
        "EPSG:2292",
        "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2294": [
        "EPSG:2294",
        "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=4500000 +y_0=0 +a=6378135 +b=6356750.304921594 +units=m +no_defs ",
    ],
    "EPSG:2295": [
        "EPSG:2295",
        "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=5500000 +y_0=0 +a=6378135 +b=6356750.304921594 +units=m +no_defs ",
    ],
    "EPSG:2308": [
        "EPSG:2308",
        "+proj=tmerc +lat_0=0 +lon_0=109 +k=0.9996 +x_0=500000 +y_0=10000000 +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2309": [
        "EPSG:2309",
        "+proj=tmerc +lat_0=0 +lon_0=116 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2310": [
        "EPSG:2310",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4380": ["EPSG:4380", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:2314": [
        "EPSG:2314",
        "+proj=cass +lat_0=10.44166666666667 +lon_0=-61.33333333333334 +x_0=86501.46392052001 +y_0=65379.0134283 +a=6378293.645208759 +b=6356617.987679838 +towgs84=-61.702,284.488,472.052,0,0,0,0 +to_meter=0.3047972654 +no_defs ",
    ],
    "EPSG:2315": [
        "EPSG:2315",
        "+proj=utm +zone=19 +south +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2316": [
        "EPSG:2316",
        "+proj=utm +zone=20 +south +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2317": [
        "EPSG:2317",
        "+proj=lcc +lat_1=9 +lat_2=3 +lat_0=6 +lon_0=-66 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2318": [
        "EPSG:2318",
        "+proj=lcc +lat_1=17 +lat_2=33 +lat_0=25.08951 +lon_0=48 +x_0=0 +y_0=0 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2319": [
        "EPSG:2319",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2320": [
        "EPSG:2320",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2322": [
        "EPSG:2322",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2323": [
        "EPSG:2323",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2324": [
        "EPSG:2324",
        "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2325": [
        "EPSG:2325",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2327": [
        "EPSG:2327",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2328": [
        "EPSG:2328",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2329": [
        "EPSG:2329",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2330": [
        "EPSG:2330",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2331": [
        "EPSG:2331",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2332": [
        "EPSG:2332",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2333": [
        "EPSG:2333",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:4382": ["EPSG:4382", "+proj=geocent +ellps=intl +units=m +no_defs "],
    "EPSG:2336": [
        "EPSG:2336",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2337": [
        "EPSG:2337",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2338": [
        "EPSG:2338",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2339": [
        "EPSG:2339",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2340": [
        "EPSG:2340",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2341": [
        "EPSG:2341",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2342": [
        "EPSG:2342",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2343": [
        "EPSG:2343",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2344": [
        "EPSG:2344",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2346": [
        "EPSG:2346",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2347": [
        "EPSG:2347",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2348": [
        "EPSG:2348",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2349": [
        "EPSG:2349",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2350": [
        "EPSG:2350",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2351": [
        "EPSG:2351",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2352": [
        "EPSG:2352",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2353": [
        "EPSG:2353",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2354": [
        "EPSG:2354",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2355": [
        "EPSG:2355",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2356": [
        "EPSG:2356",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2357": [
        "EPSG:2357",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2358": [
        "EPSG:2358",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2359": [
        "EPSG:2359",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2360": [
        "EPSG:2360",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2361": [
        "EPSG:2361",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2362": [
        "EPSG:2362",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2363": [
        "EPSG:2363",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2364": [
        "EPSG:2364",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2365": [
        "EPSG:2365",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2366": [
        "EPSG:2366",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2367": [
        "EPSG:2367",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2368": [
        "EPSG:2368",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2369": [
        "EPSG:2369",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2370": [
        "EPSG:2370",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2371": [
        "EPSG:2371",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2372": [
        "EPSG:2372",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2373": [
        "EPSG:2373",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2374": [
        "EPSG:2374",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2375": [
        "EPSG:2375",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2376": [
        "EPSG:2376",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2377": [
        "EPSG:2377",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2378": [
        "EPSG:2378",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2379": [
        "EPSG:2379",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2380": [
        "EPSG:2380",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2381": [
        "EPSG:2381",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2382": [
        "EPSG:2382",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2383": [
        "EPSG:2383",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2384": [
        "EPSG:2384",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2386": [
        "EPSG:2386",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2387": [
        "EPSG:2387",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2388": [
        "EPSG:2388",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2389": [
        "EPSG:2389",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2390": [
        "EPSG:2390",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs ",
    ],
    "EPSG:2391": [
        "EPSG:2391",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs ",
    ],
    "EPSG:2392": [
        "EPSG:2392",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs ",
    ],
    "EPSG:2394": [
        "EPSG:2394",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=4500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs ",
    ],
    "EPSG:2395": [
        "EPSG:2395",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2396": [
        "EPSG:2396",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2397": [
        "EPSG:2397",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2398": [
        "EPSG:2398",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2399": [
        "EPSG:2399",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2401": [
        "EPSG:2401",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2402": [
        "EPSG:2402",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2403": [
        "EPSG:2403",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2404": [
        "EPSG:2404",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2405": [
        "EPSG:2405",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2406": [
        "EPSG:2406",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2407": [
        "EPSG:2407",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2408": [
        "EPSG:2408",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2409": [
        "EPSG:2409",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2410": [
        "EPSG:2410",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2411": [
        "EPSG:2411",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2412": [
        "EPSG:2412",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2413": [
        "EPSG:2413",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2414": [
        "EPSG:2414",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2415": [
        "EPSG:2415",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2416": [
        "EPSG:2416",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2417": [
        "EPSG:2417",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2418": [
        "EPSG:2418",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2419": [
        "EPSG:2419",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2420": [
        "EPSG:2420",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2421": [
        "EPSG:2421",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2422": [
        "EPSG:2422",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2423": [
        "EPSG:2423",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2424": [
        "EPSG:2424",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2425": [
        "EPSG:2425",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2426": [
        "EPSG:2426",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2427": [
        "EPSG:2427",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2428": [
        "EPSG:2428",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2429": [
        "EPSG:2429",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2430": [
        "EPSG:2430",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2431": [
        "EPSG:2431",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2432": [
        "EPSG:2432",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2433": [
        "EPSG:2433",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2435": [
        "EPSG:2435",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2436": [
        "EPSG:2436",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2437": [
        "EPSG:2437",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2438": [
        "EPSG:2438",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2439": [
        "EPSG:2439",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2440": [
        "EPSG:2440",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2441": [
        "EPSG:2441",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2442": [
        "EPSG:2442",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2443": [
        "EPSG:2443",
        "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2444": [
        "EPSG:2444",
        "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2445": [
        "EPSG:2445",
        "+proj=tmerc +lat_0=36 +lon_0=132.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2446": [
        "EPSG:2446",
        "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2447": [
        "EPSG:2447",
        "+proj=tmerc +lat_0=36 +lon_0=134.3333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2448": [
        "EPSG:2448",
        "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2449": [
        "EPSG:2449",
        "+proj=tmerc +lat_0=36 +lon_0=137.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2451": [
        "EPSG:2451",
        "+proj=tmerc +lat_0=36 +lon_0=139.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2452": [
        "EPSG:2452",
        "+proj=tmerc +lat_0=40 +lon_0=140.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2453": [
        "EPSG:2453",
        "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2454": [
        "EPSG:2454",
        "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2455": [
        "EPSG:2455",
        "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2456": [
        "EPSG:2456",
        "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2457": [
        "EPSG:2457",
        "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2458": [
        "EPSG:2458",
        "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2459": [
        "EPSG:2459",
        "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2460": [
        "EPSG:2460",
        "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2461": [
        "EPSG:2461",
        "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2462": [
        "EPSG:2462",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=-44.183,-0.58,-38.489,-2.3867,-2.7072,3.5196,-8.2703 +units=m +no_defs ",
    ],
    "EPSG:2463": [
        "EPSG:2463",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2464": [
        "EPSG:2464",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2465": [
        "EPSG:2465",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2466": [
        "EPSG:2466",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2467": [
        "EPSG:2467",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2468": [
        "EPSG:2468",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2469": [
        "EPSG:2469",
        "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2470": [
        "EPSG:2470",
        "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2471": [
        "EPSG:2471",
        "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2472": [
        "EPSG:2472",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2473": [
        "EPSG:2473",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2474": [
        "EPSG:2474",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2475": [
        "EPSG:2475",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2476": [
        "EPSG:2476",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2477": [
        "EPSG:2477",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2478": [
        "EPSG:2478",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2479": [
        "EPSG:2479",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2480": [
        "EPSG:2480",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2481": [
        "EPSG:2481",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2482": [
        "EPSG:2482",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2483": [
        "EPSG:2483",
        "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2484": [
        "EPSG:2484",
        "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2485": [
        "EPSG:2485",
        "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2486": [
        "EPSG:2486",
        "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2487": [
        "EPSG:2487",
        "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2488": [
        "EPSG:2488",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2489": [
        "EPSG:2489",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2490": [
        "EPSG:2490",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2491": [
        "EPSG:2491",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2492": [
        "EPSG:2492",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2493": [
        "EPSG:2493",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2494": [
        "EPSG:2494",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2495": [
        "EPSG:2495",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2496": [
        "EPSG:2496",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2497": [
        "EPSG:2497",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2498": [
        "EPSG:2498",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2499": [
        "EPSG:2499",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2500": [
        "EPSG:2500",
        "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2501": [
        "EPSG:2501",
        "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2502": [
        "EPSG:2502",
        "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2503": [
        "EPSG:2503",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2504": [
        "EPSG:2504",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2505": [
        "EPSG:2505",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2506": [
        "EPSG:2506",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2507": [
        "EPSG:2507",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2508": [
        "EPSG:2508",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2509": [
        "EPSG:2509",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2510": [
        "EPSG:2510",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2511": [
        "EPSG:2511",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2512": [
        "EPSG:2512",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2513": [
        "EPSG:2513",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2514": [
        "EPSG:2514",
        "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2515": [
        "EPSG:2515",
        "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2516": [
        "EPSG:2516",
        "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2517": [
        "EPSG:2517",
        "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2518": [
        "EPSG:2518",
        "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2519": [
        "EPSG:2519",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2520": [
        "EPSG:2520",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2521": [
        "EPSG:2521",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2522": [
        "EPSG:2522",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2523": [
        "EPSG:2523",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2524": [
        "EPSG:2524",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2526": [
        "EPSG:2526",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2527": [
        "EPSG:2527",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2528": [
        "EPSG:2528",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2529": [
        "EPSG:2529",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2943": [
        "EPSG:2943",
        "+proj=utm +zone=28 +ellps=intl +towgs84=-289,-124,60,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2530": [
        "EPSG:2530",
        "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2531": [
        "EPSG:2531",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2532": [
        "EPSG:2532",
        "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2533": [
        "EPSG:2533",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2534": [
        "EPSG:2534",
        "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2535": [
        "EPSG:2535",
        "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2536": [
        "EPSG:2536",
        "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2537": [
        "EPSG:2537",
        "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2538": [
        "EPSG:2538",
        "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2539": [
        "EPSG:2539",
        "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2540": [
        "EPSG:2540",
        "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2541": [
        "EPSG:2541",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2542": [
        "EPSG:2542",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2543": [
        "EPSG:2543",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2544": [
        "EPSG:2544",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2545": [
        "EPSG:2545",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2546": [
        "EPSG:2546",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2547": [
        "EPSG:2547",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2548": [
        "EPSG:2548",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2549": [
        "EPSG:2549",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2550": [
        "EPSG:2550",
        "+proj=utm +zone=50 +south +ellps=bessel +towgs84=-404.78,685.68,45.47,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2551": [
        "EPSG:2551",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2552": [
        "EPSG:2552",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2553": [
        "EPSG:2553",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2554": [
        "EPSG:2554",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2555": [
        "EPSG:2555",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2556": [
        "EPSG:2556",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2557": [
        "EPSG:2557",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2558": [
        "EPSG:2558",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2559": [
        "EPSG:2559",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2560": [
        "EPSG:2560",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2561": [
        "EPSG:2561",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2562": [
        "EPSG:2562",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2563": [
        "EPSG:2563",
        "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=46500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2564": [
        "EPSG:2564",
        "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=47500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2565": [
        "EPSG:2565",
        "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=48500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2566": [
        "EPSG:2566",
        "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=49500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2567": [
        "EPSG:2567",
        "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=50500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2568": [
        "EPSG:2568",
        "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=51500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2569": [
        "EPSG:2569",
        "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=52500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2570": [
        "EPSG:2570",
        "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=53500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2571": [
        "EPSG:2571",
        "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=54500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2572": [
        "EPSG:2572",
        "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=55500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2573": [
        "EPSG:2573",
        "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=56500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2574": [
        "EPSG:2574",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=57500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3010": [
        "EPSG:3010",
        "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2575": [
        "EPSG:2575",
        "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=58500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2576": [
        "EPSG:2576",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=59500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2577": [
        "EPSG:2577",
        "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60000000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2578": [
        "EPSG:2578",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=61500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2579": [
        "EPSG:2579",
        "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=62500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2580": [
        "EPSG:2580",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=63500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2581": [
        "EPSG:2581",
        "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=64500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2582": [
        "EPSG:2582",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2583": [
        "EPSG:2583",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2584": [
        "EPSG:2584",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2585": [
        "EPSG:2585",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2586": [
        "EPSG:2586",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2587": [
        "EPSG:2587",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2588": [
        "EPSG:2588",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2589": [
        "EPSG:2589",
        "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2590": [
        "EPSG:2590",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2591": [
        "EPSG:2591",
        "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2592": [
        "EPSG:2592",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3012": [
        "EPSG:3012",
        "+proj=tmerc +lat_0=0 +lon_0=14.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2593": [
        "EPSG:2593",
        "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2594": [
        "EPSG:2594",
        "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2595": [
        "EPSG:2595",
        "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2596": [
        "EPSG:2596",
        "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2597": [
        "EPSG:2597",
        "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2598": [
        "EPSG:2598",
        "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2599": [
        "EPSG:2599",
        "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2600": [
        "EPSG:2600",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2601": [
        "EPSG:2601",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2602": [
        "EPSG:2602",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2603": [
        "EPSG:2603",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2604": [
        "EPSG:2604",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2605": [
        "EPSG:2605",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2606": [
        "EPSG:2606",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2607": [
        "EPSG:2607",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2608": [
        "EPSG:2608",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2609": [
        "EPSG:2609",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2610": [
        "EPSG:2610",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2611": [
        "EPSG:2611",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3013": [
        "EPSG:3013",
        "+proj=tmerc +lat_0=0 +lon_0=15.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2612": [
        "EPSG:2612",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2613": [
        "EPSG:2613",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2614": [
        "EPSG:2614",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2615": [
        "EPSG:2615",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2616": [
        "EPSG:2616",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2617": [
        "EPSG:2617",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2618": [
        "EPSG:2618",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2619": [
        "EPSG:2619",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2620": [
        "EPSG:2620",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3014": [
        "EPSG:3014",
        "+proj=tmerc +lat_0=0 +lon_0=17.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2621": [
        "EPSG:2621",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2622": [
        "EPSG:2622",
        "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2623": [
        "EPSG:2623",
        "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2624": [
        "EPSG:2624",
        "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2625": [
        "EPSG:2625",
        "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2626": [
        "EPSG:2626",
        "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2627": [
        "EPSG:2627",
        "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2628": [
        "EPSG:2628",
        "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2629": [
        "EPSG:2629",
        "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2630": [
        "EPSG:2630",
        "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2631": [
        "EPSG:2631",
        "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2632": [
        "EPSG:2632",
        "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2633": [
        "EPSG:2633",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2634": [
        "EPSG:2634",
        "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2635": [
        "EPSG:2635",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2636": [
        "EPSG:2636",
        "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2637": [
        "EPSG:2637",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2638": [
        "EPSG:2638",
        "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3016": [
        "EPSG:3016",
        "+proj=tmerc +lat_0=0 +lon_0=20.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2639": [
        "EPSG:2639",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2640": [
        "EPSG:2640",
        "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2641": [
        "EPSG:2641",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2642": [
        "EPSG:2642",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2643": [
        "EPSG:2643",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2644": [
        "EPSG:2644",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2645": [
        "EPSG:2645",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2646": [
        "EPSG:2646",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2647": [
        "EPSG:2647",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2973": [
        "EPSG:2973",
        "+proj=utm +zone=20 +ellps=intl +towgs84=186,482,151,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2648": [
        "EPSG:2648",
        "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2649": [
        "EPSG:2649",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2650": [
        "EPSG:2650",
        "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2651": [
        "EPSG:2651",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2652": [
        "EPSG:2652",
        "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2653": [
        "EPSG:2653",
        "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2654": [
        "EPSG:2654",
        "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2655": [
        "EPSG:2655",
        "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2656": [
        "EPSG:2656",
        "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:3017": [
        "EPSG:3017",
        "+proj=tmerc +lat_0=0 +lon_0=21.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2657": [
        "EPSG:2657",
        "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2658": [
        "EPSG:2658",
        "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2659": [
        "EPSG:2659",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2660": [
        "EPSG:2660",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2661": [
        "EPSG:2661",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2662": [
        "EPSG:2662",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2663": [
        "EPSG:2663",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2664": [
        "EPSG:2664",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2665": [
        "EPSG:2665",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:3018": [
        "EPSG:3018",
        "+proj=tmerc +lat_0=0 +lon_0=23.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2666": [
        "EPSG:2666",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2667": [
        "EPSG:2667",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2668": [
        "EPSG:2668",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2669": [
        "EPSG:2669",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2670": [
        "EPSG:2670",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2671": [
        "EPSG:2671",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2672": [
        "EPSG:2672",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2673": [
        "EPSG:2673",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2674": [
        "EPSG:2674",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:3029": [
        "EPSG:3029",
        "+proj=tmerc +lat_0=0 +lon_0=20.30827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:2675": [
        "EPSG:2675",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2676": [
        "EPSG:2676",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2677": [
        "EPSG:2677",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2678": [
        "EPSG:2678",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2679": [
        "EPSG:2679",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2680": [
        "EPSG:2680",
        "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=46500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2681": [
        "EPSG:2681",
        "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=47500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2682": [
        "EPSG:2682",
        "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=48500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2683": [
        "EPSG:2683",
        "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=49500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:3030": [
        "EPSG:3030",
        "+proj=tmerc +lat_0=0 +lon_0=22.55827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:2684": [
        "EPSG:2684",
        "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=50500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2685": [
        "EPSG:2685",
        "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=51500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2686": [
        "EPSG:2686",
        "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=52500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2687": [
        "EPSG:2687",
        "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=53500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2688": [
        "EPSG:2688",
        "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=54500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2689": [
        "EPSG:2689",
        "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=55500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2690": [
        "EPSG:2690",
        "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=56500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2691": [
        "EPSG:2691",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=57500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2692": [
        "EPSG:2692",
        "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=58500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:3031": [
        "EPSG:3031",
        "+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2693": [
        "EPSG:2693",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=59500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2694": [
        "EPSG:2694",
        "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60000000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2695": [
        "EPSG:2695",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=61500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2696": [
        "EPSG:2696",
        "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=62500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2697": [
        "EPSG:2697",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=63500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2698": [
        "EPSG:2698",
        "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=64500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2699": [
        "EPSG:2699",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2700": [
        "EPSG:2700",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2701": [
        "EPSG:2701",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2702": [
        "EPSG:2702",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2703": [
        "EPSG:2703",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2704": [
        "EPSG:2704",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2705": [
        "EPSG:2705",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2706": [
        "EPSG:2706",
        "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2707": [
        "EPSG:2707",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2708": [
        "EPSG:2708",
        "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2709": [
        "EPSG:2709",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2710": [
        "EPSG:2710",
        "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2711": [
        "EPSG:2711",
        "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2712": [
        "EPSG:2712",
        "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2713": [
        "EPSG:2713",
        "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2714": [
        "EPSG:2714",
        "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2715": [
        "EPSG:2715",
        "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2716": [
        "EPSG:2716",
        "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2717": [
        "EPSG:2717",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2718": [
        "EPSG:2718",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2719": [
        "EPSG:2719",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2720": [
        "EPSG:2720",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2721": [
        "EPSG:2721",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2722": [
        "EPSG:2722",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2723": [
        "EPSG:2723",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2724": [
        "EPSG:2724",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2725": [
        "EPSG:2725",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2726": [
        "EPSG:2726",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2727": [
        "EPSG:2727",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2728": [
        "EPSG:2728",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2729": [
        "EPSG:2729",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2730": [
        "EPSG:2730",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2731": [
        "EPSG:2731",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2732": [
        "EPSG:2732",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2733": [
        "EPSG:2733",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2734": [
        "EPSG:2734",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2735": [
        "EPSG:2735",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2736": [
        "EPSG:2736",
        "+proj=utm +zone=36 +south +ellps=clrk66 +towgs84=-80,-100,-228,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2737": [
        "EPSG:2737",
        "+proj=utm +zone=37 +south +ellps=clrk66 +towgs84=-80,-100,-228,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2738": [
        "EPSG:2738",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2739": [
        "EPSG:2739",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2740": [
        "EPSG:2740",
        "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2741": [
        "EPSG:2741",
        "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2742": [
        "EPSG:2742",
        "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2743": [
        "EPSG:2743",
        "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2744": [
        "EPSG:2744",
        "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2745": [
        "EPSG:2745",
        "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2746": [
        "EPSG:2746",
        "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2747": [
        "EPSG:2747",
        "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2748": [
        "EPSG:2748",
        "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2749": [
        "EPSG:2749",
        "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2750": [
        "EPSG:2750",
        "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2751": [
        "EPSG:2751",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2752": [
        "EPSG:2752",
        "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2753": [
        "EPSG:2753",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2754": [
        "EPSG:2754",
        "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2755": [
        "EPSG:2755",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2756": [
        "EPSG:2756",
        "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2757": [
        "EPSG:2757",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2758": [
        "EPSG:2758",
        "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:2759": [
        "EPSG:2759",
        "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2760": [
        "EPSG:2760",
        "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2761": [
        "EPSG:2761",
        "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2762": [
        "EPSG:2762",
        "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2763": [
        "EPSG:2763",
        "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2764": [
        "EPSG:2764",
        "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2765": [
        "EPSG:2765",
        "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2766": [
        "EPSG:2766",
        "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2767": [
        "EPSG:2767",
        "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2769": [
        "EPSG:2769",
        "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2770": [
        "EPSG:2770",
        "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2771": [
        "EPSG:2771",
        "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2772": [
        "EPSG:2772",
        "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2773": [
        "EPSG:2773",
        "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2774": [
        "EPSG:2774",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2775": [
        "EPSG:2775",
        "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2776": [
        "EPSG:2776",
        "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4384": ["EPSG:4384", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:2777": [
        "EPSG:2777",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2778": [
        "EPSG:2778",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2779": [
        "EPSG:2779",
        "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2780": [
        "EPSG:2780",
        "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2781": [
        "EPSG:2781",
        "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2782": [
        "EPSG:2782",
        "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2783": [
        "EPSG:2783",
        "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2784": [
        "EPSG:2784",
        "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2785": [
        "EPSG:2785",
        "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2786": [
        "EPSG:2786",
        "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2787": [
        "EPSG:2787",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2788": [
        "EPSG:2788",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2789": [
        "EPSG:2789",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2791": [
        "EPSG:2791",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2792": [
        "EPSG:2792",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2793": [
        "EPSG:2793",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2794": [
        "EPSG:2794",
        "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2795": [
        "EPSG:2795",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2796": [
        "EPSG:2796",
        "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2797": [
        "EPSG:2797",
        "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2798": [
        "EPSG:2798",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2799": [
        "EPSG:2799",
        "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2800": [
        "EPSG:2800",
        "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2801": [
        "EPSG:2801",
        "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2802": [
        "EPSG:2802",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2803": [
        "EPSG:2803",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2804": [
        "EPSG:2804",
        "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2805": [
        "EPSG:2805",
        "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2806": [
        "EPSG:2806",
        "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2807": [
        "EPSG:2807",
        "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=8000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2808": [
        "EPSG:2808",
        "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=6000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2809": [
        "EPSG:2809",
        "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=4000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2810": [
        "EPSG:2810",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4387": ["EPSG:4387", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2813": [
        "EPSG:2813",
        "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2814": [
        "EPSG:2814",
        "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2818": [
        "EPSG:2818",
        "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2820": [
        "EPSG:2820",
        "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2821": [
        "EPSG:2821",
        "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2822": [
        "EPSG:2822",
        "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2823": [
        "EPSG:2823",
        "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2824": [
        "EPSG:2824",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2825": [
        "EPSG:2825",
        "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2826": [
        "EPSG:2826",
        "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2827": [
        "EPSG:2827",
        "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2830": [
        "EPSG:2830",
        "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2831": [
        "EPSG:2831",
        "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2832": [
        "EPSG:2832",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2833": [
        "EPSG:2833",
        "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2834": [
        "EPSG:2834",
        "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2835": [
        "EPSG:2835",
        "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2836": [
        "EPSG:2836",
        "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4087": [
        "EPSG:4087",
        "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2837": [
        "EPSG:2837",
        "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2838": [
        "EPSG:2838",
        "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2839": [
        "EPSG:2839",
        "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2840": [
        "EPSG:2840",
        "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2841": [
        "EPSG:2841",
        "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2842": [
        "EPSG:2842",
        "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2843": [
        "EPSG:2843",
        "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2844": [
        "EPSG:2844",
        "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4389": ["EPSG:4389", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2846": [
        "EPSG:2846",
        "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2847": [
        "EPSG:2847",
        "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2848": [
        "EPSG:2848",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2849": [
        "EPSG:2849",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2850": [
        "EPSG:2850",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2851": [
        "EPSG:2851",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6133": ["EPSG:6133", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2853": [
        "EPSG:2853",
        "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2854": [
        "EPSG:2854",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2855": [
        "EPSG:2855",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2856": [
        "EPSG:2856",
        "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2857": [
        "EPSG:2857",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2858": [
        "EPSG:2858",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2859": [
        "EPSG:2859",
        "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2860": [
        "EPSG:2860",
        "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4465": ["EPSG:4465", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2861": [
        "EPSG:2861",
        "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2862": [
        "EPSG:2862",
        "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2863": [
        "EPSG:2863",
        "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2864": [
        "EPSG:2864",
        "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2865": [
        "EPSG:2865",
        "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2866": [
        "EPSG:2866",
        "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2867": [
        "EPSG:2867",
        "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2868": [
        "EPSG:2868",
        "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2869": [
        "EPSG:2869",
        "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2870": [
        "EPSG:2870",
        "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2871": [
        "EPSG:2871",
        "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2874": [
        "EPSG:2874",
        "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2876": [
        "EPSG:2876",
        "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2885": [
        "EPSG:2885",
        "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2877": [
        "EPSG:2877",
        "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2878": [
        "EPSG:2878",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2879": [
        "EPSG:2879",
        "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096012192 +y_0=152400.3048006096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2880": [
        "EPSG:2880",
        "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2881": [
        "EPSG:2881",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2882": [
        "EPSG:2882",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2883": [
        "EPSG:2883",
        "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2884": [
        "EPSG:2884",
        "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:4468": ["EPSG:4468", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2886": [
        "EPSG:2886",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2887": [
        "EPSG:2887",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2888": [
        "EPSG:2888",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2889": [
        "EPSG:2889",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249364.9987299975 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2890": [
        "EPSG:2890",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249364.9987299975 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2891": [
        "EPSG:2891",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2892": [
        "EPSG:2892",
        "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000.0001016001 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2893": [
        "EPSG:2893",
        "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=399999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:4473": ["EPSG:4473", "+proj=geocent +ellps=intl +units=m +no_defs "],
    "EPSG:2894": [
        "EPSG:2894",
        "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000.0001016002 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2895": [
        "EPSG:2895",
        "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2896": [
        "EPSG:2896",
        "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2897": [
        "EPSG:2897",
        "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2898": [
        "EPSG:2898",
        "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2899": [
        "EPSG:2899",
        "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2901": [
        "EPSG:2901",
        "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2904": [
        "EPSG:2904",
        "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2908": [
        "EPSG:2908",
        "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2909": [
        "EPSG:2909",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:4569": [
        "EPSG:4569",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:2910": [
        "EPSG:2910",
        "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2912": [
        "EPSG:2912",
        "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2913": [
        "EPSG:2913",
        "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2914": [
        "EPSG:2914",
        "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2915": [
        "EPSG:2915",
        "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2916": [
        "EPSG:2916",
        "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000.0001016002 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2917": [
        "EPSG:2917",
        "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2918": [
        "EPSG:2918",
        "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=699999.9998983998 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2919": [
        "EPSG:2919",
        "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2920": [
        "EPSG:2920",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000.0000000001 +y_0=5000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2921": [
        "EPSG:2921",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=999999.9999960001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2922": [
        "EPSG:2922",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=1999999.999992 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2923": [
        "EPSG:2923",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.0001504 +y_0=2999999.999988 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2924": [
        "EPSG:2924",
        "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2933": [
        "EPSG:2933",
        "+proj=utm +zone=50 +south +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2925": [
        "EPSG:2925",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2928": [
        "EPSG:2928",
        "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2929": [
        "EPSG:2929",
        "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2930": [
        "EPSG:2930",
        "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2931": [
        "EPSG:2931",
        "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.9996 +x_0=500000 +y_0=0 +a=6378249.2 +b=6356515 +towgs84=-106,-87,188,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2932": [
        "EPSG:2932",
        "+proj=tmerc +lat_0=24.45 +lon_0=51.21666666666667 +k=0.99999 +x_0=200000 +y_0=300000 +ellps=intl +towgs84=-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065 +units=m +no_defs ",
    ],
    "EPSG:2934": [
        "EPSG:2934",
        "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +pm=jakarta +units=m +no_defs ",
    ],
    "EPSG:2935": [
        "EPSG:2935",
        "+proj=tmerc +lat_0=0.1166666666666667 +lon_0=41.53333333333333 +k=1 +x_0=1300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2936": [
        "EPSG:2936",
        "+proj=tmerc +lat_0=0.1166666666666667 +lon_0=44.53333333333333 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2937": [
        "EPSG:2937",
        "+proj=tmerc +lat_0=0.1166666666666667 +lon_0=47.53333333333333 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2938": [
        "EPSG:2938",
        "+proj=tmerc +lat_0=0.1166666666666667 +lon_0=50.53333333333333 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2939": [
        "EPSG:2939",
        "+proj=tmerc +lat_0=0.1333333333333333 +lon_0=50.76666666666667 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2940": [
        "EPSG:2940",
        "+proj=tmerc +lat_0=0.1333333333333333 +lon_0=53.76666666666667 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2941": [
        "EPSG:2941",
        "+proj=tmerc +lat_0=0.1333333333333333 +lon_0=56.76666666666667 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:2942": [
        "EPSG:2942",
        "+proj=utm +zone=28 +ellps=intl +towgs84=-499,-249,314,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2944": [
        "EPSG:2944",
        "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2945": [
        "EPSG:2945",
        "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2946": [
        "EPSG:2946",
        "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2947": [
        "EPSG:2947",
        "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2948": [
        "EPSG:2948",
        "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2949": [
        "EPSG:2949",
        "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2950": [
        "EPSG:2950",
        "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2951": [
        "EPSG:2951",
        "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2952": [
        "EPSG:2952",
        "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4570": [
        "EPSG:4570",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:2954": [
        "EPSG:2954",
        "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2955": [
        "EPSG:2955",
        "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2957": [
        "EPSG:2957",
        "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2959": [
        "EPSG:2959",
        "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2960": [
        "EPSG:2960",
        "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2961": [
        "EPSG:2961",
        "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2962": [
        "EPSG:2962",
        "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2964": [
        "EPSG:2964",
        "+proj=aea +lat_1=55 +lat_2=65 +lat_0=50 +lon_0=-154 +x_0=0 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:2965": [
        "EPSG:2965",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249999.9998983998 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2966": [
        "EPSG:2966",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998983998 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:2967": [
        "EPSG:2967",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2968": [
        "EPSG:2968",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:2969": [
        "EPSG:2969",
        "+proj=utm +zone=20 +ellps=intl +towgs84=137,248,-430,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2970": [
        "EPSG:2970",
        "+proj=utm +zone=20 +ellps=intl +towgs84=-467,-16,-300,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2971": [
        "EPSG:2971",
        "+proj=utm +zone=22 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2972": [
        "EPSG:2972",
        "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2975": [
        "EPSG:2975",
        "+proj=utm +zone=40 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2976": [
        "EPSG:2976",
        "+proj=utm +zone=6 +south +ellps=intl +towgs84=162,117,154,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2977": [
        "EPSG:2977",
        "+proj=utm +zone=5 +south +ellps=intl +towgs84=72.438,345.918,79.486,1.6045,0.8823,0.5565,1.3746 +units=m +no_defs ",
    ],
    "EPSG:2978": [
        "EPSG:2978",
        "+proj=utm +zone=7 +south +ellps=intl +towgs84=84,274,65,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2979": [
        "EPSG:2979",
        "+proj=utm +zone=42 +south +ellps=intl +towgs84=145,-187,103,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2980": [
        "EPSG:2980",
        "+proj=utm +zone=38 +south +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2981": [
        "EPSG:2981",
        "+proj=utm +zone=58 +south +ellps=intl +towgs84=335.47,222.58,-230.94,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2982": [
        "EPSG:2982",
        "+proj=utm +zone=58 +south +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2983": [
        "EPSG:2983",
        "+proj=utm +zone=58 +south +ellps=intl +towgs84=-122.383,-188.696,103.344,3.5107,-4.9668,-5.7047,4.4798 +units=m +no_defs ",
    ],
    "EPSG:2995": [
        "EPSG:2995",
        "+proj=utm +zone=58 +south +ellps=intl +towgs84=287.58,177.78,-135.41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2984": [
        "EPSG:2984",
        "+proj=lcc +lat_1=-20.66666666666667 +lat_2=-22.33333333333333 +lat_0=-21.5 +lon_0=166 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2987": [
        "EPSG:2987",
        "+proj=utm +zone=21 +ellps=clrk66 +towgs84=30,430,368,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2988": [
        "EPSG:2988",
        "+proj=utm +zone=1 +south +ellps=intl +towgs84=253,-132,-127,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2990": [
        "EPSG:2990",
        "+proj=tmerc +lat_0=-21.11666666666667 +lon_0=55.53333333333333 +k=1 +x_0=50000 +y_0=160000 +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2991": [
        "EPSG:2991",
        "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:2992": [
        "EPSG:2992",
        "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=399999.9999984 +y_0=0 +datum=NAD83 +units=ft +no_defs ",
    ],
    "EPSG:2993": [
        "EPSG:2993",
        "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2994": [
        "EPSG:2994",
        "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:2996": [
        "EPSG:2996",
        "+proj=utm +zone=58 +south +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2997": [
        "EPSG:2997",
        "+proj=utm +zone=58 +south +ellps=intl +towgs84=-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002 +units=m +no_defs ",
    ],
    "EPSG:2998": [
        "EPSG:2998",
        "+proj=utm +zone=58 +south +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2999": [
        "EPSG:2999",
        "+proj=utm +zone=38 +south +ellps=intl +towgs84=-963,510,-359,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3000": [
        "EPSG:3000",
        "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3001": [
        "EPSG:3001",
        "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3002": [
        "EPSG:3002",
        "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3019": [
        "EPSG:3019",
        "+proj=tmerc +lat_0=0 +lon_0=11.30827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs ",
    ],
    "EPSG:3020": [
        "EPSG:3020",
        "+proj=tmerc +lat_0=0 +lon_0=13.55827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs ",
    ],
    "EPSG:3023": [
        "EPSG:3023",
        "+proj=tmerc +lat_0=0 +lon_0=20.30827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs ",
    ],
    "EPSG:3024": [
        "EPSG:3024",
        "+proj=tmerc +lat_0=0 +lon_0=22.55827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs ",
    ],
    "EPSG:3025": [
        "EPSG:3025",
        "+proj=tmerc +lat_0=0 +lon_0=11.30827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:3026": [
        "EPSG:3026",
        "+proj=tmerc +lat_0=0 +lon_0=13.55827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:3028": [
        "EPSG:3028",
        "+proj=tmerc +lat_0=0 +lon_0=18.05827777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:3032": [
        "EPSG:3032",
        "+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=70 +k=1 +x_0=6000000 +y_0=6000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3033": [
        "EPSG:3033",
        "+proj=lcc +lat_1=-68.5 +lat_2=-74.5 +lat_0=-50 +lon_0=70 +x_0=6000000 +y_0=6000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3037": [
        "EPSG:3037",
        "+proj=utm +zone=37 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3038": [
        "EPSG:3038",
        "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3039": [
        "EPSG:3039",
        "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3040": [
        "EPSG:3040",
        "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3041": [
        "EPSG:3041",
        "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3048": [
        "EPSG:3048",
        "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3050": [
        "EPSG:3050",
        "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3051": [
        "EPSG:3051",
        "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3054": [
        "EPSG:3054",
        "+proj=utm +zone=26 +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3055": [
        "EPSG:3055",
        "+proj=utm +zone=27 +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3056": [
        "EPSG:3056",
        "+proj=utm +zone=28 +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4556": ["EPSG:4556", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3058": [
        "EPSG:3058",
        "+proj=tmerc +lat_0=0 +lon_0=-8.5 +k=1 +x_0=50000 +y_0=-7800000 +ellps=intl +towgs84=982.6087,552.753,-540.873,6.6816266,-31.6114924,-19.84816,16.805 +units=m +no_defs ",
    ],
    "EPSG:3060": [
        "EPSG:3060",
        "+proj=utm +zone=58 +south +ellps=intl +towgs84=-11.64,-348.6,291.98,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3061": [
        "EPSG:3061",
        "+proj=utm +zone=28 +ellps=intl +towgs84=-502.862,-247.438,312.724,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3063": [
        "EPSG:3063",
        "+proj=utm +zone=26 +ellps=intl +towgs84=-106.226,166.366,-37.893,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3066": [
        "EPSG:3066",
        "+proj=tmerc +lat_0=0 +lon_0=37 +k=0.9998 +x_0=500000 +y_0=-3000000 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3068": [
        "EPSG:3068",
        "+proj=cass +lat_0=52.41864827777778 +lon_0=13.62720366666667 +x_0=40000 +y_0=10000 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:3069": [
        "EPSG:3069",
        "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=500000 +y_0=-4500000 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3072": [
        "EPSG:3072",
        "+proj=tmerc +lat_0=43.83333333333334 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3073": [
        "EPSG:3073",
        "+proj=tmerc +lat_0=43 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3074": [
        "EPSG:3074",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3075": [
        "EPSG:3075",
        "+proj=tmerc +lat_0=43.83333333333334 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3076": [
        "EPSG:3076",
        "+proj=tmerc +lat_0=43 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3077": [
        "EPSG:3077",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3078": [
        "EPSG:3078",
        "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +no_uoff +gamma=337.25556 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3079": [
        "EPSG:3079",
        "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +no_uoff +gamma=337.25556 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3080": [
        "EPSG:3080",
        "+proj=lcc +lat_1=27.41666666666667 +lat_2=34.91666666666666 +lat_0=31.16666666666667 +lon_0=-100 +x_0=914400 +y_0=914400 +datum=NAD27 +units=ft +no_defs ",
    ],
    "EPSG:3081": [
        "EPSG:3081",
        "+proj=lcc +lat_1=27.41666666666667 +lat_2=34.91666666666666 +lat_0=31.16666666666667 +lon_0=-100 +x_0=1000000 +y_0=1000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3082": [
        "EPSG:3082",
        "+proj=lcc +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=5000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3083": [
        "EPSG:3083",
        "+proj=aea +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=6000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3084": [
        "EPSG:3084",
        "+proj=lcc +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3103": [
        "EPSG:3103",
        "+proj=utm +zone=28 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3085": [
        "EPSG:3085",
        "+proj=aea +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3086": [
        "EPSG:3086",
        "+proj=aea +lat_1=24 +lat_2=31.5 +lat_0=24 +lon_0=-84 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3087": [
        "EPSG:3087",
        "+proj=aea +lat_1=24 +lat_2=31.5 +lat_0=24 +lon_0=-84 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3088": [
        "EPSG:3088",
        "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3089": [
        "EPSG:3089",
        "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=999999.9998983998 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3090": [
        "EPSG:3090",
        "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3091": [
        "EPSG:3091",
        "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3092": [
        "EPSG:3092",
        "+proj=utm +zone=51 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3369": [
        "EPSG:3369",
        "+proj=utm +zone=30 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3093": [
        "EPSG:3093",
        "+proj=utm +zone=52 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3094": [
        "EPSG:3094",
        "+proj=utm +zone=53 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3095": [
        "EPSG:3095",
        "+proj=utm +zone=54 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3096": [
        "EPSG:3096",
        "+proj=utm +zone=55 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3097": [
        "EPSG:3097",
        "+proj=utm +zone=51 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3099": [
        "EPSG:3099",
        "+proj=utm +zone=53 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3100": [
        "EPSG:3100",
        "+proj=utm +zone=54 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3101": [
        "EPSG:3101",
        "+proj=utm +zone=55 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3102": [
        "EPSG:3102",
        "+proj=lcc +lat_1=-14.26666666666667 +lat_0=-14.26666666666667 +lon_0=-170 +k_0=1 +x_0=152400.3048006096 +y_0=95169.31165862332 +ellps=clrk66 +towgs84=-115,118,426,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3104": [
        "EPSG:3104",
        "+proj=utm +zone=29 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3105": [
        "EPSG:3105",
        "+proj=utm +zone=30 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3106": [
        "EPSG:3106",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=0 +a=6377276.345 +b=6356075.41314024 +towgs84=283.7,735.9,261.1,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3107": [
        "EPSG:3107",
        "+proj=lcc +lat_1=-28 +lat_2=-36 +lat_0=-32 +lon_0=135 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3108": [
        "EPSG:3108",
        "+proj=tmerc +lat_0=49.5 +lon_0=-2.416666666666667 +k=0.999997 +x_0=47000 +y_0=50000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3109": [
        "EPSG:3109",
        "+proj=tmerc +lat_0=49.225 +lon_0=-2.135 +k=0.9999999000000001 +x_0=40000 +y_0=70000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3110": [
        "EPSG:3110",
        "+proj=lcc +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145 +x_0=2500000 +y_0=4500000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:3114": [
        "EPSG:3114",
        "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-80.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3117": [
        "EPSG:3117",
        "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-71.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3118": [
        "EPSG:3118",
        "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-68.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3119": [
        "EPSG:3119",
        "+proj=tmerc +lat_0=0 +lon_0=10.5 +k=0.999 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=-206.1,-174.7,-87.7,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3120": [
        "EPSG:3120",
        "+proj=sterea +lat_0=50.625 +lon_0=21.08333333333333 +k=0.9998 +x_0=4637000 +y_0=5467000 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3121": [
        "EPSG:3121",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs ",
    ],
    "EPSG:3122": [
        "EPSG:3122",
        "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs ",
    ],
    "EPSG:3123": [
        "EPSG:3123",
        "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs ",
    ],
    "EPSG:3124": [
        "EPSG:3124",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs ",
    ],
    "EPSG:3125": [
        "EPSG:3125",
        "+proj=tmerc +lat_0=0 +lon_0=125 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs ",
    ],
    "EPSG:3126": [
        "EPSG:3126",
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3127": [
        "EPSG:3127",
        "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3128": [
        "EPSG:3128",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3129": [
        "EPSG:3129",
        "+proj=tmerc +lat_0=0 +lon_0=22 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3130": [
        "EPSG:3130",
        "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3131": [
        "EPSG:3131",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3133": [
        "EPSG:3133",
        "+proj=tmerc +lat_0=0 +lon_0=26 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3134": [
        "EPSG:3134",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3135": [
        "EPSG:3135",
        "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3136": [
        "EPSG:3136",
        "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3137": [
        "EPSG:3137",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3138": [
        "EPSG:3138",
        "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3140": [
        "EPSG:3140",
        "+proj=cass +lat_0=-18 +lon_0=178 +x_0=109435.392 +y_0=141622.272 +a=6378306.3696 +b=6356571.996 +towgs84=98,390,-22,0,0,0,0 +to_meter=0.201168 +no_defs ",
    ],
    "EPSG:3141": [
        "EPSG:3141",
        "+proj=utm +zone=60 +south +ellps=intl +towgs84=265.025,384.929,-194.046,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3142": [
        "EPSG:3142",
        "+proj=utm +zone=1 +south +ellps=intl +towgs84=265.025,384.929,-194.046,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3143": [
        "EPSG:3143",
        "+proj=tmerc +lat_0=-17 +lon_0=178.75 +k=0.99985 +x_0=2000000 +y_0=4000000 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:3146": [
        "EPSG:3146",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3147": [
        "EPSG:3147",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3148": [
        "EPSG:3148",
        "+proj=utm +zone=48 +a=6377276.345 +b=6356075.41314024 +towgs84=198,881,317,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3149": [
        "EPSG:3149",
        "+proj=utm +zone=49 +a=6377276.345 +b=6356075.41314024 +towgs84=198,881,317,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3150": [
        "EPSG:3150",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:3151": [
        "EPSG:3151",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:3152": [
        "EPSG:3152",
        "+proj=tmerc +lat_0=0 +lon_0=18.05779 +k=0.99999425 +x_0=100178.1808 +y_0=-6500614.7836 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4882": ["EPSG:4882", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3154": [
        "EPSG:3154",
        "+proj=utm +zone=7 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3156": [
        "EPSG:3156",
        "+proj=utm +zone=9 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3161": [
        "EPSG:3161",
        "+proj=lcc +lat_1=44.5 +lat_2=53.5 +lat_0=0 +lon_0=-85 +x_0=930000 +y_0=6430000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3162": [
        "EPSG:3162",
        "+proj=lcc +lat_1=44.5 +lat_2=53.5 +lat_0=0 +lon_0=-85 +x_0=930000 +y_0=6430000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3172": [
        "EPSG:3172",
        "+proj=utm +zone=59 +south +ellps=intl +towgs84=287.58,177.78,-135.41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3164": [
        "EPSG:3164",
        "+proj=utm +zone=58 +south +ellps=WGS84 +towgs84=-56.263,16.136,-22.856,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3165": [
        "EPSG:3165",
        "+proj=lcc +lat_1=-22.24469175 +lat_2=-22.29469175 +lat_0=-22.26969175 +lon_0=166.44242575 +x_0=0.66 +y_0=1.02 +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3166": [
        "EPSG:3166",
        "+proj=lcc +lat_1=-22.24472222222222 +lat_2=-22.29472222222222 +lat_0=-22.26972222222222 +lon_0=166.4425 +x_0=8.313000000000001 +y_0=-2.354 +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3167": [
        "EPSG:3167",
        "+proj=omerc +lat_0=4 +lonc=102.25 +alpha=323.0257905 +k=0.99984 +x_0=40000 +y_0=0 +no_uoff +gamma=323.1301023611111 +a=6377295.664 +b=6356094.667915204 +to_meter=20.116756 +no_defs ",
    ],
    "EPSG:3168": [
        "EPSG:3168",
        "+proj=omerc +lat_0=4 +lonc=102.25 +alpha=323.0257905 +k=0.99984 +x_0=804670.24 +y_0=0 +no_uoff +gamma=323.1301023611111 +a=6377295.664 +b=6356094.667915204 +units=m +no_defs ",
    ],
    "EPSG:3169": [
        "EPSG:3169",
        "+proj=utm +zone=57 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3170": [
        "EPSG:3170",
        "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3171": [
        "EPSG:3171",
        "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3174": [
        "EPSG:3174",
        "+proj=aea +lat_1=42.122774 +lat_2=49.01518 +lat_0=45.568977 +lon_0=-84.455955 +x_0=1000000 +y_0=1000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3175": [
        "EPSG:3175",
        "+proj=aea +lat_1=42.122774 +lat_2=49.01518 +lat_0=45.568977 +lon_0=-83.248627 +x_0=1000000 +y_0=1000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3176": [
        "EPSG:3176",
        "+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9996 +x_0=500000 +y_0=0 +a=6377276.345 +b=6356075.41314024 +towgs84=198,881,317,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3177": [
        "EPSG:3177",
        "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.9965000000000001 +x_0=1000000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3178": [
        "EPSG:3178",
        "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3179": [
        "EPSG:3179",
        "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3180": [
        "EPSG:3180",
        "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3181": [
        "EPSG:3181",
        "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3183": [
        "EPSG:3183",
        "+proj=utm +zone=23 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3184": [
        "EPSG:3184",
        "+proj=utm +zone=24 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3185": [
        "EPSG:3185",
        "+proj=utm +zone=25 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3186": [
        "EPSG:3186",
        "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3187": [
        "EPSG:3187",
        "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3188": [
        "EPSG:3188",
        "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3189": [
        "EPSG:3189",
        "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3190": [
        "EPSG:3190",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3191": [
        "EPSG:3191",
        "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3192": [
        "EPSG:3192",
        "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3193": [
        "EPSG:3193",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3194": [
        "EPSG:3194",
        "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3195": [
        "EPSG:3195",
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3196": [
        "EPSG:3196",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3197": [
        "EPSG:3197",
        "+proj=tmerc +lat_0=0 +lon_0=23 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3198": [
        "EPSG:3198",
        "+proj=tmerc +lat_0=0 +lon_0=25 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3199": [
        "EPSG:3199",
        "+proj=utm +zone=32 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3200": [
        "EPSG:3200",
        "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078000001 +x_0=1500000 +y_0=1166200 +ellps=clrk80 +towgs84=-241.54,-163.64,396.06,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3201": [
        "EPSG:3201",
        "+proj=utm +zone=33 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3202": [
        "EPSG:3202",
        "+proj=utm +zone=34 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4884": ["EPSG:4884", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3203": [
        "EPSG:3203",
        "+proj=utm +zone=35 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3204": [
        "EPSG:3204",
        "+proj=lcc +lat_1=-60.66666666666666 +lat_2=-63.33333333333334 +lat_0=-90 +lon_0=-66 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3205": [
        "EPSG:3205",
        "+proj=lcc +lat_1=-60.66666666666666 +lat_2=-63.33333333333334 +lat_0=-90 +lon_0=-54 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3206": [
        "EPSG:3206",
        "+proj=lcc +lat_1=-60.66666666666666 +lat_2=-63.33333333333334 +lat_0=-90 +lon_0=-42 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3207": [
        "EPSG:3207",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=-174 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3208": [
        "EPSG:3208",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=-66 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3209": [
        "EPSG:3209",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=-54 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3210": [
        "EPSG:3210",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=42 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3211": [
        "EPSG:3211",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=54 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4886": ["EPSG:4886", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:3212": [
        "EPSG:3212",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=66 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3213": [
        "EPSG:3213",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=78 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3214": [
        "EPSG:3214",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3215": [
        "EPSG:3215",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=102 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3216": [
        "EPSG:3216",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=114 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3217": [
        "EPSG:3217",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=126 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3218": [
        "EPSG:3218",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=138 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3219": [
        "EPSG:3219",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3220": [
        "EPSG:3220",
        "+proj=lcc +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +lat_0=-90 +lon_0=162 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3221": [
        "EPSG:3221",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-102 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3222": [
        "EPSG:3222",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3223": [
        "EPSG:3223",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-78 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3224": [
        "EPSG:3224",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-66 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3225": [
        "EPSG:3225",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-18 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3226": [
        "EPSG:3226",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=-6 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3227": [
        "EPSG:3227",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=6 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3228": [
        "EPSG:3228",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=18 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3229": [
        "EPSG:3229",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=30 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3230": [
        "EPSG:3230",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=42 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3231": [
        "EPSG:3231",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=54 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3232": [
        "EPSG:3232",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=66 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3233": [
        "EPSG:3233",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=78 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3234": [
        "EPSG:3234",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3235": [
        "EPSG:3235",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=102 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3236": [
        "EPSG:3236",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=114 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3237": [
        "EPSG:3237",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=126 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3238": [
        "EPSG:3238",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=138 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3239": [
        "EPSG:3239",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3240": [
        "EPSG:3240",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=162 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3241": [
        "EPSG:3241",
        "+proj=lcc +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +lat_0=-90 +lon_0=174 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3242": [
        "EPSG:3242",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-153 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3243": [
        "EPSG:3243",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-135 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3244": [
        "EPSG:3244",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-117 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3245": [
        "EPSG:3245",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-99 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3246": [
        "EPSG:3246",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-81 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3247": [
        "EPSG:3247",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-63 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3248": [
        "EPSG:3248",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-27 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3249": [
        "EPSG:3249",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=-9 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3250": [
        "EPSG:3250",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=9 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3251": [
        "EPSG:3251",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=27 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3252": [
        "EPSG:3252",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=45 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3253": [
        "EPSG:3253",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=63 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3254": [
        "EPSG:3254",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=81 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3255": [
        "EPSG:3255",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=99 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3256": [
        "EPSG:3256",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=117 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3257": [
        "EPSG:3257",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=135 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3258": [
        "EPSG:3258",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=153 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3259": [
        "EPSG:3259",
        "+proj=lcc +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +lat_0=-90 +lon_0=171 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3260": [
        "EPSG:3260",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-168 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3261": [
        "EPSG:3261",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-144 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3262": [
        "EPSG:3262",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-120 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3263": [
        "EPSG:3263",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-96 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3264": [
        "EPSG:3264",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-72 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3265": [
        "EPSG:3265",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-48 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3266": [
        "EPSG:3266",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=-24 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3267": [
        "EPSG:3267",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3268": [
        "EPSG:3268",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=24 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3269": [
        "EPSG:3269",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=48 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3270": [
        "EPSG:3270",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=72 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3271": [
        "EPSG:3271",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=96 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3272": [
        "EPSG:3272",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=120 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3273": [
        "EPSG:3273",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=144 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3274": [
        "EPSG:3274",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=168 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3275": [
        "EPSG:3275",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-165 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3276": [
        "EPSG:3276",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-135 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3277": [
        "EPSG:3277",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-105 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3278": [
        "EPSG:3278",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-75 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3279": [
        "EPSG:3279",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3280": [
        "EPSG:3280",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-15 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3281": [
        "EPSG:3281",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=15 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3282": [
        "EPSG:3282",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=45 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3283": [
        "EPSG:3283",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=75 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3284": [
        "EPSG:3284",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=105 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3285": [
        "EPSG:3285",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=135 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3286": [
        "EPSG:3286",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=165 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3287": [
        "EPSG:3287",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-150 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3288": [
        "EPSG:3288",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-90 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3289": [
        "EPSG:3289",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=-30 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3291": [
        "EPSG:3291",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=90 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3292": [
        "EPSG:3292",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=150 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3293": [
        "EPSG:3293",
        "+proj=stere +lat_0=-90 +lat_ts=-80.23861111111111 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3294": [
        "EPSG:3294",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-78 +lon_0=162 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3296": [
        "EPSG:3296",
        "+proj=utm +zone=5 +south +ellps=GRS80 +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093 +units=m +no_defs ",
    ],
    "EPSG:3297": [
        "EPSG:3297",
        "+proj=utm +zone=6 +south +ellps=GRS80 +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093 +units=m +no_defs ",
    ],
    "EPSG:3298": [
        "EPSG:3298",
        "+proj=utm +zone=7 +south +ellps=GRS80 +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093 +units=m +no_defs ",
    ],
    "EPSG:3299": [
        "EPSG:3299",
        "+proj=utm +zone=8 +south +ellps=GRS80 +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093 +units=m +no_defs ",
    ],
    "EPSG:3302": [
        "EPSG:3302",
        "+proj=utm +zone=7 +south +ellps=intl +towgs84=410.721,55.049,80.746,2.5779,2.3514,0.6664,17.3311 +units=m +no_defs ",
    ],
    "EPSG:3303": [
        "EPSG:3303",
        "+proj=utm +zone=7 +south +ellps=intl +towgs84=347.103,1078.125,2623.922,-33.8875,70.6773,-9.3943,186.074 +units=m +no_defs ",
    ],
    "EPSG:3304": [
        "EPSG:3304",
        "+proj=utm +zone=6 +south +ellps=intl +towgs84=221.525,152.948,176.768,-2.3847,-1.3896,-0.877,11.4741 +units=m +no_defs ",
    ],
    "EPSG:3305": [
        "EPSG:3305",
        "+proj=utm +zone=6 +south +ellps=intl +towgs84=215.525,149.593,176.229,-3.2624,-1.692,-1.1571,10.4773 +units=m +no_defs ",
    ],
    "EPSG:3306": [
        "EPSG:3306",
        "+proj=utm +zone=5 +south +ellps=intl +towgs84=217.037,86.959,23.956,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3307": [
        "EPSG:3307",
        "+proj=utm +zone=39 +ellps=WGS84 +towgs84=0,-0.15,0.68,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3308": [
        "EPSG:3308",
        "+proj=lcc +lat_1=-30.75 +lat_2=-35.75 +lat_0=-33.25 +lon_0=147 +x_0=9300000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3309": [
        "EPSG:3309",
        "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3311": [
        "EPSG:3311",
        "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3312": [
        "EPSG:3312",
        "+proj=utm +zone=21 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3313": [
        "EPSG:3313",
        "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4571": [
        "EPSG:4571",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:3314": [
        "EPSG:3314",
        "+proj=lcc +lat_1=-6.5 +lat_2=-11.5 +lat_0=0 +lon_0=26 +x_0=0 +y_0=0 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3315": [
        "EPSG:3315",
        "+proj=tmerc +lat_0=-9 +lon_0=26 +k=0.9998 +x_0=0 +y_0=0 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3316": [
        "EPSG:3316",
        "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3317": [
        "EPSG:3317",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3318": [
        "EPSG:3318",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3319": [
        "EPSG:3319",
        "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3320": [
        "EPSG:3320",
        "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3321": [
        "EPSG:3321",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3322": [
        "EPSG:3322",
        "+proj=tmerc +lat_0=0 +lon_0=20 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:4572": [
        "EPSG:4572",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:3323": [
        "EPSG:3323",
        "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3324": [
        "EPSG:3324",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3325": [
        "EPSG:3325",
        "+proj=tmerc +lat_0=0 +lon_0=26 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3326": [
        "EPSG:3326",
        "+proj=tmerc +lat_0=0 +lon_0=28 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3327": [
        "EPSG:3327",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3328": [
        "EPSG:3328",
        "+proj=sterea +lat_0=52.16666666666666 +lon_0=19.16666666666667 +k=0.999714 +x_0=500000 +y_0=500000 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3329": [
        "EPSG:3329",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3330": [
        "EPSG:3330",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3332": [
        "EPSG:3332",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3333": [
        "EPSG:3333",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3334": [
        "EPSG:3334",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3335": [
        "EPSG:3335",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3336": [
        "EPSG:3336",
        "+proj=utm +zone=42 +south +ellps=intl +towgs84=145,-187,103,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3337": [
        "EPSG:3337",
        "+proj=lcc +lat_1=-20.19506944444445 +lat_0=-20.19506944444445 +lon_0=57.52182777777778 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=clrk80 +towgs84=-770.1,158.4,-498.2,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3339": [
        "EPSG:3339",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3340": [
        "EPSG:3340",
        "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3341": [
        "EPSG:3341",
        "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3342": [
        "EPSG:3342",
        "+proj=utm +zone=33 +south +ellps=clrk80 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3343": [
        "EPSG:3343",
        "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3344": [
        "EPSG:3344",
        "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3345": [
        "EPSG:3345",
        "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3348": [
        "EPSG:3348",
        "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=63.390675 +lon_0=-91.86666666666666 +x_0=6200000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3350": [
        "EPSG:3350",
        "+proj=tmerc +lat_0=0.1 +lon_0=21.95 +k=1 +x_0=250000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3351": [
        "EPSG:3351",
        "+proj=tmerc +lat_0=0.1 +lon_0=24.95 +k=1 +x_0=1250000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3352": [
        "EPSG:3352",
        "+proj=tmerc +lat_0=0.1 +lon_0=27.95 +k=1 +x_0=2250000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3353": [
        "EPSG:3353",
        "+proj=utm +zone=32 +south +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:3354": [
        "EPSG:3354",
        "+proj=utm +zone=32 +south +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:3355": [
        "EPSG:3355",
        "+proj=tmerc +lat_0=30 +lon_0=31 +k=1 +x_0=615000 +y_0=810000 +ellps=helmert +towgs84=-146.21,112.63,4.05,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3356": [
        "EPSG:3356",
        "+proj=utm +zone=17 +ellps=clrk66 +towgs84=-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925 +units=m +no_defs ",
    ],
    "EPSG:3357": [
        "EPSG:3357",
        "+proj=utm +zone=17 +ellps=clrk66 +towgs84=8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081 +units=m +no_defs ",
    ],
    "EPSG:3358": [
        "EPSG:3358",
        "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.22 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3359": [
        "EPSG:3359",
        "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024385 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:4888": ["EPSG:4888", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3360": [
        "EPSG:3360",
        "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3361": [
        "EPSG:3361",
        "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3362": [
        "EPSG:3362",
        "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3363": [
        "EPSG:3363",
        "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3364": [
        "EPSG:3364",
        "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3365": [
        "EPSG:3365",
        "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3366": [
        "EPSG:3366",
        "+proj=cass +lat_0=22.31213333333334 +lon_0=114.1785555555556 +x_0=40243.57775604237 +y_0=19069.93351512578 +a=6378293.645208759 +b=6356617.987679838 +units=m +no_defs ",
    ],
    "EPSG:3367": [
        "EPSG:3367",
        "+proj=utm +zone=28 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3368": [
        "EPSG:3368",
        "+proj=utm +zone=29 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:3370": [
        "EPSG:3370",
        "+proj=utm +zone=59 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3371": [
        "EPSG:3371",
        "+proj=utm +zone=60 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3372": [
        "EPSG:3372",
        "+proj=utm +zone=59 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3373": [
        "EPSG:3373",
        "+proj=utm +zone=60 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3374": [
        "EPSG:3374",
        "+proj=utm +zone=29 +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:3376": [
        "EPSG:3376",
        "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31580995 +k=0.99984 +x_0=0 +y_0=0 +no_uoff +gamma=53.13010236111111 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3377": [
        "EPSG:3377",
        "+proj=cass +lat_0=2.121679744444445 +lon_0=103.4279362361111 +x_0=-14810.562 +y_0=8758.32 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3378": [
        "EPSG:3378",
        "+proj=cass +lat_0=2.682347636111111 +lon_0=101.9749050416667 +x_0=3673.785 +y_0=-4240.573 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3379": [
        "EPSG:3379",
        "+proj=cass +lat_0=3.769388088888889 +lon_0=102.3682989833333 +x_0=-7368.228 +y_0=6485.858 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3380": [
        "EPSG:3380",
        "+proj=cass +lat_0=3.68464905 +lon_0=101.3891079138889 +x_0=-34836.161 +y_0=56464.049 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3381": [
        "EPSG:3381",
        "+proj=cass +lat_0=4.9762852 +lon_0=103.070275625 +x_0=19594.245 +y_0=3371.895 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3382": [
        "EPSG:3382",
        "+proj=cass +lat_0=5.421517541666667 +lon_0=100.3443769638889 +x_0=-23.414 +y_0=62.283 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3383": [
        "EPSG:3383",
        "+proj=cass +lat_0=5.964672713888889 +lon_0=100.6363711111111 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3384": [
        "EPSG:3384",
        "+proj=cass +lat_0=4.859063022222222 +lon_0=100.8154105861111 +x_0=-1.769 +y_0=133454.779 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3385": [
        "EPSG:3385",
        "+proj=cass +lat_0=5.972543658333334 +lon_0=102.2952416694444 +x_0=13227.851 +y_0=8739.894 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:3386": [
        "EPSG:3386",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs ",
    ],
    "EPSG:3387": [
        "EPSG:3387",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=5500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs ",
    ],
    "EPSG:3388": [
        "EPSG:3388",
        "+proj=merc +lon_0=51 +lat_ts=42 +x_0=0 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3389": [
        "EPSG:3389",
        "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:3390": [
        "EPSG:3390",
        "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:3391": [
        "EPSG:3391",
        "+proj=utm +zone=37 +ellps=clrk80 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3392": [
        "EPSG:3392",
        "+proj=utm +zone=38 +ellps=clrk80 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3393": [
        "EPSG:3393",
        "+proj=utm +zone=39 +ellps=clrk80 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3394": [
        "EPSG:3394",
        "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078000001 +x_0=1500000 +y_0=1166200 +ellps=clrk80 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3396": [
        "EPSG:3396",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:3398": [
        "EPSG:3398",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:3399": [
        "EPSG:3399",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:4890": ["EPSG:4890", "+proj=geocent +ellps=WGS66 +units=m +no_defs "],
    "EPSG:3400": [
        "EPSG:3400",
        "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3401": [
        "EPSG:3401",
        "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3402": [
        "EPSG:3402",
        "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3404": [
        "EPSG:3404",
        "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3405": [
        "EPSG:3405",
        "+proj=utm +zone=48 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs ",
    ],
    "EPSG:3406": [
        "EPSG:3406",
        "+proj=utm +zone=49 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs ",
    ],
    "EPSG:3407": [
        "EPSG:3407",
        "+proj=cass +lat_0=22.31213333333334 +lon_0=114.1785555555556 +x_0=40243.57775604237 +y_0=19069.93351512578 +a=6378293.645208759 +b=6356617.987679838 +to_meter=0.3047972654 +no_defs ",
    ],
    "EPSG:3408": [
        "EPSG:3408",
        "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +a=6371228 +b=6371228 +units=m +no_defs ",
    ],
    "EPSG:3409": [
        "EPSG:3409",
        "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +a=6371228 +b=6371228 +units=m +no_defs ",
    ],
    "EPSG:3410": [
        "EPSG:3410",
        "+proj=cea +lon_0=0 +lat_ts=30 +x_0=0 +y_0=0 +a=6371228 +b=6371228 +units=m +no_defs ",
    ],
    "EPSG:3411": [
        "EPSG:3411",
        "+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +a=6378273 +b=6356889.449 +units=m +no_defs ",
    ],
    "EPSG:3412": [
        "EPSG:3412",
        "+proj=stere +lat_0=-90 +lat_ts=-70 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6378273 +b=6356889.449 +units=m +no_defs ",
    ],
    "EPSG:3414": [
        "EPSG:3414",
        "+proj=tmerc +lat_0=1.366666666666667 +lon_0=103.8333333333333 +k=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3415": [
        "EPSG:3415",
        "+proj=lcc +lat_1=18 +lat_2=24 +lat_0=21 +lon_0=114 +x_0=500000 +y_0=500000 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:3416": [
        "EPSG:3416",
        "+proj=lcc +lat_1=49 +lat_2=46 +lat_0=47.5 +lon_0=13.33333333333333 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3417": [
        "EPSG:3417",
        "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=999999.9999898402 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4892": ["EPSG:4892", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3418": [
        "EPSG:3418",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3419": [
        "EPSG:3419",
        "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3420": [
        "EPSG:3420",
        "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=399999.99998984 +y_0=399999.99998984 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3421": [
        "EPSG:3421",
        "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.000010163 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3422": [
        "EPSG:3422",
        "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3424": [
        "EPSG:3424",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3425": [
        "EPSG:3425",
        "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=999999.9999898402 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:4584": [
        "EPSG:4584",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:3426": [
        "EPSG:3426",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3427": [
        "EPSG:3427",
        "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3428": [
        "EPSG:3428",
        "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3429": [
        "EPSG:3429",
        "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.000010163 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3430": [
        "EPSG:3430",
        "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3431": [
        "EPSG:3431",
        "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000.0000101599 +y_0=3999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3433": [
        "EPSG:3433",
        "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4894": ["EPSG:4894", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:3434": [
        "EPSG:3434",
        "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=399999.99998984 +y_0=399999.99998984 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3435": [
        "EPSG:3435",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000.0000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3436": [
        "EPSG:3436",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=699999.9999898402 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3438": [
        "EPSG:3438",
        "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998983997 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3439": [
        "EPSG:3439",
        "+proj=utm +zone=39 +ellps=clrk80 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +units=m +no_defs ",
    ],
    "EPSG:3440": [
        "EPSG:3440",
        "+proj=utm +zone=40 +ellps=clrk80 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +units=m +no_defs ",
    ],
    "EPSG:3441": [
        "EPSG:3441",
        "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3442": [
        "EPSG:3442",
        "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3443": [
        "EPSG:3443",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3444": [
        "EPSG:3444",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=699999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3445": [
        "EPSG:3445",
        "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3446": [
        "EPSG:3446",
        "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998983997 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3448": [
        "EPSG:3448",
        "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=750000 +y_0=650000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3450": [
        "EPSG:3450",
        "+proj=utm +zone=18 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3451": [
        "EPSG:3451",
        "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=999999.9999898402 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3454": [
        "EPSG:3454",
        "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3455": [
        "EPSG:3455",
        "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3456": [
        "EPSG:3456",
        "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3458": [
        "EPSG:3458",
        "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3459": [
        "EPSG:3459",
        "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3460": [
        "EPSG:3460",
        "+proj=tmerc +lat_0=-17 +lon_0=178.75 +k=0.99985 +x_0=2000000 +y_0=4000000 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:3461": [
        "EPSG:3461",
        "+proj=utm +zone=28 +a=6378249.2 +b=6356515 +towgs84=-83,37,124,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3462": [
        "EPSG:3462",
        "+proj=utm +zone=29 +a=6378249.2 +b=6356515 +towgs84=-83,37,124,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3463": [
        "EPSG:3463",
        "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3464": [
        "EPSG:3464",
        "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3465": [
        "EPSG:3465",
        "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3466": [
        "EPSG:3466",
        "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3467": [
        "EPSG:3467",
        "+proj=aea +lat_1=55 +lat_2=65 +lat_0=50 +lon_0=-154 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3468": [
        "EPSG:3468",
        "+proj=omerc +lat_0=57 +lonc=-133.6666666666667 +alpha=323.1301023611111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +no_uoff +gamma=323.1301023611111 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3469": [
        "EPSG:3469",
        "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3470": [
        "EPSG:3470",
        "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3471": [
        "EPSG:3471",
        "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3472": [
        "EPSG:3472",
        "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3473": [
        "EPSG:3473",
        "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3474": [
        "EPSG:3474",
        "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3475": [
        "EPSG:3475",
        "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3476": [
        "EPSG:3476",
        "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3477": [
        "EPSG:3477",
        "+proj=lcc +lat_1=53.83333333333334 +lat_2=51.83333333333334 +lat_0=51 +lon_0=-176 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3478": [
        "EPSG:3478",
        "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3479": [
        "EPSG:3479",
        "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3480": [
        "EPSG:3480",
        "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3481": [
        "EPSG:3481",
        "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3482": [
        "EPSG:3482",
        "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3483": [
        "EPSG:3483",
        "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3484": [
        "EPSG:3484",
        "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3493": [
        "EPSG:3493",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3485": [
        "EPSG:3485",
        "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3486": [
        "EPSG:3486",
        "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3487": [
        "EPSG:3487",
        "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3488": [
        "EPSG:3488",
        "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3489": [
        "EPSG:3489",
        "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3490": [
        "EPSG:3490",
        "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3492": [
        "EPSG:3492",
        "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3494": [
        "EPSG:3494",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3495": [
        "EPSG:3495",
        "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3497": [
        "EPSG:3497",
        "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3498": [
        "EPSG:3498",
        "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3499": [
        "EPSG:3499",
        "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3500": [
        "EPSG:3500",
        "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3501": [
        "EPSG:3501",
        "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3502": [
        "EPSG:3502",
        "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3503": [
        "EPSG:3503",
        "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3504": [
        "EPSG:3504",
        "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3505": [
        "EPSG:3505",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3506": [
        "EPSG:3506",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3507": [
        "EPSG:3507",
        "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3508": [
        "EPSG:3508",
        "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096012192 +y_0=152400.3048006096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3509": [
        "EPSG:3509",
        "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3510": [
        "EPSG:3510",
        "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3512": [
        "EPSG:3512",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3513": [
        "EPSG:3513",
        "+proj=aea +lat_1=24 +lat_2=31.5 +lat_0=24 +lon_0=-84 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3514": [
        "EPSG:3514",
        "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3515": [
        "EPSG:3515",
        "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3516": [
        "EPSG:3516",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3576": [
        "EPSG:3576",
        "+proj=laea +lat_0=90 +lon_0=90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3519": [
        "EPSG:3519",
        "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3520": [
        "EPSG:3520",
        "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3521": [
        "EPSG:3521",
        "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3522": [
        "EPSG:3522",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3523": [
        "EPSG:3523",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3524": [
        "EPSG:3524",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3525": [
        "EPSG:3525",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3526": [
        "EPSG:3526",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3527": [
        "EPSG:3527",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3528": [
        "EPSG:3528",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3529": [
        "EPSG:3529",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3530": [
        "EPSG:3530",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3531": [
        "EPSG:3531",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=699999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3532": [
        "EPSG:3532",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3533": [
        "EPSG:3533",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3534": [
        "EPSG:3534",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4585": [
        "EPSG:4585",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:3535": [
        "EPSG:3535",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3536": [
        "EPSG:3536",
        "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3537": [
        "EPSG:3537",
        "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=999999.9999898402 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3538": [
        "EPSG:3538",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3539": [
        "EPSG:3539",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3540": [
        "EPSG:3540",
        "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3541": [
        "EPSG:3541",
        "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3542": [
        "EPSG:3542",
        "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3543": [
        "EPSG:3543",
        "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3544": [
        "EPSG:3544",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3545": [
        "EPSG:3545",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3546": [
        "EPSG:3546",
        "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3547": [
        "EPSG:3547",
        "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3548": [
        "EPSG:3548",
        "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3549": [
        "EPSG:3549",
        "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000.0001016001 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3550": [
        "EPSG:3550",
        "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3551": [
        "EPSG:3551",
        "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3552": [
        "EPSG:3552",
        "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3554": [
        "EPSG:3554",
        "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3555": [
        "EPSG:3555",
        "+proj=tmerc +lat_0=43.83333333333334 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3556": [
        "EPSG:3556",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3557": [
        "EPSG:3557",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3558": [
        "EPSG:3558",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3709": [
        "EPSG:3709",
        "+proj=utm +zone=2 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3559": [
        "EPSG:3559",
        "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3560": [
        "EPSG:3560",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=999999.9999898402 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3561": [
        "EPSG:3561",
        "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3562": [
        "EPSG:3562",
        "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3563": [
        "EPSG:3563",
        "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3564": [
        "EPSG:3564",
        "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.99999 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3565": [
        "EPSG:3565",
        "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3566": [
        "EPSG:3566",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=2000000.00001016 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3567": [
        "EPSG:3567",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.00001016 +y_0=3000000 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3568": [
        "EPSG:3568",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=999999.9999898402 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3569": [
        "EPSG:3569",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3570": [
        "EPSG:3570",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3572": [
        "EPSG:3572",
        "+proj=laea +lat_0=90 +lon_0=-150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3573": [
        "EPSG:3573",
        "+proj=laea +lat_0=90 +lon_0=-100 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3574": [
        "EPSG:3574",
        "+proj=laea +lat_0=90 +lon_0=-40 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4899": ["EPSG:4899", "+proj=geocent +ellps=intl +units=m +no_defs "],
    "EPSG:3579": [
        "EPSG:3579",
        "+proj=aea +lat_1=61.66666666666666 +lat_2=68 +lat_0=59 +lon_0=-132.5 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3580": [
        "EPSG:3580",
        "+proj=lcc +lat_1=62 +lat_2=70 +lat_0=0 +lon_0=-112 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3581": [
        "EPSG:3581",
        "+proj=lcc +lat_1=62 +lat_2=70 +lat_0=0 +lon_0=-112 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3582": [
        "EPSG:3582",
        "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=399999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3583": [
        "EPSG:3583",
        "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3584": [
        "EPSG:3584",
        "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3585": [
        "EPSG:3585",
        "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4906": ["EPSG:4906", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3586": [
        "EPSG:3586",
        "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000.0001016002 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3587": [
        "EPSG:3587",
        "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=6000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3588": [
        "EPSG:3588",
        "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3589": [
        "EPSG:3589",
        "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=8000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3590": [
        "EPSG:3590",
        "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3591": [
        "EPSG:3591",
        "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +no_uoff +gamma=337.25556 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3592": [
        "EPSG:3592",
        "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=4000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3593": [
        "EPSG:3593",
        "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3594": [
        "EPSG:3594",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3595": [
        "EPSG:3595",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3596": [
        "EPSG:3596",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3597": [
        "EPSG:3597",
        "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3598": [
        "EPSG:3598",
        "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3599": [
        "EPSG:3599",
        "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3600": [
        "EPSG:3600",
        "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3601": [
        "EPSG:3601",
        "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3602": [
        "EPSG:3602",
        "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3603": [
        "EPSG:3603",
        "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3604": [
        "EPSG:3604",
        "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3605": [
        "EPSG:3605",
        "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3606": [
        "EPSG:3606",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3607": [
        "EPSG:3607",
        "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3608": [
        "EPSG:3608",
        "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3609": [
        "EPSG:3609",
        "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3619": [
        "EPSG:3619",
        "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3610": [
        "EPSG:3610",
        "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.000010163 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3611": [
        "EPSG:3611",
        "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3612": [
        "EPSG:3612",
        "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000.0000101599 +y_0=3999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3613": [
        "EPSG:3613",
        "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3614": [
        "EPSG:3614",
        "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3615": [
        "EPSG:3615",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3617": [
        "EPSG:3617",
        "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3618": [
        "EPSG:3618",
        "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3620": [
        "EPSG:3620",
        "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3621": [
        "EPSG:3621",
        "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3622": [
        "EPSG:3622",
        "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3623": [
        "EPSG:3623",
        "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3624": [
        "EPSG:3624",
        "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=249999.9998983998 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3625": [
        "EPSG:3625",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3626": [
        "EPSG:3626",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3627": [
        "EPSG:3627",
        "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3710": [
        "EPSG:3710",
        "+proj=utm +zone=3 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3628": [
        "EPSG:3628",
        "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3629": [
        "EPSG:3629",
        "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3631": [
        "EPSG:3631",
        "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.22 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3632": [
        "EPSG:3632",
        "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3633": [
        "EPSG:3633",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3634": [
        "EPSG:3634",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3635": [
        "EPSG:3635",
        "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3636": [
        "EPSG:3636",
        "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3637": [
        "EPSG:3637",
        "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3638": [
        "EPSG:3638",
        "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3639": [
        "EPSG:3639",
        "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3640": [
        "EPSG:3640",
        "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3641": [
        "EPSG:3641",
        "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3642": [
        "EPSG:3642",
        "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3643": [
        "EPSG:3643",
        "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3644": [
        "EPSG:3644",
        "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3645": [
        "EPSG:3645",
        "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3646": [
        "EPSG:3646",
        "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3647": [
        "EPSG:3647",
        "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3648": [
        "EPSG:3648",
        "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3649": [
        "EPSG:3649",
        "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3650": [
        "EPSG:3650",
        "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3653": [
        "EPSG:3653",
        "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3654": [
        "EPSG:3654",
        "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998983997 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3655": [
        "EPSG:3655",
        "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3656": [
        "EPSG:3656",
        "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3657": [
        "EPSG:3657",
        "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3658": [
        "EPSG:3658",
        "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3659": [
        "EPSG:3659",
        "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3660": [
        "EPSG:3660",
        "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3661": [
        "EPSG:3661",
        "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3662": [
        "EPSG:3662",
        "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3663": [
        "EPSG:3663",
        "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3664": [
        "EPSG:3664",
        "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=699999.9998983998 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3665": [
        "EPSG:3665",
        "+proj=aea +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3666": [
        "EPSG:3666",
        "+proj=lcc +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3667": [
        "EPSG:3667",
        "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3668": [
        "EPSG:3668",
        "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000.0001016002 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3669": [
        "EPSG:3669",
        "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3670": [
        "EPSG:3670",
        "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3671": [
        "EPSG:3671",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3672": [
        "EPSG:3672",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000.0000000001 +y_0=5000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3673": [
        "EPSG:3673",
        "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3674": [
        "EPSG:3674",
        "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3699": [
        "EPSG:3699",
        "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3675": [
        "EPSG:3675",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3676": [
        "EPSG:3676",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=1999999.999992 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3677": [
        "EPSG:3677",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3678": [
        "EPSG:3678",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3679": [
        "EPSG:3679",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.0001504 +y_0=999999.9999960001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3680": [
        "EPSG:3680",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=999999.9999898402 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3681": [
        "EPSG:3681",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3682": [
        "EPSG:3682",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.0001504 +y_0=2999999.999988 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:3683": [
        "EPSG:3683",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3684": [
        "EPSG:3684",
        "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3685": [
        "EPSG:3685",
        "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3686": [
        "EPSG:3686",
        "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3687": [
        "EPSG:3687",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3688": [
        "EPSG:3688",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=999999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3689": [
        "EPSG:3689",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3691": [
        "EPSG:3691",
        "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3692": [
        "EPSG:3692",
        "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3693": [
        "EPSG:3693",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3694": [
        "EPSG:3694",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3695": [
        "EPSG:3695",
        "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3696": [
        "EPSG:3696",
        "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3697": [
        "EPSG:3697",
        "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3698": [
        "EPSG:3698",
        "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3700": [
        "EPSG:3700",
        "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3701": [
        "EPSG:3701",
        "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3702": [
        "EPSG:3702",
        "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3703": [
        "EPSG:3703",
        "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3704": [
        "EPSG:3704",
        "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3705": [
        "EPSG:3705",
        "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3706": [
        "EPSG:3706",
        "+proj=utm +zone=59 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3707": [
        "EPSG:3707",
        "+proj=utm +zone=60 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3708": [
        "EPSG:3708",
        "+proj=utm +zone=1 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3711": [
        "EPSG:3711",
        "+proj=utm +zone=4 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3712": [
        "EPSG:3712",
        "+proj=utm +zone=5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3713": [
        "EPSG:3713",
        "+proj=utm +zone=6 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3714": [
        "EPSG:3714",
        "+proj=utm +zone=7 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3715": [
        "EPSG:3715",
        "+proj=utm +zone=8 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3716": [
        "EPSG:3716",
        "+proj=utm +zone=9 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3718": [
        "EPSG:3718",
        "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3719": [
        "EPSG:3719",
        "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3720": [
        "EPSG:3720",
        "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3721": [
        "EPSG:3721",
        "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3722": [
        "EPSG:3722",
        "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3723": [
        "EPSG:3723",
        "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3724": [
        "EPSG:3724",
        "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3726": [
        "EPSG:3726",
        "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3727": [
        "EPSG:3727",
        "+proj=tmerc +lat_0=-21.11666666666667 +lon_0=55.53333333333333 +k=1 +x_0=160000 +y_0=50000 +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3728": [
        "EPSG:3728",
        "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3729": [
        "EPSG:3729",
        "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:4908": ["EPSG:4908", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3730": [
        "EPSG:3730",
        "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3731": [
        "EPSG:3731",
        "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3732": [
        "EPSG:3732",
        "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3733": [
        "EPSG:3733",
        "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3735": [
        "EPSG:3735",
        "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3736": [
        "EPSG:3736",
        "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3737": [
        "EPSG:3737",
        "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998983997 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3880": [
        "EPSG:3880",
        "+proj=tmerc +lat_0=0 +lon_0=26 +k=1 +x_0=26500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3738": [
        "EPSG:3738",
        "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3739": [
        "EPSG:3739",
        "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000.0000101599 +y_0=99999.99998983997 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3741": [
        "EPSG:3741",
        "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3743": [
        "EPSG:3743",
        "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3744": [
        "EPSG:3744",
        "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3746": [
        "EPSG:3746",
        "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3747": [
        "EPSG:3747",
        "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3748": [
        "EPSG:3748",
        "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3749": [
        "EPSG:3749",
        "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3750": [
        "EPSG:3750",
        "+proj=utm +zone=4 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3751": [
        "EPSG:3751",
        "+proj=utm +zone=5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3752": [
        "EPSG:3752",
        "+proj=merc +lon_0=100 +lat_ts=-41 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3753": [
        "EPSG:3753",
        "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3754": [
        "EPSG:3754",
        "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3755": [
        "EPSG:3755",
        "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3756": [
        "EPSG:3756",
        "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:4910": ["EPSG:4910", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3757": [
        "EPSG:3757",
        "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3758": [
        "EPSG:3758",
        "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3759": [
        "EPSG:3759",
        "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:3760": [
        "EPSG:3760",
        "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3761": [
        "EPSG:3761",
        "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3762": [
        "EPSG:3762",
        "+proj=lcc +lat_1=-54 +lat_2=-54.75 +lat_0=-55 +lon_0=-37 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3764": [
        "EPSG:3764",
        "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4911": ["EPSG:4911", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3766": [
        "EPSG:3766",
        "+proj=lcc +lat_1=45.91666666666666 +lat_2=43.08333333333334 +lat_0=0 +lon_0=16.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3767": [
        "EPSG:3767",
        "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3768": [
        "EPSG:3768",
        "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3769": [
        "EPSG:3769",
        "+proj=utm +zone=20 +ellps=clrk66 +towgs84=-73,213,296,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3770": [
        "EPSG:3770",
        "+proj=tmerc +lat_0=32 +lon_0=-64.75 +k=1 +x_0=550000 +y_0=100000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3771": [
        "EPSG:3771",
        "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3772": [
        "EPSG:3772",
        "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3773": [
        "EPSG:3773",
        "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3774": [
        "EPSG:3774",
        "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3775": [
        "EPSG:3775",
        "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3776": [
        "EPSG:3776",
        "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3777": [
        "EPSG:3777",
        "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3778": [
        "EPSG:3778",
        "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3779": [
        "EPSG:3779",
        "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3780": [
        "EPSG:3780",
        "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3781": [
        "EPSG:3781",
        "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3782": [
        "EPSG:3782",
        "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3783": [
        "EPSG:3783",
        "+proj=tmerc +lat_0=-25.06855261111111 +lon_0=-130.1129671111111 +k=1 +x_0=14200 +y_0=15500 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3784": [
        "EPSG:3784",
        "+proj=utm +zone=9 +south +ellps=intl +towgs84=185,165,42,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3787": [
        "EPSG:3787",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:3788": [
        "EPSG:3788",
        "+proj=tmerc +lat_0=0 +lon_0=166 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3789": [
        "EPSG:3789",
        "+proj=tmerc +lat_0=0 +lon_0=169 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3790": [
        "EPSG:3790",
        "+proj=tmerc +lat_0=0 +lon_0=179 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3791": [
        "EPSG:3791",
        "+proj=tmerc +lat_0=0 +lon_0=-178 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3793": [
        "EPSG:3793",
        "+proj=tmerc +lat_0=0 +lon_0=-176.5 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3794": [
        "EPSG:3794",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3974": [
        "EPSG:3974",
        "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3795": [
        "EPSG:3795",
        "+proj=lcc +lat_1=23 +lat_2=21.7 +lat_0=22.35 +lon_0=-81 +x_0=500000 +y_0=280296.016 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3796": [
        "EPSG:3796",
        "+proj=lcc +lat_1=21.3 +lat_2=20.13333333333333 +lat_0=20.71666666666667 +lon_0=-76.83333333333333 +x_0=500000 +y_0=229126.939 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3797": [
        "EPSG:3797",
        "+proj=lcc +lat_1=50 +lat_2=46 +lat_0=44 +lon_0=-70 +x_0=800000 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3798": [
        "EPSG:3798",
        "+proj=lcc +lat_1=50 +lat_2=46 +lat_0=44 +lon_0=-70 +x_0=800000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3799": [
        "EPSG:3799",
        "+proj=lcc +lat_1=50 +lat_2=46 +lat_0=44 +lon_0=-70 +x_0=800000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3800": [
        "EPSG:3800",
        "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:3801": [
        "EPSG:3801",
        "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3802": [
        "EPSG:3802",
        "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4912": ["EPSG:4912", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:3814": [
        "EPSG:3814",
        "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3816": [
        "EPSG:3816",
        "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3825": [
        "EPSG:3825",
        "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3827": [
        "EPSG:3827",
        "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=aust_SA +units=m +no_defs ",
    ],
    "EPSG:3829": [
        "EPSG:3829",
        "+proj=utm +zone=51 +ellps=intl +towgs84=-637,-549,-203,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3833": [
        "EPSG:3833",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3834": [
        "EPSG:3834",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3835": [
        "EPSG:3835",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3836": [
        "EPSG:3836",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3837": [
        "EPSG:3837",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3838": [
        "EPSG:3838",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3839": [
        "EPSG:3839",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3840": [
        "EPSG:3840",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:3841": [
        "EPSG:3841",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3842": [
        "EPSG:3842",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3843": [
        "EPSG:3843",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3844": [
        "EPSG:3844",
        "+proj=sterea +lat_0=46 +lon_0=25 +k=0.99975 +x_0=500000 +y_0=500000 +ellps=krass +towgs84=2.329,-147.042,-92.08,0.309,-0.325,-0.497,5.69 +units=m +no_defs ",
    ],
    "EPSG:3845": [
        "EPSG:3845",
        "+proj=tmerc +lat_0=0 +lon_0=11.30625 +k=1.000006 +x_0=1500025.141 +y_0=-667.282 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3846": [
        "EPSG:3846",
        "+proj=tmerc +lat_0=0 +lon_0=13.55626666666667 +k=1.0000058 +x_0=1500044.695 +y_0=-667.13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3847": [
        "EPSG:3847",
        "+proj=tmerc +lat_0=0 +lon_0=15.80628452944445 +k=1.00000561024 +x_0=1500064.274 +y_0=-667.711 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3848": [
        "EPSG:3848",
        "+proj=tmerc +lat_0=0 +lon_0=18.0563 +k=1.0000054 +x_0=1500083.521 +y_0=-668.8440000000001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3849": [
        "EPSG:3849",
        "+proj=tmerc +lat_0=0 +lon_0=20.30631666666667 +k=1.0000052 +x_0=1500102.765 +y_0=-670.706 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3850": [
        "EPSG:3850",
        "+proj=tmerc +lat_0=0 +lon_0=22.55633333333333 +k=1.0000049 +x_0=1500121.846 +y_0=-672.557 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3851": [
        "EPSG:3851",
        "+proj=lcc +lat_1=-37.5 +lat_2=-44.5 +lat_0=-41 +lon_0=173 +x_0=3000000 +y_0=7000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3852": [
        "EPSG:3852",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-90 +lon_0=157 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3854": [
        "EPSG:3854",
        "+proj=tmerc +lat_0=0 +lon_0=18.05787 +k=0.99999506 +x_0=100182.7406 +y_0=-6500620.1207 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3873": [
        "EPSG:3873",
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=19500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3874": [
        "EPSG:3874",
        "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=20500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3875": [
        "EPSG:3875",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=21500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3876": [
        "EPSG:3876",
        "+proj=tmerc +lat_0=0 +lon_0=22 +k=1 +x_0=22500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3877": [
        "EPSG:3877",
        "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=23500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3878": [
        "EPSG:3878",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=24500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3881": [
        "EPSG:3881",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=27500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3882": [
        "EPSG:3882",
        "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=28500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3883": [
        "EPSG:3883",
        "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=29500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3884": [
        "EPSG:3884",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=30500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3885": [
        "EPSG:3885",
        "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=31500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3890": [
        "EPSG:3890",
        "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3891": [
        "EPSG:3891",
        "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3892": [
        "EPSG:3892",
        "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3893": [
        "EPSG:3893",
        "+proj=tmerc +lat_0=29.02626833333333 +lon_0=46.5 +k=0.9994 +x_0=800000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3909": [
        "EPSG:3909",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3910": [
        "EPSG:3910",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=8500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3911": [
        "EPSG:3911",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3912": [
        "EPSG:3912",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3920": [
        "EPSG:3920",
        "+proj=utm +zone=20 +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3942": [
        "EPSG:3942",
        "+proj=lcc +lat_1=41.25 +lat_2=42.75 +lat_0=42 +lon_0=3 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3944": [
        "EPSG:3944",
        "+proj=lcc +lat_1=43.25 +lat_2=44.75 +lat_0=44 +lon_0=3 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3976": [
        "EPSG:3976",
        "+proj=stere +lat_0=-90 +lat_ts=-70 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3945": [
        "EPSG:3945",
        "+proj=lcc +lat_1=44.25 +lat_2=45.75 +lat_0=45 +lon_0=3 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3946": [
        "EPSG:3946",
        "+proj=lcc +lat_1=45.25 +lat_2=46.75 +lat_0=46 +lon_0=3 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3947": [
        "EPSG:3947",
        "+proj=lcc +lat_1=46.25 +lat_2=47.75 +lat_0=47 +lon_0=3 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3948": [
        "EPSG:3948",
        "+proj=lcc +lat_1=47.25 +lat_2=48.75 +lat_0=48 +lon_0=3 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3949": [
        "EPSG:3949",
        "+proj=lcc +lat_1=48.25 +lat_2=49.75 +lat_0=49 +lon_0=3 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3950": [
        "EPSG:3950",
        "+proj=lcc +lat_1=49.25 +lat_2=50.75 +lat_0=50 +lon_0=3 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3968": [
        "EPSG:3968",
        "+proj=lcc +lat_1=37 +lat_2=39.5 +lat_0=36 +lon_0=-79.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:3969": [
        "EPSG:3969",
        "+proj=lcc +lat_1=37 +lat_2=39.5 +lat_0=36 +lon_0=-79.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3970": [
        "EPSG:3970",
        "+proj=lcc +lat_1=37 +lat_2=39.5 +lat_0=36 +lon_0=-79.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3979": [
        "EPSG:3979",
        "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=49 +lon_0=-95 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3985": [
        "EPSG:3985",
        "+proj=lcc +lat_1=-6.5 +lat_2=-11.5 +lat_0=9 +lon_0=26 +x_0=500000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3986": [
        "EPSG:3986",
        "+proj=tmerc +lat_0=-9 +lon_0=30 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3987": [
        "EPSG:3987",
        "+proj=tmerc +lat_0=-9 +lon_0=28 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3988": [
        "EPSG:3988",
        "+proj=tmerc +lat_0=-9 +lon_0=26 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3989": [
        "EPSG:3989",
        "+proj=tmerc +lat_0=-9 +lon_0=24 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:3991": [
        "EPSG:3991",
        "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3992": [
        "EPSG:3992",
        "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=152400.3048006096 +y_0=30480.06096012192 +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:3996": [
        "EPSG:3996",
        "+proj=stere +lat_0=90 +lat_ts=75 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3997": [
        "EPSG:3997",
        "+proj=tmerc +lat_0=0 +lon_0=55.33333333333334 +k=1 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4026": [
        "EPSG:4026",
        "+proj=tmerc +lat_0=0 +lon_0=28.4 +k=0.9999400000000001 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4038": [
        "EPSG:4038",
        "+proj=utm +zone=36 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4048": [
        "EPSG:4048",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4049": [
        "EPSG:4049",
        "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4050": [
        "EPSG:4050",
        "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4051": [
        "EPSG:4051",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4056": [
        "EPSG:4056",
        "+proj=tmerc +lat_0=0 +lon_0=20 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4057": [
        "EPSG:4057",
        "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4058": [
        "EPSG:4058",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4059": [
        "EPSG:4059",
        "+proj=tmerc +lat_0=0 +lon_0=26 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4060": [
        "EPSG:4060",
        "+proj=tmerc +lat_0=0 +lon_0=28 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4061": [
        "EPSG:4061",
        "+proj=utm +zone=33 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4062": [
        "EPSG:4062",
        "+proj=utm +zone=34 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4063": [
        "EPSG:4063",
        "+proj=utm +zone=35 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4071": [
        "EPSG:4071",
        "+proj=utm +zone=23 +south +ellps=intl +towgs84=-143.87,243.37,-33.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4082": [
        "EPSG:4082",
        "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4088": [
        "EPSG:4088",
        "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6371007 +b=6371007 +units=m +no_defs ",
    ],
    "EPSG:4093": [
        "EPSG:4093",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99998 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4095": [
        "EPSG:4095",
        "+proj=tmerc +lat_0=0 +lon_0=11.75 +k=0.99998 +x_0=600000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4096": [
        "EPSG:4096",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=800000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4217": [
        "EPSG:4217",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4390": [
        "EPSG:4390",
        "+proj=cass +lat_0=2.042583333333333 +lon_0=103.5627583333333 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4391": [
        "EPSG:4391",
        "+proj=cass +lat_0=2.712283333333334 +lon_0=101.9411666666667 +x_0=-242.005 +y_0=-948.547 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4392": [
        "EPSG:4392",
        "+proj=cass +lat_0=3.710972222222222 +lon_0=102.4361777777778 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4914": ["EPSG:4914", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4393": [
        "EPSG:4393",
        "+proj=cass +lat_0=3.680344444444444 +lon_0=101.5082444444444 +x_0=-21759.438 +y_0=55960.906 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4394": [
        "EPSG:4394",
        "+proj=cass +lat_0=4.946141666666667 +lon_0=102.8952083333333 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4395": [
        "EPSG:4395",
        "+proj=cass +lat_0=5.421325 +lon_0=100.3458694444444 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4396": [
        "EPSG:4396",
        "+proj=cass +lat_0=5.965147222222223 +lon_0=100.6375944444444 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4397": [
        "EPSG:4397",
        "+proj=cass +lat_0=4.859380555555555 +lon_0=100.8167666666667 +x_0=0 +y_0=133453.669 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4398": [
        "EPSG:4398",
        "+proj=cass +lat_0=5.893922222222222 +lon_0=102.1772916666667 +x_0=0 +y_0=0 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4399": [
        "EPSG:4399",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4400": [
        "EPSG:4400",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4401": [
        "EPSG:4401",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4915": ["EPSG:4915", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4402": [
        "EPSG:4402",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4403": [
        "EPSG:4403",
        "+proj=tmerc +lat_0=0 +lon_0=-165 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4404": [
        "EPSG:4404",
        "+proj=tmerc +lat_0=0 +lon_0=-159 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4405": [
        "EPSG:4405",
        "+proj=tmerc +lat_0=0 +lon_0=-153 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4406": [
        "EPSG:4406",
        "+proj=tmerc +lat_0=0 +lon_0=-147 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4407": [
        "EPSG:4407",
        "+proj=tmerc +lat_0=0 +lon_0=-141 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4408": [
        "EPSG:4408",
        "+proj=tmerc +lat_0=0 +lon_0=-135 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4409": [
        "EPSG:4409",
        "+proj=tmerc +lat_0=0 +lon_0=-129 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4410": [
        "EPSG:4410",
        "+proj=tmerc +lat_0=0 +lon_0=-123 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4411": [
        "EPSG:4411",
        "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4412": [
        "EPSG:4412",
        "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4413": [
        "EPSG:4413",
        "+proj=tmerc +lat_0=0 +lon_0=-105 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4414": [
        "EPSG:4414",
        "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4415": [
        "EPSG:4415",
        "+proj=lcc +lat_1=-6.5 +lat_2=-11.5 +lat_0=-9 +lon_0=26 +x_0=500000 +y_0=500000 +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4417": [
        "EPSG:4417",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4418": [
        "EPSG:4418",
        "+proj=tmerc +lat_0=0 +lon_0=-75 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4419": [
        "EPSG:4419",
        "+proj=tmerc +lat_0=0 +lon_0=-69 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4420": [
        "EPSG:4420",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4421": [
        "EPSG:4421",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4491": [
        "EPSG:4491",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4422": [
        "EPSG:4422",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4423": [
        "EPSG:4423",
        "+proj=tmerc +lat_0=0 +lon_0=-165 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4424": [
        "EPSG:4424",
        "+proj=tmerc +lat_0=0 +lon_0=-159 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4425": [
        "EPSG:4425",
        "+proj=tmerc +lat_0=0 +lon_0=-153 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4426": [
        "EPSG:4426",
        "+proj=tmerc +lat_0=0 +lon_0=-147 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4427": [
        "EPSG:4427",
        "+proj=tmerc +lat_0=0 +lon_0=-141 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4428": [
        "EPSG:4428",
        "+proj=tmerc +lat_0=0 +lon_0=-135 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4429": [
        "EPSG:4429",
        "+proj=tmerc +lat_0=0 +lon_0=-129 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4430": [
        "EPSG:4430",
        "+proj=tmerc +lat_0=0 +lon_0=-123 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4431": [
        "EPSG:4431",
        "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4432": [
        "EPSG:4432",
        "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4433": [
        "EPSG:4433",
        "+proj=tmerc +lat_0=0 +lon_0=-105 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4434": [
        "EPSG:4434",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4437": [
        "EPSG:4437",
        "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4438": [
        "EPSG:4438",
        "+proj=tmerc +lat_0=0 +lon_0=-75 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4439": [
        "EPSG:4439",
        "+proj=tmerc +lat_0=0 +lon_0=-69 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4456": [
        "EPSG:4456",
        "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.5 +lon_0=-74 +x_0=609601.2192024384 +y_0=30480.06096012192 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4457": [
        "EPSG:4457",
        "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:4462": [
        "EPSG:4462",
        "+proj=lcc +lat_1=-18 +lat_2=-36 +lat_0=-27 +lon_0=132 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4467": [
        "EPSG:4467",
        "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4474": [
        "EPSG:4474",
        "+proj=utm +zone=38 +south +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4484": [
        "EPSG:4484",
        "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4485": [
        "EPSG:4485",
        "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4486": [
        "EPSG:4486",
        "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4488": [
        "EPSG:4488",
        "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4489": [
        "EPSG:4489",
        "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4492": [
        "EPSG:4492",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4493": [
        "EPSG:4493",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4494": [
        "EPSG:4494",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4495": [
        "EPSG:4495",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4496": [
        "EPSG:4496",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4498": [
        "EPSG:4498",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4499": [
        "EPSG:4499",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4500": [
        "EPSG:4500",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4501": [
        "EPSG:4501",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4502": [
        "EPSG:4502",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4503": [
        "EPSG:4503",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4504": [
        "EPSG:4504",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4505": [
        "EPSG:4505",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4506": [
        "EPSG:4506",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4507": [
        "EPSG:4507",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4509": [
        "EPSG:4509",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4510": [
        "EPSG:4510",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4511": [
        "EPSG:4511",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4512": [
        "EPSG:4512",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4513": [
        "EPSG:4513",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4514": [
        "EPSG:4514",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4515": [
        "EPSG:4515",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4516": [
        "EPSG:4516",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4517": [
        "EPSG:4517",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4518": [
        "EPSG:4518",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4519": [
        "EPSG:4519",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4520": [
        "EPSG:4520",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4521": [
        "EPSG:4521",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4522": [
        "EPSG:4522",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4523": [
        "EPSG:4523",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4524": [
        "EPSG:4524",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4525": [
        "EPSG:4525",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4526": [
        "EPSG:4526",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4527": [
        "EPSG:4527",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4528": [
        "EPSG:4528",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4529": [
        "EPSG:4529",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4530": [
        "EPSG:4530",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4531": [
        "EPSG:4531",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4532": [
        "EPSG:4532",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4533": [
        "EPSG:4533",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4534": [
        "EPSG:4534",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4916": ["EPSG:4916", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4535": [
        "EPSG:4535",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4536": [
        "EPSG:4536",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4537": [
        "EPSG:4537",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4538": [
        "EPSG:4538",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4539": [
        "EPSG:4539",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4540": [
        "EPSG:4540",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4541": [
        "EPSG:4541",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4542": [
        "EPSG:4542",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4543": [
        "EPSG:4543",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4544": [
        "EPSG:4544",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4545": [
        "EPSG:4545",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4546": [
        "EPSG:4546",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4547": [
        "EPSG:4547",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4548": [
        "EPSG:4548",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4549": [
        "EPSG:4549",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4550": [
        "EPSG:4550",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4551": [
        "EPSG:4551",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4552": [
        "EPSG:4552",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4553": [
        "EPSG:4553",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4554": [
        "EPSG:4554",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4559": [
        "EPSG:4559",
        "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4568": [
        "EPSG:4568",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4573": [
        "EPSG:4573",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4574": [
        "EPSG:4574",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4575": [
        "EPSG:4575",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4576": [
        "EPSG:4576",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4577": [
        "EPSG:4577",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4578": [
        "EPSG:4578",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4579": [
        "EPSG:4579",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4580": [
        "EPSG:4580",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4581": [
        "EPSG:4581",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4582": [
        "EPSG:4582",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4583": [
        "EPSG:4583",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4586": [
        "EPSG:4586",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4588": [
        "EPSG:4588",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4589": [
        "EPSG:4589",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4647": [
        "EPSG:4647",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4652": [
        "EPSG:4652",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4653": [
        "EPSG:4653",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4654": [
        "EPSG:4654",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4655": [
        "EPSG:4655",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4656": [
        "EPSG:4656",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4766": [
        "EPSG:4766",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4767": [
        "EPSG:4767",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4768": [
        "EPSG:4768",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4769": [
        "EPSG:4769",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4770": [
        "EPSG:4770",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4771": [
        "EPSG:4771",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4772": [
        "EPSG:4772",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4773": [
        "EPSG:4773",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4774": [
        "EPSG:4774",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4775": [
        "EPSG:4775",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4776": [
        "EPSG:4776",
        "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4777": [
        "EPSG:4777",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4778": [
        "EPSG:4778",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4779": [
        "EPSG:4779",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4780": [
        "EPSG:4780",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4781": [
        "EPSG:4781",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4782": [
        "EPSG:4782",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4783": [
        "EPSG:4783",
        "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4784": [
        "EPSG:4784",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4785": [
        "EPSG:4785",
        "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4786": [
        "EPSG:4786",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4787": [
        "EPSG:4787",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4788": [
        "EPSG:4788",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4789": [
        "EPSG:4789",
        "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4790": [
        "EPSG:4790",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4791": [
        "EPSG:4791",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4792": [
        "EPSG:4792",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4793": [
        "EPSG:4793",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4795": [
        "EPSG:4795",
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4796": [
        "EPSG:4796",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4798": [
        "EPSG:4798",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4799": [
        "EPSG:4799",
        "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4800": [
        "EPSG:4800",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4812": [
        "EPSG:4812",
        "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4822": [
        "EPSG:4822",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs ",
    ],
    "EPSG:4855": [
        "EPSG:4855",
        "+proj=tmerc +lat_0=0 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4856": [
        "EPSG:4856",
        "+proj=tmerc +lat_0=0 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4857": [
        "EPSG:4857",
        "+proj=tmerc +lat_0=0 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4858": [
        "EPSG:4858",
        "+proj=tmerc +lat_0=0 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4859": [
        "EPSG:4859",
        "+proj=tmerc +lat_0=0 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4860": [
        "EPSG:4860",
        "+proj=tmerc +lat_0=0 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4861": [
        "EPSG:4861",
        "+proj=tmerc +lat_0=0 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4862": [
        "EPSG:4862",
        "+proj=tmerc +lat_0=0 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4863": [
        "EPSG:4863",
        "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4864": [
        "EPSG:4864",
        "+proj=tmerc +lat_0=0 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4865": [
        "EPSG:4865",
        "+proj=tmerc +lat_0=0 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4866": [
        "EPSG:4866",
        "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4867": [
        "EPSG:4867",
        "+proj=tmerc +lat_0=0 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4868": [
        "EPSG:4868",
        "+proj=tmerc +lat_0=0 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4869": [
        "EPSG:4869",
        "+proj=tmerc +lat_0=0 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4870": [
        "EPSG:4870",
        "+proj=tmerc +lat_0=0 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4871": [
        "EPSG:4871",
        "+proj=tmerc +lat_0=0 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4872": [
        "EPSG:4872",
        "+proj=tmerc +lat_0=0 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4873": [
        "EPSG:4873",
        "+proj=tmerc +lat_0=0 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4874": [
        "EPSG:4874",
        "+proj=tmerc +lat_0=0 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4875": [
        "EPSG:4875",
        "+proj=tmerc +lat_0=0 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4876": [
        "EPSG:4876",
        "+proj=tmerc +lat_0=0 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4877": [
        "EPSG:4877",
        "+proj=tmerc +lat_0=0 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4878": [
        "EPSG:4878",
        "+proj=tmerc +lat_0=0 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4879": [
        "EPSG:4879",
        "+proj=tmerc +lat_0=0 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4880": [
        "EPSG:4880",
        "+proj=tmerc +lat_0=0 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5014": [
        "EPSG:5014",
        "+proj=utm +zone=25 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5015": [
        "EPSG:5015",
        "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5016": [
        "EPSG:5016",
        "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5041": [
        "EPSG:5041",
        "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5042": [
        "EPSG:5042",
        "+proj=stere +lat_0=-90 +lat_ts=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5071": [
        "EPSG:5071",
        "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5105": [
        "EPSG:5105",
        "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5106": [
        "EPSG:5106",
        "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5107": [
        "EPSG:5107",
        "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5108": [
        "EPSG:5108",
        "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5109": [
        "EPSG:5109",
        "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5110": [
        "EPSG:5110",
        "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5111": [
        "EPSG:5111",
        "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5112": [
        "EPSG:5112",
        "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5113": [
        "EPSG:5113",
        "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5114": [
        "EPSG:5114",
        "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5115": [
        "EPSG:5115",
        "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5116": [
        "EPSG:5116",
        "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5117": [
        "EPSG:5117",
        "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5118": [
        "EPSG:5118",
        "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5119": [
        "EPSG:5119",
        "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5120": [
        "EPSG:5120",
        "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5121": [
        "EPSG:5121",
        "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5122": [
        "EPSG:5122",
        "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5123": [
        "EPSG:5123",
        "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5124": [
        "EPSG:5124",
        "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5125": [
        "EPSG:5125",
        "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5126": [
        "EPSG:5126",
        "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5127": [
        "EPSG:5127",
        "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5128": [
        "EPSG:5128",
        "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5129": [
        "EPSG:5129",
        "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5130": [
        "EPSG:5130",
        "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5167": [
        "EPSG:5167",
        "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5168": [
        "EPSG:5168",
        "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=550000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5169": [
        "EPSG:5169",
        "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5170": [
        "EPSG:5170",
        "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5171": [
        "EPSG:5171",
        "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5172": [
        "EPSG:5172",
        "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5173": [
        "EPSG:5173",
        "+proj=tmerc +lat_0=38 +lon_0=125.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5174": [
        "EPSG:5174",
        "+proj=tmerc +lat_0=38 +lon_0=127.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5175": [
        "EPSG:5175",
        "+proj=tmerc +lat_0=38 +lon_0=127.0028902777778 +k=1 +x_0=200000 +y_0=550000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5176": [
        "EPSG:5176",
        "+proj=tmerc +lat_0=38 +lon_0=129.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5177": [
        "EPSG:5177",
        "+proj=tmerc +lat_0=38 +lon_0=131.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5178": [
        "EPSG:5178",
        "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5179": [
        "EPSG:5179",
        "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5180": [
        "EPSG:5180",
        "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5181": [
        "EPSG:5181",
        "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5182": [
        "EPSG:5182",
        "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=550000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5183": [
        "EPSG:5183",
        "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5184": [
        "EPSG:5184",
        "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5185": [
        "EPSG:5185",
        "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5186": [
        "EPSG:5186",
        "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5187": [
        "EPSG:5187",
        "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5188": [
        "EPSG:5188",
        "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5221": [
        "EPSG:5221",
        "+proj=krovak +lat_0=49.5 +lon_0=42.5 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:5223": [
        "EPSG:5223",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5234": [
        "EPSG:5234",
        "+proj=tmerc +lat_0=7.000480277777778 +lon_0=80.77171111111112 +k=0.9999238418 +x_0=200000 +y_0=200000 +a=6377276.345 +b=6356075.41314024 +towgs84=-97,787,86,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5235": [
        "EPSG:5235",
        "+proj=tmerc +lat_0=7.000471527777778 +lon_0=80.77171308333334 +k=0.9999238418 +x_0=500000 +y_0=500000 +a=6377276.345 +b=6356075.41314024 +towgs84=-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338 +units=m +no_defs ",
    ],
    "EPSG:5247": [
        "EPSG:5247",
        "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31580995 +k=0.99984 +x_0=0 +y_0=0 +no_uoff +gamma=53.13010236111111 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5253": [
        "EPSG:5253",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5254": [
        "EPSG:5254",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5255": [
        "EPSG:5255",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5257": [
        "EPSG:5257",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5258": [
        "EPSG:5258",
        "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5259": [
        "EPSG:5259",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5266": [
        "EPSG:5266",
        "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5269": [
        "EPSG:5269",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5270": [
        "EPSG:5270",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5271": [
        "EPSG:5271",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5273": [
        "EPSG:5273",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6309": ["EPSG:6309", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:5274": [
        "EPSG:5274",
        "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5275": [
        "EPSG:5275",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5292": [
        "EPSG:5292",
        "+proj=tmerc +lat_0=0 +lon_0=90.73333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5293": [
        "EPSG:5293",
        "+proj=tmerc +lat_0=0 +lon_0=89.55 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5294": [
        "EPSG:5294",
        "+proj=tmerc +lat_0=0 +lon_0=89.84999999999999 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5295": [
        "EPSG:5295",
        "+proj=tmerc +lat_0=0 +lon_0=90.03333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5296": [
        "EPSG:5296",
        "+proj=tmerc +lat_0=0 +lon_0=90.15000000000001 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5297": [
        "EPSG:5297",
        "+proj=tmerc +lat_0=0 +lon_0=91.13333333333334 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5298": [
        "EPSG:5298",
        "+proj=tmerc +lat_0=0 +lon_0=91.23333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4918": ["EPSG:4918", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:5299": [
        "EPSG:5299",
        "+proj=tmerc +lat_0=0 +lon_0=89.34999999999999 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5300": [
        "EPSG:5300",
        "+proj=tmerc +lat_0=0 +lon_0=91.34999999999999 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5301": [
        "EPSG:5301",
        "+proj=tmerc +lat_0=0 +lon_0=89.84999999999999 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5302": [
        "EPSG:5302",
        "+proj=tmerc +lat_0=0 +lon_0=91.56666666666666 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5303": [
        "EPSG:5303",
        "+proj=tmerc +lat_0=0 +lon_0=89.06666666666666 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5304": [
        "EPSG:5304",
        "+proj=tmerc +lat_0=0 +lon_0=90.26666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5305": [
        "EPSG:5305",
        "+proj=tmerc +lat_0=0 +lon_0=89.55 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5306": [
        "EPSG:5306",
        "+proj=tmerc +lat_0=0 +lon_0=91.75 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5307": [
        "EPSG:5307",
        "+proj=tmerc +lat_0=0 +lon_0=90.5 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4919": ["EPSG:4919", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:5308": [
        "EPSG:5308",
        "+proj=tmerc +lat_0=0 +lon_0=90.16666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5309": [
        "EPSG:5309",
        "+proj=tmerc +lat_0=0 +lon_0=90.11666666666666 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5310": [
        "EPSG:5310",
        "+proj=tmerc +lat_0=0 +lon_0=91.56666666666666 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5311": [
        "EPSG:5311",
        "+proj=tmerc +lat_0=0 +lon_0=90.86666666666666 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5316": [
        "EPSG:5316",
        "+proj=tmerc +lat_0=0 +lon_0=-7 +k=0.999997 +x_0=200000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5320": [
        "EPSG:5320",
        "+proj=lcc +lat_1=44.5 +lat_2=54.5 +lat_0=0 +lon_0=-84 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:5321": [
        "EPSG:5321",
        "+proj=lcc +lat_1=44.5 +lat_2=54.5 +lat_0=0 +lon_0=-84 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5325": [
        "EPSG:5325",
        "+proj=lcc +lat_1=64.25 +lat_2=65.75 +lat_0=65 +lon_0=-19 +x_0=1700000 +y_0=300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5329": [
        "EPSG:5329",
        "+proj=merc +lon_0=3.192280555555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +pm=jakarta +units=m +no_defs ",
    ],
    "EPSG:5330": [
        "EPSG:5330",
        "+proj=merc +lon_0=3.192280555555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +pm=jakarta +units=m +no_defs ",
    ],
    "EPSG:5331": [
        "EPSG:5331",
        "+proj=merc +lon_0=3.192280555555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +pm=jakarta +units=m +no_defs ",
    ],
    "EPSG:5337": [
        "EPSG:5337",
        "+proj=utm +zone=25 +south +ellps=intl +towgs84=-151.99,287.04,-147.45,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5343": [
        "EPSG:5343",
        "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5344": [
        "EPSG:5344",
        "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5345": [
        "EPSG:5345",
        "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5346": [
        "EPSG:5346",
        "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5347": [
        "EPSG:5347",
        "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5348": [
        "EPSG:5348",
        "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5349": [
        "EPSG:5349",
        "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5355": [
        "EPSG:5355",
        "+proj=utm +zone=20 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5356": [
        "EPSG:5356",
        "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5357": [
        "EPSG:5357",
        "+proj=utm +zone=21 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5361": [
        "EPSG:5361",
        "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5362": [
        "EPSG:5362",
        "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5382": [
        "EPSG:5382",
        "+proj=utm +zone=21 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5383": [
        "EPSG:5383",
        "+proj=utm +zone=22 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5387": [
        "EPSG:5387",
        "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5388": [
        "EPSG:5388",
        "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4922": [
        "EPSG:4922",
        "+proj=geocent +a=6378136 +b=6356751.361745712 +units=m +no_defs ",
    ],
    "EPSG:5389": [
        "EPSG:5389",
        "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5396": [
        "EPSG:5396",
        "+proj=utm +zone=26 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5456": [
        "EPSG:5456",
        "+proj=lcc +lat_1=10.46666666666667 +lat_0=10.46666666666667 +lon_0=-84.33333333333333 +k_0=0.99995696 +x_0=500000 +y_0=271820.522 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5457": [
        "EPSG:5457",
        "+proj=lcc +lat_1=9 +lat_0=9 +lon_0=-83.66666666666667 +k_0=0.99995696 +x_0=500000 +y_0=327987.436 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5458": [
        "EPSG:5458",
        "+proj=lcc +lat_1=16.81666666666667 +lat_0=16.81666666666667 +lon_0=-90.33333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:5459": [
        "EPSG:5459",
        "+proj=lcc +lat_1=14.9 +lat_0=14.9 +lon_0=-90.33333333333333 +k_0=0.99989906 +x_0=500000 +y_0=325992.681 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5460": [
        "EPSG:5460",
        "+proj=lcc +lat_1=13.78333333333333 +lat_0=13.78333333333333 +lon_0=-89 +k_0=0.99996704 +x_0=500000 +y_0=295809.184 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5461": [
        "EPSG:5461",
        "+proj=lcc +lat_1=13.86666666666667 +lat_0=13.86666666666667 +lon_0=-85.5 +k_0=0.99990314 +x_0=500000 +y_0=359891.816 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5462": [
        "EPSG:5462",
        "+proj=lcc +lat_1=11.73333333333333 +lat_0=11.73333333333333 +lon_0=-85.5 +k_0=0.9999222800000001 +x_0=500000 +y_0=288876.327 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5463": [
        "EPSG:5463",
        "+proj=utm +zone=17 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5466": [
        "EPSG:5466",
        "+proj=tmerc +lat_0=17.06124194444444 +lon_0=-88.6318575 +k=1 +x_0=66220.02833082761 +y_0=135779.5099885299 +a=6378293.645208759 +b=6356617.987679838 +units=m +no_defs ",
    ],
    "EPSG:5469": [
        "EPSG:5469",
        "+proj=lcc +lat_1=8.416666666666666 +lat_0=8.416666666666666 +lon_0=-80 +k_0=0.99989909 +x_0=500000 +y_0=294865.303 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:5472": [
        "EPSG:5472",
        "+proj=poly +lat_0=8.25 +lon_0=-81 +x_0=914391.7962 +y_0=999404.7217154861 +ellps=clrk66 +to_meter=0.9143917962 +no_defs ",
    ],
    "EPSG:5479": [
        "EPSG:5479",
        "+proj=lcc +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +lat_0=-78 +lon_0=163 +x_0=7000000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5480": [
        "EPSG:5480",
        "+proj=lcc +lat_1=-73.66666666666667 +lat_2=-75.33333333333333 +lat_0=-74.5 +lon_0=165 +x_0=5000000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5481": [
        "EPSG:5481",
        "+proj=lcc +lat_1=-70.66666666666667 +lat_2=-72.33333333333333 +lat_0=-71.5 +lon_0=166 +x_0=3000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5482": [
        "EPSG:5482",
        "+proj=stere +lat_0=-90 +lat_ts=-90 +lon_0=180 +k=0.994 +x_0=5000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5490": [
        "EPSG:5490",
        "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5518": [
        "EPSG:5518",
        "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=350000 +y_0=650000 +ellps=intl +towgs84=175,-38,113,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5519": [
        "EPSG:5519",
        "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=350000 +y_0=650000 +ellps=intl +towgs84=174.05,-25.49,112.57,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:5520": [
        "EPSG:5520",
        "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:5523": [
        "EPSG:5523",
        "+proj=tmerc +lat_0=0 +lon_0=11.5 +k=0.9996 +x_0=1500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5530": [
        "EPSG:5530",
        "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4924": ["EPSG:4924", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:5535": [
        "EPSG:5535",
        "+proj=utm +zone=25 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5536": [
        "EPSG:5536",
        "+proj=utm +zone=21 +south +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:5537": [
        "EPSG:5537",
        "+proj=utm +zone=22 +south +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:5539": [
        "EPSG:5539",
        "+proj=utm +zone=24 +south +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:5559": [
        "EPSG:5559",
        "+proj=lcc +lat_1=16.81666666666667 +lat_0=16.81666666666667 +lon_0=-90.33333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5562": [
        "EPSG:5562",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5563": [
        "EPSG:5563",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5564": [
        "EPSG:5564",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5565": [
        "EPSG:5565",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5566": [
        "EPSG:5566",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5567": [
        "EPSG:5567",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5568": [
        "EPSG:5568",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5569": [
        "EPSG:5569",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5570": [
        "EPSG:5570",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5571": [
        "EPSG:5571",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5572": [
        "EPSG:5572",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5573": [
        "EPSG:5573",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5574": [
        "EPSG:5574",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5575": [
        "EPSG:5575",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5576": [
        "EPSG:5576",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5577": [
        "EPSG:5577",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5578": [
        "EPSG:5578",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5579": [
        "EPSG:5579",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5580": [
        "EPSG:5580",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5581": [
        "EPSG:5581",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5582": [
        "EPSG:5582",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5583": [
        "EPSG:5583",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:5588": [
        "EPSG:5588",
        "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=304800 +y_0=304800 +datum=NAD27 +units=ft +no_defs ",
    ],
    "EPSG:5589": [
        "EPSG:5589",
        "+proj=tmerc +lat_0=17.06124194444444 +lon_0=-88.6318575 +k=1 +x_0=66220.02833082761 +y_0=135779.5099885299 +a=6378293.645208759 +b=6356617.987679838 +to_meter=0.3047972654 +no_defs ",
    ],
    "EPSG:5596": [
        "EPSG:5596",
        "+proj=tmerc +lat_0=0 +lon_0=11.33333333333333 +k=1 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5623": [
        "EPSG:5623",
        "+proj=tmerc +lat_0=41.5 +lon_0=-83.66666666666667 +k=0.999942857 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:5624": [
        "EPSG:5624",
        "+proj=tmerc +lat_0=41.5 +lon_0=-85.75 +k=0.999909091 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:5625": [
        "EPSG:5625",
        "+proj=tmerc +lat_0=41.5 +lon_0=-88.75 +k=0.999909091 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:6686": [
        "EPSG:6686",
        "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:5627": [
        "EPSG:5627",
        "+proj=tmerc +lat_0=0 +lon_0=6 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5629": [
        "EPSG:5629",
        "+proj=utm +zone=38 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5631": [
        "EPSG:5631",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:5632": [
        "EPSG:5632",
        "+proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5633": [
        "EPSG:5633",
        "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5634": [
        "EPSG:5634",
        "+proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5635": [
        "EPSG:5635",
        "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5636": [
        "EPSG:5636",
        "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5637": [
        "EPSG:5637",
        "+proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5638": [
        "EPSG:5638",
        "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5639": [
        "EPSG:5639",
        "+proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5641": [
        "EPSG:5641",
        "+proj=merc +lon_0=-43 +lat_ts=-2 +x_0=5000000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5643": [
        "EPSG:5643",
        "+proj=lcc +lat_1=52.66666666666666 +lat_2=54.33333333333334 +lat_0=48 +lon_0=10 +x_0=815000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5644": [
        "EPSG:5644",
        "+proj=utm +zone=39 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5646": [
        "EPSG:5646",
        "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:5649": [
        "EPSG:5649",
        "+proj=tmerc +lat_0=0 +lon_0=3 +k=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5650": [
        "EPSG:5650",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5651": [
        "EPSG:5651",
        "+proj=tmerc +lat_0=0 +lon_0=3 +k=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5652": [
        "EPSG:5652",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6687": [
        "EPSG:6687",
        "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:5653": [
        "EPSG:5653",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5654": [
        "EPSG:5654",
        "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:5655": [
        "EPSG:5655",
        "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:5659": [
        "EPSG:5659",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=500053 +y_0=-3999820 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +units=m +no_defs ",
    ],
    "EPSG:5663": [
        "EPSG:5663",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:5664": [
        "EPSG:5664",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5665": [
        "EPSG:5665",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5666": [
        "EPSG:5666",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5667": [
        "EPSG:5667",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5668": [
        "EPSG:5668",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5669": [
        "EPSG:5669",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5670": [
        "EPSG:5670",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:5671": [
        "EPSG:5671",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:5672": [
        "EPSG:5672",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +units=m +no_defs ",
    ],
    "EPSG:5673": [
        "EPSG:5673",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5674": [
        "EPSG:5674",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5675": [
        "EPSG:5675",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5676": [
        "EPSG:5676",
        "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:5677": [
        "EPSG:5677",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:5678": [
        "EPSG:5678",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:5679": [
        "EPSG:5679",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:5680": [
        "EPSG:5680",
        "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:5682": [
        "EPSG:5682",
        "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5683": [
        "EPSG:5683",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5684": [
        "EPSG:5684",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5685": [
        "EPSG:5685",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:5700": [
        "EPSG:5700",
        "+proj=utm +zone=1 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5879": [
        "EPSG:5879",
        "+proj=utm +zone=38 +south +ellps=intl +towgs84=-381.788,-57.501,-256.673,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5825": [
        "EPSG:5825",
        "+proj=tmerc +lat_0=-35.31773627777778 +lon_0=149.0092948305555 +k=1.000086 +x_0=200000 +y_0=600000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:5836": [
        "EPSG:5836",
        "+proj=utm +zone=37 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5837": [
        "EPSG:5837",
        "+proj=utm +zone=40 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5839": [
        "EPSG:5839",
        "+proj=utm +zone=17 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5842": [
        "EPSG:5842",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5844": [
        "EPSG:5844",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5858": [
        "EPSG:5858",
        "+proj=utm +zone=22 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5875": [
        "EPSG:5875",
        "+proj=utm +zone=18 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5876": [
        "EPSG:5876",
        "+proj=utm +zone=19 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5877": [
        "EPSG:5877",
        "+proj=utm +zone=20 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5880": [
        "EPSG:5880",
        "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5887": [
        "EPSG:5887",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:5890": [
        "EPSG:5890",
        "+proj=stere +lat_0=90 +lat_ts=70 +lon_0=90 +k=1 +x_0=0 +y_0=0 +a=6378273 +b=6356889.449 +units=m +no_defs ",
    ],
    "EPSG:5921": [
        "EPSG:5921",
        "+proj=lcc +lat_1=85 +lat_2=77 +lat_0=81.31722600000001 +lon_0=-111 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5922": [
        "EPSG:5922",
        "+proj=lcc +lat_1=85 +lat_2=77 +lat_0=81.31722600000001 +lon_0=-39 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5923": [
        "EPSG:5923",
        "+proj=lcc +lat_1=85 +lat_2=77 +lat_0=81.31722600000001 +lon_0=33 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5924": [
        "EPSG:5924",
        "+proj=lcc +lat_1=85 +lat_2=77 +lat_0=81.31722600000001 +lon_0=105 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5925": [
        "EPSG:5925",
        "+proj=lcc +lat_1=85 +lat_2=77 +lat_0=81.31722600000001 +lon_0=177 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5926": [
        "EPSG:5926",
        "+proj=lcc +lat_1=77 +lat_2=69 +lat_0=73.15574086111111 +lon_0=-111 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6688": [
        "EPSG:6688",
        "+proj=utm +zone=51 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:5927": [
        "EPSG:5927",
        "+proj=lcc +lat_1=77 +lat_2=69 +lat_0=73.15574086111111 +lon_0=-39 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5928": [
        "EPSG:5928",
        "+proj=lcc +lat_1=77 +lat_2=69 +lat_0=73.15574086111111 +lon_0=33 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5929": [
        "EPSG:5929",
        "+proj=lcc +lat_1=77 +lat_2=69 +lat_0=73.15574086111111 +lon_0=105 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5930": [
        "EPSG:5930",
        "+proj=lcc +lat_1=77 +lat_2=69 +lat_0=73.15574086111111 +lon_0=177 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5931": [
        "EPSG:5931",
        "+proj=lcc +lat_1=69 +lat_2=61 +lat_0=65.10127088888888 +lon_0=-111 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5932": [
        "EPSG:5932",
        "+proj=lcc +lat_1=69 +lat_2=61 +lat_0=65.10127088888888 +lon_0=-39 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5933": [
        "EPSG:5933",
        "+proj=lcc +lat_1=69 +lat_2=61 +lat_0=65.10127088888888 +lon_0=33 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5934": [
        "EPSG:5934",
        "+proj=lcc +lat_1=69 +lat_2=61 +lat_0=65.10127088888888 +lon_0=105 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5935": [
        "EPSG:5935",
        "+proj=lcc +lat_1=69 +lat_2=61 +lat_0=65.10127088888888 +lon_0=177 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4930": ["EPSG:4930", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:5936": [
        "EPSG:5936",
        "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=-150 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5937": [
        "EPSG:5937",
        "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=-100 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5938": [
        "EPSG:5938",
        "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=-33 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5939": [
        "EPSG:5939",
        "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=18 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:5940": [
        "EPSG:5940",
        "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=105 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6050": [
        "EPSG:6050",
        "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=-30 +x_0=25500000 +y_0=1500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6051": [
        "EPSG:6051",
        "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=-52 +x_0=18500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6052": [
        "EPSG:6052",
        "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=-12 +x_0=20500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6053": [
        "EPSG:6053",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-69 +x_0=29500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4932": ["EPSG:4932", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6054": [
        "EPSG:6054",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-39 +x_0=31500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6055": [
        "EPSG:6055",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-10 +x_0=33500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6056": [
        "EPSG:6056",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-64 +x_0=20500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6057": [
        "EPSG:6057",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-39 +x_0=22500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6058": [
        "EPSG:6058",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-14 +x_0=24500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6059": [
        "EPSG:6059",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-62 +x_0=41500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6060": [
        "EPSG:6060",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-42 +x_0=43500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6061": [
        "EPSG:6061",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-22 +x_0=45500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4934": ["EPSG:4934", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6062": [
        "EPSG:6062",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-56 +x_0=26500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6063": [
        "EPSG:6063",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-38 +x_0=28500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6064": [
        "EPSG:6064",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-20 +x_0=30500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6065": [
        "EPSG:6065",
        "+proj=lcc +lat_1=67 +lat_2=63.66666666666666 +lat_0=65.35103930555555 +lon_0=-51 +x_0=11500000 +y_0=7500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6066": [
        "EPSG:6066",
        "+proj=lcc +lat_1=67 +lat_2=63.66666666666666 +lat_0=65.35103930555555 +lon_0=-34 +x_0=13500000 +y_0=7500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6067": [
        "EPSG:6067",
        "+proj=lcc +lat_1=63.66666666666666 +lat_2=60.33333333333334 +lat_0=62.01530688888889 +lon_0=-52 +x_0=20500000 +y_0=8500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6068": [
        "EPSG:6068",
        "+proj=lcc +lat_1=63.66666666666666 +lat_2=60.33333333333334 +lat_0=62.01530688888889 +lon_0=-37 +x_0=22500000 +y_0=8500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6069": [
        "EPSG:6069",
        "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=16 +x_0=22500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6070": [
        "EPSG:6070",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=21 +x_0=11500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6071": [
        "EPSG:6071",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=10 +x_0=26500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6072": [
        "EPSG:6072",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=34 +x_0=28500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6073": [
        "EPSG:6073",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=14 +x_0=11500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6074": [
        "EPSG:6074",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=34 +x_0=13500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6075": [
        "EPSG:6075",
        "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=53 +x_0=24500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6076": [
        "EPSG:6076",
        "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=93 +x_0=26500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6077": [
        "EPSG:6077",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=52 +x_0=13500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6078": [
        "EPSG:6078",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=83 +x_0=15500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6079": [
        "EPSG:6079",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=114 +x_0=17500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6080": [
        "EPSG:6080",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=145 +x_0=19500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6081": [
        "EPSG:6081",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=58 +x_0=30500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6082": [
        "EPSG:6082",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=82 +x_0=32500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6083": [
        "EPSG:6083",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=106 +x_0=34500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6084": [
        "EPSG:6084",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=130 +x_0=36500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6085": [
        "EPSG:6085",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=154 +x_0=38500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6086": [
        "EPSG:6086",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=179 +x_0=40500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6087": [
        "EPSG:6087",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=54 +x_0=15500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6088": [
        "EPSG:6088",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=74 +x_0=17500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6089": [
        "EPSG:6089",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=95 +x_0=19500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6090": [
        "EPSG:6090",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=116 +x_0=21500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6091": [
        "EPSG:6091",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=137 +x_0=23500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6092": [
        "EPSG:6092",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=158 +x_0=25500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6093": [
        "EPSG:6093",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=179 +x_0=27500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6094": [
        "EPSG:6094",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-163 +x_0=29500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6095": [
        "EPSG:6095",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-147 +x_0=31500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6096": [
        "EPSG:6096",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-165 +x_0=14500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6097": [
        "EPSG:6097",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-147 +x_0=16500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6098": [
        "EPSG:6098",
        "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=-90 +x_0=23500000 +y_0=1500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6099": [
        "EPSG:6099",
        "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=-115 +x_0=14500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6100": [
        "EPSG:6100",
        "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=-75 +x_0=16500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6101": [
        "EPSG:6101",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-129 +x_0=25500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6102": [
        "EPSG:6102",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-99 +x_0=27500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6103": [
        "EPSG:6103",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-69 +x_0=29500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6104": [
        "EPSG:6104",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-129 +x_0=14500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6105": [
        "EPSG:6105",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-104 +x_0=16500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6106": [
        "EPSG:6106",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-79 +x_0=18500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6107": [
        "EPSG:6107",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-131 +x_0=33500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6108": [
        "EPSG:6108",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-111 +x_0=35500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6109": [
        "EPSG:6109",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-91 +x_0=37500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6110": [
        "EPSG:6110",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-71 +x_0=39500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6111": [
        "EPSG:6111",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-132 +x_0=18500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6112": [
        "EPSG:6112",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-113 +x_0=20500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6113": [
        "EPSG:6113",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-94 +x_0=22500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6114": [
        "EPSG:6114",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-75 +x_0=24500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6115": [
        "EPSG:6115",
        "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=30 +x_0=27500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6116": [
        "EPSG:6116",
        "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=90 +x_0=29500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6117": [
        "EPSG:6117",
        "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=150 +x_0=31500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6118": [
        "EPSG:6118",
        "+proj=lcc +lat_1=87 +lat_2=83.66666666666667 +lat_0=85.43711833333333 +lon_0=-150 +x_0=21500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6119": [
        "EPSG:6119",
        "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=133 +x_0=28500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6120": [
        "EPSG:6120",
        "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=166 +x_0=10500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6121": [
        "EPSG:6121",
        "+proj=lcc +lat_1=83.66666666666667 +lat_2=80.33333333333333 +lat_0=82.05842488888888 +lon_0=-154 +x_0=12500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6122": [
        "EPSG:6122",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=176 +x_0=21500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6123": [
        "EPSG:6123",
        "+proj=lcc +lat_1=80.33333333333333 +lat_2=77 +lat_0=78.70733752777778 +lon_0=-153 +x_0=23500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6124": [
        "EPSG:6124",
        "+proj=lcc +lat_1=77 +lat_2=73.66666666666667 +lat_0=75.36440330555556 +lon_0=-155 +x_0=12500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6125": [
        "EPSG:6125",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-5 +x_0=47500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6128": [
        "EPSG:6128",
        "+proj=utm +zone=17 +ellps=clrk66 +towgs84=-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925 +units=ft +no_defs ",
    ],
    "EPSG:6129": [
        "EPSG:6129",
        "+proj=utm +zone=17 +ellps=clrk66 +towgs84=8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081 +units=ft +no_defs ",
    ],
    "EPSG:6141": [
        "EPSG:6141",
        "+proj=lcc +lat_1=19.33333333333333 +lat_2=19.7 +lat_0=19.33333333333333 +lon_0=80.56666666666666 +x_0=899160 +y_0=579120 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:6204": [
        "EPSG:6204",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6210": [
        "EPSG:6210",
        "+proj=utm +zone=23 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6211": [
        "EPSG:6211",
        "+proj=utm +zone=24 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6307": [
        "EPSG:6307",
        "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6312": [
        "EPSG:6312",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=0.99995 +x_0=200000 +y_0=-3500000 +ellps=WGS84 +towgs84=8.846,-4.394,-1.122,0.00237,0.146528,-0.130428,0.783926 +units=m +no_defs ",
    ],
    "EPSG:6316": [
        "EPSG:6316",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6328": [
        "EPSG:6328",
        "+proj=utm +zone=59 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6329": [
        "EPSG:6329",
        "+proj=utm +zone=60 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4942": ["EPSG:4942", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6330": [
        "EPSG:6330",
        "+proj=utm +zone=1 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6331": [
        "EPSG:6331",
        "+proj=utm +zone=2 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6332": [
        "EPSG:6332",
        "+proj=utm +zone=3 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6333": [
        "EPSG:6333",
        "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6334": [
        "EPSG:6334",
        "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6335": [
        "EPSG:6335",
        "+proj=utm +zone=6 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6336": [
        "EPSG:6336",
        "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6337": [
        "EPSG:6337",
        "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6338": [
        "EPSG:6338",
        "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6339": [
        "EPSG:6339",
        "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4944": ["EPSG:4944", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6340": [
        "EPSG:6340",
        "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6341": [
        "EPSG:6341",
        "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6342": [
        "EPSG:6342",
        "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6343": [
        "EPSG:6343",
        "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6344": [
        "EPSG:6344",
        "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6345": [
        "EPSG:6345",
        "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6346": [
        "EPSG:6346",
        "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6347": [
        "EPSG:6347",
        "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6348": [
        "EPSG:6348",
        "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6350": [
        "EPSG:6350",
        "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4946": ["EPSG:4946", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6351": [
        "EPSG:6351",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-163 +x_0=29500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6352": [
        "EPSG:6352",
        "+proj=lcc +lat_1=73.66666666666667 +lat_2=70.33333333333333 +lat_0=72.02500919444445 +lon_0=-147 +x_0=31500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6353": [
        "EPSG:6353",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-165 +x_0=14500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6354": [
        "EPSG:6354",
        "+proj=lcc +lat_1=70.33333333333333 +lat_2=67 +lat_0=68.68747555555557 +lon_0=-147 +x_0=16500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6355": [
        "EPSG:6355",
        "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6356": [
        "EPSG:6356",
        "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6362": [
        "EPSG:6362",
        "+proj=lcc +lat_1=17.5 +lat_2=29.5 +lat_0=12 +lon_0=-102 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6366": [
        "EPSG:6366",
        "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6367": [
        "EPSG:6367",
        "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6368": [
        "EPSG:6368",
        "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6369": [
        "EPSG:6369",
        "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6370": [
        "EPSG:6370",
        "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6371": [
        "EPSG:6371",
        "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6372": [
        "EPSG:6372",
        "+proj=lcc +lat_1=17.5 +lat_2=29.5 +lat_0=12 +lon_0=-102 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6381": [
        "EPSG:6381",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:6382": [
        "EPSG:6382",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:6383": [
        "EPSG:6383",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:6384": [
        "EPSG:6384",
        "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:6385": [
        "EPSG:6385",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:6386": [
        "EPSG:6386",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:6387": [
        "EPSG:6387",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=300000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs ",
    ],
    "EPSG:6391": [
        "EPSG:6391",
        "+proj=lcc +lat_1=19.33333333333333 +lat_2=19.7 +lat_0=19.33333333333333 +lon_0=-80.56666666666666 +x_0=899160 +y_0=579120 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs ",
    ],
    "EPSG:6393": [
        "EPSG:6393",
        "+proj=aea +lat_1=55 +lat_2=65 +lat_0=50 +lon_0=-154 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6394": [
        "EPSG:6394",
        "+proj=omerc +lat_0=57 +lonc=-133.6666666666667 +alpha=323.1301023611111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +no_uoff +gamma=323.1301023611111 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6395": [
        "EPSG:6395",
        "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6396": [
        "EPSG:6396",
        "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6397": [
        "EPSG:6397",
        "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6398": [
        "EPSG:6398",
        "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4948": ["EPSG:4948", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6399": [
        "EPSG:6399",
        "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6400": [
        "EPSG:6400",
        "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6401": [
        "EPSG:6401",
        "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6402": [
        "EPSG:6402",
        "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6403": [
        "EPSG:6403",
        "+proj=lcc +lat_1=53.83333333333334 +lat_2=51.83333333333334 +lat_0=51 +lon_0=-176 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6404": [
        "EPSG:6404",
        "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6405": [
        "EPSG:6405",
        "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6406": [
        "EPSG:6406",
        "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6407": [
        "EPSG:6407",
        "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6408": [
        "EPSG:6408",
        "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6409": [
        "EPSG:6409",
        "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6410": [
        "EPSG:6410",
        "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6411": [
        "EPSG:6411",
        "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6412": [
        "EPSG:6412",
        "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6413": [
        "EPSG:6413",
        "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6414": [
        "EPSG:6414",
        "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6415": [
        "EPSG:6415",
        "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6416": [
        "EPSG:6416",
        "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6528": [
        "EPSG:6528",
        "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6417": [
        "EPSG:6417",
        "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6418": [
        "EPSG:6418",
        "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6419": [
        "EPSG:6419",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6420": [
        "EPSG:6420",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6421": [
        "EPSG:6421",
        "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6422": [
        "EPSG:6422",
        "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6423": [
        "EPSG:6423",
        "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6424": [
        "EPSG:6424",
        "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:4950": ["EPSG:4950", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6425": [
        "EPSG:6425",
        "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6426": [
        "EPSG:6426",
        "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6427": [
        "EPSG:6427",
        "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6428": [
        "EPSG:6428",
        "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6429": [
        "EPSG:6429",
        "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6430": [
        "EPSG:6430",
        "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6431": [
        "EPSG:6431",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6432": [
        "EPSG:6432",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8288036576 +y_0=304800.6096012192 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6433": [
        "EPSG:6433",
        "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6434": [
        "EPSG:6434",
        "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096012192 +y_0=152400.3048006096 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6435": [
        "EPSG:6435",
        "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6436": [
        "EPSG:6436",
        "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6437": [
        "EPSG:6437",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6438": [
        "EPSG:6438",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6439": [
        "EPSG:6439",
        "+proj=aea +lat_1=24 +lat_2=31.5 +lat_0=24 +lon_0=-84 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6440": [
        "EPSG:6440",
        "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6441": [
        "EPSG:6441",
        "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6442": [
        "EPSG:6442",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6443": [
        "EPSG:6443",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6444": [
        "EPSG:6444",
        "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6445": [
        "EPSG:6445",
        "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6446": [
        "EPSG:6446",
        "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6447": [
        "EPSG:6447",
        "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6448": [
        "EPSG:6448",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6449": [
        "EPSG:6449",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6450": [
        "EPSG:6450",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4952": ["EPSG:4952", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:6451": [
        "EPSG:6451",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6452": [
        "EPSG:6452",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6453": [
        "EPSG:6453",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6454": [
        "EPSG:6454",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6455": [
        "EPSG:6455",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6456": [
        "EPSG:6456",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6457": [
        "EPSG:6457",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=699999.9999898402 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6458": [
        "EPSG:6458",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6459": [
        "EPSG:6459",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=99999.99989839978 +y_0=249999.9998983998 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6460": [
        "EPSG:6460",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6461": [
        "EPSG:6461",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998983998 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6462": [
        "EPSG:6462",
        "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6463": [
        "EPSG:6463",
        "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=999999.9999898402 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6464": [
        "EPSG:6464",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6465": [
        "EPSG:6465",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6466": [
        "EPSG:6466",
        "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6467": [
        "EPSG:6467",
        "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6673": [
        "EPSG:6673",
        "+proj=tmerc +lat_0=36 +lon_0=134.3333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6468": [
        "EPSG:6468",
        "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6469": [
        "EPSG:6469",
        "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6470": [
        "EPSG:6470",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6471": [
        "EPSG:6471",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6472": [
        "EPSG:6472",
        "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6473": [
        "EPSG:6473",
        "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=1500000 +y_0=999999.9998983998 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6474": [
        "EPSG:6474",
        "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6475": [
        "EPSG:6475",
        "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000.0001016001 +y_0=500000.0001016001 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6476": [
        "EPSG:6476",
        "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6477": [
        "EPSG:6477",
        "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6478": [
        "EPSG:6478",
        "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6479": [
        "EPSG:6479",
        "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=999999.9999898402 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6480": [
        "EPSG:6480",
        "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6481": [
        "EPSG:6481",
        "+proj=tmerc +lat_0=43.83333333333334 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6482": [
        "EPSG:6482",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6483": [
        "EPSG:6483",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6484": [
        "EPSG:6484",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6485": [
        "EPSG:6485",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6486": [
        "EPSG:6486",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6487": [
        "EPSG:6487",
        "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6488": [
        "EPSG:6488",
        "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=399999.9998983998 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6489": [
        "EPSG:6489",
        "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6490": [
        "EPSG:6490",
        "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6491": [
        "EPSG:6491",
        "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000 +y_0=750000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6492": [
        "EPSG:6492",
        "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000.0001016002 +y_0=750000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6610": [
        "EPSG:6610",
        "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6493": [
        "EPSG:6493",
        "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=6000000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6494": [
        "EPSG:6494",
        "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6495": [
        "EPSG:6495",
        "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=8000000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6496": [
        "EPSG:6496",
        "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6497": [
        "EPSG:6497",
        "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +no_uoff +gamma=337.25556 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6498": [
        "EPSG:6498",
        "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=4000000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6499": [
        "EPSG:6499",
        "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6500": [
        "EPSG:6500",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6501": [
        "EPSG:6501",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6502": [
        "EPSG:6502",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6503": [
        "EPSG:6503",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6504": [
        "EPSG:6504",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6505": [
        "EPSG:6505",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6506": [
        "EPSG:6506",
        "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6507": [
        "EPSG:6507",
        "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6508": [
        "EPSG:6508",
        "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6509": [
        "EPSG:6509",
        "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6510": [
        "EPSG:6510",
        "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=699999.9998983998 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6511": [
        "EPSG:6511",
        "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6512": [
        "EPSG:6512",
        "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6513": [
        "EPSG:6513",
        "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6514": [
        "EPSG:6514",
        "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6515": [
        "EPSG:6515",
        "+proj=lcc +lat_1=49 +lat_2=45 +lat_0=44.25 +lon_0=-109.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6516": [
        "EPSG:6516",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6517": [
        "EPSG:6517",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:6518": [
        "EPSG:6518",
        "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6519": [
        "EPSG:6519",
        "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6520": [
        "EPSG:6520",
        "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6521": [
        "EPSG:6521",
        "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.000010163 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6522": [
        "EPSG:6522",
        "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6523": [
        "EPSG:6523",
        "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000.0000101599 +y_0=3999999.99998984 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6524": [
        "EPSG:6524",
        "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6525": [
        "EPSG:6525",
        "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6526": [
        "EPSG:6526",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6527": [
        "EPSG:6527",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:4958": ["EPSG:4958", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6529": [
        "EPSG:6529",
        "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6530": [
        "EPSG:6530",
        "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6531": [
        "EPSG:6531",
        "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6532": [
        "EPSG:6532",
        "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6533": [
        "EPSG:6533",
        "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6534": [
        "EPSG:6534",
        "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6535": [
        "EPSG:6535",
        "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=249999.9998983998 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6536": [
        "EPSG:6536",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6537": [
        "EPSG:6537",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:4960": ["EPSG:4960", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6538": [
        "EPSG:6538",
        "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6539": [
        "EPSG:6539",
        "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6540": [
        "EPSG:6540",
        "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6541": [
        "EPSG:6541",
        "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6542": [
        "EPSG:6542",
        "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.22 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6543": [
        "EPSG:6543",
        "+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6544": [
        "EPSG:6544",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6545": [
        "EPSG:6545",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6611": [
        "EPSG:6611",
        "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6546": [
        "EPSG:6546",
        "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6547": [
        "EPSG:6547",
        "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6548": [
        "EPSG:6548",
        "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6549": [
        "EPSG:6549",
        "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6550": [
        "EPSG:6550",
        "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6551": [
        "EPSG:6551",
        "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6552": [
        "EPSG:6552",
        "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6553": [
        "EPSG:6553",
        "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6674": [
        "EPSG:6674",
        "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6554": [
        "EPSG:6554",
        "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6555": [
        "EPSG:6555",
        "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6556": [
        "EPSG:6556",
        "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6557": [
        "EPSG:6557",
        "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6558": [
        "EPSG:6558",
        "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6559": [
        "EPSG:6559",
        "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6560": [
        "EPSG:6560",
        "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6561": [
        "EPSG:6561",
        "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6612": [
        "EPSG:6612",
        "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6562": [
        "EPSG:6562",
        "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6563": [
        "EPSG:6563",
        "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6564": [
        "EPSG:6564",
        "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6565": [
        "EPSG:6565",
        "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6566": [
        "EPSG:6566",
        "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6567": [
        "EPSG:6567",
        "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6568": [
        "EPSG:6568",
        "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998983997 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6569": [
        "EPSG:6569",
        "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6671": [
        "EPSG:6671",
        "+proj=tmerc +lat_0=36 +lon_0=132.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6570": [
        "EPSG:6570",
        "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6571": [
        "EPSG:6571",
        "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6572": [
        "EPSG:6572",
        "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6573": [
        "EPSG:6573",
        "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6574": [
        "EPSG:6574",
        "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6575": [
        "EPSG:6575",
        "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6576": [
        "EPSG:6576",
        "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6577": [
        "EPSG:6577",
        "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4962": ["EPSG:4962", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6578": [
        "EPSG:6578",
        "+proj=lcc +lat_1=31.88333333333333 +lat_2=30.11666666666667 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=699999.9998983998 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6579": [
        "EPSG:6579",
        "+proj=aea +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6580": [
        "EPSG:6580",
        "+proj=lcc +lat_1=27.5 +lat_2=35 +lat_0=18 +lon_0=-100 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6581": [
        "EPSG:6581",
        "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6582": [
        "EPSG:6582",
        "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000.0001016002 +y_0=999999.9998983998 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6583": [
        "EPSG:6583",
        "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6584": [
        "EPSG:6584",
        "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6585": [
        "EPSG:6585",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4964": ["EPSG:4964", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6586": [
        "EPSG:6586",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000.0000000001 +y_0=5000000.0001016 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6587": [
        "EPSG:6587",
        "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6588": [
        "EPSG:6588",
        "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6589": [
        "EPSG:6589",
        "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6590": [
        "EPSG:6590",
        "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6591": [
        "EPSG:6591",
        "+proj=lcc +lat_1=37 +lat_2=39.5 +lat_0=36 +lon_0=-79.5 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6592": [
        "EPSG:6592",
        "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6593": [
        "EPSG:6593",
        "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6672": [
        "EPSG:6672",
        "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6594": [
        "EPSG:6594",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6595": [
        "EPSG:6595",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000.0001016 +y_0=999999.9998983998 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6596": [
        "EPSG:6596",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6597": [
        "EPSG:6597",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6598": [
        "EPSG:6598",
        "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6599": [
        "EPSG:6599",
        "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000.0001016001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6600": [
        "EPSG:6600",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6601": [
        "EPSG:6601",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:4966": ["EPSG:4966", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6602": [
        "EPSG:6602",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6603": [
        "EPSG:6603",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6604": [
        "EPSG:6604",
        "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6605": [
        "EPSG:6605",
        "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6606": [
        "EPSG:6606",
        "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6607": [
        "EPSG:6607",
        "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6608": [
        "EPSG:6608",
        "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6609": [
        "EPSG:6609",
        "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:32603": [
        "EPSG:32603",
        "+proj=utm +zone=3 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6613": [
        "EPSG:6613",
        "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6614": [
        "EPSG:6614",
        "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998983997 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6615": [
        "EPSG:6615",
        "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6616": [
        "EPSG:6616",
        "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6617": [
        "EPSG:6617",
        "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6618": [
        "EPSG:6618",
        "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6619": [
        "EPSG:6619",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6620": [
        "EPSG:6620",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6621": [
        "EPSG:6621",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6622": [
        "EPSG:6622",
        "+proj=lcc +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6623": [
        "EPSG:6623",
        "+proj=aea +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:6624": [
        "EPSG:6624",
        "+proj=aea +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6625": [
        "EPSG:6625",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6626": [
        "EPSG:6626",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.00001016 +y_0=999999.9999898402 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6627": [
        "EPSG:6627",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6628": [
        "EPSG:6628",
        "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6629": [
        "EPSG:6629",
        "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6630": [
        "EPSG:6630",
        "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6631": [
        "EPSG:6631",
        "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6632": [
        "EPSG:6632",
        "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6633": [
        "EPSG:6633",
        "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6634": [
        "EPSG:6634",
        "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6635": [
        "EPSG:6635",
        "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6636": [
        "EPSG:6636",
        "+proj=utm +zone=2 +south +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6637": [
        "EPSG:6637",
        "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6646": [
        "EPSG:6646",
        "+proj=tmerc +lat_0=29.02626833333333 +lon_0=46.5 +k=0.9994 +x_0=800000 +y_0=0 +ellps=clrk80 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6669": [
        "EPSG:6669",
        "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6670": [
        "EPSG:6670",
        "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6675": [
        "EPSG:6675",
        "+proj=tmerc +lat_0=36 +lon_0=137.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6676": [
        "EPSG:6676",
        "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6677": [
        "EPSG:6677",
        "+proj=tmerc +lat_0=36 +lon_0=139.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6678": [
        "EPSG:6678",
        "+proj=tmerc +lat_0=40 +lon_0=140.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6679": [
        "EPSG:6679",
        "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6680": [
        "EPSG:6680",
        "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6681": [
        "EPSG:6681",
        "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6682": [
        "EPSG:6682",
        "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6683": [
        "EPSG:6683",
        "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6684": [
        "EPSG:6684",
        "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6685": [
        "EPSG:6685",
        "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6689": [
        "EPSG:6689",
        "+proj=utm +zone=52 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6690": [
        "EPSG:6690",
        "+proj=utm +zone=53 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6691": [
        "EPSG:6691",
        "+proj=utm +zone=54 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6692": [
        "EPSG:6692",
        "+proj=utm +zone=55 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6703": [
        "EPSG:6703",
        "+proj=tmerc +lat_0=0 +lon_0=-60 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6707": [
        "EPSG:6707",
        "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6708": [
        "EPSG:6708",
        "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6709": [
        "EPSG:6709",
        "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6720": [
        "EPSG:6720",
        "+proj=tmerc +lat_0=0 +lon_0=105.625 +k=1.000024 +x_0=50000 +y_0=1300000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6721": [
        "EPSG:6721",
        "+proj=tmerc +lat_0=0 +lon_0=105.625 +k=1.00002514 +x_0=50000 +y_0=1300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6722": [
        "EPSG:6722",
        "+proj=tmerc +lat_0=0 +lon_0=96.875 +k=1 +x_0=50000 +y_0=1400000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6723": [
        "EPSG:6723",
        "+proj=tmerc +lat_0=0 +lon_0=96.875 +k=0.99999387 +x_0=50000 +y_0=1500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6732": [
        "EPSG:6732",
        "+proj=utm +zone=41 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6733": [
        "EPSG:6733",
        "+proj=utm +zone=42 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6734": [
        "EPSG:6734",
        "+proj=utm +zone=43 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6735": [
        "EPSG:6735",
        "+proj=utm +zone=44 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6736": [
        "EPSG:6736",
        "+proj=utm +zone=46 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6737": [
        "EPSG:6737",
        "+proj=utm +zone=47 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6738": [
        "EPSG:6738",
        "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6784": [
        "EPSG:6784",
        "+proj=tmerc +lat_0=44.5 +lon_0=-117.8333333333333 +k=1.00016 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6785": [
        "EPSG:6785",
        "+proj=tmerc +lat_0=44.5 +lon_0=-117.8333333333333 +k=1.00016 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6786": [
        "EPSG:6786",
        "+proj=tmerc +lat_0=44.5 +lon_0=-117.8333333333333 +k=1.00016 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6787": [
        "EPSG:6787",
        "+proj=tmerc +lat_0=44.5 +lon_0=-117.8333333333333 +k=1.00016 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6788": [
        "EPSG:6788",
        "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6789": [
        "EPSG:6789",
        "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6790": [
        "EPSG:6790",
        "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6791": [
        "EPSG:6791",
        "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6792": [
        "EPSG:6792",
        "+proj=lcc +lat_1=44.66666666666666 +lat_0=44.66666666666666 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6793": [
        "EPSG:6793",
        "+proj=lcc +lat_1=44.66666666666666 +lat_0=44.66666666666666 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6794": [
        "EPSG:6794",
        "+proj=lcc +lat_1=44.66666666666666 +lat_0=44.66666666666666 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4968": ["EPSG:4968", "+proj=geocent +ellps=intl +units=m +no_defs "],
    "EPSG:6795": [
        "EPSG:6795",
        "+proj=lcc +lat_1=44.66666666666666 +lat_0=44.66666666666666 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6796": [
        "EPSG:6796",
        "+proj=lcc +lat_1=43.66666666666666 +lat_0=43.66666666666666 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6797": [
        "EPSG:6797",
        "+proj=lcc +lat_1=43.66666666666666 +lat_0=43.66666666666666 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999952 +y_0=59999.99999976 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6798": [
        "EPSG:6798",
        "+proj=lcc +lat_1=43.66666666666666 +lat_0=43.66666666666666 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6799": [
        "EPSG:6799",
        "+proj=lcc +lat_1=43.66666666666666 +lat_0=43.66666666666666 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999952 +y_0=59999.99999976 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6800": [
        "EPSG:6800",
        "+proj=tmerc +lat_0=42.5 +lon_0=-123.3333333333333 +k=1.00007 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6801": [
        "EPSG:6801",
        "+proj=tmerc +lat_0=42.5 +lon_0=-123.3333333333333 +k=1.00007 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6802": [
        "EPSG:6802",
        "+proj=tmerc +lat_0=42.5 +lon_0=-123.3333333333333 +k=1.00007 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6803": [
        "EPSG:6803",
        "+proj=tmerc +lat_0=42.5 +lon_0=-123.3333333333333 +k=1.00007 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6804": [
        "EPSG:6804",
        "+proj=lcc +lat_1=45.66666666666666 +lat_0=45.66666666666666 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6805": [
        "EPSG:6805",
        "+proj=lcc +lat_1=45.66666666666666 +lat_0=45.66666666666666 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6806": [
        "EPSG:6806",
        "+proj=lcc +lat_1=45.66666666666666 +lat_0=45.66666666666666 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6807": [
        "EPSG:6807",
        "+proj=lcc +lat_1=45.66666666666666 +lat_0=45.66666666666666 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6808": [
        "EPSG:6808",
        "+proj=omerc +lat_0=45.91666666666666 +lonc=-123 +alpha=295 +k=1 +x_0=7000000 +y_0=-3000000 +no_uoff +gamma=295 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6809": [
        "EPSG:6809",
        "+proj=omerc +lat_0=45.91666666666666 +lonc=-123 +alpha=295 +k=1 +x_0=7000000.00000248 +y_0=-2999999.999988 +no_uoff +gamma=295 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6810": [
        "EPSG:6810",
        "+proj=omerc +lat_0=45.91666666666666 +lonc=-123 +alpha=295 +k=1 +x_0=7000000 +y_0=-3000000 +no_uoff +gamma=295 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6811": [
        "EPSG:6811",
        "+proj=omerc +lat_0=45.91666666666666 +lonc=-123 +alpha=295 +k=1 +x_0=7000000.00000248 +y_0=-2999999.999988 +no_uoff +gamma=295 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:4970": ["EPSG:4970", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6812": [
        "EPSG:6812",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-123.3333333333333 +k=1.000023 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6813": [
        "EPSG:6813",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-123.3333333333333 +k=1.000023 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6814": [
        "EPSG:6814",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-123.3333333333333 +k=1.000023 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6815": [
        "EPSG:6815",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-123.3333333333333 +k=1.000023 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6816": [
        "EPSG:6816",
        "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6817": [
        "EPSG:6817",
        "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6818": [
        "EPSG:6818",
        "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6819": [
        "EPSG:6819",
        "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6820": [
        "EPSG:6820",
        "+proj=tmerc +lat_0=43.75 +lon_0=-123.1666666666667 +k=1.000015 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4972": ["EPSG:4972", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:6821": [
        "EPSG:6821",
        "+proj=tmerc +lat_0=43.75 +lon_0=-123.1666666666667 +k=1.000015 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6822": [
        "EPSG:6822",
        "+proj=tmerc +lat_0=43.75 +lon_0=-123.1666666666667 +k=1.000015 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6823": [
        "EPSG:6823",
        "+proj=tmerc +lat_0=43.75 +lon_0=-123.1666666666667 +k=1.000015 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6824": [
        "EPSG:6824",
        "+proj=tmerc +lat_0=41.75 +lon_0=-123.3333333333333 +k=1.000043 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6825": [
        "EPSG:6825",
        "+proj=tmerc +lat_0=41.75 +lon_0=-123.3333333333333 +k=1.000043 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6826": [
        "EPSG:6826",
        "+proj=tmerc +lat_0=41.75 +lon_0=-123.3333333333333 +k=1.000043 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6827": [
        "EPSG:6827",
        "+proj=tmerc +lat_0=41.75 +lon_0=-123.3333333333333 +k=1.000043 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6828": [
        "EPSG:6828",
        "+proj=tmerc +lat_0=45 +lon_0=-122.3333333333333 +k=1.00005 +x_0=10000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6829": [
        "EPSG:6829",
        "+proj=tmerc +lat_0=45 +lon_0=-122.3333333333333 +k=1.00005 +x_0=10000.0000152 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:4974": ["EPSG:4974", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6830": [
        "EPSG:6830",
        "+proj=tmerc +lat_0=45 +lon_0=-122.3333333333333 +k=1.00005 +x_0=10000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6831": [
        "EPSG:6831",
        "+proj=tmerc +lat_0=45 +lon_0=-122.3333333333333 +k=1.00005 +x_0=10000.0000152 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6832": [
        "EPSG:6832",
        "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6833": [
        "EPSG:6833",
        "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6834": [
        "EPSG:6834",
        "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6835": [
        "EPSG:6835",
        "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6836": [
        "EPSG:6836",
        "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6837": [
        "EPSG:6837",
        "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6838": [
        "EPSG:6838",
        "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6870": [
        "EPSG:6870",
        "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6839": [
        "EPSG:6839",
        "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6840": [
        "EPSG:6840",
        "+proj=omerc +lat_0=44.75 +lonc=-124.05 +alpha=5 +k=1 +x_0=-300000 +y_0=-4600000 +no_uoff +gamma=5 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6841": [
        "EPSG:6841",
        "+proj=omerc +lat_0=44.75 +lonc=-124.05 +alpha=5 +k=1 +x_0=-299999.9999988 +y_0=-4600000.00001208 +no_uoff +gamma=5 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6842": [
        "EPSG:6842",
        "+proj=omerc +lat_0=44.75 +lonc=-124.05 +alpha=5 +k=1 +x_0=-300000 +y_0=-4600000 +no_uoff +gamma=5 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6843": [
        "EPSG:6843",
        "+proj=omerc +lat_0=44.75 +lonc=-124.05 +alpha=5 +k=1 +x_0=-299999.9999988 +y_0=-4600000.00001208 +no_uoff +gamma=5 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6844": [
        "EPSG:6844",
        "+proj=tmerc +lat_0=45.25 +lon_0=-119.1666666666667 +k=1.000045 +x_0=60000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6845": [
        "EPSG:6845",
        "+proj=tmerc +lat_0=45.25 +lon_0=-119.1666666666667 +k=1.000045 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6846": [
        "EPSG:6846",
        "+proj=tmerc +lat_0=45.25 +lon_0=-119.1666666666667 +k=1.000045 +x_0=60000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6847": [
        "EPSG:6847",
        "+proj=tmerc +lat_0=45.25 +lon_0=-119.1666666666667 +k=1.000045 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6848": [
        "EPSG:6848",
        "+proj=tmerc +lat_0=45.08333333333334 +lon_0=-118.3333333333333 +k=1.000175 +x_0=30000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6849": [
        "EPSG:6849",
        "+proj=tmerc +lat_0=45.08333333333334 +lon_0=-118.3333333333333 +k=1.000175 +x_0=30000.00001512 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6850": [
        "EPSG:6850",
        "+proj=tmerc +lat_0=45.08333333333334 +lon_0=-118.3333333333333 +k=1.000175 +x_0=30000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6851": [
        "EPSG:6851",
        "+proj=tmerc +lat_0=45.08333333333334 +lon_0=-118.3333333333333 +k=1.000175 +x_0=30000.00001512 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6852": [
        "EPSG:6852",
        "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6853": [
        "EPSG:6853",
        "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.99999960001 +y_0=50000.00001504 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6854": [
        "EPSG:6854",
        "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6855": [
        "EPSG:6855",
        "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.99999960001 +y_0=50000.00001504 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6856": [
        "EPSG:6856",
        "+proj=tmerc +lat_0=44.33333333333334 +lon_0=-123.0833333333333 +k=1.00001 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6857": [
        "EPSG:6857",
        "+proj=tmerc +lat_0=44.33333333333334 +lon_0=-123.0833333333333 +k=1.00001 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6858": [
        "EPSG:6858",
        "+proj=tmerc +lat_0=44.33333333333334 +lon_0=-123.0833333333333 +k=1.00001 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6859": [
        "EPSG:6859",
        "+proj=tmerc +lat_0=44.33333333333334 +lon_0=-123.0833333333333 +k=1.00001 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6860": [
        "EPSG:6860",
        "+proj=tmerc +lat_0=44.08333333333334 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6861": [
        "EPSG:6861",
        "+proj=tmerc +lat_0=44.08333333333334 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6862": [
        "EPSG:6862",
        "+proj=tmerc +lat_0=44.08333333333334 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6863": [
        "EPSG:6863",
        "+proj=tmerc +lat_0=44.08333333333334 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6867": [
        "EPSG:6867",
        "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6868": [
        "EPSG:6868",
        "+proj=lcc +lat_1=43 +lat_2=45.5 +lat_0=41.75 +lon_0=-120.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6875": [
        "EPSG:6875",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9985000000000001 +x_0=7000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6876": [
        "EPSG:6876",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=3000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6879": [
        "EPSG:6879",
        "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6880": [
        "EPSG:6880",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6884": [
        "EPSG:6884",
        "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6885": [
        "EPSG:6885",
        "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6886": [
        "EPSG:6886",
        "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6887": [
        "EPSG:6887",
        "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:6915": [
        "EPSG:6915",
        "+proj=utm +zone=40 +ellps=clrk80 +towgs84=-43.685,-179.785,-267.721,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6922": [
        "EPSG:6922",
        "+proj=lcc +lat_1=39.5 +lat_2=37.5 +lat_0=36 +lon_0=-98.25 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:6923": [
        "EPSG:6923",
        "+proj=lcc +lat_1=39.5 +lat_2=37.5 +lat_0=36 +lon_0=-98.25 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:6924": [
        "EPSG:6924",
        "+proj=lcc +lat_1=39.5 +lat_2=37.5 +lat_0=36 +lon_0=-98.25 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6925": [
        "EPSG:6925",
        "+proj=lcc +lat_1=39.5 +lat_2=37.5 +lat_0=36 +lon_0=-98.25 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:6931": [
        "EPSG:6931",
        "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6932": [
        "EPSG:6932",
        "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6933": [
        "EPSG:6933",
        "+proj=cea +lon_0=0 +lat_ts=30 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6956": [
        "EPSG:6956",
        "+proj=tmerc +lat_0=0 +lon_0=102 +k=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs ",
    ],
    "EPSG:6957": [
        "EPSG:6957",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs ",
    ],
    "EPSG:32604": [
        "EPSG:32604",
        "+proj=utm +zone=4 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:6958": [
        "EPSG:6958",
        "+proj=tmerc +lat_0=0 +lon_0=108 +k=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs ",
    ],
    "EPSG:6959": [
        "EPSG:6959",
        "+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs ",
    ],
    "EPSG:6962": [
        "EPSG:6962",
        "+proj=lcc +lat_1=39 +lat_2=43 +lat_0=41 +lon_0=20 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:6984": [
        "EPSG:6984",
        "+proj=tmerc +lat_0=31.73439361111111 +lon_0=35.20451694444445 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6991": [
        "EPSG:6991",
        "+proj=tmerc +lat_0=31.73439361111111 +lon_0=35.20451694444445 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6996": [
        "EPSG:6996",
        "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:6997": [
        "EPSG:6997",
        "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7005": [
        "EPSG:7005",
        "+proj=utm +zone=37 +ellps=clrk80 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:7006": [
        "EPSG:7006",
        "+proj=utm +zone=38 +ellps=clrk80 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:7007": [
        "EPSG:7007",
        "+proj=utm +zone=39 +ellps=clrk80 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:7057": [
        "EPSG:7057",
        "+proj=lcc +lat_1=43.2 +lat_0=43.2 +lon_0=-95.25 +k_0=1.000052 +x_0=3505207.010414021 +y_0=2926085.852171705 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7058": [
        "EPSG:7058",
        "+proj=lcc +lat_1=43.16666666666666 +lat_0=43.16666666666666 +lon_0=-92.75 +k_0=1.000043 +x_0=3810007.62001524 +y_0=2987045.974091948 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7059": [
        "EPSG:7059",
        "+proj=tmerc +lat_0=40.25 +lon_0=-91.2 +k=1.000035 +x_0=4114808.229616459 +y_0=2529845.05969012 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7060": [
        "EPSG:7060",
        "+proj=lcc +lat_1=42.53333333333333 +lat_0=42.53333333333333 +lon_0=-94.83333333333333 +k_0=1.000045 +x_0=4419608.839217679 +y_0=2621285.242570485 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7061": [
        "EPSG:7061",
        "+proj=lcc +lat_1=42.65 +lat_0=42.65 +lon_0=-92.25 +k_0=1.000032 +x_0=4724409.448818898 +y_0=2712725.425450851 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7062": [
        "EPSG:7062",
        "+proj=tmerc +lat_0=40.25 +lon_0=-95.73333333333333 +k=1.000039 +x_0=5029210.058420117 +y_0=2011684.023368047 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7063": [
        "EPSG:7063",
        "+proj=tmerc +lat_0=40.25 +lon_0=-94.63333333333334 +k=1.000045 +x_0=5334010.668021336 +y_0=2072644.145288291 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7064": [
        "EPSG:7064",
        "+proj=tmerc +lat_0=40.25 +lon_0=-93.71666666666667 +k=1.000033 +x_0=5638811.277622555 +y_0=2133604.267208535 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7065": [
        "EPSG:7065",
        "+proj=tmerc +lat_0=40.25 +lon_0=-92.81666666666666 +k=1.000027 +x_0=5943611.887223775 +y_0=2194564.389128779 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7066": [
        "EPSG:7066",
        "+proj=lcc +lat_1=41.83333333333334 +lat_0=41.83333333333334 +lon_0=-91.66666666666667 +k_0=1.00002 +x_0=6248412.496824994 +y_0=2438404.876809754 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7067": [
        "EPSG:7067",
        "+proj=tmerc +lat_0=40.25 +lon_0=-90.53333333333333 +k=1.000027 +x_0=6553213.106426213 +y_0=2316484.632969266 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7068": [
        "EPSG:7068",
        "+proj=lcc +lat_1=40.91666666666666 +lat_0=40.91666666666666 +lon_0=-93.75 +k_0=1.000037 +x_0=6858013.716027432 +y_0=1889763.779527559 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7069": [
        "EPSG:7069",
        "+proj=tmerc +lat_0=40.25 +lon_0=-91.91666666666667 +k=1.00002 +x_0=7162814.325628651 +y_0=1950723.901447803 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7070": [
        "EPSG:7070",
        "+proj=tmerc +lat_0=40.25 +lon_0=-91.25 +k=1.000018 +x_0=7467614.93522987 +y_0=1889763.779527559 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7074": [
        "EPSG:7074",
        "+proj=utm +zone=37 +south +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7075": [
        "EPSG:7075",
        "+proj=utm +zone=38 +south +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7076": [
        "EPSG:7076",
        "+proj=utm +zone=39 +south +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7077": [
        "EPSG:7077",
        "+proj=utm +zone=40 +south +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7078": [
        "EPSG:7078",
        "+proj=utm +zone=41 +south +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7079": [
        "EPSG:7079",
        "+proj=utm +zone=42 +south +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7080": [
        "EPSG:7080",
        "+proj=utm +zone=43 +south +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7081": [
        "EPSG:7081",
        "+proj=utm +zone=44 +south +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7109": [
        "EPSG:7109",
        "+proj=tmerc +lat_0=48.5 +lon_0=-112.5 +k=1.00016 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7110": [
        "EPSG:7110",
        "+proj=tmerc +lat_0=48 +lon_0=-112.5 +k=1.00019 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7111": [
        "EPSG:7111",
        "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000 +y_0=200000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7112": [
        "EPSG:7112",
        "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=200000 +y_0=150000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7113": [
        "EPSG:7113",
        "+proj=lcc +lat_1=48.33333333333334 +lat_0=48.33333333333334 +lon_0=-105.5 +k_0=1.00012 +x_0=200000 +y_0=100000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7114": [
        "EPSG:7114",
        "+proj=lcc +lat_1=48.33333333333334 +lat_0=48.33333333333334 +lon_0=-105.5 +k_0=1.00009 +x_0=100000 +y_0=50000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7115": [
        "EPSG:7115",
        "+proj=tmerc +lat_0=44.75 +lon_0=-107.75 +k=1.000148 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7116": [
        "EPSG:7116",
        "+proj=lcc +lat_1=46.25 +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=100000 +y_0=100000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7117": [
        "EPSG:7117",
        "+proj=lcc +lat_1=45.78333333333333 +lat_0=45.78333333333333 +lon_0=-108.4166666666667 +k_0=1.0001515 +x_0=200000 +y_0=50000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7118": [
        "EPSG:7118",
        "+proj=tmerc +lat_0=42.66666666666666 +lon_0=-108.3333333333333 +k=1.00024 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7119": [
        "EPSG:7119",
        "+proj=tmerc +lat_0=48.5 +lon_0=-112.5 +k=1.00016 +x_0=150000.00001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:7120": [
        "EPSG:7120",
        "+proj=tmerc +lat_0=48 +lon_0=-112.5 +k=1.00019 +x_0=99999.99999960001 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:7121": [
        "EPSG:7121",
        "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000.00001464 +y_0=199999.9999992 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:7122": [
        "EPSG:7122",
        "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=199999.9999992 +y_0=150000.00001464 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:4980": ["EPSG:4980", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:7123": [
        "EPSG:7123",
        "+proj=lcc +lat_1=48.33333333333334 +lat_0=48.33333333333334 +lon_0=-105.5 +k_0=1.00012 +x_0=199999.9999992 +y_0=99999.99999960001 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:7124": [
        "EPSG:7124",
        "+proj=lcc +lat_1=48.33333333333334 +lat_0=48.33333333333334 +lon_0=-105.5 +k_0=1.00009 +x_0=99999.99999960001 +y_0=49999.99971024 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:7125": [
        "EPSG:7125",
        "+proj=tmerc +lat_0=44.75 +lon_0=-107.75 +k=1.000148 +x_0=199999.9999992 +y_0=0 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:7126": [
        "EPSG:7126",
        "+proj=lcc +lat_1=46.25 +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=99999.99999960001 +y_0=99999.99999960001 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:7127": [
        "EPSG:7127",
        "+proj=lcc +lat_1=45.78333333333333 +lat_0=45.78333333333333 +lon_0=-108.4166666666667 +k_0=1.0001515 +x_0=199999.9999992 +y_0=50000.00001504 +ellps=GRS80 +units=ft +no_defs ",
    ],
    "EPSG:7128": [
        "EPSG:7128",
        "+proj=tmerc +lat_0=42.66666666666666 +lon_0=-108.3333333333333 +k=1.00024 +x_0=99999.99998983997 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7131": [
        "EPSG:7131",
        "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7132": [
        "EPSG:7132",
        "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7142": [
        "EPSG:7142",
        "+proj=tmerc +lat_0=31.73409694444445 +lon_0=35.21208055555556 +k=1 +x_0=170251.555 +y_0=126867.909 +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +units=m +no_defs ",
    ],
    "EPSG:7257": [
        "EPSG:7257",
        "+proj=tmerc +lat_0=40.55 +lon_0=-84.95 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7258": [
        "EPSG:7258",
        "+proj=tmerc +lat_0=40.55 +lon_0=-84.95 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7259": [
        "EPSG:7259",
        "+proj=tmerc +lat_0=40.9 +lon_0=-85.05 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7260": [
        "EPSG:7260",
        "+proj=tmerc +lat_0=40.9 +lon_0=-85.05 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7261": [
        "EPSG:7261",
        "+proj=tmerc +lat_0=39 +lon_0=-85.84999999999999 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7262": [
        "EPSG:7262",
        "+proj=tmerc +lat_0=39 +lon_0=-85.84999999999999 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7263": [
        "EPSG:7263",
        "+proj=tmerc +lat_0=40.45 +lon_0=-87.3 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7264": [
        "EPSG:7264",
        "+proj=tmerc +lat_0=40.45 +lon_0=-87.3 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7265": [
        "EPSG:7265",
        "+proj=tmerc +lat_0=40.05 +lon_0=-85.40000000000001 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:22832": [
        "EPSG:22832",
        "+proj=utm +zone=32 +a=6378249.2 +b=6356515 +units=m +no_defs ",
    ],
    "EPSG:7266": [
        "EPSG:7266",
        "+proj=tmerc +lat_0=40.05 +lon_0=-85.40000000000001 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7267": [
        "EPSG:7267",
        "+proj=tmerc +lat_0=39.6 +lon_0=-86.5 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7268": [
        "EPSG:7268",
        "+proj=tmerc +lat_0=39.6 +lon_0=-86.5 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7269": [
        "EPSG:7269",
        "+proj=tmerc +lat_0=39 +lon_0=-86.3 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7270": [
        "EPSG:7270",
        "+proj=tmerc +lat_0=39 +lon_0=-86.3 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7271": [
        "EPSG:7271",
        "+proj=tmerc +lat_0=40.4 +lon_0=-86.65000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7272": [
        "EPSG:7272",
        "+proj=tmerc +lat_0=40.4 +lon_0=-86.65000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7273": [
        "EPSG:7273",
        "+proj=tmerc +lat_0=40.55 +lon_0=-86.40000000000001 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7274": [
        "EPSG:7274",
        "+proj=tmerc +lat_0=40.55 +lon_0=-86.40000000000001 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:4982": ["EPSG:4982", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:7275": [
        "EPSG:7275",
        "+proj=tmerc +lat_0=38.15 +lon_0=-85.59999999999999 +k=1.000021 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7276": [
        "EPSG:7276",
        "+proj=tmerc +lat_0=38.15 +lon_0=-85.59999999999999 +k=1.000021 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7277": [
        "EPSG:7277",
        "+proj=tmerc +lat_0=39.15 +lon_0=-87.15000000000001 +k=1.000024 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7278": [
        "EPSG:7278",
        "+proj=tmerc +lat_0=39.15 +lon_0=-87.15000000000001 +k=1.000024 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7279": [
        "EPSG:7279",
        "+proj=tmerc +lat_0=40.15 +lon_0=-86.59999999999999 +k=1.000032 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7280": [
        "EPSG:7280",
        "+proj=tmerc +lat_0=40.15 +lon_0=-86.59999999999999 +k=1.000032 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7281": [
        "EPSG:7281",
        "+proj=tmerc +lat_0=38.1 +lon_0=-86.5 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7282": [
        "EPSG:7282",
        "+proj=tmerc +lat_0=38.1 +lon_0=-86.5 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7283": [
        "EPSG:7283",
        "+proj=tmerc +lat_0=38.45 +lon_0=-87.09999999999999 +k=1.000018 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4984": ["EPSG:4984", "+proj=geocent +ellps=WGS72 +units=m +no_defs "],
    "EPSG:7284": [
        "EPSG:7284",
        "+proj=tmerc +lat_0=38.45 +lon_0=-87.09999999999999 +k=1.000018 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7285": [
        "EPSG:7285",
        "+proj=tmerc +lat_0=38.65 +lon_0=-84.90000000000001 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7286": [
        "EPSG:7286",
        "+proj=tmerc +lat_0=38.65 +lon_0=-84.90000000000001 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7287": [
        "EPSG:7287",
        "+proj=tmerc +lat_0=39.1 +lon_0=-85.65000000000001 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7288": [
        "EPSG:7288",
        "+proj=tmerc +lat_0=39.1 +lon_0=-85.65000000000001 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7289": [
        "EPSG:7289",
        "+proj=tmerc +lat_0=41.25 +lon_0=-84.95 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7290": [
        "EPSG:7290",
        "+proj=tmerc +lat_0=41.25 +lon_0=-84.95 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7291": [
        "EPSG:7291",
        "+proj=tmerc +lat_0=38.2 +lon_0=-86.95 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7292": [
        "EPSG:7292",
        "+proj=tmerc +lat_0=38.2 +lon_0=-86.95 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7293": [
        "EPSG:7293",
        "+proj=tmerc +lat_0=40.65 +lon_0=-85.84999999999999 +k=1.000033 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7294": [
        "EPSG:7294",
        "+proj=tmerc +lat_0=40.65 +lon_0=-85.84999999999999 +k=1.000033 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7295": [
        "EPSG:7295",
        "+proj=tmerc +lat_0=39.25 +lon_0=-85.05 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7296": [
        "EPSG:7296",
        "+proj=tmerc +lat_0=39.25 +lon_0=-85.05 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7297": [
        "EPSG:7297",
        "+proj=tmerc +lat_0=39.95 +lon_0=-87.3 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7298": [
        "EPSG:7298",
        "+proj=tmerc +lat_0=39.95 +lon_0=-87.3 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7299": [
        "EPSG:7299",
        "+proj=tmerc +lat_0=40.9 +lon_0=-86.3 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7300": [
        "EPSG:7300",
        "+proj=tmerc +lat_0=40.9 +lon_0=-86.3 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7301": [
        "EPSG:7301",
        "+proj=tmerc +lat_0=38.15 +lon_0=-87.65000000000001 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:4988": ["EPSG:4988", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:7302": [
        "EPSG:7302",
        "+proj=tmerc +lat_0=38.15 +lon_0=-87.65000000000001 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7303": [
        "EPSG:7303",
        "+proj=tmerc +lat_0=40.35 +lon_0=-85.7 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7304": [
        "EPSG:7304",
        "+proj=tmerc +lat_0=40.35 +lon_0=-85.7 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7305": [
        "EPSG:7305",
        "+proj=tmerc +lat_0=39.9 +lon_0=-86 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7306": [
        "EPSG:7306",
        "+proj=tmerc +lat_0=39.9 +lon_0=-86 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7307": [
        "EPSG:7307",
        "+proj=tmerc +lat_0=39.65 +lon_0=-85.8 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7308": [
        "EPSG:7308",
        "+proj=tmerc +lat_0=39.65 +lon_0=-85.8 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7309": [
        "EPSG:7309",
        "+proj=tmerc +lat_0=37.95 +lon_0=-86.15000000000001 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7310": [
        "EPSG:7310",
        "+proj=tmerc +lat_0=37.95 +lon_0=-86.15000000000001 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:4990": ["EPSG:4990", "+proj=geocent +ellps=krass +units=m +no_defs "],
    "EPSG:7311": [
        "EPSG:7311",
        "+proj=tmerc +lat_0=39.75 +lon_0=-85.45 +k=1.000043 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7312": [
        "EPSG:7312",
        "+proj=tmerc +lat_0=39.75 +lon_0=-85.45 +k=1.000043 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7313": [
        "EPSG:7313",
        "+proj=tmerc +lat_0=40.35 +lon_0=-86.15000000000001 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7314": [
        "EPSG:7314",
        "+proj=tmerc +lat_0=40.35 +lon_0=-86.15000000000001 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7315": [
        "EPSG:7315",
        "+proj=tmerc +lat_0=40.65 +lon_0=-85.5 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7316": [
        "EPSG:7316",
        "+proj=tmerc +lat_0=40.65 +lon_0=-85.5 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7317": [
        "EPSG:7317",
        "+proj=tmerc +lat_0=38.7 +lon_0=-85.95 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7318": [
        "EPSG:7318",
        "+proj=tmerc +lat_0=38.7 +lon_0=-85.95 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7319": [
        "EPSG:7319",
        "+proj=tmerc +lat_0=40.7 +lon_0=-87.09999999999999 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:32605": [
        "EPSG:32605",
        "+proj=utm +zone=5 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:7320": [
        "EPSG:7320",
        "+proj=tmerc +lat_0=40.7 +lon_0=-87.09999999999999 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7321": [
        "EPSG:7321",
        "+proj=tmerc +lat_0=40.3 +lon_0=-85 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7322": [
        "EPSG:7322",
        "+proj=tmerc +lat_0=40.3 +lon_0=-85 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7323": [
        "EPSG:7323",
        "+proj=tmerc +lat_0=38.55 +lon_0=-85.34999999999999 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7324": [
        "EPSG:7324",
        "+proj=tmerc +lat_0=38.55 +lon_0=-85.34999999999999 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7325": [
        "EPSG:7325",
        "+proj=tmerc +lat_0=38.8 +lon_0=-85.8 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7326": [
        "EPSG:7326",
        "+proj=tmerc +lat_0=38.8 +lon_0=-85.8 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7327": [
        "EPSG:7327",
        "+proj=tmerc +lat_0=39.3 +lon_0=-86.15000000000001 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7328": [
        "EPSG:7328",
        "+proj=tmerc +lat_0=39.3 +lon_0=-86.15000000000001 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:4992": ["EPSG:4992", "+proj=geocent +ellps=krass +units=m +no_defs "],
    "EPSG:7329": [
        "EPSG:7329",
        "+proj=tmerc +lat_0=38.4 +lon_0=-87.45 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7330": [
        "EPSG:7330",
        "+proj=tmerc +lat_0=38.4 +lon_0=-87.45 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7331": [
        "EPSG:7331",
        "+proj=tmerc +lat_0=41.25 +lon_0=-85.45 +k=1.000037 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7332": [
        "EPSG:7332",
        "+proj=tmerc +lat_0=41.25 +lon_0=-85.45 +k=1.000037 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7333": [
        "EPSG:7333",
        "+proj=tmerc +lat_0=40.7 +lon_0=-87.40000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7334": [
        "EPSG:7334",
        "+proj=tmerc +lat_0=40.7 +lon_0=-87.40000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7335": [
        "EPSG:7335",
        "+proj=tmerc +lat_0=40.9 +lon_0=-86.75 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7336": [
        "EPSG:7336",
        "+proj=tmerc +lat_0=40.9 +lon_0=-86.75 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7337": [
        "EPSG:7337",
        "+proj=tmerc +lat_0=38.95 +lon_0=-86.5 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7338": [
        "EPSG:7338",
        "+proj=tmerc +lat_0=38.95 +lon_0=-86.5 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7339": [
        "EPSG:7339",
        "+proj=tmerc +lat_0=39.45 +lon_0=-86.95 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7340": [
        "EPSG:7340",
        "+proj=tmerc +lat_0=39.45 +lon_0=-86.95 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7341": [
        "EPSG:7341",
        "+proj=tmerc +lat_0=39.15 +lon_0=-86.90000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7342": [
        "EPSG:7342",
        "+proj=tmerc +lat_0=39.15 +lon_0=-86.90000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7343": [
        "EPSG:7343",
        "+proj=tmerc +lat_0=39.6 +lon_0=-87.34999999999999 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7344": [
        "EPSG:7344",
        "+proj=tmerc +lat_0=39.6 +lon_0=-87.34999999999999 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7345": [
        "EPSG:7345",
        "+proj=tmerc +lat_0=37.8 +lon_0=-86.7 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7346": [
        "EPSG:7346",
        "+proj=tmerc +lat_0=37.8 +lon_0=-86.7 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:4994": [
        "EPSG:4994",
        "+proj=geocent +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:7347": [
        "EPSG:7347",
        "+proj=tmerc +lat_0=37.85 +lon_0=-87.3 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7348": [
        "EPSG:7348",
        "+proj=tmerc +lat_0=37.85 +lon_0=-87.3 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7349": [
        "EPSG:7349",
        "+proj=tmerc +lat_0=37.75 +lon_0=-87.95 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7350": [
        "EPSG:7350",
        "+proj=tmerc +lat_0=37.75 +lon_0=-87.95 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7351": [
        "EPSG:7351",
        "+proj=tmerc +lat_0=39.7 +lon_0=-85.05 +k=1.000044 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7352": [
        "EPSG:7352",
        "+proj=tmerc +lat_0=39.7 +lon_0=-85.05 +k=1.000044 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7353": [
        "EPSG:7353",
        "+proj=tmerc +lat_0=38.9 +lon_0=-85.3 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7354": [
        "EPSG:7354",
        "+proj=tmerc +lat_0=38.9 +lon_0=-85.3 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7355": [
        "EPSG:7355",
        "+proj=tmerc +lat_0=39.3 +lon_0=-85.90000000000001 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:26702": [
        "EPSG:26702",
        "+proj=utm +zone=2 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:7356": [
        "EPSG:7356",
        "+proj=tmerc +lat_0=39.3 +lon_0=-85.90000000000001 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7357": [
        "EPSG:7357",
        "+proj=tmerc +lat_0=37.75 +lon_0=-87.05 +k=1.000014 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7358": [
        "EPSG:7358",
        "+proj=tmerc +lat_0=37.75 +lon_0=-87.05 +k=1.000014 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7359": [
        "EPSG:7359",
        "+proj=tmerc +lat_0=41.5 +lon_0=-85 +k=1.000041 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7360": [
        "EPSG:7360",
        "+proj=tmerc +lat_0=41.5 +lon_0=-85 +k=1.000041 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7361": [
        "EPSG:7361",
        "+proj=tmerc +lat_0=38.9 +lon_0=-87.5 +k=1.000017 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7362": [
        "EPSG:7362",
        "+proj=tmerc +lat_0=38.9 +lon_0=-87.5 +k=1.000017 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7363": [
        "EPSG:7363",
        "+proj=tmerc +lat_0=40.2 +lon_0=-86.90000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7364": [
        "EPSG:7364",
        "+proj=tmerc +lat_0=40.2 +lon_0=-86.90000000000001 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:32607": [
        "EPSG:32607",
        "+proj=utm +zone=7 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:7365": [
        "EPSG:7365",
        "+proj=tmerc +lat_0=37.8 +lon_0=-87.55 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7366": [
        "EPSG:7366",
        "+proj=tmerc +lat_0=37.8 +lon_0=-87.55 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7367": [
        "EPSG:7367",
        "+proj=tmerc +lat_0=39.25 +lon_0=-87.45 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7368": [
        "EPSG:7368",
        "+proj=tmerc +lat_0=39.25 +lon_0=-87.45 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7369": [
        "EPSG:7369",
        "+proj=tmerc +lat_0=40.55 +lon_0=-85.25 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7370": [
        "EPSG:7370",
        "+proj=tmerc +lat_0=40.55 +lon_0=-85.25 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7374": [
        "EPSG:7374",
        "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:7375": [
        "EPSG:7375",
        "+proj=utm +zone=40 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:7376": [
        "EPSG:7376",
        "+proj=utm +zone=41 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:7528": [
        "EPSG:7528",
        "+proj=tmerc +lat_0=43.36666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7529": [
        "EPSG:7529",
        "+proj=tmerc +lat_0=45.70611111111111 +lon_0=-90.62222222222222 +k=1.0000495683 +x_0=172821.9461 +y_0=0.0017 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7530": [
        "EPSG:7530",
        "+proj=tmerc +lat_0=45.13333333333333 +lon_0=-91.84999999999999 +k=1.0000486665 +x_0=93150 +y_0=0.0029 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7531": [
        "EPSG:7531",
        "+proj=lcc +lat_1=46.66964837722222 +lat_0=46.66964837722222 +lon_0=-91.15277777777779 +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7532": [
        "EPSG:7532",
        "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31600 +y_0=4600 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7533": [
        "EPSG:7533",
        "+proj=tmerc +lat_0=43.48138888888889 +lon_0=-91.79722222222222 +k=1.0000382778 +x_0=175260.3502 +y_0=0.0048 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7534": [
        "EPSG:7534",
        "+proj=lcc +lat_1=45.89871486583333 +lat_0=45.89871486583333 +lon_0=-92.45777777777778 +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7535": [
        "EPSG:7535",
        "+proj=tmerc +lat_0=42.71944444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7536": [
        "EPSG:7536",
        "+proj=lcc +lat_1=44.97785689861112 +lat_0=44.97785689861112 +lon_0=-91.29444444444444 +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7537": [
        "EPSG:7537",
        "+proj=tmerc +lat_0=43.6 +lon_0=-90.70833333333334 +k=1.0000463003 +x_0=199949.1989 +y_0=0.0086 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7538": [
        "EPSG:7538",
        "+proj=lcc +lat_1=43.46254664583333 +lat_0=43.46254664583333 +lon_0=-89.39444444444445 +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7539": [
        "EPSG:7539",
        "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7540": [
        "EPSG:7540",
        "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.42222222222223 +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7541": [
        "EPSG:7541",
        "+proj=tmerc +lat_0=41.47222222222222 +lon_0=-88.77500000000001 +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7542": [
        "EPSG:7542",
        "+proj=tmerc +lat_0=44.4 +lon_0=-87.27222222222223 +k=1.0000187521 +x_0=158801.1176 +y_0=0.0023 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7543": [
        "EPSG:7543",
        "+proj=tmerc +lat_0=45.88333333333333 +lon_0=-91.91666666666667 +k=1.0000385418 +x_0=59131.3183 +y_0=0.0041 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7544": [
        "EPSG:7544",
        "+proj=tmerc +lat_0=44.40833333333333 +lon_0=-91.89444444444445 +k=1.0000410324 +x_0=51816.104 +y_0=0.003 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7545": [
        "EPSG:7545",
        "+proj=lcc +lat_1=44.87228112638889 +lat_0=44.87228112638889 +lon_0=-91.28888888888889 +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.92389999999 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7546": [
        "EPSG:7546",
        "+proj=tmerc +lat_0=45.43888888888888 +lon_0=-88.14166666666668 +k=1.0000552095 +x_0=133502.6683 +y_0=0.0063 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7547": [
        "EPSG:7547",
        "+proj=tmerc +lat_0=44.00555555555555 +lon_0=-88.63333333333334 +k=1.0000673004 +x_0=275844.5533 +y_0=0.0157 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7548": [
        "EPSG:7548",
        "+proj=tmerc +lat_0=41.41111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.4841 +y_0=0.01 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7549": [
        "EPSG:7549",
        "+proj=lcc +lat_1=42.63756227694444 +lat_0=42.63756227694444 +lon_0=-89.83888888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7550": [
        "EPSG:7550",
        "+proj=lcc +lat_1=43.80700011777778 +lat_0=43.80700011777778 +lon_0=-89.24166666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7551": [
        "EPSG:7551",
        "+proj=tmerc +lat_0=42.53888888888888 +lon_0=-90.16111111111111 +k=1.0000394961 +x_0=113081.0261 +y_0=0.0045 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7552": [
        "EPSG:7552",
        "+proj=tmerc +lat_0=45.43333333333333 +lon_0=-90.25555555555556 +k=1.0000677153 +x_0=220980.4419 +y_0=0.008500000000000001 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7553": [
        "EPSG:7553",
        "+proj=tmerc +lat_0=44.25333512777778 +lon_0=-90.84429651944444 +k=1.0000353 +x_0=27000 +y_0=25000 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7554": [
        "EPSG:7554",
        "+proj=tmerc +lat_0=42.21666666666667 +lon_0=-87.89444444444445 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7555": [
        "EPSG:7555",
        "+proj=tmerc +lat_0=43.26666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7556": [
        "EPSG:7556",
        "+proj=tmerc +lat_0=43.45111111111111 +lon_0=-91.31666666666666 +k=1.0000319985 +x_0=130454.6598 +y_0=0.0033 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7557": [
        "EPSG:7557",
        "+proj=lcc +lat_1=45.15423710527778 +lat_0=45.15423710527778 +lon_0=-89.03333333333333 +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7558": [
        "EPSG:7558",
        "+proj=tmerc +lat_0=44.84444444444445 +lon_0=-89.73333333333333 +k=1.0000599003 +x_0=116129.0323 +y_0=0.0058 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7559": [
        "EPSG:7559",
        "+proj=lcc +lat_1=44.90090442361111 +lat_0=44.90090442361111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7560": [
        "EPSG:7560",
        "+proj=tmerc +lat_0=44.69166666666666 +lon_0=-87.71111111111111 +k=1.0000234982 +x_0=238658.8794 +y_0=0.0032 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7561": [
        "EPSG:7561",
        "+proj=tmerc +lat_0=44.71666666666667 +lon_0=-88.41666666666667 +k=1.0000362499 +x_0=105461.0121 +y_0=0.0029 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7562": [
        "EPSG:7562",
        "+proj=lcc +lat_1=44.00007392861111 +lat_0=44.00007392861111 +lon_0=-90.64166666666668 +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7563": [
        "EPSG:7563",
        "+proj=tmerc +lat_0=44.39722222222222 +lon_0=-87.90833333333335 +k=1.0000236869 +x_0=182880.3676 +y_0=0.0033 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7564": [
        "EPSG:7564",
        "+proj=lcc +lat_1=45.70422377027778 +lat_0=45.70422377027778 +lon_0=-89.54444444444444 +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7565": [
        "EPSG:7565",
        "+proj=lcc +lat_1=44.63614887194444 +lat_0=44.63614887194444 +lon_0=-92.22777777777777 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7566": [
        "EPSG:7566",
        "+proj=tmerc +lat_0=44.66111111111111 +lon_0=-92.63333333333334 +k=1.0000433849 +x_0=141732.2823 +y_0=0.0059 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7567": [
        "EPSG:7567",
        "+proj=lcc +lat_1=44.41682397527777 +lat_0=44.41682397527777 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7568": [
        "EPSG:7568",
        "+proj=tmerc +lat_0=44.55555555555555 +lon_0=-90.48888888888889 +k=1.0000649554 +x_0=227990.8546 +y_0=0.0109 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7569": [
        "EPSG:7569",
        "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.43055555555556 +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7570": [
        "EPSG:7570",
        "+proj=tmerc +lat_0=41.94444444444444 +lon_0=-89.07222222222222 +k=1.0000337311 +x_0=146304.2926 +y_0=0.0068 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7571": [
        "EPSG:7571",
        "+proj=tmerc +lat_0=43.91944444444444 +lon_0=-91.06666666666666 +k=1.0000495976 +x_0=250546.1013 +y_0=0.0234 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7572": [
        "EPSG:7572",
        "+proj=tmerc +lat_0=42.81944444444445 +lon_0=-89.90000000000001 +k=1.0000373868 +x_0=185623.5716 +y_0=0.0051 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7573": [
        "EPSG:7573",
        "+proj=lcc +lat_1=45.90009913138888 +lat_0=45.90009913138888 +lon_0=-91.11666666666666 +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7574": [
        "EPSG:7574",
        "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-88.60555555555555 +k=1.000032144 +x_0=262433.3253 +y_0=0.009599999999999999 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7575": [
        "EPSG:7575",
        "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-92.63333333333334 +k=1.0000381803 +x_0=165506.7302 +y_0=0.0103 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7576": [
        "EPSG:7576",
        "+proj=lcc +lat_1=45.17782208583333 +lat_0=45.17782208583333 +lon_0=-90.48333333333333 +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7577": [
        "EPSG:7577",
        "+proj=tmerc +lat_0=43.16111111111111 +lon_0=-91.36666666666666 +k=1.0000361538 +x_0=256946.9138 +y_0=0.0041 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7578": [
        "EPSG:7578",
        "+proj=lcc +lat_1=43.57503293972223 +lat_0=43.57503293972223 +lon_0=-90.78333333333333 +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7579": [
        "EPSG:7579",
        "+proj=lcc +lat_1=46.07784409055556 +lat_0=46.07784409055556 +lon_0=-89.48888888888889 +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7580": [
        "EPSG:7580",
        "+proj=lcc +lat_1=42.66946209694444 +lat_0=42.66946209694444 +lon_0=-88.54166666666667 +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7581": [
        "EPSG:7581",
        "+proj=lcc +lat_1=45.96121983333334 +lat_0=45.96121983333334 +lon_0=-91.78333333333333 +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7582": [
        "EPSG:7582",
        "+proj=tmerc +lat_0=42.91805555555555 +lon_0=-88.06388888888888 +k=1.00003738 +x_0=120091.4415 +y_0=0.003 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7583": [
        "EPSG:7583",
        "+proj=tmerc +lat_0=42.56944444444445 +lon_0=-88.22499999999999 +k=1.0000346179 +x_0=208788.418 +y_0=0.0034 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7584": [
        "EPSG:7584",
        "+proj=tmerc +lat_0=43.42027777777778 +lon_0=-88.81666666666666 +k=1.0000333645 +x_0=185013.9709 +y_0=0.007 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7585": [
        "EPSG:7585",
        "+proj=lcc +lat_1=44.11394404583334 +lat_0=44.11394404583334 +lon_0=-89.24166666666667 +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7586": [
        "EPSG:7586",
        "+proj=lcc +lat_1=44.36259546944444 +lat_0=44.36259546944444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754 +ellps=GRS80 +units=m +no_defs ",
    ],
    "EPSG:7587": [
        "EPSG:7587",
        "+proj=tmerc +lat_0=43.36666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6941325883 +y_0=0.00365760731521463 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7588": [
        "EPSG:7588",
        "+proj=tmerc +lat_0=45.70611111111111 +lon_0=-90.62222222222222 +k=1.0000495683 +x_0=172821.945948692 +y_0=0.001828803657607315 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7589": [
        "EPSG:7589",
        "+proj=tmerc +lat_0=45.13333333333333 +lon_0=-91.84999999999999 +k=1.0000486665 +x_0=93150 +y_0=0.003048006096012192 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7590": [
        "EPSG:7590",
        "+proj=lcc +lat_1=46.66964837722222 +lat_0=46.66964837722222 +lon_0=-91.15277777777779 +k_0=1.0000331195 +x_0=228600.4575057151 +y_0=148551.4835661671 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7591": [
        "EPSG:7591",
        "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31599.99989839979 +y_0=4599.999898399797 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7592": [
        "EPSG:7592",
        "+proj=tmerc +lat_0=43.48138888888889 +lon_0=-91.79722222222222 +k=1.0000382778 +x_0=175260.3502159004 +y_0=0.004876809753619507 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7593": [
        "EPSG:7593",
        "+proj=lcc +lat_1=45.89871486583333 +lat_0=45.89871486583333 +lon_0=-92.45777777777778 +k_0=1.0000383841 +x_0=64008.12771145543 +y_0=59445.90419100838 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7594": [
        "EPSG:7594",
        "+proj=tmerc +lat_0=42.71944444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8892049784 +y_0=0.004876809753619507 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7595": [
        "EPSG:7595",
        "+proj=lcc +lat_1=44.97785689861112 +lat_0=44.97785689861112 +lon_0=-91.29444444444444 +k_0=1.0000391127 +x_0=60045.72009144018 +y_0=44091.43449326898 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7596": [
        "EPSG:7596",
        "+proj=tmerc +lat_0=43.6 +lon_0=-90.70833333333334 +k=1.0000463003 +x_0=199949.198983998 +y_0=0.008534417068834137 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7597": [
        "EPSG:7597",
        "+proj=lcc +lat_1=43.46254664583333 +lat_0=43.46254664583333 +lon_0=-89.39444444444445 +k_0=1.00003498 +x_0=169164.338023876 +y_0=111569.613512827 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7598": [
        "EPSG:7598",
        "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6273812548 +y_0=53703.12024384048 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7599": [
        "EPSG:7599",
        "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.42222222222223 +k_0=1.0000384786 +x_0=247193.2943865888 +y_0=146591.9896367793 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:4996": ["EPSG:4996", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:7600": [
        "EPSG:7600",
        "+proj=tmerc +lat_0=41.47222222222222 +lon_0=-88.77500000000001 +k=1.0000346418 +x_0=263347.7263906528 +y_0=0.00762001524003048 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7601": [
        "EPSG:7601",
        "+proj=tmerc +lat_0=44.4 +lon_0=-87.27222222222223 +k=1.0000187521 +x_0=158801.1176022352 +y_0=0.002438404876809754 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7602": [
        "EPSG:7602",
        "+proj=tmerc +lat_0=45.88333333333333 +lon_0=-91.91666666666667 +k=1.0000385418 +x_0=59131.31826263652 +y_0=0.003962407924815849 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7603": [
        "EPSG:7603",
        "+proj=tmerc +lat_0=44.40833333333333 +lon_0=-91.89444444444445 +k=1.0000410324 +x_0=51816.10393700787 +y_0=0.003048006096012192 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7604": [
        "EPSG:7604",
        "+proj=lcc +lat_1=44.87228112638889 +lat_0=44.87228112638889 +lon_0=-91.28888888888889 +k_0=1.000035079 +x_0=120091.4401828804 +y_0=91687.92390144781 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7605": [
        "EPSG:7605",
        "+proj=tmerc +lat_0=45.43888888888888 +lon_0=-88.14166666666668 +k=1.0000552095 +x_0=133502.6682245364 +y_0=0.006400812801625603 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7606": [
        "EPSG:7606",
        "+proj=tmerc +lat_0=44.00555555555555 +lon_0=-88.63333333333334 +k=1.0000673004 +x_0=275844.5532131065 +y_0=0.0158496316992634 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7607": [
        "EPSG:7607",
        "+proj=tmerc +lat_0=41.41111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.484023368 +y_0=0.01005842011684023 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:32608": [
        "EPSG:32608",
        "+proj=utm +zone=8 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:7608": [
        "EPSG:7608",
        "+proj=lcc +lat_1=42.63756227694444 +lat_0=42.63756227694444 +lon_0=-89.83888888888889 +k_0=1.0000390487 +x_0=170078.7401574803 +y_0=45830.29484378968 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7609": [
        "EPSG:7609",
        "+proj=lcc +lat_1=43.80700011777778 +lat_0=43.80700011777778 +lon_0=-89.24166666666667 +k_0=1.0000344057 +x_0=150876.3017526035 +y_0=79170.77937515875 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7610": [
        "EPSG:7610",
        "+proj=tmerc +lat_0=42.53888888888888 +lon_0=-90.16111111111111 +k=1.0000394961 +x_0=113081.0261620523 +y_0=0.004572009144018288 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7611": [
        "EPSG:7611",
        "+proj=tmerc +lat_0=45.43333333333333 +lon_0=-90.25555555555556 +k=1.0000677153 +x_0=220980.4419608839 +y_0=0.008534417068834137 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7612": [
        "EPSG:7612",
        "+proj=tmerc +lat_0=44.25333512777778 +lon_0=-90.84429651944444 +k=1.0000353 +x_0=27000 +y_0=24999.99989839979 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7613": [
        "EPSG:7613",
        "+proj=tmerc +lat_0=42.21666666666667 +lon_0=-87.89444444444445 +k=1.0000260649 +x_0=185928.3727711455 +y_0=0.0009144018288036576 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7614": [
        "EPSG:7614",
        "+proj=tmerc +lat_0=43.26666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.76154432308 +y_0=0.001219202438404877 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7615": [
        "EPSG:7615",
        "+proj=tmerc +lat_0=43.45111111111111 +lon_0=-91.31666666666666 +k=1.0000319985 +x_0=130454.6596901194 +y_0=0.003352806705613411 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:4998": ["EPSG:4998", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:7616": [
        "EPSG:7616",
        "+proj=lcc +lat_1=45.15423710527778 +lat_0=45.15423710527778 +lon_0=-89.03333333333333 +k_0=1.0000627024 +x_0=198425.1968503937 +y_0=105279.7828803657 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7617": [
        "EPSG:7617",
        "+proj=tmerc +lat_0=44.84444444444445 +lon_0=-89.73333333333333 +k=1.0000599003 +x_0=116129.0322580645 +y_0=0.005791211582423164 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7618": [
        "EPSG:7618",
        "+proj=lcc +lat_1=44.90090442361111 +lat_0=44.90090442361111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493522987 +y_0=55049.26695453391 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7619": [
        "EPSG:7619",
        "+proj=tmerc +lat_0=44.69166666666666 +lon_0=-87.71111111111111 +k=1.0000234982 +x_0=238658.8794513589 +y_0=0.003048006096012192 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7620": [
        "EPSG:7620",
        "+proj=tmerc +lat_0=44.71666666666667 +lon_0=-88.41666666666667 +k=1.0000362499 +x_0=105461.0121412243 +y_0=0.003048006096012192 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7621": [
        "EPSG:7621",
        "+proj=lcc +lat_1=44.00007392861111 +lat_0=44.00007392861111 +lon_0=-90.64166666666668 +k_0=1.0000434122 +x_0=204521.2090424181 +y_0=121923.9861823724 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7622": [
        "EPSG:7622",
        "+proj=tmerc +lat_0=44.39722222222222 +lon_0=-87.90833333333335 +k=1.0000236869 +x_0=182880.3675895352 +y_0=0.003352806705613411 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7623": [
        "EPSG:7623",
        "+proj=lcc +lat_1=45.70422377027778 +lat_0=45.70422377027778 +lon_0=-89.54444444444444 +k_0=1.0000686968 +x_0=70104.14020828041 +y_0=57588.03474726949 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:5011": ["EPSG:5011", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:7624": [
        "EPSG:7624",
        "+proj=lcc +lat_1=44.63614887194444 +lat_0=44.63614887194444 +lon_0=-92.22777777777777 +k_0=1.0000362977 +x_0=167640.3352806706 +y_0=86033.08773177546 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7625": [
        "EPSG:7625",
        "+proj=tmerc +lat_0=44.66111111111111 +lon_0=-92.63333333333334 +k=1.0000433849 +x_0=141732.2822453645 +y_0=0.005791211582423164 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7626": [
        "EPSG:7626",
        "+proj=lcc +lat_1=44.41682397527777 +lat_0=44.41682397527777 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.11277622555 +y_0=50022.1874523749 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7627": [
        "EPSG:7627",
        "+proj=tmerc +lat_0=44.55555555555555 +lon_0=-90.48888888888889 +k=1.0000649554 +x_0=227990.8544577089 +y_0=0.01097282194564389 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7628": [
        "EPSG:7628",
        "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.43055555555556 +k_0=1.0000375653 +x_0=202387.6047752095 +y_0=134255.4254508509 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7629": [
        "EPSG:7629",
        "+proj=tmerc +lat_0=41.94444444444444 +lon_0=-89.07222222222222 +k=1.0000337311 +x_0=146304.2926085852 +y_0=0.006705613411226822 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7630": [
        "EPSG:7630",
        "+proj=tmerc +lat_0=43.91944444444444 +lon_0=-91.06666666666666 +k=1.0000495976 +x_0=250546.1013970028 +y_0=0.02346964693929388 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7631": [
        "EPSG:7631",
        "+proj=tmerc +lat_0=42.81944444444445 +lon_0=-89.90000000000001 +k=1.0000373868 +x_0=185623.5715519431 +y_0=0.005181610363220727 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:5244": ["EPSG:5244", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:7632": [
        "EPSG:7632",
        "+proj=lcc +lat_1=45.90009913138888 +lat_0=45.90009913138888 +lon_0=-91.11666666666666 +k_0=1.0000573461 +x_0=216713.2337312675 +y_0=120734.1631699263 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7633": [
        "EPSG:7633",
        "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-88.60555555555555 +k=1.000032144 +x_0=262433.3251714504 +y_0=0.009448818897637795 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7634": [
        "EPSG:7634",
        "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-92.63333333333334 +k=1.0000381803 +x_0=165506.7300990602 +y_0=0.01036322072644145 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7635": [
        "EPSG:7635",
        "+proj=lcc +lat_1=45.17782208583333 +lat_0=45.17782208583333 +lon_0=-90.48333333333333 +k_0=1.0000597566 +x_0=187147.5742951486 +y_0=107746.7521463043 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7636": [
        "EPSG:7636",
        "+proj=tmerc +lat_0=43.16111111111111 +lon_0=-91.36666666666666 +k=1.0000361538 +x_0=256946.9138938278 +y_0=0.003962407924815849 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7637": [
        "EPSG:7637",
        "+proj=lcc +lat_1=43.57503293972223 +lat_0=43.57503293972223 +lon_0=-90.78333333333333 +k_0=1.0000408158 +x_0=222504.44500889 +y_0=47532.0603505207 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7638": [
        "EPSG:7638",
        "+proj=lcc +lat_1=46.07784409055556 +lat_0=46.07784409055556 +lon_0=-89.48888888888889 +k_0=1.0000730142 +x_0=134417.0688341377 +y_0=50337.10927101854 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7639": [
        "EPSG:7639",
        "+proj=lcc +lat_1=42.66946209694444 +lat_0=42.66946209694444 +lon_0=-88.54166666666667 +k_0=1.0000367192 +x_0=232562.8651257302 +y_0=111088.2224028448 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:5250": ["EPSG:5250", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:7640": [
        "EPSG:7640",
        "+proj=lcc +lat_1=45.96121983333334 +lat_0=45.96121983333334 +lon_0=-91.78333333333333 +k_0=1.0000475376 +x_0=234086.8681737363 +y_0=188358.6059436119 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7641": [
        "EPSG:7641",
        "+proj=tmerc +lat_0=42.91805555555555 +lon_0=-88.06388888888888 +k=1.00003738 +x_0=120091.4414020828 +y_0=0.003048006096012192 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7642": [
        "EPSG:7642",
        "+proj=tmerc +lat_0=42.56944444444445 +lon_0=-88.22499999999999 +k=1.0000346179 +x_0=208788.4178816358 +y_0=0.003352806705613411 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7643": [
        "EPSG:7643",
        "+proj=tmerc +lat_0=43.42027777777778 +lon_0=-88.81666666666666 +k=1.0000333645 +x_0=185013.9709423419 +y_0=0.007010414020828041 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7644": [
        "EPSG:7644",
        "+proj=lcc +lat_1=44.11394404583334 +lat_0=44.11394404583334 +lon_0=-89.24166666666667 +k_0=1.0000392096 +x_0=120091.4401828804 +y_0=45069.7588011176 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:7645": [
        "EPSG:7645",
        "+proj=lcc +lat_1=44.36259546944444 +lat_0=44.36259546944444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6172720346 +y_0=134589.7539243078 +ellps=GRS80 +units=us-ft +no_defs ",
    ],
    "EPSG:20004": [
        "EPSG:20004",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20005": [
        "EPSG:20005",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20006": [
        "EPSG:20006",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20007": [
        "EPSG:20007",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20008": [
        "EPSG:20008",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20009": [
        "EPSG:20009",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20010": [
        "EPSG:20010",
        "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20011": [
        "EPSG:20011",
        "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20012": [
        "EPSG:20012",
        "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20013": [
        "EPSG:20013",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20014": [
        "EPSG:20014",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20015": [
        "EPSG:20015",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20016": [
        "EPSG:20016",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20017": [
        "EPSG:20017",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20018": [
        "EPSG:20018",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20019": [
        "EPSG:20019",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20020": [
        "EPSG:20020",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20021": [
        "EPSG:20021",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20022": [
        "EPSG:20022",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20023": [
        "EPSG:20023",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20024": [
        "EPSG:20024",
        "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20025": [
        "EPSG:20025",
        "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20026": [
        "EPSG:20026",
        "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20027": [
        "EPSG:20027",
        "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20028": [
        "EPSG:20028",
        "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20029": [
        "EPSG:20029",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20030": [
        "EPSG:20030",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20031": [
        "EPSG:20031",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20032": [
        "EPSG:20032",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20064": [
        "EPSG:20064",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20065": [
        "EPSG:20065",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20066": [
        "EPSG:20066",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20067": [
        "EPSG:20067",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20068": [
        "EPSG:20068",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20069": [
        "EPSG:20069",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20070": [
        "EPSG:20070",
        "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20071": [
        "EPSG:20071",
        "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20072": [
        "EPSG:20072",
        "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20073": [
        "EPSG:20073",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20074": [
        "EPSG:20074",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20075": [
        "EPSG:20075",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20076": [
        "EPSG:20076",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20077": [
        "EPSG:20077",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20078": [
        "EPSG:20078",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20079": [
        "EPSG:20079",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20080": [
        "EPSG:20080",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20081": [
        "EPSG:20081",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20082": [
        "EPSG:20082",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20083": [
        "EPSG:20083",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20084": [
        "EPSG:20084",
        "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20085": [
        "EPSG:20085",
        "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20086": [
        "EPSG:20086",
        "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20087": [
        "EPSG:20087",
        "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20088": [
        "EPSG:20088",
        "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20089": [
        "EPSG:20089",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20090": [
        "EPSG:20090",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20091": [
        "EPSG:20091",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20092": [
        "EPSG:20092",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs ",
    ],
    "EPSG:20135": [
        "EPSG:20135",
        "+proj=utm +zone=35 +ellps=clrk80 +towgs84=-166,-15,204,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20136": [
        "EPSG:20136",
        "+proj=utm +zone=36 +ellps=clrk80 +towgs84=-166,-15,204,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20137": [
        "EPSG:20137",
        "+proj=utm +zone=37 +ellps=clrk80 +towgs84=-166,-15,204,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20138": [
        "EPSG:20138",
        "+proj=utm +zone=38 +ellps=clrk80 +towgs84=-166,-15,204,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20248": [
        "EPSG:20248",
        "+proj=utm +zone=48 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20249": [
        "EPSG:20249",
        "+proj=utm +zone=49 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20250": [
        "EPSG:20250",
        "+proj=utm +zone=50 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20251": [
        "EPSG:20251",
        "+proj=utm +zone=51 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20252": [
        "EPSG:20252",
        "+proj=utm +zone=52 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20253": [
        "EPSG:20253",
        "+proj=utm +zone=53 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20254": [
        "EPSG:20254",
        "+proj=utm +zone=54 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20255": [
        "EPSG:20255",
        "+proj=utm +zone=55 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20256": [
        "EPSG:20256",
        "+proj=utm +zone=56 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20257": [
        "EPSG:20257",
        "+proj=utm +zone=57 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20258": [
        "EPSG:20258",
        "+proj=utm +zone=58 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs ",
    ],
    "EPSG:20348": [
        "EPSG:20348",
        "+proj=utm +zone=48 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20349": [
        "EPSG:20349",
        "+proj=utm +zone=49 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20350": [
        "EPSG:20350",
        "+proj=utm +zone=50 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20351": [
        "EPSG:20351",
        "+proj=utm +zone=51 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20352": [
        "EPSG:20352",
        "+proj=utm +zone=52 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20353": [
        "EPSG:20353",
        "+proj=utm +zone=53 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20354": [
        "EPSG:20354",
        "+proj=utm +zone=54 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20355": [
        "EPSG:20355",
        "+proj=utm +zone=55 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20539": [
        "EPSG:20539",
        "+proj=utm +zone=39 +ellps=krass +towgs84=-43,-163,45,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20357": [
        "EPSG:20357",
        "+proj=utm +zone=57 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20358": [
        "EPSG:20358",
        "+proj=utm +zone=58 +south +ellps=aust_SA +towgs84=-134,-48,149,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20436": [
        "EPSG:20436",
        "+proj=utm +zone=36 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20437": [
        "EPSG:20437",
        "+proj=utm +zone=37 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20439": [
        "EPSG:20439",
        "+proj=utm +zone=39 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20440": [
        "EPSG:20440",
        "+proj=utm +zone=40 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20499": [
        "EPSG:20499",
        "+proj=utm +zone=39 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20538": [
        "EPSG:20538",
        "+proj=utm +zone=38 +ellps=krass +towgs84=-43,-163,45,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20791": [
        "EPSG:20791",
        "+proj=tmerc +lat_0=39.66666666666666 +lon_0=1 +k=1 +x_0=0 +y_0=0 +ellps=intl +towgs84=-304.046,-60.576,103.64,0,0,0,0 +pm=lisbon +units=m +no_defs ",
    ],
    "EPSG:20822": [
        "EPSG:20822",
        "+proj=utm +zone=22 +south +ellps=intl +towgs84=-151.99,287.04,-147.45,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20823": [
        "EPSG:20823",
        "+proj=utm +zone=23 +south +ellps=intl +towgs84=-151.99,287.04,-147.45,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20824": [
        "EPSG:20824",
        "+proj=utm +zone=24 +south +ellps=intl +towgs84=-151.99,287.04,-147.45,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20934": [
        "EPSG:20934",
        "+proj=utm +zone=34 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-143,-90,-294,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20935": [
        "EPSG:20935",
        "+proj=utm +zone=35 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-143,-90,-294,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:20936": [
        "EPSG:20936",
        "+proj=utm +zone=36 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-143,-90,-294,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21035": [
        "EPSG:21035",
        "+proj=utm +zone=35 +south +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21036": [
        "EPSG:21036",
        "+proj=utm +zone=36 +south +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21037": [
        "EPSG:21037",
        "+proj=utm +zone=37 +south +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21095": [
        "EPSG:21095",
        "+proj=utm +zone=35 +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21097": [
        "EPSG:21097",
        "+proj=utm +zone=37 +ellps=clrk80 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21100": [
        "EPSG:21100",
        "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +pm=jakarta +units=m +no_defs ",
    ],
    "EPSG:21148": [
        "EPSG:21148",
        "+proj=utm +zone=48 +south +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21149": [
        "EPSG:21149",
        "+proj=utm +zone=49 +south +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21150": [
        "EPSG:21150",
        "+proj=utm +zone=50 +south +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21291": [
        "EPSG:21291",
        "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=31.95,300.99,419.19,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21292": [
        "EPSG:21292",
        "+proj=tmerc +lat_0=13.17638888888889 +lon_0=-59.55972222222222 +k=0.9999986 +x_0=30000 +y_0=75000 +ellps=clrk80 +towgs84=31.95,300.99,419.19,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21413": [
        "EPSG:21413",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21414": [
        "EPSG:21414",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21415": [
        "EPSG:21415",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21416": [
        "EPSG:21416",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21417": [
        "EPSG:21417",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21418": [
        "EPSG:21418",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21419": [
        "EPSG:21419",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21420": [
        "EPSG:21420",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21421": [
        "EPSG:21421",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21422": [
        "EPSG:21422",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21423": [
        "EPSG:21423",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21453": [
        "EPSG:21453",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21454": [
        "EPSG:21454",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21455": [
        "EPSG:21455",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21456": [
        "EPSG:21456",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21457": [
        "EPSG:21457",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21458": [
        "EPSG:21458",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21459": [
        "EPSG:21459",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21460": [
        "EPSG:21460",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21461": [
        "EPSG:21461",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21462": [
        "EPSG:21462",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21463": [
        "EPSG:21463",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21473": [
        "EPSG:21473",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21474": [
        "EPSG:21474",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21475": [
        "EPSG:21475",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21476": [
        "EPSG:21476",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21477": [
        "EPSG:21477",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21478": [
        "EPSG:21478",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21479": [
        "EPSG:21479",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21480": [
        "EPSG:21480",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21481": [
        "EPSG:21481",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21482": [
        "EPSG:21482",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21483": [
        "EPSG:21483",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21500": [
        "EPSG:21500",
        "+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=90 +lon_0=0 +x_0=150000 +y_0=5400000 +ellps=intl +pm=brussels +units=m +no_defs ",
    ],
    "EPSG:21780": [
        "EPSG:21780",
        "+proj=somerc +lat_0=46.95240555555556 +lon_0=0 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=674.4,15.1,405.3,0,0,0,0 +pm=bern +units=m +no_defs ",
    ],
    "EPSG:21782": [
        "EPSG:21782",
        "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=674.4,15.1,405.3,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21817": [
        "EPSG:21817",
        "+proj=utm +zone=17 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21818": [
        "EPSG:21818",
        "+proj=utm +zone=18 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5262": ["EPSG:5262", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:21891": [
        "EPSG:21891",
        "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-77.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21893": [
        "EPSG:21893",
        "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-71.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21894": [
        "EPSG:21894",
        "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-68.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21896": [
        "EPSG:21896",
        "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-77.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21898": [
        "EPSG:21898",
        "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-71.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:21899": [
        "EPSG:21899",
        "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-68.08091666666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22032": [
        "EPSG:22032",
        "+proj=utm +zone=32 +south +ellps=clrk80 +towgs84=-50.9,-347.6,-231,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22033": [
        "EPSG:22033",
        "+proj=utm +zone=33 +south +ellps=clrk80 +towgs84=-50.9,-347.6,-231,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22091": [
        "EPSG:22091",
        "+proj=tmerc +lat_0=0 +lon_0=11.5 +k=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +towgs84=-50.9,-347.6,-231,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22092": [
        "EPSG:22092",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +towgs84=-50.9,-347.6,-231,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22171": [
        "EPSG:22171",
        "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22172": [
        "EPSG:22172",
        "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22173": [
        "EPSG:22173",
        "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22174": [
        "EPSG:22174",
        "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22175": [
        "EPSG:22175",
        "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22176": [
        "EPSG:22176",
        "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22177": [
        "EPSG:22177",
        "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22181": [
        "EPSG:22181",
        "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22182": [
        "EPSG:22182",
        "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22183": [
        "EPSG:22183",
        "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22186": [
        "EPSG:22186",
        "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22187": [
        "EPSG:22187",
        "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22191": [
        "EPSG:22191",
        "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22192": [
        "EPSG:22192",
        "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22193": [
        "EPSG:22193",
        "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22194": [
        "EPSG:22194",
        "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22195": [
        "EPSG:22195",
        "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22196": [
        "EPSG:22196",
        "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22197": [
        "EPSG:22197",
        "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22234": [
        "EPSG:22234",
        "+proj=utm +zone=34 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22235": [
        "EPSG:22235",
        "+proj=utm +zone=35 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22236": [
        "EPSG:22236",
        "+proj=utm +zone=36 +south +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22275": [
        "EPSG:22275",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22277": [
        "EPSG:22277",
        "+proj=tmerc +lat_0=0 +lon_0=17 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22279": [
        "EPSG:22279",
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22281": [
        "EPSG:22281",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22283": [
        "EPSG:22283",
        "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22285": [
        "EPSG:22285",
        "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22287": [
        "EPSG:22287",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22289": [
        "EPSG:22289",
        "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22291": [
        "EPSG:22291",
        "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22293": [
        "EPSG:22293",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=0 +y_0=0 +axis=wsu +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22300": ["EPSG:22300", ""],
    "EPSG:22332": [
        "EPSG:22332",
        "+proj=utm +zone=32 +datum=carthage +units=m +no_defs ",
    ],
    "EPSG:22392": [
        "EPSG:22392",
        "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=9.9 +k_0=0.999625769 +x_0=500000 +y_0=300000 +datum=carthage +units=m +no_defs ",
    ],
    "EPSG:22521": [
        "EPSG:22521",
        "+proj=utm +zone=21 +south +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22522": [
        "EPSG:22522",
        "+proj=utm +zone=22 +south +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22525": [
        "EPSG:22525",
        "+proj=utm +zone=25 +south +ellps=intl +towgs84=-205.57,168.77,-4.12,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22700": [
        "EPSG:22700",
        "+proj=lcc +lat_1=34.65 +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256 +x_0=300000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=-190.421,8.532,238.69,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22770": [
        "EPSG:22770",
        "+proj=lcc +lat_1=34.65 +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256 +x_0=300000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=-190.421,8.532,238.69,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22780": [
        "EPSG:22780",
        "+proj=sterea +lat_0=34.2 +lon_0=39.15 +k=0.9995341 +x_0=0 +y_0=0 +a=6378249.2 +b=6356515 +towgs84=-190.421,8.532,238.69,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5322": ["EPSG:5322", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:22991": [
        "EPSG:22991",
        "+proj=tmerc +lat_0=30 +lon_0=35 +k=1 +x_0=300000 +y_0=1100000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22992": [
        "EPSG:22992",
        "+proj=tmerc +lat_0=30 +lon_0=31 +k=1 +x_0=615000 +y_0=810000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22993": [
        "EPSG:22993",
        "+proj=tmerc +lat_0=30 +lon_0=27 +k=1 +x_0=700000 +y_0=200000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:22994": [
        "EPSG:22994",
        "+proj=tmerc +lat_0=30 +lon_0=27 +k=1 +x_0=700000 +y_0=1200000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23028": [
        "EPSG:23028",
        "+proj=utm +zone=28 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23034": [
        "EPSG:23034",
        "+proj=utm +zone=34 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23037": [
        "EPSG:23037",
        "+proj=utm +zone=37 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23038": [
        "EPSG:23038",
        "+proj=utm +zone=38 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23090": [
        "EPSG:23090",
        "+proj=tmerc +lat_0=0 +lon_0=0 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23095": [
        "EPSG:23095",
        "+proj=tmerc +lat_0=0 +lon_0=5 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23239": [
        "EPSG:23239",
        "+proj=utm +zone=39 +ellps=clrk80 +towgs84=-333.102,-11.02,230.69,0,0,0.554,0.219 +units=m +no_defs ",
    ],
    "EPSG:23240": [
        "EPSG:23240",
        "+proj=utm +zone=40 +ellps=clrk80 +towgs84=-333.102,-11.02,230.69,0,0,0.554,0.219 +units=m +no_defs ",
    ],
    "EPSG:23433": [
        "EPSG:23433",
        "+proj=utm +zone=33 +a=6378249.2 +b=6356515 +units=m +no_defs ",
    ],
    "EPSG:23830": [
        "EPSG:23830",
        "+proj=tmerc +lat_0=0 +lon_0=94.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23831": [
        "EPSG:23831",
        "+proj=tmerc +lat_0=0 +lon_0=97.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23832": [
        "EPSG:23832",
        "+proj=tmerc +lat_0=0 +lon_0=100.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23833": [
        "EPSG:23833",
        "+proj=tmerc +lat_0=0 +lon_0=103.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23835": [
        "EPSG:23835",
        "+proj=tmerc +lat_0=0 +lon_0=109.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23836": [
        "EPSG:23836",
        "+proj=tmerc +lat_0=0 +lon_0=112.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23837": [
        "EPSG:23837",
        "+proj=tmerc +lat_0=0 +lon_0=115.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5332": ["EPSG:5332", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:23838": [
        "EPSG:23838",
        "+proj=tmerc +lat_0=0 +lon_0=118.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23839": [
        "EPSG:23839",
        "+proj=tmerc +lat_0=0 +lon_0=121.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23840": [
        "EPSG:23840",
        "+proj=tmerc +lat_0=0 +lon_0=124.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23841": [
        "EPSG:23841",
        "+proj=tmerc +lat_0=0 +lon_0=127.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23842": [
        "EPSG:23842",
        "+proj=tmerc +lat_0=0 +lon_0=130.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23843": [
        "EPSG:23843",
        "+proj=tmerc +lat_0=0 +lon_0=133.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23844": [
        "EPSG:23844",
        "+proj=tmerc +lat_0=0 +lon_0=136.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23845": [
        "EPSG:23845",
        "+proj=tmerc +lat_0=0 +lon_0=139.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23846": [
        "EPSG:23846",
        "+proj=utm +zone=46 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23847": [
        "EPSG:23847",
        "+proj=utm +zone=47 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23848": [
        "EPSG:23848",
        "+proj=utm +zone=48 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23849": [
        "EPSG:23849",
        "+proj=utm +zone=49 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23850": [
        "EPSG:23850",
        "+proj=utm +zone=50 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23851": [
        "EPSG:23851",
        "+proj=utm +zone=51 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23852": [
        "EPSG:23852",
        "+proj=utm +zone=52 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23853": [
        "EPSG:23853",
        "+proj=utm +zone=53 +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23866": [
        "EPSG:23866",
        "+proj=utm +zone=46 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23867": [
        "EPSG:23867",
        "+proj=utm +zone=47 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23868": [
        "EPSG:23868",
        "+proj=utm +zone=48 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23869": [
        "EPSG:23869",
        "+proj=utm +zone=49 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23870": [
        "EPSG:23870",
        "+proj=utm +zone=50 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23871": [
        "EPSG:23871",
        "+proj=utm +zone=51 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23872": [
        "EPSG:23872",
        "+proj=utm +zone=52 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23877": [
        "EPSG:23877",
        "+proj=utm +zone=47 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23878": [
        "EPSG:23878",
        "+proj=utm +zone=48 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23880": [
        "EPSG:23880",
        "+proj=utm +zone=50 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23881": [
        "EPSG:23881",
        "+proj=utm +zone=51 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23882": [
        "EPSG:23882",
        "+proj=utm +zone=52 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23883": [
        "EPSG:23883",
        "+proj=utm +zone=53 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23886": [
        "EPSG:23886",
        "+proj=utm +zone=46 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23887": [
        "EPSG:23887",
        "+proj=utm +zone=47 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23888": [
        "EPSG:23888",
        "+proj=utm +zone=48 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23889": [
        "EPSG:23889",
        "+proj=utm +zone=49 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23890": [
        "EPSG:23890",
        "+proj=utm +zone=50 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23891": [
        "EPSG:23891",
        "+proj=utm +zone=51 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23892": [
        "EPSG:23892",
        "+proj=utm +zone=52 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23893": [
        "EPSG:23893",
        "+proj=utm +zone=53 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23894": [
        "EPSG:23894",
        "+proj=utm +zone=54 +south +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23946": [
        "EPSG:23946",
        "+proj=utm +zone=46 +a=6377276.345 +b=6356075.41314024 +towgs84=217,823,299,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:23947": [
        "EPSG:23947",
        "+proj=utm +zone=47 +a=6377276.345 +b=6356075.41314024 +towgs84=217,823,299,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24100": [
        "EPSG:24100",
        "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=167638.49597 +y_0=121918.90616 +a=6378249.144808011 +b=6356514.966204134 +to_meter=0.3047972654 +no_defs ",
    ],
    "EPSG:24200": [
        "EPSG:24200",
        "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=250000 +y_0=150000 +ellps=clrk66 +towgs84=70,207,389.5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24305": [
        "EPSG:24305",
        "+proj=utm +zone=45 +a=6377276.345 +b=6356075.41314024 +towgs84=214,804,268,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24306": [
        "EPSG:24306",
        "+proj=utm +zone=46 +a=6377276.345 +b=6356075.41314024 +towgs84=214,804,268,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5341": ["EPSG:5341", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:24311": [
        "EPSG:24311",
        "+proj=utm +zone=41 +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24312": [
        "EPSG:24312",
        "+proj=utm +zone=42 +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24313": [
        "EPSG:24313",
        "+proj=utm +zone=43 +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24342": [
        "EPSG:24342",
        "+proj=utm +zone=42 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24343": [
        "EPSG:24343",
        "+proj=utm +zone=43 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24344": [
        "EPSG:24344",
        "+proj=utm +zone=44 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24345": [
        "EPSG:24345",
        "+proj=utm +zone=45 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24346": [
        "EPSG:24346",
        "+proj=utm +zone=46 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24347": [
        "EPSG:24347",
        "+proj=utm +zone=47 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24370": [
        "EPSG:24370",
        "+proj=lcc +lat_1=39.5 +lat_0=39.5 +lon_0=68 +k_0=0.99846154 +x_0=2153865.73916853 +y_0=2368292.194628102 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs ",
    ],
    "EPSG:24371": [
        "EPSG:24371",
        "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs ",
    ],
    "EPSG:24372": [
        "EPSG:24372",
        "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs ",
    ],
    "EPSG:24373": [
        "EPSG:24373",
        "+proj=lcc +lat_1=19 +lat_0=19 +lon_0=80 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs ",
    ],
    "EPSG:24374": [
        "EPSG:24374",
        "+proj=lcc +lat_1=12 +lat_0=12 +lon_0=80 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs ",
    ],
    "EPSG:24375": [
        "EPSG:24375",
        "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743185.69 +y_0=914395.23 +a=6377276.345 +b=6356075.41314024 +towgs84=214,804,268,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24376": [
        "EPSG:24376",
        "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8 +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24377": [
        "EPSG:24377",
        "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8 +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24378": [
        "EPSG:24378",
        "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24379": [
        "EPSG:24379",
        "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24380": [
        "EPSG:24380",
        "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24381": [
        "EPSG:24381",
        "+proj=lcc +lat_1=19 +lat_0=19 +lon_0=80 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24382": [
        "EPSG:24382",
        "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +to_meter=0.9143985307444408 +no_defs ",
    ],
    "EPSG:24383": [
        "EPSG:24383",
        "+proj=lcc +lat_1=12 +lat_0=12 +lon_0=80 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24500": [
        "EPSG:24500",
        "+proj=cass +lat_0=1.287646666666667 +lon_0=103.8530022222222 +x_0=30000 +y_0=30000 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24547": [
        "EPSG:24547",
        "+proj=utm +zone=47 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24548": [
        "EPSG:24548",
        "+proj=utm +zone=48 +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24600": [
        "EPSG:24600",
        "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078000001 +x_0=1500000 +y_0=1166200 +ellps=clrk80 +towgs84=-294.7,-200.1,525.5,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24718": [
        "EPSG:24718",
        "+proj=utm +zone=18 +ellps=intl +towgs84=-273.5,110.6,-357.9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24720": [
        "EPSG:24720",
        "+proj=utm +zone=20 +ellps=intl +towgs84=-273.5,110.6,-357.9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24817": [
        "EPSG:24817",
        "+proj=utm +zone=17 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24818": [
        "EPSG:24818",
        "+proj=utm +zone=18 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24819": [
        "EPSG:24819",
        "+proj=utm +zone=19 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24820": [
        "EPSG:24820",
        "+proj=utm +zone=20 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5352": ["EPSG:5352", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:24821": [
        "EPSG:24821",
        "+proj=utm +zone=21 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24877": [
        "EPSG:24877",
        "+proj=utm +zone=17 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24878": [
        "EPSG:24878",
        "+proj=utm +zone=18 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24879": [
        "EPSG:24879",
        "+proj=utm +zone=19 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24880": [
        "EPSG:24880",
        "+proj=utm +zone=20 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24881": [
        "EPSG:24881",
        "+proj=utm +zone=21 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24882": [
        "EPSG:24882",
        "+proj=utm +zone=22 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24891": [
        "EPSG:24891",
        "+proj=tmerc +lat_0=-6 +lon_0=-80.5 +k=0.99983008 +x_0=222000 +y_0=1426834.743 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24892": [
        "EPSG:24892",
        "+proj=tmerc +lat_0=-9.5 +lon_0=-76 +k=0.99932994 +x_0=720000 +y_0=1039979.159 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:24893": [
        "EPSG:24893",
        "+proj=tmerc +lat_0=-9.5 +lon_0=-70.5 +k=0.99952992 +x_0=1324000 +y_0=1040084.558 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25000": [
        "EPSG:25000",
        "+proj=tmerc +lat_0=4.666666666666667 +lon_0=-1 +k=0.99975 +x_0=274319.51 +y_0=0 +ellps=clrk80 +towgs84=-130,29,364,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25231": [
        "EPSG:25231",
        "+proj=utm +zone=31 +a=6378249.2 +b=6356515 +units=m +no_defs ",
    ],
    "EPSG:25391": [
        "EPSG:25391",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25392": [
        "EPSG:25392",
        "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25393": [
        "EPSG:25393",
        "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25394": [
        "EPSG:25394",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25395": [
        "EPSG:25395",
        "+proj=tmerc +lat_0=0 +lon_0=125 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25700": [
        "EPSG:25700",
        "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +pm=jakarta +units=m +no_defs ",
    ],
    "EPSG:25834": [
        "EPSG:25834",
        "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25836": [
        "EPSG:25836",
        "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25837": [
        "EPSG:25837",
        "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25838": [
        "EPSG:25838",
        "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25884": [
        "EPSG:25884",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:25932": [
        "EPSG:25932",
        "+proj=utm +zone=32 +south +ellps=intl +towgs84=-254.1,-5.36,-100.29,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26193": [
        "EPSG:26193",
        "+proj=lcc +lat_1=26.1 +lat_0=26.1 +lon_0=-5.4 +k_0=0.9996 +x_0=1200000 +y_0=400000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26194": [
        "EPSG:26194",
        "+proj=lcc +lat_1=26.1 +lat_0=26.1 +lon_0=-5.4 +k_0=0.999616304 +x_0=1200000 +y_0=400000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26195": [
        "EPSG:26195",
        "+proj=lcc +lat_1=22.5 +lat_0=22.5 +lon_0=-5.4 +k_0=0.999616437 +x_0=1500000 +y_0=400000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26237": [
        "EPSG:26237",
        "+proj=utm +zone=37 +ellps=bessel +towgs84=639,405,60,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26332": [
        "EPSG:26332",
        "+proj=utm +zone=32 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26391": [
        "EPSG:26391",
        "+proj=tmerc +lat_0=4 +lon_0=4.5 +k=0.99975 +x_0=230738.26 +y_0=0 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26392": [
        "EPSG:26392",
        "+proj=tmerc +lat_0=4 +lon_0=8.5 +k=0.99975 +x_0=670553.98 +y_0=0 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26393": [
        "EPSG:26393",
        "+proj=tmerc +lat_0=4 +lon_0=12.5 +k=0.99975 +x_0=1110369.7 +y_0=0 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26432": [
        "EPSG:26432",
        "+proj=utm +zone=32 +south +ellps=intl +towgs84=-252.95,-4.11,-96.38,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26592": [
        "EPSG:26592",
        "+proj=tmerc +lat_0=0 +lon_0=2.54766666666666 +k=0.9996 +x_0=2520000 +y_0=0 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +pm=rome +units=m +no_defs ",
    ],
    "EPSG:26632": [
        "EPSG:26632",
        "+proj=utm +zone=32 +a=6378249.2 +b=6356515 +towgs84=-74,-130,42,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26692": [
        "EPSG:26692",
        "+proj=utm +zone=32 +south +a=6378249.2 +b=6356515 +towgs84=-74,-130,42,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26701": [
        "EPSG:26701",
        "+proj=utm +zone=1 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26703": [
        "EPSG:26703",
        "+proj=utm +zone=3 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26704": [
        "EPSG:26704",
        "+proj=utm +zone=4 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26706": [
        "EPSG:26706",
        "+proj=utm +zone=6 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26707": [
        "EPSG:26707",
        "+proj=utm +zone=7 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26708": [
        "EPSG:26708",
        "+proj=utm +zone=8 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26709": [
        "EPSG:26709",
        "+proj=utm +zone=9 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26720": [
        "EPSG:26720",
        "+proj=utm +zone=20 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26721": [
        "EPSG:26721",
        "+proj=utm +zone=21 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26722": [
        "EPSG:26722",
        "+proj=utm +zone=22 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:26729": [
        "EPSG:26729",
        "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.99996 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26731": [
        "EPSG:26731",
        "+proj=omerc +lat_0=57 +lonc=-133.6666666666667 +alpha=323.1301023611111 +k=0.9999 +x_0=5000000.001016002 +y_0=-5000000.001016002 +no_uoff +gamma=323.1301023611111 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26732": [
        "EPSG:26732",
        "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26733": [
        "EPSG:26733",
        "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26734": [
        "EPSG:26734",
        "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26735": [
        "EPSG:26735",
        "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26736": [
        "EPSG:26736",
        "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26737": [
        "EPSG:26737",
        "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=213360.4267208534 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26738": [
        "EPSG:26738",
        "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26739": [
        "EPSG:26739",
        "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=182880.3657607315 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26740": [
        "EPSG:26740",
        "+proj=lcc +lat_1=53.83333333333334 +lat_2=51.83333333333334 +lat_0=51 +lon_0=-176 +x_0=914401.8288036576 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26741": [
        "EPSG:26741",
        "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26742": [
        "EPSG:26742",
        "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26743": [
        "EPSG:26743",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.06666666666667 +lat_0=36.5 +lon_0=-120.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26744": [
        "EPSG:26744",
        "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26745": [
        "EPSG:26745",
        "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26746": [
        "EPSG:26746",
        "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26747": [
        "EPSG:26747",
        "+proj=lcc +lat_1=34.41666666666666 +lat_2=33.86666666666667 +lat_0=34.13333333333333 +lon_0=-118.3333333333333 +x_0=1276106.450596901 +y_0=127079.524511049 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:5358": ["EPSG:5358", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:26748": [
        "EPSG:26748",
        "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26749": [
        "EPSG:26749",
        "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26750": [
        "EPSG:26750",
        "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26751": [
        "EPSG:26751",
        "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26752": [
        "EPSG:26752",
        "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26754": [
        "EPSG:26754",
        "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26755": [
        "EPSG:26755",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26756": [
        "EPSG:26756",
        "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=182880.3657607315 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26757": [
        "EPSG:26757",
        "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26758": [
        "EPSG:26758",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26759": [
        "EPSG:26759",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26760": [
        "EPSG:26760",
        "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26766": [
        "EPSG:26766",
        "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26767": [
        "EPSG:26767",
        "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26768": [
        "EPSG:26768",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26769": [
        "EPSG:26769",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26770": [
        "EPSG:26770",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:5363": ["EPSG:5363", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:26772": [
        "EPSG:26772",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26773": [
        "EPSG:26773",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26774": [
        "EPSG:26774",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26775": [
        "EPSG:26775",
        "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26776": [
        "EPSG:26776",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26777": [
        "EPSG:26777",
        "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26779": [
        "EPSG:26779",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26780": [
        "EPSG:26780",
        "+proj=lcc +lat_1=36.73333333333333 +lat_2=37.93333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26781": [
        "EPSG:26781",
        "+proj=lcc +lat_1=31.16666666666667 +lat_2=32.66666666666666 +lat_0=30.66666666666667 +lon_0=-92.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26782": [
        "EPSG:26782",
        "+proj=lcc +lat_1=29.3 +lat_2=30.7 +lat_0=28.66666666666667 +lon_0=-91.33333333333333 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26783": [
        "EPSG:26783",
        "+proj=tmerc +lat_0=43.83333333333334 +lon_0=-68.5 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26784": [
        "EPSG:26784",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26786": [
        "EPSG:26786",
        "+proj=lcc +lat_1=41.71666666666667 +lat_2=42.68333333333333 +lat_0=41 +lon_0=-71.5 +x_0=182880.3657607315 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26787": [
        "EPSG:26787",
        "+proj=lcc +lat_1=41.28333333333333 +lat_2=41.48333333333333 +lat_0=41 +lon_0=-70.5 +x_0=60960.12192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26893": [
        "EPSG:26893",
        "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26791": [
        "EPSG:26791",
        "+proj=lcc +lat_1=47.03333333333333 +lat_2=48.63333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26792": [
        "EPSG:26792",
        "+proj=lcc +lat_1=45.61666666666667 +lat_2=47.05 +lat_0=45 +lon_0=-94.25 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26793": [
        "EPSG:26793",
        "+proj=lcc +lat_1=43.78333333333333 +lat_2=45.21666666666667 +lat_0=43 +lon_0=-94 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26794": [
        "EPSG:26794",
        "+proj=tmerc +lat_0=29.66666666666667 +lon_0=-88.83333333333333 +k=0.99996 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26795": [
        "EPSG:26795",
        "+proj=tmerc +lat_0=30.5 +lon_0=-90.33333333333333 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26796": [
        "EPSG:26796",
        "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933333 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26797": [
        "EPSG:26797",
        "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933333 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26798": [
        "EPSG:26798",
        "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26799": [
        "EPSG:26799",
        "+proj=lcc +lat_1=34.41666666666666 +lat_2=33.86666666666667 +lat_0=34.13333333333333 +lon_0=-118.3333333333333 +x_0=1276106.450596901 +y_0=1268253.006858014 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:26801": [
        "EPSG:26801",
        "+proj=tmerc +lat_0=41.5 +lon_0=-83.66666666666667 +k=0.999942857 +x_0=152400.3048006096 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs ",
    ],
    "EPSG:26802": [
        "EPSG:26802",
        "+proj=tmerc +lat_0=41.5 +lon_0=-85.75 +k=0.999909091 +x_0=152400.3048006096 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs ",
    ],
    "EPSG:26803": [
        "EPSG:26803",
        "+proj=tmerc +lat_0=41.5 +lon_0=-88.75 +k=0.999909091 +x_0=152400.3048006096 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs ",
    ],
    "EPSG:26811": [
        "EPSG:26811",
        "+proj=lcc +lat_1=45.48333333333333 +lat_2=47.08333333333334 +lat_0=44.78333333333333 +lon_0=-87 +x_0=609601.2192024384 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs ",
    ],
    "EPSG:26812": [
        "EPSG:26812",
        "+proj=lcc +lat_1=44.18333333333333 +lat_2=45.7 +lat_0=43.31666666666667 +lon_0=-84.33333333333333 +x_0=609601.2192024384 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs ",
    ],
    "EPSG:26813": [
        "EPSG:26813",
        "+proj=lcc +lat_1=42.1 +lat_2=43.66666666666666 +lat_0=41.5 +lon_0=-84.33333333333333 +x_0=609601.2192024384 +y_0=0 +a=6378450.047548896 +b=6356826.621488444 +units=us-ft +no_defs ",
    ],
    "EPSG:26814": [
        "EPSG:26814",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26815": [
        "EPSG:26815",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26905": [
        "EPSG:26905",
        "+proj=utm +zone=5 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26819": [
        "EPSG:26819",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101601 +y_0=99999.99998984 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26820": [
        "EPSG:26820",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101601 +y_0=99999.99998984 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26821": [
        "EPSG:26821",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101601 +y_0=99999.99998984 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26822": [
        "EPSG:26822",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.0000101601 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26823": [
        "EPSG:26823",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=1968500 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26824": [
        "EPSG:26824",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=1968500 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26825": [
        "EPSG:26825",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26826": [
        "EPSG:26826",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26906": [
        "EPSG:26906",
        "+proj=utm +zone=6 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26830": [
        "EPSG:26830",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26831": [
        "EPSG:26831",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26832": [
        "EPSG:26832",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26833": [
        "EPSG:26833",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26834": [
        "EPSG:26834",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=1968500 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26835": [
        "EPSG:26835",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=1968500 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26836": [
        "EPSG:26836",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26837": [
        "EPSG:26837",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5368": ["EPSG:5368", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:26841": [
        "EPSG:26841",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26842": [
        "EPSG:26842",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26843": [
        "EPSG:26843",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26844": [
        "EPSG:26844",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26845": [
        "EPSG:26845",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=1968500 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26846": [
        "EPSG:26846",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=1968500 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26847": [
        "EPSG:26847",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000.0000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:26848": [
        "EPSG:26848",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:5369": ["EPSG:5369", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:26849": [
        "EPSG:26849",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101599 +y_0=99999.99998983997 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:26850": [
        "EPSG:26850",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101599 +y_0=99999.99998983997 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:26851": [
        "EPSG:26851",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101599 +y_0=99999.99998983997 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:26852": [
        "EPSG:26852",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:26853": [
        "EPSG:26853",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:26854": [
        "EPSG:26854",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:26855": [
        "EPSG:26855",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26856": [
        "EPSG:26856",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:5379": ["EPSG:5379", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:26857": [
        "EPSG:26857",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26858": [
        "EPSG:26858",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26859": [
        "EPSG:26859",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26860": [
        "EPSG:26860",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26861": [
        "EPSG:26861",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26862": [
        "EPSG:26862",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26863": [
        "EPSG:26863",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000.0000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26864": [
        "EPSG:26864",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26865": [
        "EPSG:26865",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26866": [
        "EPSG:26866",
        "+proj=lcc +lat_1=47.05 +lat_2=45.61666666666667 +lat_0=45 +lon_0=-94.25 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26867": [
        "EPSG:26867",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000.0000101599 +y_0=99999.99998983997 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26868": [
        "EPSG:26868",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26869": [
        "EPSG:26869",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26870": [
        "EPSG:26870",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs ",
    ],
    "EPSG:26891": [
        "EPSG:26891",
        "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26892": [
        "EPSG:26892",
        "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5391": ["EPSG:5391", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:26897": [
        "EPSG:26897",
        "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26898": [
        "EPSG:26898",
        "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26899": [
        "EPSG:26899",
        "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:26901": [
        "EPSG:26901",
        "+proj=utm +zone=1 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26902": [
        "EPSG:26902",
        "+proj=utm +zone=2 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26903": [
        "EPSG:26903",
        "+proj=utm +zone=3 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26907": [
        "EPSG:26907",
        "+proj=utm +zone=7 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26908": [
        "EPSG:26908",
        "+proj=utm +zone=8 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26909": [
        "EPSG:26909",
        "+proj=utm +zone=9 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26919": [
        "EPSG:26919",
        "+proj=utm +zone=19 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26921": [
        "EPSG:26921",
        "+proj=utm +zone=21 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26922": [
        "EPSG:26922",
        "+proj=utm +zone=22 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26923": [
        "EPSG:26923",
        "+proj=utm +zone=23 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26929": [
        "EPSG:26929",
        "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.99996 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26930": [
        "EPSG:26930",
        "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26931": [
        "EPSG:26931",
        "+proj=omerc +lat_0=57 +lonc=-133.6666666666667 +alpha=323.1301023611111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +no_uoff +gamma=323.1301023611111 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26932": [
        "EPSG:26932",
        "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26933": [
        "EPSG:26933",
        "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26934": [
        "EPSG:26934",
        "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26935": [
        "EPSG:26935",
        "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26936": [
        "EPSG:26936",
        "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26937": [
        "EPSG:26937",
        "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26938": [
        "EPSG:26938",
        "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26939": [
        "EPSG:26939",
        "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26940": [
        "EPSG:26940",
        "+proj=lcc +lat_1=53.83333333333334 +lat_2=51.83333333333334 +lat_0=51 +lon_0=-176 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26941": [
        "EPSG:26941",
        "+proj=lcc +lat_1=41.66666666666666 +lat_2=40 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26942": [
        "EPSG:26942",
        "+proj=lcc +lat_1=39.83333333333334 +lat_2=38.33333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26944": [
        "EPSG:26944",
        "+proj=lcc +lat_1=37.25 +lat_2=36 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26945": [
        "EPSG:26945",
        "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26946": [
        "EPSG:26946",
        "+proj=lcc +lat_1=33.88333333333333 +lat_2=32.78333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26948": [
        "EPSG:26948",
        "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26949": [
        "EPSG:26949",
        "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26950": [
        "EPSG:26950",
        "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26951": [
        "EPSG:26951",
        "+proj=lcc +lat_1=36.23333333333333 +lat_2=34.93333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26952": [
        "EPSG:26952",
        "+proj=lcc +lat_1=34.76666666666667 +lat_2=33.3 +lat_0=32.66666666666666 +lon_0=-92 +x_0=400000 +y_0=400000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26953": [
        "EPSG:26953",
        "+proj=lcc +lat_1=40.78333333333333 +lat_2=39.71666666666667 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26954": [
        "EPSG:26954",
        "+proj=lcc +lat_1=39.75 +lat_2=38.45 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26955": [
        "EPSG:26955",
        "+proj=lcc +lat_1=38.43333333333333 +lat_2=37.23333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26956": [
        "EPSG:26956",
        "+proj=lcc +lat_1=41.86666666666667 +lat_2=41.2 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096 +y_0=152400.3048 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26957": [
        "EPSG:26957",
        "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26959": [
        "EPSG:26959",
        "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26960": [
        "EPSG:26960",
        "+proj=lcc +lat_1=30.75 +lat_2=29.58333333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26961": [
        "EPSG:26961",
        "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26962": [
        "EPSG:26962",
        "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26963": [
        "EPSG:26963",
        "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26964": [
        "EPSG:26964",
        "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26965": [
        "EPSG:26965",
        "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26966": [
        "EPSG:26966",
        "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.9999 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26968": [
        "EPSG:26968",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.9999473679999999 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26969": [
        "EPSG:26969",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.9999473679999999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26970": [
        "EPSG:26970",
        "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:29635": [
        "EPSG:29635",
        "+proj=utm +zone=35 +a=6378249.2 +b=6356515 +units=m +no_defs ",
    ],
    "EPSG:26971": [
        "EPSG:26971",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26972": [
        "EPSG:26972",
        "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26973": [
        "EPSG:26973",
        "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26974": [
        "EPSG:26974",
        "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26975": [
        "EPSG:26975",
        "+proj=lcc +lat_1=43.26666666666667 +lat_2=42.06666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26976": [
        "EPSG:26976",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.61666666666667 +lat_0=40 +lon_0=-93.5 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26977": [
        "EPSG:26977",
        "+proj=lcc +lat_1=39.78333333333333 +lat_2=38.71666666666667 +lat_0=38.33333333333334 +lon_0=-98 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26978": [
        "EPSG:26978",
        "+proj=lcc +lat_1=38.56666666666667 +lat_2=37.26666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=400000 +y_0=400000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26979": [
        "EPSG:26979",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=37.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26980": [
        "EPSG:26980",
        "+proj=lcc +lat_1=37.93333333333333 +lat_2=36.73333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000 +y_0=500000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26981": [
        "EPSG:26981",
        "+proj=lcc +lat_1=32.66666666666666 +lat_2=31.16666666666667 +lat_0=30.5 +lon_0=-92.5 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26982": [
        "EPSG:26982",
        "+proj=lcc +lat_1=30.7 +lat_2=29.3 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26983": [
        "EPSG:26983",
        "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26984": [
        "EPSG:26984",
        "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26985": [
        "EPSG:26985",
        "+proj=lcc +lat_1=39.45 +lat_2=38.3 +lat_0=37.66666666666666 +lon_0=-77 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26986": [
        "EPSG:26986",
        "+proj=lcc +lat_1=42.68333333333333 +lat_2=41.71666666666667 +lat_0=41 +lon_0=-71.5 +x_0=200000 +y_0=750000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26987": [
        "EPSG:26987",
        "+proj=lcc +lat_1=41.48333333333333 +lat_2=41.28333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26988": [
        "EPSG:26988",
        "+proj=lcc +lat_1=47.08333333333334 +lat_2=45.48333333333333 +lat_0=44.78333333333333 +lon_0=-87 +x_0=8000000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26989": [
        "EPSG:26989",
        "+proj=lcc +lat_1=45.7 +lat_2=44.18333333333333 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=6000000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26990": [
        "EPSG:26990",
        "+proj=lcc +lat_1=43.66666666666666 +lat_2=42.1 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=4000000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26991": [
        "EPSG:26991",
        "+proj=lcc +lat_1=48.63333333333333 +lat_2=47.03333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26993": [
        "EPSG:26993",
        "+proj=lcc +lat_1=45.21666666666667 +lat_2=43.78333333333333 +lat_0=43 +lon_0=-94 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26994": [
        "EPSG:26994",
        "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.99995 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26995": [
        "EPSG:26995",
        "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.99995 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26997": [
        "EPSG:26997",
        "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:26998": [
        "EPSG:26998",
        "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:27037": [
        "EPSG:27037",
        "+proj=utm +zone=37 +ellps=clrk80 +towgs84=-249,-156,381,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27038": [
        "EPSG:27038",
        "+proj=utm +zone=38 +ellps=clrk80 +towgs84=-249,-156,381,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27039": [
        "EPSG:27039",
        "+proj=utm +zone=39 +ellps=clrk80 +towgs84=-249,-156,381,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27120": [
        "EPSG:27120",
        "+proj=utm +zone=20 +ellps=intl +towgs84=-10,375,165,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27205": [
        "EPSG:27205",
        "+proj=tmerc +lat_0=-36.87986527777778 +lon_0=174.7643393611111 +k=0.9999 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27206": [
        "EPSG:27206",
        "+proj=tmerc +lat_0=-37.76124980555556 +lon_0=176.46619725 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:5487": ["EPSG:5487", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:27207": [
        "EPSG:27207",
        "+proj=tmerc +lat_0=-38.62470277777778 +lon_0=177.8856362777778 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27208": [
        "EPSG:27208",
        "+proj=tmerc +lat_0=-39.65092930555556 +lon_0=176.6736805277778 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27209": [
        "EPSG:27209",
        "+proj=tmerc +lat_0=-39.13575830555556 +lon_0=174.22801175 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27210": [
        "EPSG:27210",
        "+proj=tmerc +lat_0=-39.51247038888889 +lon_0=175.6400368055556 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27211": [
        "EPSG:27211",
        "+proj=tmerc +lat_0=-40.24194713888889 +lon_0=175.4880996111111 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27212": [
        "EPSG:27212",
        "+proj=tmerc +lat_0=-40.92553263888889 +lon_0=175.6473496666667 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27213": [
        "EPSG:27213",
        "+proj=tmerc +lat_0=-41.30131963888888 +lon_0=174.7766231111111 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27214": [
        "EPSG:27214",
        "+proj=tmerc +lat_0=-40.71475905555556 +lon_0=172.6720465 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:29636": [
        "EPSG:29636",
        "+proj=utm +zone=36 +a=6378249.2 +b=6356515 +units=m +no_defs ",
    ],
    "EPSG:27215": [
        "EPSG:27215",
        "+proj=tmerc +lat_0=-41.27454472222222 +lon_0=173.2993168055555 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27216": [
        "EPSG:27216",
        "+proj=tmerc +lat_0=-41.28991152777778 +lon_0=172.1090281944444 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27217": [
        "EPSG:27217",
        "+proj=tmerc +lat_0=-41.81080286111111 +lon_0=171.5812600555556 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27218": [
        "EPSG:27218",
        "+proj=tmerc +lat_0=-42.33369427777778 +lon_0=171.5497713055556 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27219": [
        "EPSG:27219",
        "+proj=tmerc +lat_0=-42.68911658333333 +lon_0=173.0101333888889 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27220": [
        "EPSG:27220",
        "+proj=tmerc +lat_0=-41.54448666666666 +lon_0=173.8020741111111 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27221": [
        "EPSG:27221",
        "+proj=tmerc +lat_0=-42.88632236111111 +lon_0=170.9799935 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27222": [
        "EPSG:27222",
        "+proj=tmerc +lat_0=-43.11012813888889 +lon_0=170.2609258333333 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27223": [
        "EPSG:27223",
        "+proj=tmerc +lat_0=-43.97780288888889 +lon_0=168.606267 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27224": [
        "EPSG:27224",
        "+proj=tmerc +lat_0=-43.59063758333333 +lon_0=172.7271935833333 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +units=m +no_defs ",
    ],
    "EPSG:27225": [
        "EPSG:27225",
        "+proj=tmerc +lat_0=-43.74871155555556 +lon_0=171.3607484722222 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27226": [
        "EPSG:27226",
        "+proj=tmerc +lat_0=-44.40222036111111 +lon_0=171.0572508333333 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27227": [
        "EPSG:27227",
        "+proj=tmerc +lat_0=-44.73526797222222 +lon_0=169.4677550833333 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27228": [
        "EPSG:27228",
        "+proj=tmerc +lat_0=-45.13290258333333 +lon_0=168.3986411944444 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27229": [
        "EPSG:27229",
        "+proj=tmerc +lat_0=-45.56372616666666 +lon_0=167.7388617777778 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27230": [
        "EPSG:27230",
        "+proj=tmerc +lat_0=-45.81619661111111 +lon_0=170.6285951666667 +k=1 +x_0=300000 +y_0=700000 +datum=nzgd49 +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +units=m +no_defs ",
    ],
    "EPSG:27231": [
        "EPSG:27231",
        "+proj=tmerc +lat_0=-45.86151336111111 +lon_0=170.2825891111111 +k=0.99996 +x_0=300000 +y_0=700000 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27232": [
        "EPSG:27232",
        "+proj=tmerc +lat_0=-46.60000961111111 +lon_0=168.342872 +k=1 +x_0=300002.66 +y_0=699999.58 +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27258": [
        "EPSG:27258",
        "+proj=utm +zone=58 +south +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27259": [
        "EPSG:27259",
        "+proj=utm +zone=59 +south +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27260": [
        "EPSG:27260",
        "+proj=utm +zone=60 +south +datum=nzgd49 +units=m +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27291": [
        "EPSG:27291",
        "+proj=tmerc +lat_0=-39 +lon_0=175.5 +k=1 +x_0=274319.5243848086 +y_0=365759.3658464114 +datum=nzgd49 +to_meter=0.9143984146160287 +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:27292": [
        "EPSG:27292",
        "+proj=tmerc +lat_0=-44 +lon_0=171.5 +k=1 +x_0=457199.2073080143 +y_0=457199.2073080143 +datum=nzgd49 +to_meter=0.9143984146160287 +towgs84=59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993 +nadgrids=nzgd2kgrid0005.gsb +no_defs ",
    ],
    "EPSG:31121": [
        "EPSG:31121",
        "+proj=utm +zone=21 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27392": [
        "EPSG:27392",
        "+proj=tmerc +lat_0=58 +lon_0=-2.333333333333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs ",
    ],
    "EPSG:27394": [
        "EPSG:27394",
        "+proj=tmerc +lat_0=58 +lon_0=2.5 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs ",
    ],
    "EPSG:27395": [
        "EPSG:27395",
        "+proj=tmerc +lat_0=58 +lon_0=6.166666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs ",
    ],
    "EPSG:27396": [
        "EPSG:27396",
        "+proj=tmerc +lat_0=58 +lon_0=10.16666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs ",
    ],
    "EPSG:27397": [
        "EPSG:27397",
        "+proj=tmerc +lat_0=58 +lon_0=14.16666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs ",
    ],
    "EPSG:27398": [
        "EPSG:27398",
        "+proj=tmerc +lat_0=58 +lon_0=18.33333333333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +pm=oslo +units=m +no_defs ",
    ],
    "EPSG:27429": [
        "EPSG:27429",
        "+proj=utm +zone=29 +ellps=intl +towgs84=-223.237,110.193,36.649,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:27500": [
        "EPSG:27500",
        "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=5.399999999999999 +k_0=0.99950908 +x_0=500000 +y_0=300000 +a=6376523 +b=6355862.933255573 +pm=2.337208333333333 +units=m +no_defs ",
    ],
    "EPSG:27564": [
        "EPSG:27564",
        "+proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:27571": [
        "EPSG:27571",
        "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:5544": ["EPSG:5544", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:27574": [
        "EPSG:27574",
        "+proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:27581": [
        "EPSG:27581",
        "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:27583": [
        "EPSG:27583",
        "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:27584": [
        "EPSG:27584",
        "+proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:27591": [
        "EPSG:27591",
        "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:27592": [
        "EPSG:27592",
        "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:5558": ["EPSG:5558", "+proj=geocent +ellps=krass +units=m +no_defs "],
    "EPSG:27593": [
        "EPSG:27593",
        "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:27594": [
        "EPSG:27594",
        "+proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:28191": [
        "EPSG:28191",
        "+proj=cass +lat_0=31.73409694444445 +lon_0=35.21208055555556 +x_0=170251.555 +y_0=126867.909 +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +units=m +no_defs ",
    ],
    "EPSG:28192": [
        "EPSG:28192",
        "+proj=tmerc +lat_0=31.73409694444445 +lon_0=35.21208055555556 +k=1 +x_0=170251.555 +y_0=1126867.909 +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +units=m +no_defs ",
    ],
    "EPSG:28193": [
        "EPSG:28193",
        "+proj=cass +lat_0=31.73409694444445 +lon_0=35.21208055555556 +x_0=170251.555 +y_0=1126867.909 +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +units=m +no_defs ",
    ],
    "EPSG:28232": [
        "EPSG:28232",
        "+proj=utm +zone=32 +south +a=6378249.2 +b=6356515 +towgs84=-148,51,-291,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:28348": [
        "EPSG:28348",
        "+proj=utm +zone=48 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:28349": [
        "EPSG:28349",
        "+proj=utm +zone=49 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:28357": [
        "EPSG:28357",
        "+proj=utm +zone=57 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:28358": [
        "EPSG:28358",
        "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:28402": [
        "EPSG:28402",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28403": [
        "EPSG:28403",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28404": [
        "EPSG:28404",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28405": [
        "EPSG:28405",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28406": [
        "EPSG:28406",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28407": [
        "EPSG:28407",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28408": [
        "EPSG:28408",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28409": [
        "EPSG:28409",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28410": [
        "EPSG:28410",
        "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28411": [
        "EPSG:28411",
        "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28412": [
        "EPSG:28412",
        "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28413": [
        "EPSG:28413",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28414": [
        "EPSG:28414",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28415": [
        "EPSG:28415",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28416": [
        "EPSG:28416",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28417": [
        "EPSG:28417",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28418": [
        "EPSG:28418",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28419": [
        "EPSG:28419",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28420": [
        "EPSG:28420",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28421": [
        "EPSG:28421",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28422": [
        "EPSG:28422",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28423": [
        "EPSG:28423",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28424": [
        "EPSG:28424",
        "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28425": [
        "EPSG:28425",
        "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28426": [
        "EPSG:28426",
        "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28427": [
        "EPSG:28427",
        "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28428": [
        "EPSG:28428",
        "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28429": [
        "EPSG:28429",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28430": [
        "EPSG:28430",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28431": [
        "EPSG:28431",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28432": [
        "EPSG:28432",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28462": [
        "EPSG:28462",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28463": [
        "EPSG:28463",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28464": [
        "EPSG:28464",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28465": [
        "EPSG:28465",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28466": [
        "EPSG:28466",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28467": [
        "EPSG:28467",
        "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28468": [
        "EPSG:28468",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28469": [
        "EPSG:28469",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28470": [
        "EPSG:28470",
        "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28471": [
        "EPSG:28471",
        "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28472": [
        "EPSG:28472",
        "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28473": [
        "EPSG:28473",
        "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28474": [
        "EPSG:28474",
        "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28475": [
        "EPSG:28475",
        "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28476": [
        "EPSG:28476",
        "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28477": [
        "EPSG:28477",
        "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28478": [
        "EPSG:28478",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28479": [
        "EPSG:28479",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:32207": [
        "EPSG:32207",
        "+proj=utm +zone=7 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:28480": [
        "EPSG:28480",
        "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28481": [
        "EPSG:28481",
        "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28482": [
        "EPSG:28482",
        "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28483": [
        "EPSG:28483",
        "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28484": [
        "EPSG:28484",
        "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28485": [
        "EPSG:28485",
        "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28486": [
        "EPSG:28486",
        "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28487": [
        "EPSG:28487",
        "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28488": [
        "EPSG:28488",
        "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:32208": [
        "EPSG:32208",
        "+proj=utm +zone=8 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:28489": [
        "EPSG:28489",
        "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28490": [
        "EPSG:28490",
        "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28491": [
        "EPSG:28491",
        "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28492": [
        "EPSG:28492",
        "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +units=m +no_defs ",
    ],
    "EPSG:28600": [
        "EPSG:28600",
        "+proj=tmerc +lat_0=24.45 +lon_0=51.21666666666667 +k=0.99999 +x_0=200000 +y_0=300000 +ellps=intl +towgs84=-128.16,-282.42,21.93,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5591": ["EPSG:5591", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:29118": [
        "EPSG:29118",
        "+proj=utm +zone=18 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29119": [
        "EPSG:29119",
        "+proj=utm +zone=19 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29120": [
        "EPSG:29120",
        "+proj=utm +zone=20 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29121": [
        "EPSG:29121",
        "+proj=utm +zone=21 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29122": [
        "EPSG:29122",
        "+proj=utm +zone=22 +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29168": [
        "EPSG:29168",
        "+proj=utm +zone=18 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29169": [
        "EPSG:29169",
        "+proj=utm +zone=19 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29170": [
        "EPSG:29170",
        "+proj=utm +zone=20 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29171": [
        "EPSG:29171",
        "+proj=utm +zone=21 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29172": [
        "EPSG:29172",
        "+proj=utm +zone=22 +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29177": [
        "EPSG:29177",
        "+proj=utm +zone=17 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29178": [
        "EPSG:29178",
        "+proj=utm +zone=18 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29179": [
        "EPSG:29179",
        "+proj=utm +zone=19 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29181": [
        "EPSG:29181",
        "+proj=utm +zone=21 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29183": [
        "EPSG:29183",
        "+proj=utm +zone=23 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29185": [
        "EPSG:29185",
        "+proj=utm +zone=25 +south +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29187": [
        "EPSG:29187",
        "+proj=utm +zone=17 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29188": [
        "EPSG:29188",
        "+proj=utm +zone=18 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29189": [
        "EPSG:29189",
        "+proj=utm +zone=19 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29190": [
        "EPSG:29190",
        "+proj=utm +zone=20 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29192": [
        "EPSG:29192",
        "+proj=utm +zone=22 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29194": [
        "EPSG:29194",
        "+proj=utm +zone=24 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29195": [
        "EPSG:29195",
        "+proj=utm +zone=25 +south +ellps=aust_SA +towgs84=-66.87,4.37,-38.52,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29220": [
        "EPSG:29220",
        "+proj=utm +zone=20 +south +ellps=intl +towgs84=-355,21,72,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29221": [
        "EPSG:29221",
        "+proj=utm +zone=21 +south +ellps=intl +towgs84=-355,21,72,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29333": [
        "EPSG:29333",
        "+proj=utm +zone=33 +south +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29371": [
        "EPSG:29371",
        "+proj=tmerc +lat_0=-22 +lon_0=11 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs ",
    ],
    "EPSG:29373": [
        "EPSG:29373",
        "+proj=tmerc +lat_0=-22 +lon_0=13 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs ",
    ],
    "EPSG:29375": [
        "EPSG:29375",
        "+proj=tmerc +lat_0=-22 +lon_0=15 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs ",
    ],
    "EPSG:29377": [
        "EPSG:29377",
        "+proj=tmerc +lat_0=-22 +lon_0=17 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs ",
    ],
    "EPSG:29379": [
        "EPSG:29379",
        "+proj=tmerc +lat_0=-22 +lon_0=19 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs ",
    ],
    "EPSG:29381": [
        "EPSG:29381",
        "+proj=tmerc +lat_0=-22 +lon_0=21 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs ",
    ],
    "EPSG:29383": [
        "EPSG:29383",
        "+proj=tmerc +lat_0=-22 +lon_0=23 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs ",
    ],
    "EPSG:29385": [
        "EPSG:29385",
        "+proj=tmerc +lat_0=-22 +lon_0=25 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +to_meter=1.0000135965 +no_defs ",
    ],
    "EPSG:29700": [
        "EPSG:29700",
        "+proj=omerc +lat_0=-18.9 +lonc=44.10000000000001 +alpha=18.9 +k=0.9995000000000001 +x_0=400000 +y_0=800000 +gamma=18.9 +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:29701": ["EPSG:29701", ""],
    "EPSG:29702": [
        "EPSG:29702",
        "+proj=omerc +lat_0=-18.9 +lonc=44.10000000000001 +alpha=18.9 +k=0.9995000000000001 +x_0=400000 +y_0=800000 +gamma=18.9 +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +pm=paris +units=m +no_defs ",
    ],
    "EPSG:29738": [
        "EPSG:29738",
        "+proj=utm +zone=38 +south +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29739": [
        "EPSG:29739",
        "+proj=utm +zone=39 +south +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29849": [
        "EPSG:29849",
        "+proj=utm +zone=49 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29850": [
        "EPSG:29850",
        "+proj=utm +zone=50 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29871": [
        "EPSG:29871",
        "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +k=0.99984 +x_0=590476.8714630401 +y_0=442857.653094361 +gamma=53.13010236111111 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +to_meter=20.11676512155263 +no_defs ",
    ],
    "EPSG:29873": [
        "EPSG:29873",
        "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +k=0.99984 +x_0=590476.87 +y_0=442857.65 +gamma=53.13010236111111 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:29901": [
        "EPSG:29901",
        "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1 +x_0=200000 +y_0=250000 +ellps=airy +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +units=m +no_defs ",
    ],
    "EPSG:29903": [
        "EPSG:29903",
        "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +ellps=mod_airy +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +units=m +no_defs ",
    ],
    "EPSG:30161": [
        "EPSG:30161",
        "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30162": [
        "EPSG:30162",
        "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30163": [
        "EPSG:30163",
        "+proj=tmerc +lat_0=36 +lon_0=132.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30164": [
        "EPSG:30164",
        "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5828": [
        "EPSG:5828",
        "+proj=geocent +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:30165": [
        "EPSG:30165",
        "+proj=tmerc +lat_0=36 +lon_0=134.3333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30166": [
        "EPSG:30166",
        "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30167": [
        "EPSG:30167",
        "+proj=tmerc +lat_0=36 +lon_0=137.1666666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30168": [
        "EPSG:30168",
        "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30169": [
        "EPSG:30169",
        "+proj=tmerc +lat_0=36 +lon_0=139.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30170": [
        "EPSG:30170",
        "+proj=tmerc +lat_0=40 +lon_0=140.8333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30171": [
        "EPSG:30171",
        "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30172": [
        "EPSG:30172",
        "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30173": [
        "EPSG:30173",
        "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30174": [
        "EPSG:30174",
        "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30175": [
        "EPSG:30175",
        "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30176": [
        "EPSG:30176",
        "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30177": [
        "EPSG:30177",
        "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30178": [
        "EPSG:30178",
        "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30179": [
        "EPSG:30179",
        "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30200": [
        "EPSG:30200",
        "+proj=cass +lat_0=10.44166666666667 +lon_0=-61.33333333333334 +x_0=86501.46392051999 +y_0=65379.0134283 +a=6378293.645208759 +b=6356617.987679838 +towgs84=-61.702,284.488,472.052,0,0,0,0 +to_meter=0.201166195164 +no_defs ",
    ],
    "EPSG:30339": [
        "EPSG:30339",
        "+proj=utm +zone=39 +ellps=helmert +units=m +no_defs ",
    ],
    "EPSG:30340": [
        "EPSG:30340",
        "+proj=utm +zone=40 +ellps=helmert +units=m +no_defs ",
    ],
    "EPSG:30491": [
        "EPSG:30491",
        "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=-73,-247,227,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31028": [
        "EPSG:31028",
        "+proj=utm +zone=28 +a=6378249.2 +b=6356515 +towgs84=-30,190,89,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30492": [
        "EPSG:30492",
        "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=-73,-247,227,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:30493": [
        "EPSG:30493",
        "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +units=m +no_defs ",
    ],
    "EPSG:30494": [
        "EPSG:30494",
        "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +units=m +no_defs ",
    ],
    "EPSG:30729": [
        "EPSG:30729",
        "+proj=utm +zone=29 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs ",
    ],
    "EPSG:30730": [
        "EPSG:30730",
        "+proj=utm +zone=30 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs ",
    ],
    "EPSG:30731": [
        "EPSG:30731",
        "+proj=utm +zone=31 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs ",
    ],
    "EPSG:30732": [
        "EPSG:30732",
        "+proj=utm +zone=32 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs ",
    ],
    "EPSG:30791": [
        "EPSG:30791",
        "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500135 +y_0=300090 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs ",
    ],
    "EPSG:30792": [
        "EPSG:30792",
        "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500135 +y_0=300090 +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +units=m +no_defs ",
    ],
    "EPSG:31154": [
        "EPSG:31154",
        "+proj=tmerc +lat_0=0 +lon_0=-54 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31170": [
        "EPSG:31170",
        "+proj=tmerc +lat_0=0 +lon_0=-55.68333333333333 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31171": [
        "EPSG:31171",
        "+proj=tmerc +lat_0=0 +lon_0=-55.68333333333333 +k=0.9999 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31251": [
        "EPSG:31251",
        "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31253": [
        "EPSG:31253",
        "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31256": [
        "EPSG:31256",
        "+proj=tmerc +lat_0=0 +lon_0=16.33333333333333 +k=1 +x_0=0 +y_0=-5000000 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31257": [
        "EPSG:31257",
        "+proj=tmerc +lat_0=0 +lon_0=10.33333333333333 +k=1 +x_0=150000 +y_0=-5000000 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31259": [
        "EPSG:31259",
        "+proj=tmerc +lat_0=0 +lon_0=16.33333333333333 +k=1 +x_0=750000 +y_0=-5000000 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31265": [
        "EPSG:31265",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31266": [
        "EPSG:31266",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31268": [
        "EPSG:31268",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31275": [
        "EPSG:31275",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=5500000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:32209": [
        "EPSG:32209",
        "+proj=utm +zone=9 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:31277": [
        "EPSG:31277",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31278": [
        "EPSG:31278",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31279": [
        "EPSG:31279",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=8500000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31281": [
        "EPSG:31281",
        "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31282": [
        "EPSG:31282",
        "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31283": [
        "EPSG:31283",
        "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31284": [
        "EPSG:31284",
        "+proj=tmerc +lat_0=0 +lon_0=10.33333333333333 +k=1 +x_0=150000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31286": [
        "EPSG:31286",
        "+proj=tmerc +lat_0=0 +lon_0=16.33333333333333 +k=1 +x_0=750000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31288": [
        "EPSG:31288",
        "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=150000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31289": [
        "EPSG:31289",
        "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=450000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31290": [
        "EPSG:31290",
        "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=750000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31291": [
        "EPSG:31291",
        "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31292": [
        "EPSG:31292",
        "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31293": [
        "EPSG:31293",
        "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +units=m +no_defs ",
    ],
    "EPSG:31294": [
        "EPSG:31294",
        "+proj=tmerc +lat_0=0 +lon_0=10.33333333333333 +k=1 +x_0=150000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31295": [
        "EPSG:31295",
        "+proj=tmerc +lat_0=0 +lon_0=13.33333333333333 +k=1 +x_0=450000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:31296": [
        "EPSG:31296",
        "+proj=tmerc +lat_0=0 +lon_0=16.33333333333333 +k=1 +x_0=750000 +y_0=0 +datum=hermannskogel +units=m +no_defs ",
    ],
    "EPSG:4334": ["EPSG:4334", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:31461": [
        "EPSG:31461",
        "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:31462": [
        "EPSG:31462",
        "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:31465": [
        "EPSG:31465",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:31466": [
        "EPSG:31466",
        "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:31469": [
        "EPSG:31469",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +datum=potsdam +units=m +no_defs ",
    ],
    "EPSG:31528": [
        "EPSG:31528",
        "+proj=utm +zone=28 +a=6378249.2 +b=6356515 +towgs84=-23,259,-9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31529": [
        "EPSG:31529",
        "+proj=utm +zone=29 +a=6378249.2 +b=6356515 +towgs84=-23,259,-9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31600": [
        "EPSG:31600",
        "+proj=sterea +lat_0=45.9 +lon_0=25.39246588888889 +k=0.9996667 +x_0=500000 +y_0=500000 +ellps=intl +towgs84=103.25,-100.4,-307.19,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31838": [
        "EPSG:31838",
        "+proj=utm +zone=38 +ellps=WGS84 +towgs84=-3.2,-5.7,2.8,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31839": [
        "EPSG:31839",
        "+proj=utm +zone=39 +ellps=WGS84 +towgs84=-3.2,-5.7,2.8,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31900": [
        "EPSG:31900",
        "+proj=tmerc +lat_0=0 +lon_0=48 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=-20.8,11.3,2.4,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31901": [
        "EPSG:31901",
        "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=-20.8,11.3,2.4,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31965": [
        "EPSG:31965",
        "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31966": [
        "EPSG:31966",
        "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31967": [
        "EPSG:31967",
        "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31968": [
        "EPSG:31968",
        "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31969": [
        "EPSG:31969",
        "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31970": [
        "EPSG:31970",
        "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31971": [
        "EPSG:31971",
        "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31972": [
        "EPSG:31972",
        "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31973": [
        "EPSG:31973",
        "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31974": [
        "EPSG:31974",
        "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31975": [
        "EPSG:31975",
        "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31976": [
        "EPSG:31976",
        "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31977": [
        "EPSG:31977",
        "+proj=utm +zone=17 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31978": [
        "EPSG:31978",
        "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31979": [
        "EPSG:31979",
        "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31980": [
        "EPSG:31980",
        "+proj=utm +zone=20 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31982": [
        "EPSG:31982",
        "+proj=utm +zone=22 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31986": [
        "EPSG:31986",
        "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31987": [
        "EPSG:31987",
        "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31988": [
        "EPSG:31988",
        "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31989": [
        "EPSG:31989",
        "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31990": [
        "EPSG:31990",
        "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31991": [
        "EPSG:31991",
        "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31993": [
        "EPSG:31993",
        "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31994": [
        "EPSG:31994",
        "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31995": [
        "EPSG:31995",
        "+proj=utm +zone=20 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31996": [
        "EPSG:31996",
        "+proj=utm +zone=21 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31997": [
        "EPSG:31997",
        "+proj=utm +zone=22 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31998": [
        "EPSG:31998",
        "+proj=utm +zone=23 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:31999": [
        "EPSG:31999",
        "+proj=utm +zone=24 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32000": [
        "EPSG:32000",
        "+proj=utm +zone=25 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:32001": [
        "EPSG:32001",
        "+proj=lcc +lat_1=48.71666666666667 +lat_2=47.85 +lat_0=47 +lon_0=-109.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32002": [
        "EPSG:32002",
        "+proj=lcc +lat_1=47.88333333333333 +lat_2=46.45 +lat_0=45.83333333333334 +lon_0=-109.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32003": [
        "EPSG:32003",
        "+proj=lcc +lat_1=46.4 +lat_2=44.86666666666667 +lat_0=44 +lon_0=-109.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4335": ["EPSG:4335", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32006": [
        "EPSG:32006",
        "+proj=lcc +lat_1=40.28333333333333 +lat_2=41.71666666666667 +lat_0=39.66666666666666 +lon_0=-99.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32007": [
        "EPSG:32007",
        "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32008": [
        "EPSG:32008",
        "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32009": [
        "EPSG:32009",
        "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32010": [
        "EPSG:32010",
        "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32011": [
        "EPSG:32011",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.66666666666667 +k=0.9999749999999999 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32012": [
        "EPSG:32012",
        "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32013": [
        "EPSG:32013",
        "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32014": [
        "EPSG:32014",
        "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32015": [
        "EPSG:32015",
        "+proj=tmerc +lat_0=40 +lon_0=-74.33333333333333 +k=0.999966667 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32016": [
        "EPSG:32016",
        "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.9999375 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32017": [
        "EPSG:32017",
        "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32018": [
        "EPSG:32018",
        "+proj=lcc +lat_1=41.03333333333333 +lat_2=40.66666666666666 +lat_0=40.5 +lon_0=-74 +x_0=304800.6096012192 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32020": [
        "EPSG:32020",
        "+proj=lcc +lat_1=47.43333333333333 +lat_2=48.73333333333333 +lat_0=47 +lon_0=-100.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32021": [
        "EPSG:32021",
        "+proj=lcc +lat_1=46.18333333333333 +lat_2=47.48333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32022": [
        "EPSG:32022",
        "+proj=lcc +lat_1=40.43333333333333 +lat_2=41.7 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32023": [
        "EPSG:32023",
        "+proj=lcc +lat_1=38.73333333333333 +lat_2=40.03333333333333 +lat_0=38 +lon_0=-82.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32024": [
        "EPSG:32024",
        "+proj=lcc +lat_1=35.56666666666667 +lat_2=36.76666666666667 +lat_0=35 +lon_0=-98 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32025": [
        "EPSG:32025",
        "+proj=lcc +lat_1=33.93333333333333 +lat_2=35.23333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32026": [
        "EPSG:32026",
        "+proj=lcc +lat_1=44.33333333333334 +lat_2=46 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32027": [
        "EPSG:32027",
        "+proj=lcc +lat_1=42.33333333333334 +lat_2=44 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32028": [
        "EPSG:32028",
        "+proj=lcc +lat_1=40.88333333333333 +lat_2=41.95 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32029": [
        "EPSG:32029",
        "+proj=lcc +lat_1=39.93333333333333 +lat_2=40.8 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32030": [
        "EPSG:32030",
        "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.9999938 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32210": [
        "EPSG:32210",
        "+proj=utm +zone=10 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32033": [
        "EPSG:32033",
        "+proj=lcc +lat_1=32.33333333333334 +lat_2=33.66666666666666 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32034": [
        "EPSG:32034",
        "+proj=lcc +lat_1=44.41666666666666 +lat_2=45.68333333333333 +lat_0=43.83333333333334 +lon_0=-100 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32035": [
        "EPSG:32035",
        "+proj=lcc +lat_1=42.83333333333334 +lat_2=44.4 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32037": [
        "EPSG:32037",
        "+proj=lcc +lat_1=34.65 +lat_2=36.18333333333333 +lat_0=34 +lon_0=-101.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32038": [
        "EPSG:32038",
        "+proj=lcc +lat_1=32.13333333333333 +lat_2=33.96666666666667 +lat_0=31.66666666666667 +lon_0=-97.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4336": ["EPSG:4336", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32040": [
        "EPSG:32040",
        "+proj=lcc +lat_1=28.38333333333333 +lat_2=30.28333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32041": [
        "EPSG:32041",
        "+proj=lcc +lat_1=26.16666666666667 +lat_2=27.83333333333333 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32042": [
        "EPSG:32042",
        "+proj=lcc +lat_1=40.71666666666667 +lat_2=41.78333333333333 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32043": [
        "EPSG:32043",
        "+proj=lcc +lat_1=39.01666666666667 +lat_2=40.65 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32044": [
        "EPSG:32044",
        "+proj=lcc +lat_1=37.21666666666667 +lat_2=38.35 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32046": [
        "EPSG:32046",
        "+proj=lcc +lat_1=38.03333333333333 +lat_2=39.2 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32047": [
        "EPSG:32047",
        "+proj=lcc +lat_1=36.76666666666667 +lat_2=37.96666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32048": [
        "EPSG:32048",
        "+proj=lcc +lat_1=47.5 +lat_2=48.73333333333333 +lat_0=47 +lon_0=-120.8333333333333 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32050": [
        "EPSG:32050",
        "+proj=lcc +lat_1=39 +lat_2=40.25 +lat_0=38.5 +lon_0=-79.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32051": [
        "EPSG:32051",
        "+proj=lcc +lat_1=37.48333333333333 +lat_2=38.88333333333333 +lat_0=37 +lon_0=-81 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32052": [
        "EPSG:32052",
        "+proj=lcc +lat_1=45.56666666666667 +lat_2=46.76666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32053": [
        "EPSG:32053",
        "+proj=lcc +lat_1=44.25 +lat_2=45.5 +lat_0=43.83333333333334 +lon_0=-90 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32054": [
        "EPSG:32054",
        "+proj=lcc +lat_1=42.73333333333333 +lat_2=44.06666666666667 +lat_0=42 +lon_0=-90 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32055": [
        "EPSG:32055",
        "+proj=tmerc +lat_0=40.66666666666666 +lon_0=-105.1666666666667 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32185": [
        "EPSG:32185",
        "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32056": [
        "EPSG:32056",
        "+proj=tmerc +lat_0=40.66666666666666 +lon_0=-107.3333333333333 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32057": [
        "EPSG:32057",
        "+proj=tmerc +lat_0=40.66666666666666 +lon_0=-108.75 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32058": [
        "EPSG:32058",
        "+proj=tmerc +lat_0=40.66666666666666 +lon_0=-110.0833333333333 +k=0.999941177 +x_0=152400.3048006096 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32061": [
        "EPSG:32061",
        "+proj=lcc +lat_1=16.81666666666667 +lat_0=16.81666666666667 +lon_0=-90.33333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32062": [
        "EPSG:32062",
        "+proj=lcc +lat_1=14.9 +lat_0=14.9 +lon_0=-90.33333333333333 +k_0=0.99989906 +x_0=500000 +y_0=325992.681 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32064": [
        "EPSG:32064",
        "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32065": [
        "EPSG:32065",
        "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32066": [
        "EPSG:32066",
        "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32067": [
        "EPSG:32067",
        "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:4337": ["EPSG:4337", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32074": [
        "EPSG:32074",
        "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32075": [
        "EPSG:32075",
        "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32076": [
        "EPSG:32076",
        "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32077": [
        "EPSG:32077",
        "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32081": [
        "EPSG:32081",
        "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32082": [
        "EPSG:32082",
        "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32083": [
        "EPSG:32083",
        "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32084": [
        "EPSG:32084",
        "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32085": [
        "EPSG:32085",
        "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32086": [
        "EPSG:32086",
        "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32098": [
        "EPSG:32098",
        "+proj=lcc +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:32099": [
        "EPSG:32099",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-91.33333333333333 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs ",
    ],
    "EPSG:32104": [
        "EPSG:32104",
        "+proj=lcc +lat_1=43 +lat_2=40 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32107": [
        "EPSG:32107",
        "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32108": [
        "EPSG:32108",
        "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32109": [
        "EPSG:32109",
        "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32110": [
        "EPSG:32110",
        "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32111": [
        "EPSG:32111",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:4338": ["EPSG:4338", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32112": [
        "EPSG:32112",
        "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32113": [
        "EPSG:32113",
        "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32114": [
        "EPSG:32114",
        "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999916667 +x_0=830000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32115": [
        "EPSG:32115",
        "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32117": [
        "EPSG:32117",
        "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.9999375 +x_0=350000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32120": [
        "EPSG:32120",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.43333333333333 +lat_0=47 +lon_0=-100.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:4340": ["EPSG:4340", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32121": [
        "EPSG:32121",
        "+proj=lcc +lat_1=47.48333333333333 +lat_2=46.18333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32122": [
        "EPSG:32122",
        "+proj=lcc +lat_1=41.7 +lat_2=40.43333333333333 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32123": [
        "EPSG:32123",
        "+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32124": [
        "EPSG:32124",
        "+proj=lcc +lat_1=36.76666666666667 +lat_2=35.56666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32125": [
        "EPSG:32125",
        "+proj=lcc +lat_1=35.23333333333333 +lat_2=33.93333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32126": [
        "EPSG:32126",
        "+proj=lcc +lat_1=46 +lat_2=44.33333333333334 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32127": [
        "EPSG:32127",
        "+proj=lcc +lat_1=44 +lat_2=42.33333333333334 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32128": [
        "EPSG:32128",
        "+proj=lcc +lat_1=41.95 +lat_2=40.88333333333333 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32156": [
        "EPSG:32156",
        "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32129": [
        "EPSG:32129",
        "+proj=lcc +lat_1=40.96666666666667 +lat_2=39.93333333333333 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32133": [
        "EPSG:32133",
        "+proj=lcc +lat_1=34.83333333333334 +lat_2=32.5 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32134": [
        "EPSG:32134",
        "+proj=lcc +lat_1=45.68333333333333 +lat_2=44.41666666666666 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32135": [
        "EPSG:32135",
        "+proj=lcc +lat_1=44.4 +lat_2=42.83333333333334 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32136": [
        "EPSG:32136",
        "+proj=lcc +lat_1=36.41666666666666 +lat_2=35.25 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32137": [
        "EPSG:32137",
        "+proj=lcc +lat_1=36.18333333333333 +lat_2=34.65 +lat_0=34 +lon_0=-101.5 +x_0=200000 +y_0=1000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32138": [
        "EPSG:32138",
        "+proj=lcc +lat_1=33.96666666666667 +lat_2=32.13333333333333 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32157": [
        "EPSG:32157",
        "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32140": [
        "EPSG:32140",
        "+proj=lcc +lat_1=30.28333333333333 +lat_2=28.38333333333333 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=4000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32141": [
        "EPSG:32141",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000 +y_0=5000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32142": [
        "EPSG:32142",
        "+proj=lcc +lat_1=41.78333333333333 +lat_2=40.71666666666667 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32143": [
        "EPSG:32143",
        "+proj=lcc +lat_1=40.65 +lat_2=39.01666666666667 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=2000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32144": [
        "EPSG:32144",
        "+proj=lcc +lat_1=38.35 +lat_2=37.21666666666667 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000 +y_0=3000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32145": [
        "EPSG:32145",
        "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32146": [
        "EPSG:32146",
        "+proj=lcc +lat_1=39.2 +lat_2=38.03333333333333 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000 +y_0=2000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32158": [
        "EPSG:32158",
        "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32147": [
        "EPSG:32147",
        "+proj=lcc +lat_1=37.96666666666667 +lat_2=36.76666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32148": [
        "EPSG:32148",
        "+proj=lcc +lat_1=48.73333333333333 +lat_2=47.5 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32149": [
        "EPSG:32149",
        "+proj=lcc +lat_1=47.33333333333334 +lat_2=45.83333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32150": [
        "EPSG:32150",
        "+proj=lcc +lat_1=40.25 +lat_2=39 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32151": [
        "EPSG:32151",
        "+proj=lcc +lat_1=38.88333333333333 +lat_2=37.48333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32152": [
        "EPSG:32152",
        "+proj=lcc +lat_1=46.76666666666667 +lat_2=45.56666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32153": [
        "EPSG:32153",
        "+proj=lcc +lat_1=45.5 +lat_2=44.25 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32154": [
        "EPSG:32154",
        "+proj=lcc +lat_1=44.06666666666667 +lat_2=42.73333333333333 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32155": [
        "EPSG:32155",
        "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32161": [
        "EPSG:32161",
        "+proj=lcc +lat_1=18.43333333333333 +lat_2=18.03333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32164": [
        "EPSG:32164",
        "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:32165": [
        "EPSG:32165",
        "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:32166": [
        "EPSG:32166",
        "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:32167": [
        "EPSG:32167",
        "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs ",
    ],
    "EPSG:32180": [
        "EPSG:32180",
        "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32181": [
        "EPSG:32181",
        "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32182": [
        "EPSG:32182",
        "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32183": [
        "EPSG:32183",
        "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32184": [
        "EPSG:32184",
        "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32186": [
        "EPSG:32186",
        "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32187": [
        "EPSG:32187",
        "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32188": [
        "EPSG:32188",
        "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32189": [
        "EPSG:32189",
        "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32190": [
        "EPSG:32190",
        "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32191": [
        "EPSG:32191",
        "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32192": [
        "EPSG:32192",
        "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32193": [
        "EPSG:32193",
        "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32194": [
        "EPSG:32194",
        "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32197": [
        "EPSG:32197",
        "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32198": [
        "EPSG:32198",
        "+proj=lcc +lat_1=60 +lat_2=46 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32199": [
        "EPSG:32199",
        "+proj=lcc +lat_1=27.83333333333333 +lat_2=26.16666666666667 +lat_0=25.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs ",
    ],
    "EPSG:32201": [
        "EPSG:32201",
        "+proj=utm +zone=1 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32202": [
        "EPSG:32202",
        "+proj=utm +zone=2 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32203": [
        "EPSG:32203",
        "+proj=utm +zone=3 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32204": [
        "EPSG:32204",
        "+proj=utm +zone=4 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32205": [
        "EPSG:32205",
        "+proj=utm +zone=5 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32206": [
        "EPSG:32206",
        "+proj=utm +zone=6 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32211": [
        "EPSG:32211",
        "+proj=utm +zone=11 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32212": [
        "EPSG:32212",
        "+proj=utm +zone=12 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32214": [
        "EPSG:32214",
        "+proj=utm +zone=14 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32215": [
        "EPSG:32215",
        "+proj=utm +zone=15 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32216": [
        "EPSG:32216",
        "+proj=utm +zone=16 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32217": [
        "EPSG:32217",
        "+proj=utm +zone=17 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32218": [
        "EPSG:32218",
        "+proj=utm +zone=18 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32219": [
        "EPSG:32219",
        "+proj=utm +zone=19 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32220": [
        "EPSG:32220",
        "+proj=utm +zone=20 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:4342": ["EPSG:4342", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32221": [
        "EPSG:32221",
        "+proj=utm +zone=21 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32222": [
        "EPSG:32222",
        "+proj=utm +zone=22 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32223": [
        "EPSG:32223",
        "+proj=utm +zone=23 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32224": [
        "EPSG:32224",
        "+proj=utm +zone=24 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32225": [
        "EPSG:32225",
        "+proj=utm +zone=25 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32226": [
        "EPSG:32226",
        "+proj=utm +zone=26 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32227": [
        "EPSG:32227",
        "+proj=utm +zone=27 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32228": [
        "EPSG:32228",
        "+proj=utm +zone=28 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32229": [
        "EPSG:32229",
        "+proj=utm +zone=29 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32230": [
        "EPSG:32230",
        "+proj=utm +zone=30 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:4344": ["EPSG:4344", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32231": [
        "EPSG:32231",
        "+proj=utm +zone=31 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32232": [
        "EPSG:32232",
        "+proj=utm +zone=32 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32233": [
        "EPSG:32233",
        "+proj=utm +zone=33 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32234": [
        "EPSG:32234",
        "+proj=utm +zone=34 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32235": [
        "EPSG:32235",
        "+proj=utm +zone=35 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32236": [
        "EPSG:32236",
        "+proj=utm +zone=36 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32237": [
        "EPSG:32237",
        "+proj=utm +zone=37 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32238": [
        "EPSG:32238",
        "+proj=utm +zone=38 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32239": [
        "EPSG:32239",
        "+proj=utm +zone=39 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32240": [
        "EPSG:32240",
        "+proj=utm +zone=40 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:4346": ["EPSG:4346", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32241": [
        "EPSG:32241",
        "+proj=utm +zone=41 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32243": [
        "EPSG:32243",
        "+proj=utm +zone=43 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32244": [
        "EPSG:32244",
        "+proj=utm +zone=44 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32245": [
        "EPSG:32245",
        "+proj=utm +zone=45 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32246": [
        "EPSG:32246",
        "+proj=utm +zone=46 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32247": [
        "EPSG:32247",
        "+proj=utm +zone=47 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32248": [
        "EPSG:32248",
        "+proj=utm +zone=48 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32249": [
        "EPSG:32249",
        "+proj=utm +zone=49 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32250": [
        "EPSG:32250",
        "+proj=utm +zone=50 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32251": [
        "EPSG:32251",
        "+proj=utm +zone=51 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32252": [
        "EPSG:32252",
        "+proj=utm +zone=52 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32253": [
        "EPSG:32253",
        "+proj=utm +zone=53 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32254": [
        "EPSG:32254",
        "+proj=utm +zone=54 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32255": [
        "EPSG:32255",
        "+proj=utm +zone=55 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32256": [
        "EPSG:32256",
        "+proj=utm +zone=56 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32257": [
        "EPSG:32257",
        "+proj=utm +zone=57 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32258": [
        "EPSG:32258",
        "+proj=utm +zone=58 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32259": [
        "EPSG:32259",
        "+proj=utm +zone=59 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32260": [
        "EPSG:32260",
        "+proj=utm +zone=60 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:4350": ["EPSG:4350", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:32301": [
        "EPSG:32301",
        "+proj=utm +zone=1 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32302": [
        "EPSG:32302",
        "+proj=utm +zone=2 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32303": [
        "EPSG:32303",
        "+proj=utm +zone=3 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32304": [
        "EPSG:32304",
        "+proj=utm +zone=4 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32305": [
        "EPSG:32305",
        "+proj=utm +zone=5 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32306": [
        "EPSG:32306",
        "+proj=utm +zone=6 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32307": [
        "EPSG:32307",
        "+proj=utm +zone=7 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32308": [
        "EPSG:32308",
        "+proj=utm +zone=8 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32309": [
        "EPSG:32309",
        "+proj=utm +zone=9 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32310": [
        "EPSG:32310",
        "+proj=utm +zone=10 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32311": [
        "EPSG:32311",
        "+proj=utm +zone=11 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32312": [
        "EPSG:32312",
        "+proj=utm +zone=12 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32313": [
        "EPSG:32313",
        "+proj=utm +zone=13 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32314": [
        "EPSG:32314",
        "+proj=utm +zone=14 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32315": [
        "EPSG:32315",
        "+proj=utm +zone=15 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32316": [
        "EPSG:32316",
        "+proj=utm +zone=16 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32317": [
        "EPSG:32317",
        "+proj=utm +zone=17 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32318": [
        "EPSG:32318",
        "+proj=utm +zone=18 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32319": [
        "EPSG:32319",
        "+proj=utm +zone=19 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32320": [
        "EPSG:32320",
        "+proj=utm +zone=20 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32321": [
        "EPSG:32321",
        "+proj=utm +zone=21 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32322": [
        "EPSG:32322",
        "+proj=utm +zone=22 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32323": [
        "EPSG:32323",
        "+proj=utm +zone=23 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32324": [
        "EPSG:32324",
        "+proj=utm +zone=24 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32325": [
        "EPSG:32325",
        "+proj=utm +zone=25 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32326": [
        "EPSG:32326",
        "+proj=utm +zone=26 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32327": [
        "EPSG:32327",
        "+proj=utm +zone=27 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32328": [
        "EPSG:32328",
        "+proj=utm +zone=28 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32329": [
        "EPSG:32329",
        "+proj=utm +zone=29 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32330": [
        "EPSG:32330",
        "+proj=utm +zone=30 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32331": [
        "EPSG:32331",
        "+proj=utm +zone=31 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32332": [
        "EPSG:32332",
        "+proj=utm +zone=32 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32333": [
        "EPSG:32333",
        "+proj=utm +zone=33 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32334": [
        "EPSG:32334",
        "+proj=utm +zone=34 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32335": [
        "EPSG:32335",
        "+proj=utm +zone=35 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32336": [
        "EPSG:32336",
        "+proj=utm +zone=36 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32338": [
        "EPSG:32338",
        "+proj=utm +zone=38 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32339": [
        "EPSG:32339",
        "+proj=utm +zone=39 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32340": [
        "EPSG:32340",
        "+proj=utm +zone=40 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32341": [
        "EPSG:32341",
        "+proj=utm +zone=41 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32342": [
        "EPSG:32342",
        "+proj=utm +zone=42 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32343": [
        "EPSG:32343",
        "+proj=utm +zone=43 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32344": [
        "EPSG:32344",
        "+proj=utm +zone=44 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32345": [
        "EPSG:32345",
        "+proj=utm +zone=45 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32346": [
        "EPSG:32346",
        "+proj=utm +zone=46 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32347": [
        "EPSG:32347",
        "+proj=utm +zone=47 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32348": [
        "EPSG:32348",
        "+proj=utm +zone=48 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32349": [
        "EPSG:32349",
        "+proj=utm +zone=49 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32350": [
        "EPSG:32350",
        "+proj=utm +zone=50 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32351": [
        "EPSG:32351",
        "+proj=utm +zone=51 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32352": [
        "EPSG:32352",
        "+proj=utm +zone=52 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32353": [
        "EPSG:32353",
        "+proj=utm +zone=53 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32354": [
        "EPSG:32354",
        "+proj=utm +zone=54 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32355": [
        "EPSG:32355",
        "+proj=utm +zone=55 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32356": [
        "EPSG:32356",
        "+proj=utm +zone=56 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32357": [
        "EPSG:32357",
        "+proj=utm +zone=57 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32358": [
        "EPSG:32358",
        "+proj=utm +zone=58 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32359": [
        "EPSG:32359",
        "+proj=utm +zone=59 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32360": [
        "EPSG:32360",
        "+proj=utm +zone=60 +south +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs ",
    ],
    "EPSG:32401": [
        "EPSG:32401",
        "+proj=utm +zone=1 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32402": [
        "EPSG:32402",
        "+proj=utm +zone=2 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32403": [
        "EPSG:32403",
        "+proj=utm +zone=3 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32404": [
        "EPSG:32404",
        "+proj=utm +zone=4 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32405": [
        "EPSG:32405",
        "+proj=utm +zone=5 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32406": [
        "EPSG:32406",
        "+proj=utm +zone=6 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32407": [
        "EPSG:32407",
        "+proj=utm +zone=7 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32408": [
        "EPSG:32408",
        "+proj=utm +zone=8 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32409": [
        "EPSG:32409",
        "+proj=utm +zone=9 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32410": [
        "EPSG:32410",
        "+proj=utm +zone=10 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32411": [
        "EPSG:32411",
        "+proj=utm +zone=11 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32412": [
        "EPSG:32412",
        "+proj=utm +zone=12 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32413": [
        "EPSG:32413",
        "+proj=utm +zone=13 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32414": [
        "EPSG:32414",
        "+proj=utm +zone=14 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32415": [
        "EPSG:32415",
        "+proj=utm +zone=15 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32416": [
        "EPSG:32416",
        "+proj=utm +zone=16 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32417": [
        "EPSG:32417",
        "+proj=utm +zone=17 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32418": [
        "EPSG:32418",
        "+proj=utm +zone=18 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32419": [
        "EPSG:32419",
        "+proj=utm +zone=19 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32420": [
        "EPSG:32420",
        "+proj=utm +zone=20 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32421": [
        "EPSG:32421",
        "+proj=utm +zone=21 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32422": [
        "EPSG:32422",
        "+proj=utm +zone=22 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32423": [
        "EPSG:32423",
        "+proj=utm +zone=23 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32424": [
        "EPSG:32424",
        "+proj=utm +zone=24 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32425": [
        "EPSG:32425",
        "+proj=utm +zone=25 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32426": [
        "EPSG:32426",
        "+proj=utm +zone=26 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32427": [
        "EPSG:32427",
        "+proj=utm +zone=27 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32428": [
        "EPSG:32428",
        "+proj=utm +zone=28 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32429": [
        "EPSG:32429",
        "+proj=utm +zone=29 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32430": [
        "EPSG:32430",
        "+proj=utm +zone=30 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32431": [
        "EPSG:32431",
        "+proj=utm +zone=31 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32432": [
        "EPSG:32432",
        "+proj=utm +zone=32 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32433": [
        "EPSG:32433",
        "+proj=utm +zone=33 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32434": [
        "EPSG:32434",
        "+proj=utm +zone=34 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32435": [
        "EPSG:32435",
        "+proj=utm +zone=35 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32436": [
        "EPSG:32436",
        "+proj=utm +zone=36 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32437": [
        "EPSG:32437",
        "+proj=utm +zone=37 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32438": [
        "EPSG:32438",
        "+proj=utm +zone=38 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32439": [
        "EPSG:32439",
        "+proj=utm +zone=39 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32440": [
        "EPSG:32440",
        "+proj=utm +zone=40 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32441": [
        "EPSG:32441",
        "+proj=utm +zone=41 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32442": [
        "EPSG:32442",
        "+proj=utm +zone=42 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32443": [
        "EPSG:32443",
        "+proj=utm +zone=43 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32444": [
        "EPSG:32444",
        "+proj=utm +zone=44 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32445": [
        "EPSG:32445",
        "+proj=utm +zone=45 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32446": [
        "EPSG:32446",
        "+proj=utm +zone=46 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32447": [
        "EPSG:32447",
        "+proj=utm +zone=47 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32448": [
        "EPSG:32448",
        "+proj=utm +zone=48 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32449": [
        "EPSG:32449",
        "+proj=utm +zone=49 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32450": [
        "EPSG:32450",
        "+proj=utm +zone=50 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32451": [
        "EPSG:32451",
        "+proj=utm +zone=51 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32452": [
        "EPSG:32452",
        "+proj=utm +zone=52 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32453": [
        "EPSG:32453",
        "+proj=utm +zone=53 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32454": [
        "EPSG:32454",
        "+proj=utm +zone=54 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32455": [
        "EPSG:32455",
        "+proj=utm +zone=55 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32456": [
        "EPSG:32456",
        "+proj=utm +zone=56 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32457": [
        "EPSG:32457",
        "+proj=utm +zone=57 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32458": [
        "EPSG:32458",
        "+proj=utm +zone=58 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32459": [
        "EPSG:32459",
        "+proj=utm +zone=59 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32460": [
        "EPSG:32460",
        "+proj=utm +zone=60 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32501": [
        "EPSG:32501",
        "+proj=utm +zone=1 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32502": [
        "EPSG:32502",
        "+proj=utm +zone=2 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32503": [
        "EPSG:32503",
        "+proj=utm +zone=3 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32504": [
        "EPSG:32504",
        "+proj=utm +zone=4 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32505": [
        "EPSG:32505",
        "+proj=utm +zone=5 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32506": [
        "EPSG:32506",
        "+proj=utm +zone=6 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32507": [
        "EPSG:32507",
        "+proj=utm +zone=7 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32508": [
        "EPSG:32508",
        "+proj=utm +zone=8 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32509": [
        "EPSG:32509",
        "+proj=utm +zone=9 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32510": [
        "EPSG:32510",
        "+proj=utm +zone=10 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32511": [
        "EPSG:32511",
        "+proj=utm +zone=11 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32512": [
        "EPSG:32512",
        "+proj=utm +zone=12 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32513": [
        "EPSG:32513",
        "+proj=utm +zone=13 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32514": [
        "EPSG:32514",
        "+proj=utm +zone=14 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32515": [
        "EPSG:32515",
        "+proj=utm +zone=15 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32516": [
        "EPSG:32516",
        "+proj=utm +zone=16 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32517": [
        "EPSG:32517",
        "+proj=utm +zone=17 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32518": [
        "EPSG:32518",
        "+proj=utm +zone=18 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32519": [
        "EPSG:32519",
        "+proj=utm +zone=19 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32521": [
        "EPSG:32521",
        "+proj=utm +zone=21 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32522": [
        "EPSG:32522",
        "+proj=utm +zone=22 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32523": [
        "EPSG:32523",
        "+proj=utm +zone=23 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32524": [
        "EPSG:32524",
        "+proj=utm +zone=24 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32525": [
        "EPSG:32525",
        "+proj=utm +zone=25 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32526": [
        "EPSG:32526",
        "+proj=utm +zone=26 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32527": [
        "EPSG:32527",
        "+proj=utm +zone=27 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32528": [
        "EPSG:32528",
        "+proj=utm +zone=28 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32529": [
        "EPSG:32529",
        "+proj=utm +zone=29 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32530": [
        "EPSG:32530",
        "+proj=utm +zone=30 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32531": [
        "EPSG:32531",
        "+proj=utm +zone=31 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32532": [
        "EPSG:32532",
        "+proj=utm +zone=32 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32533": [
        "EPSG:32533",
        "+proj=utm +zone=33 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32534": [
        "EPSG:32534",
        "+proj=utm +zone=34 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32535": [
        "EPSG:32535",
        "+proj=utm +zone=35 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32536": [
        "EPSG:32536",
        "+proj=utm +zone=36 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32537": [
        "EPSG:32537",
        "+proj=utm +zone=37 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32538": [
        "EPSG:32538",
        "+proj=utm +zone=38 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32539": [
        "EPSG:32539",
        "+proj=utm +zone=39 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32540": [
        "EPSG:32540",
        "+proj=utm +zone=40 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32541": [
        "EPSG:32541",
        "+proj=utm +zone=41 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32542": [
        "EPSG:32542",
        "+proj=utm +zone=42 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32543": [
        "EPSG:32543",
        "+proj=utm +zone=43 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32544": [
        "EPSG:32544",
        "+proj=utm +zone=44 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32545": [
        "EPSG:32545",
        "+proj=utm +zone=45 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32546": [
        "EPSG:32546",
        "+proj=utm +zone=46 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32547": [
        "EPSG:32547",
        "+proj=utm +zone=47 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32548": [
        "EPSG:32548",
        "+proj=utm +zone=48 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32549": [
        "EPSG:32549",
        "+proj=utm +zone=49 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32550": [
        "EPSG:32550",
        "+proj=utm +zone=50 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32551": [
        "EPSG:32551",
        "+proj=utm +zone=51 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32552": [
        "EPSG:32552",
        "+proj=utm +zone=52 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32553": [
        "EPSG:32553",
        "+proj=utm +zone=53 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32554": [
        "EPSG:32554",
        "+proj=utm +zone=54 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32555": [
        "EPSG:32555",
        "+proj=utm +zone=55 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32556": [
        "EPSG:32556",
        "+proj=utm +zone=56 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32557": [
        "EPSG:32557",
        "+proj=utm +zone=57 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32558": [
        "EPSG:32558",
        "+proj=utm +zone=58 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32559": [
        "EPSG:32559",
        "+proj=utm +zone=59 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32560": [
        "EPSG:32560",
        "+proj=utm +zone=60 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:32625": [
        "EPSG:32625",
        "+proj=utm +zone=25 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32626": [
        "EPSG:32626",
        "+proj=utm +zone=26 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4352": ["EPSG:4352", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32627": [
        "EPSG:32627",
        "+proj=utm +zone=27 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4354": ["EPSG:4354", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32641": [
        "EPSG:32641",
        "+proj=utm +zone=41 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4356": ["EPSG:4356", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:32653": [
        "EPSG:32653",
        "+proj=utm +zone=53 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32656": [
        "EPSG:32656",
        "+proj=utm +zone=56 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32657": [
        "EPSG:32657",
        "+proj=utm +zone=57 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32658": [
        "EPSG:32658",
        "+proj=utm +zone=58 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32659": [
        "EPSG:32659",
        "+proj=utm +zone=59 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:4358": ["EPSG:4358", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:32660": [
        "EPSG:32660",
        "+proj=utm +zone=60 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32661": [
        "EPSG:32661",
        "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32663": [
        "EPSG:32663",
        "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32664": [
        "EPSG:32664",
        "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs ",
    ],
    "EPSG:32665": [
        "EPSG:32665",
        "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs ",
    ],
    "EPSG:32666": [
        "EPSG:32666",
        "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs ",
    ],
    "EPSG:32667": [
        "EPSG:32667",
        "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs ",
    ],
    "EPSG:32701": [
        "EPSG:32701",
        "+proj=utm +zone=1 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32702": [
        "EPSG:32702",
        "+proj=utm +zone=2 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32703": [
        "EPSG:32703",
        "+proj=utm +zone=3 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32704": [
        "EPSG:32704",
        "+proj=utm +zone=4 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32705": [
        "EPSG:32705",
        "+proj=utm +zone=5 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32706": [
        "EPSG:32706",
        "+proj=utm +zone=6 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32707": [
        "EPSG:32707",
        "+proj=utm +zone=7 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32708": [
        "EPSG:32708",
        "+proj=utm +zone=8 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32709": [
        "EPSG:32709",
        "+proj=utm +zone=9 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32710": [
        "EPSG:32710",
        "+proj=utm +zone=10 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32711": [
        "EPSG:32711",
        "+proj=utm +zone=11 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32712": [
        "EPSG:32712",
        "+proj=utm +zone=12 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32713": [
        "EPSG:32713",
        "+proj=utm +zone=13 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32714": [
        "EPSG:32714",
        "+proj=utm +zone=14 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32715": [
        "EPSG:32715",
        "+proj=utm +zone=15 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32716": [
        "EPSG:32716",
        "+proj=utm +zone=16 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32725": [
        "EPSG:32725",
        "+proj=utm +zone=25 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32726": [
        "EPSG:32726",
        "+proj=utm +zone=26 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32727": [
        "EPSG:32727",
        "+proj=utm +zone=27 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32728": [
        "EPSG:32728",
        "+proj=utm +zone=28 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32729": [
        "EPSG:32729",
        "+proj=utm +zone=29 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32730": [
        "EPSG:32730",
        "+proj=utm +zone=30 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32731": [
        "EPSG:32731",
        "+proj=utm +zone=31 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32732": [
        "EPSG:32732",
        "+proj=utm +zone=32 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32733": [
        "EPSG:32733",
        "+proj=utm +zone=33 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32738": [
        "EPSG:32738",
        "+proj=utm +zone=38 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32739": [
        "EPSG:32739",
        "+proj=utm +zone=39 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32740": [
        "EPSG:32740",
        "+proj=utm +zone=40 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32741": [
        "EPSG:32741",
        "+proj=utm +zone=41 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32742": [
        "EPSG:32742",
        "+proj=utm +zone=42 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32743": [
        "EPSG:32743",
        "+proj=utm +zone=43 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32744": [
        "EPSG:32744",
        "+proj=utm +zone=44 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32745": [
        "EPSG:32745",
        "+proj=utm +zone=45 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32746": [
        "EPSG:32746",
        "+proj=utm +zone=46 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32752": [
        "EPSG:32752",
        "+proj=utm +zone=52 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32753": [
        "EPSG:32753",
        "+proj=utm +zone=53 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32758": [
        "EPSG:32758",
        "+proj=utm +zone=58 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32759": [
        "EPSG:32759",
        "+proj=utm +zone=59 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32760": [
        "EPSG:32760",
        "+proj=utm +zone=60 +south +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32761": [
        "EPSG:32761",
        "+proj=stere +lat_0=-90 +lat_ts=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:32766": [
        "EPSG:32766",
        "+proj=tmerc +lat_0=0 +lon_0=36 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:3887": ["EPSG:3887", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4000": ["EPSG:4000", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4039": ["EPSG:4039", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4073": ["EPSG:4073", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4079": ["EPSG:4079", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4330": ["EPSG:4330", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4332": ["EPSG:4332", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:4333": ["EPSG:4333", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6317": ["EPSG:6317", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6320": ["EPSG:6320", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6323": ["EPSG:6323", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6363": ["EPSG:6363", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6666": ["EPSG:6666", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6704": ["EPSG:6704", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6781": ["EPSG:6781", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6934": ["EPSG:6934", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6978": ["EPSG:6978", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6981": ["EPSG:6981", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6985": ["EPSG:6985", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:6988": ["EPSG:6988", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:7071": ["EPSG:7071", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:7134": ["EPSG:7134", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:7137": ["EPSG:7137", "+proj=geocent +ellps=WGS84 +units=m +no_defs "],
    "EPSG:7371": ["EPSG:7371", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:5628": [
        "EPSG:5628",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs ",
    ],
    "EPSG:3901": [
        "EPSG:3901",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:3902": [
        "EPSG:3902",
        "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:3903": [
        "EPSG:3903",
        "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:4097": [
        "EPSG:4097",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99998 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:4098": [
        "EPSG:4098",
        "+proj=tmerc +lat_0=0 +lon_0=10 +k=0.99998 +x_0=400000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:4099": [
        "EPSG:4099",
        "+proj=tmerc +lat_0=0 +lon_0=11.75 +k=0.99998 +x_0=600000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:4100": [
        "EPSG:4100",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=800000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7404": [
        "EPSG:7404",
        "+proj=longlat +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +vunits=m +no_defs ",
    ],
    "EPSG:5318": [
        "EPSG:5318",
        "+proj=tmerc +lat_0=0 +lon_0=-7 +k=0.999997 +x_0=200000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5498": [
        "EPSG:5498",
        "+proj=longlat +datum=NAD83 +geoidgrids=g2012a_conus.gtx,g2012a_alaska.gtx,g2012a_guam.gtx,g2012a_hawaii.gtx,g2012a_puertorico.gtx,g2012a_samoa.gtx +vunits=m +no_defs ",
    ],
    "EPSG:5499": [
        "EPSG:5499",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=g2012a_conus.gtx,g2012a_alaska.gtx,g2012a_guam.gtx,g2012a_hawaii.gtx,g2012a_puertorico.gtx,g2012a_samoa.gtx +vunits=m +no_defs ",
    ],
    "EPSG:5500": [
        "EPSG:5500",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=g2012a_conus.gtx,g2012a_alaska.gtx,g2012a_guam.gtx,g2012a_hawaii.gtx,g2012a_puertorico.gtx,g2012a_samoa.gtx +vunits=m +no_defs ",
    ],
    "EPSG:5554": [
        "EPSG:5554",
        "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5555": [
        "EPSG:5555",
        "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5556": [
        "EPSG:5556",
        "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5598": [
        "EPSG:5598",
        "+proj=tmerc +lat_0=0 +lon_0=11.33333333333333 +k=1 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5698": [
        "EPSG:5698",
        "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5699": [
        "EPSG:5699",
        "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5707": [
        "EPSG:5707",
        "+proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5708": [
        "EPSG:5708",
        "+proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5832": [
        "EPSG:5832",
        "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5833": [
        "EPSG:5833",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5834": [
        "EPSG:5834",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5835": [
        "EPSG:5835",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5845": [
        "EPSG:5845",
        "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5846": [
        "EPSG:5846",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5847": [
        "EPSG:5847",
        "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5848": [
        "EPSG:5848",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5849": [
        "EPSG:5849",
        "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5850": [
        "EPSG:5850",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5851": [
        "EPSG:5851",
        "+proj=tmerc +lat_0=0 +lon_0=14.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5852": [
        "EPSG:5852",
        "+proj=tmerc +lat_0=0 +lon_0=15.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5853": [
        "EPSG:5853",
        "+proj=tmerc +lat_0=0 +lon_0=17.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5854": [
        "EPSG:5854",
        "+proj=tmerc +lat_0=0 +lon_0=18.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5855": [
        "EPSG:5855",
        "+proj=tmerc +lat_0=0 +lon_0=20.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5856": [
        "EPSG:5856",
        "+proj=tmerc +lat_0=0 +lon_0=21.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5857": [
        "EPSG:5857",
        "+proj=tmerc +lat_0=0 +lon_0=23.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5942": [
        "EPSG:5942",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs ",
    ],
    "EPSG:5945": [
        "EPSG:5945",
        "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5946": [
        "EPSG:5946",
        "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5947": [
        "EPSG:5947",
        "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5948": [
        "EPSG:5948",
        "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5949": [
        "EPSG:5949",
        "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5950": [
        "EPSG:5950",
        "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5951": [
        "EPSG:5951",
        "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5952": [
        "EPSG:5952",
        "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5953": [
        "EPSG:5953",
        "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5954": [
        "EPSG:5954",
        "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5955": [
        "EPSG:5955",
        "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5956": [
        "EPSG:5956",
        "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5957": [
        "EPSG:5957",
        "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5958": [
        "EPSG:5958",
        "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5959": [
        "EPSG:5959",
        "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5960": [
        "EPSG:5960",
        "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5961": [
        "EPSG:5961",
        "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5962": [
        "EPSG:5962",
        "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5963": [
        "EPSG:5963",
        "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5964": [
        "EPSG:5964",
        "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5965": [
        "EPSG:5965",
        "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5966": [
        "EPSG:5966",
        "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5967": [
        "EPSG:5967",
        "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5968": [
        "EPSG:5968",
        "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5969": [
        "EPSG:5969",
        "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5970": [
        "EPSG:5970",
        "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5971": [
        "EPSG:5971",
        "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5972": [
        "EPSG:5972",
        "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5973": [
        "EPSG:5973",
        "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5974": [
        "EPSG:5974",
        "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5975": [
        "EPSG:5975",
        "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:5976": [
        "EPSG:5976",
        "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6144": [
        "EPSG:6144",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs ",
    ],
    "EPSG:6145": [
        "EPSG:6145",
        "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6146": [
        "EPSG:6146",
        "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6147": [
        "EPSG:6147",
        "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6148": [
        "EPSG:6148",
        "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6149": [
        "EPSG:6149",
        "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6150": [
        "EPSG:6150",
        "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6151": [
        "EPSG:6151",
        "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6152": [
        "EPSG:6152",
        "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6153": [
        "EPSG:6153",
        "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6154": [
        "EPSG:6154",
        "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6155": [
        "EPSG:6155",
        "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6156": [
        "EPSG:6156",
        "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6157": [
        "EPSG:6157",
        "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6158": [
        "EPSG:6158",
        "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6159": [
        "EPSG:6159",
        "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6160": [
        "EPSG:6160",
        "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6161": [
        "EPSG:6161",
        "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6162": [
        "EPSG:6162",
        "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6163": [
        "EPSG:6163",
        "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6164": [
        "EPSG:6164",
        "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6165": [
        "EPSG:6165",
        "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6166": [
        "EPSG:6166",
        "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6167": [
        "EPSG:6167",
        "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6168": [
        "EPSG:6168",
        "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6169": [
        "EPSG:6169",
        "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6170": [
        "EPSG:6170",
        "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6171": [
        "EPSG:6171",
        "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6172": [
        "EPSG:6172",
        "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6173": [
        "EPSG:6173",
        "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6174": [
        "EPSG:6174",
        "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6175": [
        "EPSG:6175",
        "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6176": [
        "EPSG:6176",
        "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6190": [
        "EPSG:6190",
        "+proj=lcc +lat_1=51.16666723333333 +lat_2=49.8333339 +lat_0=90 +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6349": [
        "EPSG:6349",
        "+proj=longlat +ellps=GRS80 +geoidgrids=g2012a_conus.gtx,g2012a_alaska.gtx,g2012a_guam.gtx,g2012a_hawaii.gtx,g2012a_puertorico.gtx,g2012a_samoa.gtx +vunits=m +no_defs ",
    ],
    "EPSG:6649": [
        "EPSG:6649",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs ",
    ],
    "EPSG:6650": [
        "EPSG:6650",
        "+proj=utm +zone=7 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6651": [
        "EPSG:6651",
        "+proj=utm +zone=8 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6652": [
        "EPSG:6652",
        "+proj=utm +zone=9 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6653": [
        "EPSG:6653",
        "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6654": [
        "EPSG:6654",
        "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6655": [
        "EPSG:6655",
        "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6656": [
        "EPSG:6656",
        "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6657": [
        "EPSG:6657",
        "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6658": [
        "EPSG:6658",
        "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6659": [
        "EPSG:6659",
        "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6660": [
        "EPSG:6660",
        "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6661": [
        "EPSG:6661",
        "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6662": [
        "EPSG:6662",
        "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6663": [
        "EPSG:6663",
        "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6664": [
        "EPSG:6664",
        "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6665": [
        "EPSG:6665",
        "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:6696": [
        "EPSG:6696",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs ",
    ],
    "EPSG:6697": [
        "EPSG:6697",
        "+proj=longlat +ellps=GRS80 +vunits=m +no_defs ",
    ],
    "EPSG:6700": [
        "EPSG:6700",
        "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +vunits=m +no_defs ",
    ],
    "EPSG:6871": [
        "EPSG:6871",
        "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +geoidgrids=egm08_25.gtx +vunits=m +no_defs ",
    ],
    "EPSG:6893": [
        "EPSG:6893",
        "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +geoidgrids=egm08_25.gtx +vunits=m +no_defs ",
    ],
    "EPSG:6917": [
        "EPSG:6917",
        "+proj=longlat +ellps=WGS84 +vunits=m +no_defs ",
    ],
    "EPSG:6927": [
        "EPSG:6927",
        "+proj=tmerc +lat_0=1.366666666666667 +lon_0=103.8333333333333 +k=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7400": [
        "EPSG:7400",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +vunits=m +no_defs ",
    ],
    "EPSG:7401": [
        "EPSG:7401",
        "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7402": [
        "EPSG:7402",
        "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7403": [
        "EPSG:7403",
        "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7406": [
        "EPSG:7406",
        "+proj=longlat +datum=NAD27 +vunits=us-ft +no_defs ",
    ],
    "EPSG:7407": [
        "EPSG:7407",
        "+proj=lcc +lat_1=34.65 +lat_2=36.18333333333333 +lat_0=34 +lon_0=-101.5 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +vunits=us-ft +no_defs ",
    ],
    "EPSG:7409": [
        "EPSG:7409",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs ",
    ],
    "EPSG:7410": [
        "EPSG:7410",
        "+proj=longlat +ellps=clrk80 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +vunits=m +no_defs ",
    ],
    "EPSG:7411": [
        "EPSG:7411",
        "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7412": [
        "EPSG:7412",
        "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7413": [
        "EPSG:7413",
        "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7414": [
        "EPSG:7414",
        "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +vunits=m +no_defs ",
    ],
    "EPSG:7417": [
        "EPSG:7417",
        "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7418": [
        "EPSG:7418",
        "+proj=tmerc +lat_0=0 +lon_0=9.5 +k=0.99995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7419": [
        "EPSG:7419",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.99995 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7420": [
        "EPSG:7420",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7421": [
        "EPSG:7421",
        "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7422": [
        "EPSG:7422",
        "+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +vunits=m +no_defs ",
    ],
    "EPSG:7423": [
        "EPSG:7423",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs ",
    ],
    "EPSG:4349": ["EPSG:4349", "undefined"],
    "EPSG:4466": ["EPSG:4466", "undefined"],
    "EPSG:63266416": ["EPSG:63266416", "undefined"],
    "EPSG:5729": ["EPSG:5729", "undefined"],
    "EPSG:5237": ["EPSG:5237", "undefined"],
    "EPSG:63266407": ["EPSG:63266407", "undefined"],
    "EPSG:66086405": ["EPSG:66086405", "undefined"],
    "EPSG:4388": ["EPSG:4388", "undefined"],
    "EPSG:3823": ["EPSG:3823", "undefined"],
    "EPSG:5796": ["EPSG:5796", "undefined"],
    "EPSG:5605": ["EPSG:5605", "undefined"],
    "EPSG:2300": ["EPSG:2300", "undefined"],
    "EPSG:6782": ["EPSG:6782", "undefined"],
    "EPSG:6642": ["EPSG:6642", "undefined"],
    "EPSG:62326405": ["EPSG:62326405", "undefined"],
    "EPSG:61516405": ["EPSG:61516405", "undefined"],
    "EPSG:4355": ["EPSG:4355", "undefined"],
    "EPSG:61746405": ["EPSG:61746405", "undefined"],
    "EPSG:66236405": ["EPSG:66236405", "undefined"],
    "EPSG:66386405": ["EPSG:66386405", "undefined"],
    "EPSG:62976405": ["EPSG:62976405", "undefined"],
    "EPSG:5865": ["EPSG:5865", "undefined"],
    "EPSG:5762": ["EPSG:5762", "undefined"],
    "EPSG:5224": ["EPSG:5224", "undefined"],
    "EPSG:4359": ["EPSG:4359", "undefined"],
    "EPSG:6693": ["EPSG:6693", "undefined"],
    "EPSG:5610": ["EPSG:5610", "undefined"],
    "EPSG:5803": ["EPSG:5803", "undefined"],
    "EPSG:6247": ["EPSG:6247", "undefined"],
    "EPSG:5770": ["EPSG:5770", "undefined"],
    "EPSG:6643": ["EPSG:6643", "undefined"],
    "EPSG:5821": ["EPSG:5821", "undefined"],
    "EPSG:5370": ["EPSG:5370", "undefined"],
    "EPSG:3900": ["EPSG:3900", "undefined"],
    "EPSG:4347": ["EPSG:4347", "undefined"],
    "EPSG:62886405": ["EPSG:62886405", "undefined"],
    "EPSG:62586405": ["EPSG:62586405", "undefined"],
    "EPSG:62256405": ["EPSG:62256405", "undefined"],
    "EPSG:66446405": ["EPSG:66446405", "undefined"],
    "EPSG:3173": ["EPSG:3173", "undefined"],
    "EPSG:4963": ["EPSG:4963", "undefined"],
    "EPSG:5701": ["EPSG:5701", "undefined"],
    "EPSG:4887": ["EPSG:4887", "undefined"],
    "EPSG:61846405": ["EPSG:61846405", "undefined"],
    "EPSG:61686405": ["EPSG:61686405", "undefined"],
    "EPSG:5359": ["EPSG:5359", "undefined"],
    "EPSG:5620": ["EPSG:5620", "undefined"],
    "EPSG:66246405": ["EPSG:66246405", "undefined"],
    "EPSG:5766": ["EPSG:5766", "undefined"],
    "EPSG:5617": ["EPSG:5617", "undefined"],
    "EPSG:61996405": ["EPSG:61996405", "undefined"],
    "EPSG:61446405": ["EPSG:61446405", "undefined"],
    "EPSG:61906405": ["EPSG:61906405", "undefined"],
    "EPSG:5941": ["EPSG:5941", "undefined"],
    "EPSG:63266413": ["EPSG:63266413", "undefined"],
    "EPSG:62066405": ["EPSG:62066405", "undefined"],
    "EPSG:3993": ["EPSG:3993", "undefined"],
    "EPSG:61666405": ["EPSG:61666405", "undefined"],
    "EPSG:6639": ["EPSG:6639", "undefined"],
    "EPSG:62686405": ["EPSG:62686405", "undefined"],
    "EPSG:4343": ["EPSG:4343", "undefined"],
    "EPSG:66166405": ["EPSG:66166405", "undefined"],
    "EPSG:5735": ["EPSG:5735", "undefined"],
    "EPSG:62636405": ["EPSG:62636405", "undefined"],
    "EPSG:5831": ["EPSG:5831", "undefined"],
    "EPSG:6989": ["EPSG:6989", "undefined"],
    "EPSG:61336405": ["EPSG:61336405", "undefined"],
    "EPSG:5873": ["EPSG:5873", "undefined"],
    "EPSG:4931": ["EPSG:4931", "undefined"],
    "EPSG:5802": ["EPSG:5802", "undefined"],
    "EPSG:63266417": ["EPSG:63266417", "undefined"],
    "EPSG:63096405": ["EPSG:63096405", "undefined"],
    "EPSG:62706405": ["EPSG:62706405", "undefined"],
    "EPSG:5753": ["EPSG:5753", "undefined"],
    "EPSG:66676405": ["EPSG:66676405", "undefined"],
    "EPSG:61946405": ["EPSG:61946405", "undefined"],
    "EPSG:4329": ["EPSG:4329", "undefined"],
    "EPSG:61526405": ["EPSG:61526405", "undefined"],
    "EPSG:7446": ["EPSG:7446", "undefined"],
    "EPSG:4040": ["EPSG:4040", "undefined"],
    "EPSG:6364": ["EPSG:6364", "undefined"],
    "EPSG:4440": ["EPSG:4440", "undefined"],
    "EPSG:5758": ["EPSG:5758", "undefined"],
    "EPSG:6200": ["EPSG:6200", "undefined"],
    "EPSG:68026405": ["EPSG:68026405", "undefined"],
    "EPSG:62196405": ["EPSG:62196405", "undefined"],
    "EPSG:7040": ["EPSG:7040", "undefined"],
    "EPSG:4889": ["EPSG:4889", "undefined"],
    "EPSG:4891": ["EPSG:4891", "undefined"],
    "EPSG:6201": ["EPSG:6201", "undefined"],
    "EPSG:61936405": ["EPSG:61936405", "undefined"],
    "EPSG:68066405": ["EPSG:68066405", "undefined"],
    "EPSG:61956405": ["EPSG:61956405", "undefined"],
    "EPSG:61206405": ["EPSG:61206405", "undefined"],
    "EPSG:5745": ["EPSG:5745", "undefined"],
    "EPSG:62846405": ["EPSG:62846405", "undefined"],
    "EPSG:62956405": ["EPSG:62956405", "undefined"],
    "EPSG:4339": ["EPSG:4339", "undefined"],
    "EPSG:61566405": ["EPSG:61566405", "undefined"],
    "EPSG:61426405": ["EPSG:61426405", "undefined"],
    "EPSG:61896405": ["EPSG:61896405", "undefined"],
    "EPSG:6319": ["EPSG:6319", "undefined"],
    "EPSG:6272": ["EPSG:6272", "undefined"],
    "EPSG:5756": ["EPSG:5756", "undefined"],
    "EPSG:66126405": ["EPSG:66126405", "undefined"],
    "EPSG:66456413": ["EPSG:66456413", "undefined"],
    "EPSG:61406405": ["EPSG:61406405", "undefined"],
    "EPSG:4995": ["EPSG:4995", "undefined"],
    "EPSG:61376405": ["EPSG:61376405", "undefined"],
    "EPSG:5782": ["EPSG:5782", "undefined"],
    "EPSG:62046405": ["EPSG:62046405", "undefined"],
    "EPSG:7652": ["EPSG:7652", "undefined"],
    "EPSG:6360": ["EPSG:6360", "undefined"],
    "EPSG:5868": ["EPSG:5868", "undefined"],
    "EPSG:61796405": ["EPSG:61796405", "undefined"],
    "EPSG:66286405": ["EPSG:66286405", "undefined"],
    "EPSG:62656405": ["EPSG:62656405", "undefined"],
    "EPSG:6695": ["EPSG:6695", "undefined"],
    "EPSG:7072": ["EPSG:7072", "undefined"],
    "EPSG:5323": ["EPSG:5323", "undefined"],
    "EPSG:61296405": ["EPSG:61296405", "undefined"],
    "EPSG:7372": ["EPSG:7372", "undefined"],
    "EPSG:66196413": ["EPSG:66196413", "undefined"],
    "EPSG:61516413": ["EPSG:61516413", "undefined"],
    "EPSG:4351": ["EPSG:4351", "undefined"],
    "EPSG:63266419": ["EPSG:63266419", "undefined"],
    "EPSG:4961": ["EPSG:4961", "undefined"],
    "EPSG:5763": ["EPSG:5763", "undefined"],
    "EPSG:6255": ["EPSG:6255", "undefined"],
    "EPSG:61786405": ["EPSG:61786405", "undefined"],
    "EPSG:5600": ["EPSG:5600", "undefined"],
    "EPSG:66006405": ["EPSG:66006405", "undefined"],
    "EPSG:68096405": ["EPSG:68096405", "undefined"],
    "EPSG:61436405": ["EPSG:61436405", "undefined"],
    "EPSG:5805": ["EPSG:5805", "undefined"],
    "EPSG:68056405": ["EPSG:68056405", "undefined"],
    "EPSG:4953": ["EPSG:4953", "undefined"],
    "EPSG:6259": ["EPSG:6259", "undefined"],
    "EPSG:69036405": ["EPSG:69036405", "undefined"],
    "EPSG:5754": ["EPSG:5754", "undefined"],
    "EPSG:5759": ["EPSG:5759", "undefined"],
    "EPSG:5608": ["EPSG:5608", "undefined"],
    "EPSG:62456405": ["EPSG:62456405", "undefined"],
    "EPSG:5861": ["EPSG:5861", "undefined"],
    "EPSG:63266415": ["EPSG:63266415", "undefined"],
    "EPSG:2298": ["EPSG:2298", "undefined"],
    "EPSG:5225": ["EPSG:5225", "undefined"],
    "EPSG:5251": ["EPSG:5251", "undefined"],
    "EPSG:62116405": ["EPSG:62116405", "undefined"],
    "EPSG:61306413": ["EPSG:61306413", "undefined"],
    "EPSG:5809": ["EPSG:5809", "undefined"],
    "EPSG:63126405": ["EPSG:63126405", "undefined"],
    "EPSG:6182": ["EPSG:6182", "undefined"],
    "EPSG:6267": ["EPSG:6267", "undefined"],
    "EPSG:66066405": ["EPSG:66066405", "undefined"],
    "EPSG:4969": ["EPSG:4969", "undefined"],
    "EPSG:62416405": ["EPSG:62416405", "undefined"],
    "EPSG:61266405": ["EPSG:61266405", "undefined"],
    "EPSG:5859": ["EPSG:5859", "undefined"],
    "EPSG:4377": ["EPSG:4377", "undefined"],
    "EPSG:63266412": ["EPSG:63266412", "undefined"],
    "EPSG:4975": ["EPSG:4975", "undefined"],
    "EPSG:61816405": ["EPSG:61816405", "undefined"],
    "EPSG:3052": ["EPSG:3052", "undefined"],
    "EPSG:5810": ["EPSG:5810", "undefined"],
    "EPSG:4949": ["EPSG:4949", "undefined"],
    "EPSG:6185": ["EPSG:6185", "undefined"],
    "EPSG:63266420": ["EPSG:63266420", "undefined"],
    "EPSG:5829": ["EPSG:5829", "undefined"],
    "EPSG:6644": ["EPSG:6644", "undefined"],
    "EPSG:4472": ["EPSG:4472", "undefined"],
    "EPSG:5772": ["EPSG:5772", "undefined"],
    "EPSG:5703": ["EPSG:5703", "undefined"],
    "EPSG:7038": ["EPSG:7038", "undefined"],
    "EPSG:6130": ["EPSG:6130", "undefined"],
    "EPSG:5795": ["EPSG:5795", "undefined"],
    "EPSG:5734": ["EPSG:5734", "undefined"],
    "EPSG:4985": ["EPSG:4985", "undefined"],
    "EPSG:5777": ["EPSG:5777", "undefined"],
    "EPSG:62276405": ["EPSG:62276405", "undefined"],
    "EPSG:61276405": ["EPSG:61276405", "undefined"],
    "EPSG:61546405": ["EPSG:61546405", "undefined"],
    "EPSG:7085": ["EPSG:7085", "undefined"],
    "EPSG:4965": ["EPSG:4965", "undefined"],
    "EPSG:61466405": ["EPSG:61466405", "undefined"],
    "EPSG:4991": ["EPSG:4991", "undefined"],
    "EPSG:61916405": ["EPSG:61916405", "undefined"],
    "EPSG:61986405": ["EPSG:61986405", "undefined"],
    "EPSG:4367": ["EPSG:4367", "undefined"],
    "EPSG:5705": ["EPSG:5705", "undefined"],
    "EPSG:5317": ["EPSG:5317", "undefined"],
    "EPSG:63266406": ["EPSG:63266406", "undefined"],
    "EPSG:5793": ["EPSG:5793", "undefined"],
    "EPSG:5012": ["EPSG:5012", "undefined"],
    "EPSG:62766405": ["EPSG:62766405", "undefined"],
    "EPSG:62336405": ["EPSG:62336405", "undefined"],
    "EPSG:62056405": ["EPSG:62056405", "undefined"],
    "EPSG:61366405": ["EPSG:61366405", "undefined"],
    "EPSG:66056405": ["EPSG:66056405", "undefined"],
    "EPSG:4959": ["EPSG:4959", "undefined"],
    "EPSG:4939": ["EPSG:4939", "undefined"],
    "EPSG:5792": ["EPSG:5792", "undefined"],
    "EPSG:5871": ["EPSG:5871", "undefined"],
    "EPSG:66036405": ["EPSG:66036405", "undefined"],
    "EPSG:5621": ["EPSG:5621", "undefined"],
    "EPSG:66026405": ["EPSG:66026405", "undefined"],
    "EPSG:62006405": ["EPSG:62006405", "undefined"],
    "EPSG:32700": ["EPSG:32700", "undefined"],
    "EPSG:66256405": ["EPSG:66256405", "undefined"],
    "EPSG:6641": ["EPSG:6641", "undefined"],
    "EPSG:61706413": ["EPSG:61706413", "undefined"],
    "EPSG:66016405": ["EPSG:66016405", "undefined"],
    "EPSG:5263": ["EPSG:5263", "undefined"],
    "EPSG:61316405": ["EPSG:61316405", "undefined"],
    "EPSG:62036405": ["EPSG:62036405", "undefined"],
    "EPSG:3888": ["EPSG:3888", "undefined"],
    "EPSG:66316405": ["EPSG:66316405", "undefined"],
    "EPSG:6134": ["EPSG:6134", "undefined"],
    "EPSG:4080": ["EPSG:4080", "undefined"],
    "EPSG:63266410": ["EPSG:63266410", "undefined"],
    "EPSG:66346405": ["EPSG:66346405", "undefined"],
    "EPSG:6178": ["EPSG:6178", "undefined"],
    "EPSG:63196405": ["EPSG:63196405", "undefined"],
    "EPSG:4363": ["EPSG:4363", "undefined"],
    "EPSG:66276405": ["EPSG:66276405", "undefined"],
    "EPSG:6262": ["EPSG:6262", "undefined"],
    "EPSG:63266408": ["EPSG:63266408", "undefined"],
    "EPSG:62536405": ["EPSG:62536405", "undefined"],
    "EPSG:2307": ["EPSG:2307", "undefined"],
    "EPSG:62076405": ["EPSG:62076405", "undefined"],
    "EPSG:5613": ["EPSG:5613", "undefined"],
    "EPSG:66136405": ["EPSG:66136405", "undefined"],
    "EPSG:5812": ["EPSG:5812", "undefined"],
    "EPSG:62896405": ["EPSG:62896405", "undefined"],
    "EPSG:5869": ["EPSG:5869", "undefined"],
    "EPSG:4327": ["EPSG:4327", "undefined"],
    "EPSG:61646405": ["EPSG:61646405", "undefined"],
    "EPSG:68206405": ["EPSG:68206405", "undefined"],
    "EPSG:6261": ["EPSG:6261", "undefined"],
    "EPSG:68036405": ["EPSG:68036405", "undefined"],
    "EPSG:5706": ["EPSG:5706", "undefined"],
    "EPSG:62836413": ["EPSG:62836413", "undefined"],
    "EPSG:61656405": ["EPSG:61656405", "undefined"],
    "EPSG:6640": ["EPSG:6640", "undefined"],
    "EPSG:6694": ["EPSG:6694", "undefined"],
    "EPSG:66636405": ["EPSG:66636405", "undefined"],
    "EPSG:4967": ["EPSG:4967", "undefined"],
    "EPSG:5726": ["EPSG:5726", "undefined"],
    "EPSG:66396405": ["EPSG:66396405", "undefined"],
    "EPSG:7034": ["EPSG:7034", "undefined"],
    "EPSG:4921": ["EPSG:4921", "undefined"],
    "EPSG:4927": ["EPSG:4927", "undefined"],
    "EPSG:62716405": ["EPSG:62716405", "undefined"],
    "EPSG:61736413": ["EPSG:61736413", "undefined"],
    "EPSG:62866405": ["EPSG:62866405", "undefined"],
    "EPSG:6184": ["EPSG:6184", "undefined"],
    "EPSG:4379": ["EPSG:4379", "undefined"],
    "EPSG:5619": ["EPSG:5619", "undefined"],
    "EPSG:4929": ["EPSG:4929", "undefined"],
    "EPSG:61496405": ["EPSG:61496405", "undefined"],
    "EPSG:61966405": ["EPSG:61966405", "undefined"],
    "EPSG:61886405": ["EPSG:61886405", "undefined"],
    "EPSG:5597": ["EPSG:5597", "undefined"],
    "EPSG:62756405": ["EPSG:62756405", "undefined"],
    "EPSG:6275": ["EPSG:6275", "undefined"],
    "EPSG:4933": ["EPSG:4933", "undefined"],
    "EPSG:5761": ["EPSG:5761", "undefined"],
    "EPSG:6245": ["EPSG:6245", "undefined"],
    "EPSG:5870": ["EPSG:5870", "undefined"],
    "EPSG:62796405": ["EPSG:62796405", "undefined"],
    "EPSG:5722": ["EPSG:5722", "undefined"],
    "EPSG:6131": ["EPSG:6131", "undefined"],
    "EPSG:68186405": ["EPSG:68186405", "undefined"],
    "EPSG:5863": ["EPSG:5863", "undefined"],
    "EPSG:5791": ["EPSG:5791", "undefined"],
    "EPSG:4900": ["EPSG:4900", "undefined"],
    "EPSG:62776405": ["EPSG:62776405", "undefined"],
    "EPSG:66356405": ["EPSG:66356405", "undefined"],
    "EPSG:4386": ["EPSG:4386", "undefined"],
    "EPSG:4898": ["EPSG:4898", "undefined"],
    "EPSG:4977": ["EPSG:4977", "undefined"],
    "EPSG:6638": ["EPSG:6638", "undefined"],
    "EPSG:62546405": ["EPSG:62546405", "undefined"],
    "EPSG:66146405": ["EPSG:66146405", "undefined"],
    "EPSG:6274": ["EPSG:6274", "undefined"],
    "EPSG:66456405": ["EPSG:66456405", "undefined"],
    "EPSG:61536405": ["EPSG:61536405", "undefined"],
    "EPSG:5814": ["EPSG:5814", "undefined"],
    "EPSG:5778": ["EPSG:5778", "undefined"],
    "EPSG:4955": ["EPSG:4955", "undefined"],
    "EPSG:4923": ["EPSG:4923", "undefined"],
    "EPSG:62496405": ["EPSG:62496405", "undefined"],
    "EPSG:62926405": ["EPSG:62926405", "undefined"],
    "EPSG:6181": ["EPSG:6181", "undefined"],
    "EPSG:68016405": ["EPSG:68016405", "undefined"],
    "EPSG:4989": ["EPSG:4989", "undefined"],
    "EPSG:62566405": ["EPSG:62566405", "undefined"],
    "EPSG:5741": ["EPSG:5741", "undefined"],
    "EPSG:66586405": ["EPSG:66586405", "undefined"],
    "EPSG:61806413": ["EPSG:61806413", "undefined"],
    "EPSG:5779": ["EPSG:5779", "undefined"],
    "EPSG:6310": ["EPSG:6310", "undefined"],
    "EPSG:5746": ["EPSG:5746", "undefined"],
    "EPSG:4895": ["EPSG:4895", "undefined"],
    "EPSG:5755": ["EPSG:5755", "undefined"],
    "EPSG:63146405": ["EPSG:63146405", "undefined"],
    "EPSG:61416405": ["EPSG:61416405", "undefined"],
    "EPSG:4381": ["EPSG:4381", "undefined"],
    "EPSG:5719": ["EPSG:5719", "undefined"],
    "EPSG:2986": ["EPSG:2986", "undefined"],
    "EPSG:6359": ["EPSG:6359", "undefined"],
    "EPSG:62216405": ["EPSG:62216405", "undefined"],
    "EPSG:5711": ["EPSG:5711", "undefined"],
    "EPSG:62856405": ["EPSG:62856405", "undefined"],
    "EPSG:5819": ["EPSG:5819", "undefined"],
    "EPSG:62626405": ["EPSG:62626405", "undefined"],
    "EPSG:4947": ["EPSG:4947", "undefined"],
    "EPSG:4945": ["EPSG:4945", "undefined"],
    "EPSG:6667": ["EPSG:6667", "undefined"],
    "EPSG:61636413": ["EPSG:61636413", "undefined"],
    "EPSG:62296405": ["EPSG:62296405", "undefined"],
    "EPSG:62486405": ["EPSG:62486405", "undefined"],
    "EPSG:5820": ["EPSG:5820", "undefined"],
    "EPSG:61266413": ["EPSG:61266413", "undefined"],
    "EPSG:4375": ["EPSG:4375", "undefined"],
    "EPSG:61976405": ["EPSG:61976405", "undefined"],
    "EPSG:66186405": ["EPSG:66186405", "undefined"],
    "EPSG:4361": ["EPSG:4361", "undefined"],
    "EPSG:5748": ["EPSG:5748", "undefined"],
    "EPSG:6256": ["EPSG:6256", "undefined"],
    "EPSG:63006405": ["EPSG:63006405", "undefined"],
    "EPSG:4357": ["EPSG:4357", "undefined"],
    "EPSG:5353": ["EPSG:5353", "undefined"],
    "EPSG:4907": ["EPSG:4907", "undefined"],
    "EPSG:5601": ["EPSG:5601", "undefined"],
    "EPSG:5864": ["EPSG:5864", "undefined"],
    "EPSG:61406413": ["EPSG:61406413", "undefined"],
    "EPSG:4935": ["EPSG:4935", "undefined"],
    "EPSG:63036405": ["EPSG:63036405", "undefined"],
    "EPSG:6254": ["EPSG:6254", "undefined"],
    "EPSG:6252": ["EPSG:6252", "undefined"],
    "EPSG:62396405": ["EPSG:62396405", "undefined"],
    "EPSG:6986": ["EPSG:6986", "undefined"],
    "EPSG:62476405": ["EPSG:62476405", "undefined"],
    "EPSG:5747": ["EPSG:5747", "undefined"],
    "EPSG:62646405": ["EPSG:62646405", "undefined"],
    "EPSG:66276413": ["EPSG:66276413", "undefined"],
    "EPSG:5816": ["EPSG:5816", "undefined"],
    "EPSG:66466405": ["EPSG:66466405", "undefined"],
    "EPSG:4909": ["EPSG:4909", "undefined"],
    "EPSG:61216405": ["EPSG:61216405", "undefined"],
    "EPSG:62616405": ["EPSG:62616405", "undefined"],
    "EPSG:5801": ["EPSG:5801", "undefined"],
    "EPSG:5798": ["EPSG:5798", "undefined"],
    "EPSG:62366405": ["EPSG:62366405", "undefined"],
    "EPSG:62146405": ["EPSG:62146405", "undefined"],
    "EPSG:5721": ["EPSG:5721", "undefined"],
    "EPSG:63266414": ["EPSG:63266414", "undefined"],
    "EPSG:61596405": ["EPSG:61596405", "undefined"],
    "EPSG:5862": ["EPSG:5862", "undefined"],
    "EPSG:62226405": ["EPSG:62226405", "undefined"],
    "EPSG:5718": ["EPSG:5718", "undefined"],
    "EPSG:61586405": ["EPSG:61586405", "undefined"],
    "EPSG:62426405": ["EPSG:62426405", "undefined"],
    "EPSG:62086405": ["EPSG:62086405", "undefined"],
    "EPSG:5790": ["EPSG:5790", "undefined"],
    "EPSG:62436405": ["EPSG:62436405", "undefined"],
    "EPSG:5780": ["EPSG:5780", "undefined"],
    "EPSG:5724": ["EPSG:5724", "undefined"],
    "EPSG:5768": ["EPSG:5768", "undefined"],
    "EPSG:66046405": ["EPSG:66046405", "undefined"],
    "EPSG:6270": ["EPSG:6270", "undefined"],
    "EPSG:4981": ["EPSG:4981", "undefined"],
    "EPSG:62816405": ["EPSG:62816405", "undefined"],
    "EPSG:4893": ["EPSG:4893", "undefined"],
    "EPSG:61696405": ["EPSG:61696405", "undefined"],
    "EPSG:63266418": ["EPSG:63266418", "undefined"],
    "EPSG:4345": ["EPSG:4345", "undefined"],
    "EPSG:6260": ["EPSG:6260", "undefined"],
    "EPSG:5866": ["EPSG:5866", "undefined"],
    "EPSG:2299": ["EPSG:2299", "undefined"],
    "EPSG:61506405": ["EPSG:61506405", "undefined"],
    "EPSG:61636405": ["EPSG:61636405", "undefined"],
    "EPSG:4369": ["EPSG:4369", "undefined"],
    "EPSG:5874": ["EPSG:5874", "undefined"],
    "EPSG:4341": ["EPSG:4341", "undefined"],
    "EPSG:5784": ["EPSG:5784", "undefined"],
    "EPSG:2303": ["EPSG:2303", "undefined"],
    "EPSG:63066405": ["EPSG:63066405", "undefined"],
    "EPSG:5843": ["EPSG:5843", "undefined"],
    "EPSG:4482": ["EPSG:4482", "undefined"],
    "EPSG:5794": ["EPSG:5794", "undefined"],
    "EPSG:62206405": ["EPSG:62206405", "undefined"],
    "EPSG:66666405": ["EPSG:66666405", "undefined"],
    "EPSG:5602": ["EPSG:5602", "undefined"],
    "EPSG:5872": ["EPSG:5872", "undefined"],
    "EPSG:6705": ["EPSG:6705", "undefined"],
    "EPSG:6979": ["EPSG:6979", "undefined"],
    "EPSG:3144": ["EPSG:3144", "undefined"],
    "EPSG:5736": ["EPSG:5736", "undefined"],
    "EPSG:5813": ["EPSG:5813", "undefined"],
    "EPSG:61386405": ["EPSG:61386405", "undefined"],
    "EPSG:4373": ["EPSG:4373", "undefined"],
    "EPSG:66656405": ["EPSG:66656405", "undefined"],
    "EPSG:5342": ["EPSG:5342", "undefined"],
    "EPSG:7138": ["EPSG:7138", "undefined"],
    "EPSG:6715": ["EPSG:6715", "undefined"],
    "EPSG:6321": ["EPSG:6321", "undefined"],
    "EPSG:68156405": ["EPSG:68156405", "undefined"],
    "EPSG:5714": ["EPSG:5714", "undefined"],
    "EPSG:4383": ["EPSG:4383", "undefined"],
    "EPSG:61766413": ["EPSG:61766413", "undefined"],
    "EPSG:62506405": ["EPSG:62506405", "undefined"],
    "EPSG:5709": ["EPSG:5709", "undefined"],
    "EPSG:5716": ["EPSG:5716", "undefined"],
    "EPSG:4941": ["EPSG:4941", "undefined"],
    "EPSG:61616405": ["EPSG:61616405", "undefined"],
    "EPSG:62166405": ["EPSG:62166405", "undefined"],
    "EPSG:5712": ["EPSG:5712", "undefined"],
    "EPSG:5788": ["EPSG:5788", "undefined"],
    "EPSG:61486413": ["EPSG:61486413", "undefined"],
    "EPSG:61756405": ["EPSG:61756405", "undefined"],
    "EPSG:63176405": ["EPSG:63176405", "undefined"],
    "EPSG:63086405": ["EPSG:63086405", "undefined"],
    "EPSG:5618": ["EPSG:5618", "undefined"],
    "EPSG:5372": ["EPSG:5372", "undefined"],
    "EPSG:5817": ["EPSG:5817", "undefined"],
    "EPSG:5336": ["EPSG:5336", "undefined"],
    "EPSG:5769": ["EPSG:5769", "undefined"],
    "EPSG:2221": ["EPSG:2221", "undefined"],
    "EPSG:5515": ["EPSG:5515", "undefined"],
    "EPSG:5731": ["EPSG:5731", "undefined"],
    "EPSG:5804": ["EPSG:5804", "undefined"],
    "EPSG:5867": ["EPSG:5867", "undefined"],
    "EPSG:66206405": ["EPSG:66206405", "undefined"],
    "EPSG:66096405": ["EPSG:66096405", "undefined"],
    "EPSG:62826405": ["EPSG:62826405", "undefined"],
    "EPSG:63106405": ["EPSG:63106405", "undefined"],
    "EPSG:62996405": ["EPSG:62996405", "undefined"],
    "EPSG:61526413": ["EPSG:61526413", "undefined"],
    "EPSG:5728": ["EPSG:5728", "undefined"],
    "EPSG:6244": ["EPSG:6244", "undefined"],
    "EPSG:7082": ["EPSG:7082", "undefined"],
    "EPSG:5767": ["EPSG:5767", "undefined"],
    "EPSG:5717": ["EPSG:5717", "undefined"],
    "EPSG:5738": ["EPSG:5738", "undefined"],
    "EPSG:5749": ["EPSG:5749", "undefined"],
    "EPSG:5785": ["EPSG:5785", "undefined"],
    "EPSG:66336405": ["EPSG:66336405", "undefined"],
    "EPSG:62186405": ["EPSG:62186405", "undefined"],
    "EPSG:63166405": ["EPSG:63166405", "undefined"],
    "EPSG:62576405": ["EPSG:62576405", "undefined"],
    "EPSG:4957": ["EPSG:4957", "undefined"],
    "EPSG:63116405": ["EPSG:63116405", "undefined"],
    "EPSG:5606": ["EPSG:5606", "undefined"],
    "EPSG:62556405": ["EPSG:62556405", "undefined"],
    "EPSG:5017": ["EPSG:5017", "undefined"],
    "EPSG:5592": ["EPSG:5592", "undefined"],
    "EPSG:61676413": ["EPSG:61676413", "undefined"],
    "EPSG:62676405": ["EPSG:62676405", "undefined"],
    "EPSG:5616": ["EPSG:5616", "undefined"],
    "EPSG:7036": ["EPSG:7036", "undefined"],
    "EPSG:5744": ["EPSG:5744", "undefined"],
    "EPSG:62786405": ["EPSG:62786405", "undefined"],
    "EPSG:63136405": ["EPSG:63136405", "undefined"],
    "EPSG:62316405": ["EPSG:62316405", "undefined"],
    "EPSG:5615": ["EPSG:5615", "undefined"],
    "EPSG:5195": ["EPSG:5195", "undefined"],
    "EPSG:63266405": ["EPSG:63266405", "undefined"],
    "EPSG:5815": ["EPSG:5815", "undefined"],
    "EPSG:6966": ["EPSG:6966", "undefined"],
    "EPSG:5818": ["EPSG:5818", "undefined"],
    "EPSG:4458": ["EPSG:4458", "undefined"],
    "EPSG:62136405": ["EPSG:62136405", "undefined"],
    "EPSG:6269": ["EPSG:6269", "undefined"],
    "EPSG:61766405": ["EPSG:61766405", "undefined"],
    "EPSG:62026405": ["EPSG:62026405", "undefined"],
    "EPSG:3053": ["EPSG:3053", "undefined"],
    "EPSG:7651": ["EPSG:7651", "undefined"],
    "EPSG:61836405": ["EPSG:61836405", "undefined"],
    "EPSG:66296405": ["EPSG:66296405", "undefined"],
    "EPSG:5765": ["EPSG:5765", "undefined"],
    "EPSG:62666405": ["EPSG:62666405", "undefined"],
    "EPSG:4971": ["EPSG:4971", "undefined"],
    "EPSG:5797": ["EPSG:5797", "undefined"],
    "EPSG:66246413": ["EPSG:66246413", "undefined"],
    "EPSG:66216405": ["EPSG:66216405", "undefined"],
    "EPSG:4951": ["EPSG:4951", "undefined"],
    "EPSG:6258": ["EPSG:6258", "undefined"],
    "EPSG:66576405": ["EPSG:66576405", "undefined"],
    "EPSG:61346405": ["EPSG:61346405", "undefined"],
    "EPSG:5715": ["EPSG:5715", "undefined"],
    "EPSG:62586413": ["EPSG:62586413", "undefined"],
    "EPSG:61826405": ["EPSG:61826405", "undefined"],
    "EPSG:4983": ["EPSG:4983", "undefined"],
    "EPSG:6264": ["EPSG:6264", "undefined"],
    "EPSG:5786": ["EPSG:5786", "undefined"],
    "EPSG:61286405": ["EPSG:61286405", "undefined"],
    "EPSG:32600": ["EPSG:32600", "undefined"],
    "EPSG:62526405": ["EPSG:62526405", "undefined"],
    "EPSG:6187": ["EPSG:6187", "undefined"],
    "EPSG:6253": ["EPSG:6253", "undefined"],
    "EPSG:7135": ["EPSG:7135", "undefined"],
    "EPSG:5811": ["EPSG:5811", "undefined"],
    "EPSG:5516": ["EPSG:5516", "undefined"],
    "EPSG:5245": ["EPSG:5245", "undefined"],
    "EPSG:63246405": ["EPSG:63246405", "undefined"],
    "EPSG:4993": ["EPSG:4993", "undefined"],
    "EPSG:6273": ["EPSG:6273", "undefined"],
    "EPSG:66616413": ["EPSG:66616413", "undefined"],
    "EPSG:66126413": ["EPSG:66126413", "undefined"],
    "EPSG:62746405": ["EPSG:62746405", "undefined"],
    "EPSG:6268": ["EPSG:6268", "undefined"],
    "EPSG:3145": ["EPSG:3145", "undefined"],
    "EPSG:5603": ["EPSG:5603", "undefined"],
    "EPSG:63156405": ["EPSG:63156405", "undefined"],
    "EPSG:5614": ["EPSG:5614", "undefined"],
    "EPSG:4987": ["EPSG:4987", "undefined"],
    "EPSG:2306": ["EPSG:2306", "undefined"],
    "EPSG:68086405": ["EPSG:68086405", "undefined"],
    "EPSG:62806405": ["EPSG:62806405", "undefined"],
    "EPSG:62836405": ["EPSG:62836405", "undefined"],
    "EPSG:4885": ["EPSG:4885", "undefined"],
    "EPSG:62126405": ["EPSG:62126405", "undefined"],
    "EPSG:4999": ["EPSG:4999", "undefined"],
    "EPSG:63266411": ["EPSG:63266411", "undefined"],
    "EPSG:6180": ["EPSG:6180", "undefined"],
    "EPSG:62726405": ["EPSG:62726405", "undefined"],
    "EPSG:6357": ["EPSG:6357", "undefined"],
    "EPSG:63186405": ["EPSG:63186405", "undefined"],
    "EPSG:61476405": ["EPSG:61476405", "undefined"],
    "EPSG:4943": ["EPSG:4943", "undefined"],
    "EPSG:2304": ["EPSG:2304", "undefined"],
    "EPSG:61716405": ["EPSG:61716405", "undefined"],
    "EPSG:6250": ["EPSG:6250", "undefined"],
    "EPSG:5733": ["EPSG:5733", "undefined"],
    "EPSG:61326405": ["EPSG:61326405", "undefined"],
    "EPSG:66596413": ["EPSG:66596413", "undefined"],
    "EPSG:61676405": ["EPSG:61676405", "undefined"],
    "EPSG:4997": ["EPSG:4997", "undefined"],
    "EPSG:6982": ["EPSG:6982", "undefined"],
    "EPSG:5560": ["EPSG:5560", "undefined"],
    "EPSG:5752": ["EPSG:5752", "undefined"],
    "EPSG:66306405": ["EPSG:66306405", "undefined"],
    "EPSG:6179": ["EPSG:6179", "undefined"],
    "EPSG:62936405": ["EPSG:62936405", "undefined"],
    "EPSG:61906413": ["EPSG:61906413", "undefined"],
    "EPSG:61716413": ["EPSG:61716413", "undefined"],
    "EPSG:61896413": ["EPSG:61896413", "undefined"],
    "EPSG:66106405": ["EPSG:66106405", "undefined"],
    "EPSG:6246": ["EPSG:6246", "undefined"],
    "EPSG:4925": ["EPSG:4925", "undefined"],
    "EPSG:62376405": ["EPSG:62376405", "undefined"],
    "EPSG:66116405": ["EPSG:66116405", "undefined"],
    "EPSG:5611": ["EPSG:5611", "undefined"],
    "EPSG:62096405": ["EPSG:62096405", "undefined"],
    "EPSG:62596405": ["EPSG:62596405", "undefined"],
    "EPSG:63016405": ["EPSG:63016405", "undefined"],
    "EPSG:68136405": ["EPSG:68136405", "undefined"],
    "EPSG:4353": ["EPSG:4353", "undefined"],
    "EPSG:2305": ["EPSG:2305", "undefined"],
    "EPSG:4371": ["EPSG:4371", "undefined"],
    "EPSG:61606405": ["EPSG:61606405", "undefined"],
    "EPSG:62306405": ["EPSG:62306405", "undefined"],
    "EPSG:61706405": ["EPSG:61706405", "undefined"],
    "EPSG:5723": ["EPSG:5723", "undefined"],
    "EPSG:61806405": ["EPSG:61806405", "undefined"],
    "EPSG:63046405": ["EPSG:63046405", "undefined"],
    "EPSG:5732": ["EPSG:5732", "undefined"],
    "EPSG:5743": ["EPSG:5743", "undefined"],
    "EPSG:5193": ["EPSG:5193", "undefined"],
    "EPSG:5704": ["EPSG:5704", "undefined"],
    "EPSG:66156405": ["EPSG:66156405", "undefined"],
    "EPSG:66226405": ["EPSG:66226405", "undefined"],
    "EPSG:5885": ["EPSG:5885", "undefined"],
    "EPSG:6265": ["EPSG:6265", "undefined"],
    "EPSG:66426405": ["EPSG:66426405", "undefined"],
    "EPSG:61736405": ["EPSG:61736405", "undefined"],
    "EPSG:5727": ["EPSG:5727", "undefined"],
    "EPSG:5710": ["EPSG:5710", "undefined"],
    "EPSG:63076405": ["EPSG:63076405", "undefined"],
    "EPSG:61576405": ["EPSG:61576405", "undefined"],
    "EPSG:63226405": ["EPSG:63226405", "undefined"],
    "EPSG:62466405": ["EPSG:62466405", "undefined"],
    "EPSG:2218": ["EPSG:2218", "undefined"],
    "EPSG:6248": ["EPSG:6248", "undefined"],
    "EPSG:68146405": ["EPSG:68146405", "undefined"],
    "EPSG:5800": ["EPSG:5800", "undefined"],
    "EPSG:63026405": ["EPSG:63026405", "undefined"],
    "EPSG:61486405": ["EPSG:61486405", "undefined"],
    "EPSG:7447": ["EPSG:7447", "undefined"],
    "EPSG:5783": ["EPSG:5783", "undefined"],
    "EPSG:66376405": ["EPSG:66376405", "undefined"],
    "EPSG:6257": ["EPSG:6257", "undefined"],
    "EPSG:66266405": ["EPSG:66266405", "undefined"],
    "EPSG:2985": ["EPSG:2985", "undefined"],
    "EPSG:4017": ["EPSG:4017", "undefined"],
    "EPSG:66606405": ["EPSG:66606405", "undefined"],
    "EPSG:62986405": ["EPSG:62986405", "undefined"],
    "EPSG:62406405": ["EPSG:62406405", "undefined"],
    "EPSG:62156405": ["EPSG:62156405", "undefined"],
    "EPSG:66416405": ["EPSG:66416405", "undefined"],
    "EPSG:4557": ["EPSG:4557", "undefined"],
    "EPSG:62736405": ["EPSG:62736405", "undefined"],
    "EPSG:5808": ["EPSG:5808", "undefined"],
    "EPSG:6249": ["EPSG:6249", "undefined"],
    "EPSG:6263": ["EPSG:6263", "undefined"],
    "EPSG:5751": ["EPSG:5751", "undefined"],
    "EPSG:5750": ["EPSG:5750", "undefined"],
    "EPSG:61356405": ["EPSG:61356405", "undefined"],
    "EPSG:62016405": ["EPSG:62016405", "undefined"],
    "EPSG:63266409": ["EPSG:63266409", "undefined"],
    "EPSG:5781": ["EPSG:5781", "undefined"],
    "EPSG:5742": ["EPSG:5742", "undefined"],
    "EPSG:66326405": ["EPSG:66326405", "undefined"],
    "EPSG:62516405": ["EPSG:62516405", "undefined"],
    "EPSG:6202": ["EPSG:6202", "undefined"],
    "EPSG:66366405": ["EPSG:66366405", "undefined"],
    "EPSG:61926405": ["EPSG:61926405", "undefined"],
    "EPSG:5609": ["EPSG:5609", "undefined"],
    "EPSG:2301": ["EPSG:2301", "undefined"],
    "EPSG:61236405": ["EPSG:61236405", "undefined"],
    "EPSG:62246405": ["EPSG:62246405", "undefined"],
    "EPSG:61396405": ["EPSG:61396405", "undefined"],
    "EPSG:66196405": ["EPSG:66196405", "undefined"],
    "EPSG:4469": ["EPSG:4469", "undefined"],
    "EPSG:2302": ["EPSG:2302", "undefined"],
    "EPSG:5392": ["EPSG:5392", "undefined"],
    "EPSG:5725": ["EPSG:5725", "undefined"],
    "EPSG:2296": ["EPSG:2296", "undefined"],
    "EPSG:5739": ["EPSG:5739", "undefined"],
    "EPSG:5740": ["EPSG:5740", "undefined"],
    "EPSG:61306405": ["EPSG:61306405", "undefined"],
    "EPSG:62446405": ["EPSG:62446405", "undefined"],
    "EPSG:62106405": ["EPSG:62106405", "undefined"],
    "EPSG:66436405": ["EPSG:66436405", "undefined"],
    "EPSG:5737": ["EPSG:5737", "undefined"],
    "EPSG:66406405": ["EPSG:66406405", "undefined"],
    "EPSG:3886": ["EPSG:3886", "undefined"],
    "EPSG:5789": ["EPSG:5789", "undefined"],
    "EPSG:61246405": ["EPSG:61246405", "undefined"],
    "EPSG:5807": ["EPSG:5807", "undefined"],
    "EPSG:6132": ["EPSG:6132", "undefined"],
    "EPSG:5730": ["EPSG:5730", "undefined"],
    "EPSG:6186": ["EPSG:6186", "undefined"],
    "EPSG:6183": ["EPSG:6183", "undefined"],
    "EPSG:5774": ["EPSG:5774", "undefined"],
    "EPSG:61456405": ["EPSG:61456405", "undefined"],
    "EPSG:4883": ["EPSG:4883", "undefined"],
    "EPSG:5364": ["EPSG:5364", "undefined"],
    "EPSG:5776": ["EPSG:5776", "undefined"],
    "EPSG:4979": ["EPSG:4979", "undefined"],
    "EPSG:66406413": ["EPSG:66406413", "undefined"],
    "EPSG:4937": ["EPSG:4937", "undefined"],
    "EPSG:62696405": ["EPSG:62696405", "undefined"],
    "EPSG:61626405": ["EPSG:61626405", "undefined"],
    "EPSG:2297": ["EPSG:2297", "undefined"],
    "EPSG:5775": ["EPSG:5775", "undefined"],
    "EPSG:5612": ["EPSG:5612", "undefined"],
    "EPSG:5488": ["EPSG:5488", "undefined"],
    "EPSG:5806": ["EPSG:5806", "undefined"],
    "EPSG:61226405": ["EPSG:61226405", "undefined"],
    "EPSG:4074": ["EPSG:4074", "undefined"],
    "EPSG:4480": ["EPSG:4480", "undefined"],
    "EPSG:6271": ["EPSG:6271", "undefined"],
    "EPSG:3139": ["EPSG:3139", "undefined"],
    "EPSG:66596405": ["EPSG:66596405", "undefined"],
    "EPSG:4973": ["EPSG:4973", "undefined"],
    "EPSG:6251": ["EPSG:6251", "undefined"],
    "EPSG:5545": ["EPSG:5545", "undefined"],
    "EPSG:5787": ["EPSG:5787", "undefined"],
    "EPSG:5760": ["EPSG:5760", "undefined"],
    "EPSG:6324": ["EPSG:6324", "undefined"],
    "EPSG:6358": ["EPSG:6358", "undefined"],
    "EPSG:6266": ["EPSG:6266", "undefined"],
    "EPSG:66076405": ["EPSG:66076405", "undefined"],
    "EPSG:5771": ["EPSG:5771", "undefined"],
    "EPSG:5607": ["EPSG:5607", "undefined"],
    "EPSG:5720": ["EPSG:5720", "undefined"],
    "EPSG:5830": ["EPSG:5830", "undefined"],
    "EPSG:6647": ["EPSG:6647", "undefined"],
    "EPSG:62236405": ["EPSG:62236405", "undefined"],
    "EPSG:66616405": ["EPSG:66616405", "undefined"],
    "EPSG:3295": ["EPSG:3295", "undefined"],
    "EPSG:62386405": ["EPSG:62386405", "undefined"],
    "EPSG:7087": ["EPSG:7087", "undefined"],
    "EPSG:5380": ["EPSG:5380", "undefined"],
    "EPSG:2963": ["EPSG:2963", "undefined"],
    "EPSG:6916": ["EPSG:6916", "undefined"],
    "EPSG:66646405": ["EPSG:66646405", "undefined"],
    "EPSG:61556405": ["EPSG:61556405", "undefined"],
    "EPSG:68046405": ["EPSG:68046405", "undefined"],
    "EPSG:5702": ["EPSG:5702", "undefined"],
    "EPSG:5604": ["EPSG:5604", "undefined"],
    "EPSG:5757": ["EPSG:5757", "undefined"],
    "EPSG:4365": ["EPSG:4365", "undefined"],
    "EPSG:3819": [
        "EPSG:3819",
        "+proj=longlat +ellps=bessel +towgs84=595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408 +no_defs ",
    ],
    "EPSG:7042": ["EPSG:7042", "undefined"],
    "EPSG:3889": [
        "EPSG:3889",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:3906": [
        "EPSG:3906",
        "+proj=longlat +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +no_defs ",
    ],
    "EPSG:4002": ["EPSG:4002", "+proj=longlat +ellps=mod_airy +no_defs "],
    "EPSG:4003": ["EPSG:4003", "+proj=longlat +ellps=aust_SA +no_defs "],
    "EPSG:4006": ["EPSG:4006", "+proj=longlat +ellps=bess_nam +no_defs "],
    "EPSG:4007": [
        "EPSG:4007",
        "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +no_defs ",
    ],
    "EPSG:4008": ["EPSG:4008", "+proj=longlat +ellps=clrk66 +no_defs "],
    "EPSG:4009": [
        "EPSG:4009",
        "+proj=longlat +a=6378450.047548896 +b=6356826.621488444 +no_defs ",
    ],
    "EPSG:4010": [
        "EPSG:4010",
        "+proj=longlat +a=6378300.789 +b=6356566.435 +no_defs ",
    ],
    "EPSG:4011": [
        "EPSG:4011",
        "+proj=longlat +a=6378249.2 +b=6356515 +no_defs ",
    ],
    "EPSG:4012": ["EPSG:4012", "+proj=longlat +ellps=clrk80 +no_defs "],
    "EPSG:4013": [
        "EPSG:4013",
        "+proj=longlat +a=6378249.145 +b=6356514.966398753 +no_defs ",
    ],
    "EPSG:4014": [
        "EPSG:4014",
        "+proj=longlat +a=6378249.2 +b=6356514.996941779 +no_defs ",
    ],
    "EPSG:4016": ["EPSG:4016", "+proj=longlat +ellps=evrstSS +no_defs "],
    "EPSG:4018": [
        "EPSG:4018",
        "+proj=longlat +a=6377304.063 +b=6356103.038993155 +no_defs ",
    ],
    "EPSG:4019": ["EPSG:4019", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:4020": ["EPSG:4020", "+proj=longlat +ellps=helmert +no_defs "],
    "EPSG:4021": [
        "EPSG:4021",
        "+proj=longlat +a=6378160 +b=6356774.50408554 +no_defs ",
    ],
    "EPSG:4022": ["EPSG:4022", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4023": [
        "EPSG:4023",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4028": [
        "EPSG:4028",
        "+proj=longlat +a=6378298.3 +b=6356657.142669561 +no_defs ",
    ],
    "EPSG:4029": [
        "EPSG:4029",
        "+proj=longlat +a=6378300 +b=6356751.689189189 +no_defs ",
    ],
    "EPSG:4030": ["EPSG:4030", "+proj=longlat +ellps=WGS84 +no_defs "],
    "EPSG:4031": ["EPSG:4031", "+proj=longlat +ellps=WGS84 +no_defs "],
    "EPSG:4032": [
        "EPSG:4032",
        "+proj=longlat +a=6378136.2 +b=6356751.516927429 +no_defs ",
    ],
    "EPSG:4033": [
        "EPSG:4033",
        "+proj=longlat +a=6378136.3 +b=6356751.616592146 +no_defs ",
    ],
    "EPSG:4034": [
        "EPSG:4034",
        "+proj=longlat +a=6378249.144808011 +b=6356514.966204134 +no_defs ",
    ],
    "EPSG:4035": ["EPSG:4035", "+proj=longlat +a=6371000 +b=6371000 +no_defs "],
    "EPSG:4036": ["EPSG:4036", "+proj=longlat +ellps=GRS67 +no_defs "],
    "EPSG:4041": [
        "EPSG:4041",
        "+proj=longlat +a=6378135 +b=6356750.304921594 +no_defs ",
    ],
    "EPSG:4042": [
        "EPSG:4042",
        "+proj=longlat +a=6377299.36559538 +b=6356098.359005156 +no_defs ",
    ],
    "EPSG:4043": ["EPSG:4043", "+proj=longlat +ellps=WGS72 +no_defs "],
    "EPSG:4044": [
        "EPSG:4044",
        "+proj=longlat +a=6377301.243 +b=6356100.230165384 +no_defs ",
    ],
    "EPSG:4045": [
        "EPSG:4045",
        "+proj=longlat +a=6377299.151 +b=6356098.145120132 +no_defs ",
    ],
    "EPSG:4046": [
        "EPSG:4046",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4047": ["EPSG:4047", "+proj=longlat +a=6371007 +b=6371007 +no_defs "],
    "EPSG:4053": ["EPSG:4053", "+proj=longlat +a=6371228 +b=6371228 +no_defs "],
    "EPSG:4054": [
        "EPSG:4054",
        "+proj=longlat +a=6378273 +b=6356889.449 +no_defs ",
    ],
    "EPSG:4075": [
        "EPSG:4075",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4081": [
        "EPSG:4081",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4120": ["EPSG:4120", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:4122": [
        "EPSG:4122",
        "+proj=longlat +a=6378135 +b=6356750.304921594 +no_defs ",
    ],
    "EPSG:4123": [
        "EPSG:4123",
        "+proj=longlat +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +no_defs ",
    ],
    "EPSG:4124": [
        "EPSG:4124",
        "+proj=longlat +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +no_defs ",
    ],
    "EPSG:4125": [
        "EPSG:4125",
        "+proj=longlat +ellps=bessel +towgs84=-404.78,685.68,45.47,0,0,0,0 +no_defs ",
    ],
    "EPSG:4126": ["EPSG:4126", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:4127": [
        "EPSG:4127",
        "+proj=longlat +ellps=clrk66 +towgs84=-80,-100,-228,0,0,0,0 +no_defs ",
    ],
    "EPSG:4129": [
        "EPSG:4129",
        "+proj=longlat +ellps=clrk66 +towgs84=-132,-110,-335,0,0,0,0 +no_defs ",
    ],
    "EPSG:4130": [
        "EPSG:4130",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4131": [
        "EPSG:4131",
        "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=198,881,317,0,0,0,0 +no_defs ",
    ],
    "EPSG:4132": [
        "EPSG:4132",
        "+proj=longlat +ellps=clrk80 +towgs84=-241.54,-163.64,396.06,0,0,0,0 +no_defs ",
    ],
    "EPSG:4133": [
        "EPSG:4133",
        "+proj=longlat +ellps=GRS80 +towgs84=0.055,-0.541,-0.185,0.0183,-0.0003,-0.007,-0.014 +no_defs ",
    ],
    "EPSG:4134": [
        "EPSG:4134",
        "+proj=longlat +ellps=clrk80 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +no_defs ",
    ],
    "EPSG:4135": [
        "EPSG:4135",
        "+proj=longlat +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +no_defs ",
    ],
    "EPSG:4136": ["EPSG:4136", "+proj=longlat +ellps=clrk66 +no_defs "],
    "EPSG:4137": ["EPSG:4137", "+proj=longlat +ellps=clrk66 +no_defs "],
    "EPSG:4138": ["EPSG:4138", "+proj=longlat +ellps=clrk66 +no_defs "],
    "EPSG:4139": [
        "EPSG:4139",
        "+proj=longlat +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +no_defs ",
    ],
    "EPSG:4140": [
        "EPSG:4140",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4141": [
        "EPSG:4141",
        "+proj=longlat +ellps=GRS80 +towgs84=-48,55,52,0,0,0,0 +no_defs ",
    ],
    "EPSG:4142": [
        "EPSG:4142",
        "+proj=longlat +ellps=clrk80 +towgs84=-125,53,467,0,0,0,0 +no_defs ",
    ],
    "EPSG:4143": [
        "EPSG:4143",
        "+proj=longlat +ellps=clrk80 +towgs84=-124.76,53,466.79,0,0,0,0 +no_defs ",
    ],
    "EPSG:4144": [
        "EPSG:4144",
        "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=214,804,268,0,0,0,0 +no_defs ",
    ],
    "EPSG:4145": [
        "EPSG:4145",
        "+proj=longlat +a=6377301.243 +b=6356100.230165384 +towgs84=283,682,231,0,0,0,0 +no_defs ",
    ],
    "EPSG:4146": [
        "EPSG:4146",
        "+proj=longlat +a=6377299.151 +b=6356098.145120132 +towgs84=295,736,257,0,0,0,0 +no_defs ",
    ],
    "EPSG:4147": [
        "EPSG:4147",
        "+proj=longlat +ellps=krass +towgs84=-17.51,-108.32,-62.39,0,0,0,0 +no_defs ",
    ],
    "EPSG:4150": [
        "EPSG:4150",
        "+proj=longlat +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +no_defs ",
    ],
    "EPSG:4151": [
        "EPSG:4151",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4152": [
        "EPSG:4152",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4153": [
        "EPSG:4153",
        "+proj=longlat +ellps=intl +towgs84=-133.63,-157.5,-158.62,0,0,0,0 +no_defs ",
    ],
    "EPSG:4154": [
        "EPSG:4154",
        "+proj=longlat +ellps=intl +towgs84=-117,-132,-164,0,0,0,0 +no_defs ",
    ],
    "EPSG:4155": [
        "EPSG:4155",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-83,37,124,0,0,0,0 +no_defs ",
    ],
    "EPSG:4157": [
        "EPSG:4157",
        "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +no_defs ",
    ],
    "EPSG:4158": [
        "EPSG:4158",
        "+proj=longlat +ellps=intl +towgs84=-0.465,372.095,171.736,0,0,0,0 +no_defs ",
    ],
    "EPSG:4159": [
        "EPSG:4159",
        "+proj=longlat +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +no_defs ",
    ],
    "EPSG:4160": ["EPSG:4160", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4161": [
        "EPSG:4161",
        "+proj=longlat +ellps=intl +towgs84=27.5,14,186.4,0,0,0,0 +no_defs ",
    ],
    "EPSG:4163": [
        "EPSG:4163",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4164": [
        "EPSG:4164",
        "+proj=longlat +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +no_defs ",
    ],
    "EPSG:4165": [
        "EPSG:4165",
        "+proj=longlat +ellps=intl +towgs84=-173,253,27,0,0,0,0 +no_defs ",
    ],
    "EPSG:4166": [
        "EPSG:4166",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4167": [
        "EPSG:4167",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4168": [
        "EPSG:4168",
        "+proj=longlat +a=6378300 +b=6356751.689189189 +towgs84=-199,32,322,0,0,0,0 +no_defs ",
    ],
    "EPSG:4169": [
        "EPSG:4169",
        "+proj=longlat +ellps=clrk66 +towgs84=-115,118,426,0,0,0,0 +no_defs ",
    ],
    "EPSG:4170": [
        "EPSG:4170",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4172": [
        "EPSG:4172",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4173": [
        "EPSG:4173",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4174": [
        "EPSG:4174",
        "+proj=longlat +a=6378300 +b=6356751.689189189 +no_defs ",
    ],
    "EPSG:4175": [
        "EPSG:4175",
        "+proj=longlat +ellps=clrk80 +towgs84=-88,4,101,0,0,0,0 +no_defs ",
    ],
    "EPSG:4176": [
        "EPSG:4176",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4178": [
        "EPSG:4178",
        "+proj=longlat +ellps=krass +towgs84=26,-121,-78,0,0,0,0 +no_defs ",
    ],
    "EPSG:4179": [
        "EPSG:4179",
        "+proj=longlat +ellps=krass +towgs84=2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266 +no_defs ",
    ],
    "EPSG:4182": [
        "EPSG:4182",
        "+proj=longlat +ellps=intl +towgs84=-425,-169,81,0,0,0,0 +no_defs ",
    ],
    "EPSG:4183": [
        "EPSG:4183",
        "+proj=longlat +ellps=intl +towgs84=-104,167,-38,0,0,0,0 +no_defs ",
    ],
    "EPSG:4184": [
        "EPSG:4184",
        "+proj=longlat +ellps=intl +towgs84=-203,141,53,0,0,0,0 +no_defs ",
    ],
    "EPSG:4185": ["EPSG:4185", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4188": [
        "EPSG:4188",
        "+proj=longlat +ellps=airy +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +no_defs ",
    ],
    "EPSG:4190": [
        "EPSG:4190",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4191": [
        "EPSG:4191",
        "+proj=longlat +ellps=krass +towgs84=-44.183,-0.58,-38.489,-2.3867,-2.7072,3.5196,-8.2703 +no_defs ",
    ],
    "EPSG:4192": [
        "EPSG:4192",
        "+proj=longlat +ellps=intl +towgs84=-206.1,-174.7,-87.7,0,0,0,0 +no_defs ",
    ],
    "EPSG:4193": [
        "EPSG:4193",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-70.9,-151.8,-41.4,0,0,0,0 +no_defs ",
    ],
    "EPSG:4194": [
        "EPSG:4194",
        "+proj=longlat +ellps=intl +towgs84=164,138,-189,0,0,0,0 +no_defs ",
    ],
    "EPSG:4195": [
        "EPSG:4195",
        "+proj=longlat +ellps=intl +towgs84=105,326,-102.5,0,0,0.814,-0.6 +no_defs ",
    ],
    "EPSG:4196": [
        "EPSG:4196",
        "+proj=longlat +ellps=intl +towgs84=-45,417,-3.5,0,0,0.814,-0.6 +no_defs ",
    ],
    "EPSG:4198": ["EPSG:4198", "+proj=longlat +ellps=clrk80 +no_defs "],
    "EPSG:4199": ["EPSG:4199", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4200": [
        "EPSG:4200",
        "+proj=longlat +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +no_defs ",
    ],
    "EPSG:4201": [
        "EPSG:4201",
        "+proj=longlat +ellps=clrk80 +towgs84=-166,-15,204,0,0,0,0 +no_defs ",
    ],
    "EPSG:4202": [
        "EPSG:4202",
        "+proj=longlat +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +no_defs ",
    ],
    "EPSG:4204": [
        "EPSG:4204",
        "+proj=longlat +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +no_defs ",
    ],
    "EPSG:4205": [
        "EPSG:4205",
        "+proj=longlat +ellps=krass +towgs84=-43,-163,45,0,0,0,0 +no_defs ",
    ],
    "EPSG:4206": [
        "EPSG:4206",
        "+proj=longlat +a=6378249.2 +b=6356515 +no_defs ",
    ],
    "EPSG:4208": [
        "EPSG:4208",
        "+proj=longlat +ellps=intl +towgs84=-151.99,287.04,-147.45,0,0,0,0 +no_defs ",
    ],
    "EPSG:4211": [
        "EPSG:4211",
        "+proj=longlat +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +no_defs ",
    ],
    "EPSG:4212": [
        "EPSG:4212",
        "+proj=longlat +ellps=clrk80 +towgs84=31.95,300.99,419.19,0,0,0,0 +no_defs ",
    ],
    "EPSG:4213": [
        "EPSG:4213",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-106,-87,188,0,0,0,0 +no_defs ",
    ],
    "EPSG:4215": ["EPSG:4215", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4216": [
        "EPSG:4216",
        "+proj=longlat +ellps=clrk66 +towgs84=-73,213,296,0,0,0,0 +no_defs ",
    ],
    "EPSG:4218": [
        "EPSG:4218",
        "+proj=longlat +ellps=intl +towgs84=307,304,-318,0,0,0,0 +no_defs ",
    ],
    "EPSG:4219": [
        "EPSG:4219",
        "+proj=longlat +ellps=bessel +towgs84=-384,664,-48,0,0,0,0 +no_defs ",
    ],
    "EPSG:4220": [
        "EPSG:4220",
        "+proj=longlat +ellps=clrk80 +towgs84=-50.9,-347.6,-231,0,0,0,0 +no_defs ",
    ],
    "EPSG:4221": [
        "EPSG:4221",
        "+proj=longlat +ellps=intl +towgs84=-148,136,90,0,0,0,0 +no_defs ",
    ],
    "EPSG:4222": [
        "EPSG:4222",
        "+proj=longlat +a=6378249.145 +b=6356514.966398753 +towgs84=-136,-108,-292,0,0,0,0 +no_defs ",
    ],
    "EPSG:4223": ["EPSG:4223", "+proj=longlat +datum=carthage +no_defs "],
    "EPSG:4224": [
        "EPSG:4224",
        "+proj=longlat +ellps=intl +towgs84=-143.87,243.37,-33.52,0,0,0,0 +no_defs ",
    ],
    "EPSG:4226": [
        "EPSG:4226",
        "+proj=longlat +a=6378249.2 +b=6356515 +no_defs ",
    ],
    "EPSG:4227": [
        "EPSG:4227",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-190.421,8.532,238.69,0,0,0,0 +no_defs ",
    ],
    "EPSG:4228": [
        "EPSG:4228",
        "+proj=longlat +a=6378249.2 +b=6356515 +no_defs ",
    ],
    "EPSG:4232": [
        "EPSG:4232",
        "+proj=longlat +ellps=clrk80 +towgs84=-333.102,-11.02,230.69,0,0,0.554,0.219 +no_defs ",
    ],
    "EPSG:4233": [
        "EPSG:4233",
        "+proj=longlat +ellps=intl +towgs84=-133,-321,50,0,0,0,0 +no_defs ",
    ],
    "EPSG:4234": [
        "EPSG:4234",
        "+proj=longlat +a=6378249.2 +b=6356515 +no_defs ",
    ],
    "EPSG:4235": ["EPSG:4235", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4236": [
        "EPSG:4236",
        "+proj=longlat +ellps=intl +towgs84=-637,-549,-203,0,0,0,0 +no_defs ",
    ],
    "EPSG:4237": [
        "EPSG:4237",
        "+proj=longlat +ellps=GRS67 +towgs84=52.17,-71.82,-14.9,0,0,0,0 +no_defs ",
    ],
    "EPSG:4238": [
        "EPSG:4238",
        "+proj=longlat +a=6378160 +b=6356774.50408554 +towgs84=-24,-15,5,0,0,0,0 +no_defs ",
    ],
    "EPSG:4239": [
        "EPSG:4239",
        "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=217,823,299,0,0,0,0 +no_defs ",
    ],
    "EPSG:4240": [
        "EPSG:4240",
        "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=210,814,289,0,0,0,0 +no_defs ",
    ],
    "EPSG:4241": [
        "EPSG:4241",
        "+proj=longlat +a=6378249.144808011 +b=6356514.966204134 +no_defs ",
    ],
    "EPSG:4242": [
        "EPSG:4242",
        "+proj=longlat +ellps=clrk66 +towgs84=70,207,389.5,0,0,0,0 +no_defs ",
    ],
    "EPSG:4243": [
        "EPSG:4243",
        "+proj=longlat +a=6377299.36559538 +b=6356098.359005156 +no_defs ",
    ],
    "EPSG:4244": [
        "EPSG:4244",
        "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=-97,787,86,0,0,0,0 +no_defs ",
    ],
    "EPSG:4245": [
        "EPSG:4245",
        "+proj=longlat +a=6377304.063 +b=6356103.038993155 +towgs84=-11,851,5,0,0,0,0 +no_defs ",
    ],
    "EPSG:4246": [
        "EPSG:4246",
        "+proj=longlat +ellps=clrk80 +towgs84=-294.7,-200.1,525.5,0,0,0,0 +no_defs ",
    ],
    "EPSG:4248": [
        "EPSG:4248",
        "+proj=longlat +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +no_defs ",
    ],
    "EPSG:4249": ["EPSG:4249", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4250": [
        "EPSG:4250",
        "+proj=longlat +ellps=clrk80 +towgs84=-130,29,364,0,0,0,0 +no_defs ",
    ],
    "EPSG:4251": [
        "EPSG:4251",
        "+proj=longlat +ellps=clrk80 +towgs84=-90,40,88,0,0,0,0 +no_defs ",
    ],
    "EPSG:4252": [
        "EPSG:4252",
        "+proj=longlat +a=6378249.2 +b=6356515 +no_defs ",
    ],
    "EPSG:4253": [
        "EPSG:4253",
        "+proj=longlat +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +no_defs ",
    ],
    "EPSG:4254": [
        "EPSG:4254",
        "+proj=longlat +ellps=intl +towgs84=16,196,93,0,0,0,0 +no_defs ",
    ],
    "EPSG:4255": [
        "EPSG:4255",
        "+proj=longlat +ellps=intl +towgs84=-333,-222,114,0,0,0,0 +no_defs ",
    ],
    "EPSG:4256": [
        "EPSG:4256",
        "+proj=longlat +ellps=clrk80 +towgs84=41,-220,-134,0,0,0,0 +no_defs ",
    ],
    "EPSG:4257": [
        "EPSG:4257",
        "+proj=longlat +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +no_defs ",
    ],
    "EPSG:4259": [
        "EPSG:4259",
        "+proj=longlat +ellps=intl +towgs84=-254.1,-5.36,-100.29,0,0,0,0 +no_defs ",
    ],
    "EPSG:4260": [
        "EPSG:4260",
        "+proj=longlat +ellps=clrk80 +towgs84=-70.9,-151.8,-41.4,0,0,0,0 +no_defs ",
    ],
    "EPSG:4261": [
        "EPSG:4261",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +no_defs ",
    ],
    "EPSG:4262": [
        "EPSG:4262",
        "+proj=longlat +ellps=bessel +towgs84=639,405,60,0,0,0,0 +no_defs ",
    ],
    "EPSG:4263": [
        "EPSG:4263",
        "+proj=longlat +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +no_defs ",
    ],
    "EPSG:4264": [
        "EPSG:4264",
        "+proj=longlat +ellps=intl +towgs84=-252.95,-4.11,-96.38,0,0,0,0 +no_defs ",
    ],
    "EPSG:4266": [
        "EPSG:4266",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-74,-130,42,0,0,0,0 +no_defs ",
    ],
    "EPSG:4268": [
        "EPSG:4268",
        "+proj=longlat +a=6378450.047548896 +b=6356826.621488444 +no_defs ",
    ],
    "EPSG:4270": [
        "EPSG:4270",
        "+proj=longlat +ellps=clrk80 +towgs84=-249,-156,381,0,0,0,0 +no_defs ",
    ],
    "EPSG:4271": [
        "EPSG:4271",
        "+proj=longlat +ellps=intl +towgs84=-10,375,165,0,0,0,0 +no_defs ",
    ],
    "EPSG:4273": [
        "EPSG:4273",
        "+proj=longlat +a=6377492.018 +b=6356173.508712696 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +no_defs ",
    ],
    "EPSG:4275": [
        "EPSG:4275",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +no_defs ",
    ],
    "EPSG:4276": ["EPSG:4276", "+proj=longlat +ellps=WGS66 +no_defs "],
    "EPSG:4279": ["EPSG:4279", "+proj=longlat +ellps=airy +no_defs "],
    "EPSG:4280": ["EPSG:4280", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:4281": [
        "EPSG:4281",
        "+proj=longlat +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +no_defs ",
    ],
    "EPSG:4282": [
        "EPSG:4282",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-148,51,-291,0,0,0,0 +no_defs ",
    ],
    "EPSG:4284": [
        "EPSG:4284",
        "+proj=longlat +ellps=krass +towgs84=23.92,-141.27,-80.9,0,0.35,0.82,-0.12 +no_defs ",
    ],
    "EPSG:4285": [
        "EPSG:4285",
        "+proj=longlat +ellps=intl +towgs84=-128.16,-282.42,21.93,0,0,0,0 +no_defs ",
    ],
    "EPSG:4286": ["EPSG:4286", "+proj=longlat +ellps=helmert +no_defs "],
    "EPSG:4287": [
        "EPSG:4287",
        "+proj=longlat +ellps=intl +towgs84=164,138,-189,0,0,0,0 +no_defs ",
    ],
    "EPSG:4288": ["EPSG:4288", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4291": [
        "EPSG:4291",
        "+proj=longlat +ellps=GRS67 +towgs84=-57,1,-41,0,0,0,0 +no_defs ",
    ],
    "EPSG:4292": [
        "EPSG:4292",
        "+proj=longlat +ellps=intl +towgs84=-355,21,72,0,0,0,0 +no_defs ",
    ],
    "EPSG:4293": [
        "EPSG:4293",
        "+proj=longlat +ellps=bess_nam +towgs84=616,97,-251,0,0,0,0 +no_defs ",
    ],
    "EPSG:4294": [
        "EPSG:4294",
        "+proj=longlat +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +no_defs ",
    ],
    "EPSG:4295": ["EPSG:4295", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:4296": [
        "EPSG:4296",
        "+proj=longlat +a=6378249.2 +b=6356515 +no_defs ",
    ],
    "EPSG:7041": ["EPSG:7041", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:4297": [
        "EPSG:4297",
        "+proj=longlat +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +no_defs ",
    ],
    "EPSG:4298": [
        "EPSG:4298",
        "+proj=longlat +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +no_defs ",
    ],
    "EPSG:4299": ["EPSG:4299", "+proj=longlat +datum=ire65 +no_defs "],
    "EPSG:4300": [
        "EPSG:4300",
        "+proj=longlat +ellps=mod_airy +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +no_defs ",
    ],
    "EPSG:4301": [
        "EPSG:4301",
        "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +no_defs ",
    ],
    "EPSG:4302": [
        "EPSG:4302",
        "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +towgs84=-61.702,284.488,472.052,0,0,0,0 +no_defs ",
    ],
    "EPSG:4303": ["EPSG:4303", "+proj=longlat +ellps=helmert +no_defs "],
    "EPSG:4304": [
        "EPSG:4304",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-73,-247,227,0,0,0,0 +no_defs ",
    ],
    "EPSG:4306": ["EPSG:4306", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:4307": [
        "EPSG:4307",
        "+proj=longlat +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +no_defs ",
    ],
    "EPSG:4308": ["EPSG:4308", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:4309": [
        "EPSG:4309",
        "+proj=longlat +ellps=intl +towgs84=-155,171,37,0,0,0,0 +no_defs ",
    ],
    "EPSG:4310": [
        "EPSG:4310",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-30,190,89,0,0,0,0 +no_defs ",
    ],
    "EPSG:4311": [
        "EPSG:4311",
        "+proj=longlat +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +no_defs ",
    ],
    "EPSG:4315": [
        "EPSG:4315",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-23,259,-9,0,0,0,0 +no_defs ",
    ],
    "EPSG:4605": [
        "EPSG:4605",
        "+proj=longlat +ellps=clrk80 +towgs84=9,183,236,0,0,0,0 +no_defs ",
    ],
    "EPSG:4316": [
        "EPSG:4316",
        "+proj=longlat +ellps=intl +towgs84=103.25,-100.4,-307.19,0,0,0,0 +no_defs ",
    ],
    "EPSG:4318": [
        "EPSG:4318",
        "+proj=longlat +ellps=WGS84 +towgs84=-3.2,-5.7,2.8,0,0,0,0 +no_defs ",
    ],
    "EPSG:4319": [
        "EPSG:4319",
        "+proj=longlat +ellps=GRS80 +towgs84=-20.8,11.3,2.4,0,0,0,0 +no_defs ",
    ],
    "EPSG:4463": [
        "EPSG:4463",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4470": [
        "EPSG:4470",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4475": [
        "EPSG:4475",
        "+proj=longlat +ellps=intl +towgs84=-381.788,-57.501,-256.673,0,0,0,0 +no_defs ",
    ],
    "EPSG:4490": ["EPSG:4490", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:4555": ["EPSG:4555", "+proj=longlat +ellps=krass +no_defs "],
    "EPSG:4558": [
        "EPSG:4558",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4600": ["EPSG:4600", "+proj=longlat +ellps=clrk80 +no_defs "],
    "EPSG:4601": [
        "EPSG:4601",
        "+proj=longlat +ellps=clrk80 +towgs84=-255,-15,71,0,0,0,0 +no_defs ",
    ],
    "EPSG:4602": [
        "EPSG:4602",
        "+proj=longlat +ellps=clrk80 +towgs84=725,685,536,0,0,0,0 +no_defs ",
    ],
    "EPSG:4603": [
        "EPSG:4603",
        "+proj=longlat +ellps=clrk80 +towgs84=72,213.7,93,0,0,0,0 +no_defs ",
    ],
    "EPSG:4604": [
        "EPSG:4604",
        "+proj=longlat +ellps=clrk80 +towgs84=174,359,365,0,0,0,0 +no_defs ",
    ],
    "EPSG:4606": [
        "EPSG:4606",
        "+proj=longlat +ellps=clrk80 +towgs84=-149,128,296,0,0,0,0 +no_defs ",
    ],
    "EPSG:4607": [
        "EPSG:4607",
        "+proj=longlat +ellps=clrk80 +towgs84=195.671,332.517,274.607,0,0,0,0 +no_defs ",
    ],
    "EPSG:4608": ["EPSG:4608", "+proj=longlat +ellps=clrk66 +no_defs "],
    "EPSG:4609": ["EPSG:4609", "+proj=longlat +ellps=clrk66 +no_defs "],
    "EPSG:4610": [
        "EPSG:4610",
        "+proj=longlat +a=6378140 +b=6356755.288157528 +no_defs ",
    ],
    "EPSG:4611": [
        "EPSG:4611",
        "+proj=longlat +ellps=intl +towgs84=-162.619,-276.959,-161.764,0.067753,-2.243649,-1.158827,-1.094246 +no_defs ",
    ],
    "EPSG:4613": [
        "EPSG:4613",
        "+proj=longlat +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +no_defs ",
    ],
    "EPSG:4614": [
        "EPSG:4614",
        "+proj=longlat +ellps=intl +towgs84=-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065 +no_defs ",
    ],
    "EPSG:4615": [
        "EPSG:4615",
        "+proj=longlat +ellps=intl +towgs84=-499,-249,314,0,0,0,0 +no_defs ",
    ],
    "EPSG:4616": [
        "EPSG:4616",
        "+proj=longlat +ellps=intl +towgs84=-289,-124,60,0,0,0,0 +no_defs ",
    ],
    "EPSG:4620": [
        "EPSG:4620",
        "+proj=longlat +ellps=clrk80 +towgs84=-106,-129,165,0,0,0,0 +no_defs ",
    ],
    "EPSG:4621": [
        "EPSG:4621",
        "+proj=longlat +ellps=intl +towgs84=137,248,-430,0,0,0,0 +no_defs ",
    ],
    "EPSG:4622": [
        "EPSG:4622",
        "+proj=longlat +ellps=intl +towgs84=-467,-16,-300,0,0,0,0 +no_defs ",
    ],
    "EPSG:4623": [
        "EPSG:4623",
        "+proj=longlat +ellps=intl +towgs84=-186,230,110,0,0,0,0 +no_defs ",
    ],
    "EPSG:4624": [
        "EPSG:4624",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4625": [
        "EPSG:4625",
        "+proj=longlat +ellps=intl +towgs84=186,482,151,0,0,0,0 +no_defs ",
    ],
    "EPSG:4626": [
        "EPSG:4626",
        "+proj=longlat +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +no_defs ",
    ],
    "EPSG:4627": [
        "EPSG:4627",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4628": [
        "EPSG:4628",
        "+proj=longlat +ellps=intl +towgs84=162,117,154,0,0,0,0 +no_defs ",
    ],
    "EPSG:4629": [
        "EPSG:4629",
        "+proj=longlat +ellps=intl +towgs84=72.438,345.918,79.486,1.6045,0.8823,0.5565,1.3746 +no_defs ",
    ],
    "EPSG:4630": [
        "EPSG:4630",
        "+proj=longlat +ellps=intl +towgs84=84,274,65,0,0,0,0 +no_defs ",
    ],
    "EPSG:4631": [
        "EPSG:4631",
        "+proj=longlat +ellps=intl +towgs84=145,-187,103,0,0,0,0 +no_defs ",
    ],
    "EPSG:4632": [
        "EPSG:4632",
        "+proj=longlat +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +no_defs ",
    ],
    "EPSG:4633": [
        "EPSG:4633",
        "+proj=longlat +ellps=intl +towgs84=335.47,222.58,-230.94,0,0,0,0 +no_defs ",
    ],
    "EPSG:4634": [
        "EPSG:4634",
        "+proj=longlat +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +no_defs ",
    ],
    "EPSG:4635": [
        "EPSG:4635",
        "+proj=longlat +ellps=intl +towgs84=-122.383,-188.696,103.344,3.5107,-4.9668,-5.7047,4.4798 +no_defs ",
    ],
    "EPSG:4636": [
        "EPSG:4636",
        "+proj=longlat +ellps=intl +towgs84=365,194,166,0,0,0,0 +no_defs ",
    ],
    "EPSG:4637": [
        "EPSG:4637",
        "+proj=longlat +ellps=intl +towgs84=325,154,172,0,0,0,0 +no_defs ",
    ],
    "EPSG:4638": [
        "EPSG:4638",
        "+proj=longlat +ellps=clrk66 +towgs84=30,430,368,0,0,0,0 +no_defs ",
    ],
    "EPSG:4639": [
        "EPSG:4639",
        "+proj=longlat +ellps=intl +towgs84=253,-132,-127,0,0,0,0 +no_defs ",
    ],
    "EPSG:4640": [
        "EPSG:4640",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4641": [
        "EPSG:4641",
        "+proj=longlat +ellps=intl +towgs84=287.58,177.78,-135.41,0,0,0,0 +no_defs ",
    ],
    "EPSG:4642": [
        "EPSG:4642",
        "+proj=longlat +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +no_defs ",
    ],
    "EPSG:4671": [
        "EPSG:4671",
        "+proj=longlat +a=6378249.2 +b=6356515 +no_defs ",
    ],
    "EPSG:4643": [
        "EPSG:4643",
        "+proj=longlat +ellps=intl +towgs84=-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002 +no_defs ",
    ],
    "EPSG:4644": [
        "EPSG:4644",
        "+proj=longlat +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +no_defs ",
    ],
    "EPSG:4645": [
        "EPSG:4645",
        "+proj=longlat +ellps=intl +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4646": [
        "EPSG:4646",
        "+proj=longlat +ellps=intl +towgs84=-963,510,-359,0,0,0,0 +no_defs ",
    ],
    "EPSG:4657": [
        "EPSG:4657",
        "+proj=longlat +a=6377019.27 +b=6355762.5391 +towgs84=-28,199,5,0,0,0,0 +no_defs ",
    ],
    "EPSG:4659": [
        "EPSG:4659",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4660": [
        "EPSG:4660",
        "+proj=longlat +ellps=intl +towgs84=982.6087,552.753,-540.873,6.6816266,-31.6114924,-19.84816,16.805 +no_defs ",
    ],
    "EPSG:4661": [
        "EPSG:4661",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4662": [
        "EPSG:4662",
        "+proj=longlat +ellps=intl +towgs84=-11.64,-348.6,291.98,0,0,0,0 +no_defs ",
    ],
    "EPSG:4663": [
        "EPSG:4663",
        "+proj=longlat +ellps=intl +towgs84=-502.862,-247.438,312.724,0,0,0,0 +no_defs ",
    ],
    "EPSG:4664": [
        "EPSG:4664",
        "+proj=longlat +ellps=intl +towgs84=-204.619,140.176,55.226,0,0,0,0 +no_defs ",
    ],
    "EPSG:4665": [
        "EPSG:4665",
        "+proj=longlat +ellps=intl +towgs84=-106.226,166.366,-37.893,0,0,0,0 +no_defs ",
    ],
    "EPSG:4666": [
        "EPSG:4666",
        "+proj=longlat +ellps=bessel +towgs84=508.088,-191.042,565.223,0,0,0,0 +no_defs ",
    ],
    "EPSG:4667": [
        "EPSG:4667",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4668": [
        "EPSG:4668",
        "+proj=longlat +ellps=intl +towgs84=-86,-98,-119,0,0,0,0 +no_defs ",
    ],
    "EPSG:4669": [
        "EPSG:4669",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4670": [
        "EPSG:4670",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4746": ["EPSG:4746", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:4672": [
        "EPSG:4672",
        "+proj=longlat +ellps=intl +towgs84=175,-38,113,0,0,0,0 +no_defs ",
    ],
    "EPSG:4673": [
        "EPSG:4673",
        "+proj=longlat +ellps=intl +towgs84=174.05,-25.49,112.57,0,0,0.554,0.2263 +no_defs ",
    ],
    "EPSG:4675": [
        "EPSG:4675",
        "+proj=longlat +ellps=clrk66 +towgs84=-100,-248,259,0,0,0,0 +no_defs ",
    ],
    "EPSG:4676": ["EPSG:4676", "+proj=longlat +ellps=krass +no_defs "],
    "EPSG:4677": ["EPSG:4677", "+proj=longlat +ellps=krass +no_defs "],
    "EPSG:4678": [
        "EPSG:4678",
        "+proj=longlat +ellps=krass +towgs84=44.585,-131.212,-39.544,0,0,0,0 +no_defs ",
    ],
    "EPSG:4679": [
        "EPSG:4679",
        "+proj=longlat +ellps=clrk80 +towgs84=-80.01,253.26,291.19,0,0,0,0 +no_defs ",
    ],
    "EPSG:4680": [
        "EPSG:4680",
        "+proj=longlat +ellps=clrk80 +towgs84=124.5,-63.5,-281,0,0,0,0 +no_defs ",
    ],
    "EPSG:4681": ["EPSG:4681", "+proj=longlat +ellps=clrk80 +no_defs "],
    "EPSG:4682": [
        "EPSG:4682",
        "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=283.7,735.9,261.1,0,0,0,0 +no_defs ",
    ],
    "EPSG:4683": [
        "EPSG:4683",
        "+proj=longlat +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +no_defs ",
    ],
    "EPSG:4684": [
        "EPSG:4684",
        "+proj=longlat +ellps=intl +towgs84=-133,-321,50,0,0,0,0 +no_defs ",
    ],
    "EPSG:4685": ["EPSG:4685", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4686": [
        "EPSG:4686",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4687": [
        "EPSG:4687",
        "+proj=longlat +ellps=GRS80 +towgs84=0.072,-0.507,-0.245,-0.0183,0.0003,-0.007,-0.0093 +no_defs ",
    ],
    "EPSG:4688": [
        "EPSG:4688",
        "+proj=longlat +ellps=intl +towgs84=347.103,1078.125,2623.922,-33.8875,70.6773,-9.3943,186.074 +no_defs ",
    ],
    "EPSG:4689": [
        "EPSG:4689",
        "+proj=longlat +ellps=intl +towgs84=410.721,55.049,80.746,2.5779,2.3514,0.6664,17.3311 +no_defs ",
    ],
    "EPSG:4690": [
        "EPSG:4690",
        "+proj=longlat +ellps=intl +towgs84=221.525,152.948,176.768,-2.3847,-1.3896,-0.877,11.4741 +no_defs ",
    ],
    "EPSG:4691": [
        "EPSG:4691",
        "+proj=longlat +ellps=intl +towgs84=215.525,149.593,176.229,-3.2624,-1.692,-1.1571,10.4773 +no_defs ",
    ],
    "EPSG:4692": [
        "EPSG:4692",
        "+proj=longlat +ellps=intl +towgs84=217.037,86.959,23.956,0,0,0,0 +no_defs ",
    ],
    "EPSG:4693": [
        "EPSG:4693",
        "+proj=longlat +ellps=WGS84 +towgs84=0,-0.15,0.68,0,0,0,0 +no_defs ",
    ],
    "EPSG:4694": [
        "EPSG:4694",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4695": [
        "EPSG:4695",
        "+proj=longlat +ellps=clrk66 +towgs84=-103.746,-9.614,-255.95,0,0,0,0 +no_defs ",
    ],
    "EPSG:4696": ["EPSG:4696", "+proj=longlat +ellps=clrk80 +no_defs "],
    "EPSG:4697": ["EPSG:4697", "+proj=longlat +ellps=clrk80 +no_defs "],
    "EPSG:4698": [
        "EPSG:4698",
        "+proj=longlat +ellps=intl +towgs84=145,-187,103,0,0,0,0 +no_defs ",
    ],
    "EPSG:4699": [
        "EPSG:4699",
        "+proj=longlat +ellps=clrk80 +towgs84=-770.1,158.4,-498.2,0,0,0,0 +no_defs ",
    ],
    "EPSG:4700": ["EPSG:4700", "+proj=longlat +ellps=clrk80 +no_defs "],
    "EPSG:4701": [
        "EPSG:4701",
        "+proj=longlat +ellps=clrk80 +towgs84=-79.9,-158,-168.9,0,0,0,0 +no_defs ",
    ],
    "EPSG:4702": [
        "EPSG:4702",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4703": ["EPSG:4703", "+proj=longlat +ellps=clrk80 +no_defs "],
    "EPSG:4704": ["EPSG:4704", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4705": ["EPSG:4705", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4706": [
        "EPSG:4706",
        "+proj=longlat +ellps=helmert +towgs84=-146.21,112.63,4.05,0,0,0,0 +no_defs ",
    ],
    "EPSG:4707": [
        "EPSG:4707",
        "+proj=longlat +ellps=intl +towgs84=114,-116,-333,0,0,0,0 +no_defs ",
    ],
    "EPSG:4708": [
        "EPSG:4708",
        "+proj=longlat +ellps=aust_SA +towgs84=-491,-22,435,0,0,0,0 +no_defs ",
    ],
    "EPSG:4709": [
        "EPSG:4709",
        "+proj=longlat +ellps=intl +towgs84=145,75,-272,0,0,0,0 +no_defs ",
    ],
    "EPSG:4710": [
        "EPSG:4710",
        "+proj=longlat +ellps=intl +towgs84=-320,550,-494,0,0,0,0 +no_defs ",
    ],
    "EPSG:4711": [
        "EPSG:4711",
        "+proj=longlat +ellps=intl +towgs84=124,-234,-25,0,0,0,0 +no_defs ",
    ],
    "EPSG:4712": [
        "EPSG:4712",
        "+proj=longlat +ellps=intl +towgs84=-205,107,53,0,0,0,0 +no_defs ",
    ],
    "EPSG:4713": [
        "EPSG:4713",
        "+proj=longlat +ellps=clrk80 +towgs84=-77,-128,142,0,0,0,0 +no_defs ",
    ],
    "EPSG:4714": [
        "EPSG:4714",
        "+proj=longlat +ellps=intl +towgs84=-127,-769,472,0,0,0,0 +no_defs ",
    ],
    "EPSG:4715": [
        "EPSG:4715",
        "+proj=longlat +ellps=intl +towgs84=-104,-129,239,0,0,0,0 +no_defs ",
    ],
    "EPSG:4716": [
        "EPSG:4716",
        "+proj=longlat +ellps=intl +towgs84=298,-304,-375,0,0,0,0 +no_defs ",
    ],
    "EPSG:4717": [
        "EPSG:4717",
        "+proj=longlat +ellps=clrk66 +towgs84=-2,151,181,0,0,0,0 +no_defs ",
    ],
    "EPSG:4718": [
        "EPSG:4718",
        "+proj=longlat +ellps=intl +towgs84=230,-199,-752,0,0,0,0 +no_defs ",
    ],
    "EPSG:4719": [
        "EPSG:4719",
        "+proj=longlat +ellps=intl +towgs84=211,147,111,0,0,0,0 +no_defs ",
    ],
    "EPSG:4720": [
        "EPSG:4720",
        "+proj=longlat +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +no_defs ",
    ],
    "EPSG:4721": [
        "EPSG:4721",
        "+proj=longlat +ellps=intl +towgs84=265.025,384.929,-194.046,0,0,0,0 +no_defs ",
    ],
    "EPSG:4722": [
        "EPSG:4722",
        "+proj=longlat +ellps=intl +towgs84=-794,119,-298,0,0,0,0 +no_defs ",
    ],
    "EPSG:4723": [
        "EPSG:4723",
        "+proj=longlat +ellps=clrk66 +towgs84=-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925 +no_defs ",
    ],
    "EPSG:4724": [
        "EPSG:4724",
        "+proj=longlat +ellps=intl +towgs84=208,-435,-229,0,0,0,0 +no_defs ",
    ],
    "EPSG:4725": [
        "EPSG:4725",
        "+proj=longlat +ellps=intl +towgs84=189,-79,-202,0,0,0,0 +no_defs ",
    ],
    "EPSG:4726": [
        "EPSG:4726",
        "+proj=longlat +ellps=clrk66 +towgs84=8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081 +no_defs ",
    ],
    "EPSG:4727": [
        "EPSG:4727",
        "+proj=longlat +ellps=intl +towgs84=403,-81,277,0,0,0,0 +no_defs ",
    ],
    "EPSG:4729": [
        "EPSG:4729",
        "+proj=longlat +ellps=intl +towgs84=185,165,42,0,0,0,0 +no_defs ",
    ],
    "EPSG:4730": [
        "EPSG:4730",
        "+proj=longlat +ellps=intl +towgs84=170,42,84,0,0,0,0 +no_defs ",
    ],
    "EPSG:4731": [
        "EPSG:4731",
        "+proj=longlat +ellps=clrk80 +towgs84=51,391,-36,0,0,0,0 +no_defs ",
    ],
    "EPSG:4732": [
        "EPSG:4732",
        "+proj=longlat +a=6378270 +b=6356794.343434343 +towgs84=102,52,-38,0,0,0,0 +no_defs ",
    ],
    "EPSG:4733": [
        "EPSG:4733",
        "+proj=longlat +ellps=intl +towgs84=276,-57,149,0,0,0,0 +no_defs ",
    ],
    "EPSG:4734": [
        "EPSG:4734",
        "+proj=longlat +ellps=intl +towgs84=-632,438,-609,0,0,0,0 +no_defs ",
    ],
    "EPSG:4735": [
        "EPSG:4735",
        "+proj=longlat +ellps=intl +towgs84=647,1777,-1124,0,0,0,0 +no_defs ",
    ],
    "EPSG:4736": [
        "EPSG:4736",
        "+proj=longlat +ellps=clrk80 +towgs84=260,12,-147,0,0,0,0 +no_defs ",
    ],
    "EPSG:4737": [
        "EPSG:4737",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4738": [
        "EPSG:4738",
        "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +no_defs ",
    ],
    "EPSG:4739": [
        "EPSG:4739",
        "+proj=longlat +ellps=intl +towgs84=-156,-271,-189,0,0,0,0 +no_defs ",
    ],
    "EPSG:4740": [
        "EPSG:4740",
        "+proj=longlat +a=6378136 +b=6356751.361745712 +towgs84=0,0,1.5,0,0,0.076,0 +no_defs ",
    ],
    "EPSG:4741": ["EPSG:4741", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4742": ["EPSG:4742", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:4743": [
        "EPSG:4743",
        "+proj=longlat +ellps=clrk80 +towgs84=70.995,-335.916,262.898,0,0,0,0 +no_defs ",
    ],
    "EPSG:4744": [
        "EPSG:4744",
        "+proj=longlat +ellps=clrk80 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +no_defs ",
    ],
    "EPSG:4745": ["EPSG:4745", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:4747": [
        "EPSG:4747",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4748": [
        "EPSG:4748",
        "+proj=longlat +a=6378306.3696 +b=6356571.996 +towgs84=51,391,-36,0,0,0,0 +no_defs ",
    ],
    "EPSG:4749": [
        "EPSG:4749",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4750": [
        "EPSG:4750",
        "+proj=longlat +ellps=WGS84 +towgs84=-56.263,16.136,-22.856,0,0,0,0 +no_defs ",
    ],
    "EPSG:4751": [
        "EPSG:4751",
        "+proj=longlat +a=6377295.664 +b=6356094.667915204 +no_defs ",
    ],
    "EPSG:4752": [
        "EPSG:4752",
        "+proj=longlat +a=6378306.3696 +b=6356571.996 +towgs84=98,390,-22,0,0,0,0 +no_defs ",
    ],
    "EPSG:4753": ["EPSG:4753", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4754": [
        "EPSG:4754",
        "+proj=longlat +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +no_defs ",
    ],
    "EPSG:4755": [
        "EPSG:4755",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4756": [
        "EPSG:4756",
        "+proj=longlat +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +no_defs ",
    ],
    "EPSG:4757": ["EPSG:4757", "+proj=longlat +ellps=WGS84 +no_defs "],
    "EPSG:4758": [
        "EPSG:4758",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4759": [
        "EPSG:4759",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4760": ["EPSG:4760", "+proj=longlat +ellps=WGS66 +no_defs "],
    "EPSG:4761": [
        "EPSG:4761",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4762": [
        "EPSG:4762",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4763": [
        "EPSG:4763",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4764": [
        "EPSG:4764",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4765": [
        "EPSG:4765",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4801": [
        "EPSG:4801",
        "+proj=longlat +ellps=bessel +towgs84=674.4,15.1,405.3,0,0,0,0 +pm=bern +no_defs ",
    ],
    "EPSG:4802": [
        "EPSG:4802",
        "+proj=longlat +ellps=intl +towgs84=307,304,-318,0,0,0,0 +pm=bogota +no_defs ",
    ],
    "EPSG:4803": [
        "EPSG:4803",
        "+proj=longlat +ellps=intl +towgs84=-304.046,-60.576,103.64,0,0,0,0 +pm=lisbon +no_defs ",
    ],
    "EPSG:4804": [
        "EPSG:4804",
        "+proj=longlat +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +pm=jakarta +no_defs ",
    ],
    "EPSG:4805": [
        "EPSG:4805",
        "+proj=longlat +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +pm=ferro +no_defs ",
    ],
    "EPSG:4808": [
        "EPSG:4808",
        "+proj=longlat +ellps=bessel +pm=jakarta +no_defs ",
    ],
    "EPSG:4809": [
        "EPSG:4809",
        "+proj=longlat +ellps=intl +pm=brussels +no_defs ",
    ],
    "EPSG:4810": [
        "EPSG:4810",
        "+proj=longlat +ellps=intl +towgs84=-189,-242,-91,0,0,0,0 +pm=paris +no_defs ",
    ],
    "EPSG:4811": [
        "EPSG:4811",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-73,-247,227,0,0,0,0 +pm=paris +no_defs ",
    ],
    "EPSG:4813": [
        "EPSG:4813",
        "+proj=longlat +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +pm=jakarta +no_defs ",
    ],
    "EPSG:4814": [
        "EPSG:4814",
        "+proj=longlat +ellps=bessel +pm=stockholm +no_defs ",
    ],
    "EPSG:4816": [
        "EPSG:4816",
        "+proj=longlat +a=6378249.2 +b=6356515 +towgs84=-263,6,431,0,0,0,0 +pm=paris +no_defs ",
    ],
    "EPSG:4818": [
        "EPSG:4818",
        "+proj=longlat +ellps=bessel +towgs84=589,76,480,0,0,0,0 +pm=ferro +no_defs ",
    ],
    "EPSG:5340": [
        "EPSG:5340",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:4819": [
        "EPSG:4819",
        "+proj=longlat +ellps=clrk80 +towgs84=-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547 +pm=paris +no_defs ",
    ],
    "EPSG:4820": [
        "EPSG:4820",
        "+proj=longlat +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +pm=jakarta +no_defs ",
    ],
    "EPSG:4821": [
        "EPSG:4821",
        "+proj=longlat +a=6378249.2 +b=6356515 +pm=paris +no_defs ",
    ],
    "EPSG:4823": ["EPSG:4823", "+proj=longlat +ellps=intl +no_defs "],
    "EPSG:4902": [
        "EPSG:4902",
        "+proj=longlat +a=6376523 +b=6355862.933255573 +pm=paris +no_defs ",
    ],
    "EPSG:4903": [
        "EPSG:4903",
        "+proj=longlat +a=6378298.3 +b=6356657.142669561 +pm=madrid +no_defs ",
    ],
    "EPSG:4904": [
        "EPSG:4904",
        "+proj=longlat +ellps=bessel +towgs84=508.088,-191.042,565.223,0,0,0,0 +pm=lisbon +no_defs ",
    ],
    "EPSG:5013": [
        "EPSG:5013",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5132": ["EPSG:5132", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:5228": [
        "EPSG:5228",
        "+proj=longlat +ellps=bessel +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378 +no_defs ",
    ],
    "EPSG:5229": [
        "EPSG:5229",
        "+proj=longlat +ellps=bessel +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378 +pm=ferro +no_defs ",
    ],
    "EPSG:5233": [
        "EPSG:5233",
        "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338 +no_defs ",
    ],
    "EPSG:5246": [
        "EPSG:5246",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5252": [
        "EPSG:5252",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5264": [
        "EPSG:5264",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5324": [
        "EPSG:5324",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5354": [
        "EPSG:5354",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5360": [
        "EPSG:5360",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5365": [
        "EPSG:5365",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5371": [
        "EPSG:5371",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5373": [
        "EPSG:5373",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5381": [
        "EPSG:5381",
        "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5393": [
        "EPSG:5393",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5451": [
        "EPSG:5451",
        "+proj=longlat +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +no_defs ",
    ],
    "EPSG:5464": [
        "EPSG:5464",
        "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +no_defs ",
    ],
    "EPSG:5467": ["EPSG:5467", "+proj=longlat +ellps=clrk66 +no_defs "],
    "EPSG:5489": [
        "EPSG:5489",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5527": [
        "EPSG:5527",
        "+proj=longlat +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +no_defs ",
    ],
    "EPSG:5546": [
        "EPSG:5546",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5561": [
        "EPSG:5561",
        "+proj=longlat +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +no_defs ",
    ],
    "EPSG:5593": [
        "EPSG:5593",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:5681": ["EPSG:5681", "+proj=longlat +ellps=bessel +no_defs "],
    "EPSG:5886": ["EPSG:5886", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:6135": [
        "EPSG:6135",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:7039": ["EPSG:7039", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:6207": [
        "EPSG:6207",
        "+proj=longlat +a=6377276.345 +b=6356075.41314024 +towgs84=293.17,726.18,245.36,0,0,0,0 +no_defs ",
    ],
    "EPSG:6311": [
        "EPSG:6311",
        "+proj=longlat +ellps=WGS84 +towgs84=8.846,-4.394,-1.122,0.00237,0.146528,-0.130428,0.783926 +no_defs ",
    ],
    "EPSG:6318": ["EPSG:6318", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:6322": ["EPSG:6322", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:6325": ["EPSG:6325", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:6365": [
        "EPSG:6365",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:6668": ["EPSG:6668", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:6706": [
        "EPSG:6706",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:6783": ["EPSG:6783", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:6881": [
        "EPSG:6881",
        "+proj=longlat +ellps=clrk80 +towgs84=-24,-203,268,0,0,0,0 +no_defs ",
    ],
    "EPSG:6882": [
        "EPSG:6882",
        "+proj=longlat +ellps=clrk80 +towgs84=-183,-15,273,0,0,0,0 +no_defs ",
    ],
    "EPSG:6883": [
        "EPSG:6883",
        "+proj=longlat +ellps=intl +towgs84=-235,-110,393,0,0,0,0 +no_defs ",
    ],
    "EPSG:6892": [
        "EPSG:6892",
        "+proj=longlat +ellps=clrk80 +towgs84=-43.685,-179.785,-267.721,0,0,0,0 +no_defs ",
    ],
    "EPSG:6894": [
        "EPSG:6894",
        "+proj=longlat +ellps=clrk80 +towgs84=-63,176,185,0,0,0,0 +no_defs ",
    ],
    "EPSG:6980": ["EPSG:6980", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:6983": ["EPSG:6983", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:6987": ["EPSG:6987", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:6990": ["EPSG:6990", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:7035": ["EPSG:7035", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:7037": ["EPSG:7037", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:7073": ["EPSG:7073", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:7084": ["EPSG:7084", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:7086": ["EPSG:7086", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:7088": ["EPSG:7088", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:7133": ["EPSG:7133", "+proj=longlat +ellps=GRS80 +no_defs "],
    "EPSG:7136": ["EPSG:7136", "+proj=longlat +ellps=WGS84 +no_defs "],
    "EPSG:7139": ["EPSG:7139", "+proj=longlat +ellps=WGS84 +no_defs "],
    "EPSG:7373": [
        "EPSG:7373",
        "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
    ],
    "EPSG:2000": [
        "EPSG:2000",
        "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +units=m +no_defs ",
    ],
    "EPSG:2001": [
        "EPSG:2001",
        "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=-255,-15,71,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2002": [
        "EPSG:2002",
        "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=725,685,536,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2003": [
        "EPSG:2003",
        "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=72,213.7,93,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2311": [
        "EPSG:2311",
        "+proj=tmerc +lat_0=0 +lon_0=6 +k=0.9996 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs ",
    ],
    "EPSG:2005": [
        "EPSG:2005",
        "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=9,183,236,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2006": [
        "EPSG:2006",
        "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=-149,128,296,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2007": [
        "EPSG:2007",
        "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995000000000001 +x_0=400000 +y_0=0 +ellps=clrk80 +towgs84=195.671,332.517,274.607,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2008": [
        "EPSG:2008",
        "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2009": [
        "EPSG:2009",
        "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2010": [
        "EPSG:2010",
        "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2011": [
        "EPSG:2011",
        "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2012": [
        "EPSG:2012",
        "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2013": [
        "EPSG:2013",
        "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2014": [
        "EPSG:2014",
        "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2015": [
        "EPSG:2015",
        "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2016": [
        "EPSG:2016",
        "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2017": [
        "EPSG:2017",
        "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2018": [
        "EPSG:2018",
        "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2019": [
        "EPSG:2019",
        "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2020": [
        "EPSG:2020",
        "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2021": [
        "EPSG:2021",
        "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2022": [
        "EPSG:2022",
        "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2023": [
        "EPSG:2023",
        "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2024": [
        "EPSG:2024",
        "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2025": [
        "EPSG:2025",
        "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2026": [
        "EPSG:2026",
        "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2027": [
        "EPSG:2027",
        "+proj=utm +zone=15 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2028": [
        "EPSG:2028",
        "+proj=utm +zone=16 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2029": [
        "EPSG:2029",
        "+proj=utm +zone=17 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2030": [
        "EPSG:2030",
        "+proj=utm +zone=18 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2031": [
        "EPSG:2031",
        "+proj=utm +zone=17 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2032": [
        "EPSG:2032",
        "+proj=utm +zone=18 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2033": [
        "EPSG:2033",
        "+proj=utm +zone=19 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:4360": ["EPSG:4360", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2035": [
        "EPSG:2035",
        "+proj=utm +zone=21 +ellps=clrk66 +units=m +no_defs ",
    ],
    "EPSG:2036": [
        "EPSG:2036",
        "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=2500000 +y_0=7500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2038": [
        "EPSG:2038",
        "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2040": [
        "EPSG:2040",
        "+proj=utm +zone=30 +ellps=clrk80 +towgs84=-125,53,467,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2041": [
        "EPSG:2041",
        "+proj=utm +zone=30 +ellps=clrk80 +towgs84=-124.76,53,466.79,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2042": [
        "EPSG:2042",
        "+proj=utm +zone=29 +ellps=clrk80 +towgs84=-125,53,467,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2043": [
        "EPSG:2043",
        "+proj=utm +zone=29 +ellps=clrk80 +towgs84=-124.76,53,466.79,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2044": [
        "EPSG:2044",
        "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=-17.51,-108.32,-62.39,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2045": [
        "EPSG:2045",
        "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=-17.51,-108.32,-62.39,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2046": [
        "EPSG:2046",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2047": [
        "EPSG:2047",
        "+proj=tmerc +lat_0=0 +lon_0=17 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2048": [
        "EPSG:2048",
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2049": [
        "EPSG:2049",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2052": [
        "EPSG:2052",
        "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2054": [
        "EPSG:2054",
        "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2055": [
        "EPSG:2055",
        "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=0 +y_0=0 +axis=wsu +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2056": [
        "EPSG:2056",
        "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2057": [
        "EPSG:2057",
        "+proj=omerc +lat_0=27.51882880555555 +lonc=52.60353916666667 +alpha=0.5716611944444444 +k=0.999895934 +x_0=658377.437 +y_0=3044969.194 +gamma=0.5716611944444444 +ellps=intl +towgs84=-133.63,-157.5,-158.62,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2058": [
        "EPSG:2058",
        "+proj=utm +zone=38 +ellps=intl +towgs84=-117,-132,-164,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2059": [
        "EPSG:2059",
        "+proj=utm +zone=39 +ellps=intl +towgs84=-117,-132,-164,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2060": [
        "EPSG:2060",
        "+proj=utm +zone=40 +ellps=intl +towgs84=-117,-132,-164,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2061": [
        "EPSG:2061",
        "+proj=utm +zone=41 +ellps=intl +towgs84=-117,-132,-164,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2062": [
        "EPSG:2062",
        "+proj=lcc +lat_1=40 +lat_0=40 +lon_0=0 +k_0=0.9988085293 +x_0=600000 +y_0=600000 +a=6378298.3 +b=6356657.142669561 +pm=madrid +units=m +no_defs ",
    ],
    "EPSG:2063": [
        "EPSG:2063",
        "+proj=utm +zone=28 +a=6378249.2 +b=6356515 +towgs84=-23,259,-9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:4362": ["EPSG:4362", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2064": [
        "EPSG:2064",
        "+proj=utm +zone=29 +a=6378249.2 +b=6356515 +towgs84=-23,259,-9,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2066": [
        "EPSG:2066",
        "+proj=cass +lat_0=11.25217861111111 +lon_0=-60.68600888888889 +x_0=37718.66159325 +y_0=36209.91512952 +a=6378293.645208759 +b=6356617.987679838 +to_meter=0.201166195164 +no_defs ",
    ],
    "EPSG:2067": [
        "EPSG:2067",
        "+proj=utm +zone=20 +ellps=intl +towgs84=-0.465,372.095,171.736,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2068": [
        "EPSG:2068",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2069": [
        "EPSG:2069",
        "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2070": [
        "EPSG:2070",
        "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2071": [
        "EPSG:2071",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2072": [
        "EPSG:2072",
        "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:5884": ["EPSG:5884", "+proj=geocent +ellps=GRS80 +units=m +no_defs "],
    "EPSG:2073": [
        "EPSG:2073",
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2074": [
        "EPSG:2074",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2075": [
        "EPSG:2075",
        "+proj=tmerc +lat_0=0 +lon_0=23 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2076": [
        "EPSG:2076",
        "+proj=tmerc +lat_0=0 +lon_0=25 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2078": [
        "EPSG:2078",
        "+proj=utm +zone=33 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2079": [
        "EPSG:2079",
        "+proj=utm +zone=34 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2080": [
        "EPSG:2080",
        "+proj=utm +zone=35 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2081": [
        "EPSG:2081",
        "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:2082": [
        "EPSG:2082",
        "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=27.5,14,186.4,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2083": [
        "EPSG:2083",
        "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=16,196,93,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2084": [
        "EPSG:2084",
        "+proj=utm +zone=19 +south +ellps=intl +towgs84=16,196,93,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2085": [
        "EPSG:2085",
        "+proj=lcc +lat_1=22.35 +lat_0=22.35 +lon_0=-81 +k_0=0.99993602 +x_0=500000 +y_0=280296.016 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:2086": [
        "EPSG:2086",
        "+proj=lcc +lat_1=20.71666666666667 +lat_0=20.71666666666667 +lon_0=-76.83333333333333 +k_0=0.99994848 +x_0=500000 +y_0=229126.939 +datum=NAD27 +units=m +no_defs ",
    ],
    "EPSG:2087": [
        "EPSG:2087",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2088": [
        "EPSG:2088",
        "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.9996 +x_0=500000 +y_0=0 +datum=carthage +units=m +no_defs ",
    ],
    "EPSG:2091": [
        "EPSG:2091",
        "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2092": [
        "EPSG:2092",
        "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2093": [
        "EPSG:2093",
        "+proj=tmerc +lat_0=0 +lon_0=106 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=-17.51,-108.32,-62.39,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2094": [
        "EPSG:2094",
        "+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs ",
    ],
    "EPSG:2095": [
        "EPSG:2095",
        "+proj=utm +zone=28 +ellps=intl +towgs84=-173,253,27,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2096": [
        "EPSG:2096",
        "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:2097": [
        "EPSG:2097",
        "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:2098": [
        "EPSG:2098",
        "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs ",
    ],
    "EPSG:2099": [
        "EPSG:2099",
        "+proj=cass +lat_0=25.38236111111111 +lon_0=50.76138888888889 +x_0=100000 +y_0=100000 +ellps=helmert +units=m +no_defs ",
    ],
    "EPSG:2101": [
        "EPSG:2101",
        "+proj=lcc +lat_1=10.16666666666667 +lat_0=10.16666666666667 +lon_0=-71.60561777777777 +k_0=1 +x_0=0 +y_0=-52684.972 +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:2102": [
        "EPSG:2102",
        "+proj=lcc +lat_1=10.16666666666667 +lat_0=10.16666666666667 +lon_0=-71.60561777777777 +k_0=1 +x_0=200000 +y_0=147315.028 +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:2103": [
        "EPSG:2103",
        "+proj=lcc +lat_1=10.16666666666667 +lat_0=10.16666666666667 +lon_0=-71.60561777777777 +k_0=1 +x_0=500000 +y_0=447315.028 +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:2104": [
        "EPSG:2104",
        "+proj=lcc +lat_1=10.16666666666667 +lat_0=10.16666666666667 +lon_0=-71.60561777777777 +k_0=1 +x_0=-17044 +y_0=-23139.97 +ellps=intl +units=m +no_defs ",
    ],
    "EPSG:2105": [
        "EPSG:2105",
        "+proj=tmerc +lat_0=-36.87972222222222 +lon_0=174.7641666666667 +k=0.9999 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2106": [
        "EPSG:2106",
        "+proj=tmerc +lat_0=-37.76111111111111 +lon_0=176.4661111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2107": [
        "EPSG:2107",
        "+proj=tmerc +lat_0=-38.62444444444444 +lon_0=177.8855555555556 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2108": [
        "EPSG:2108",
        "+proj=tmerc +lat_0=-39.65083333333333 +lon_0=176.6736111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2109": [
        "EPSG:2109",
        "+proj=tmerc +lat_0=-39.13555555555556 +lon_0=174.2277777777778 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2110": [
        "EPSG:2110",
        "+proj=tmerc +lat_0=-39.51222222222222 +lon_0=175.64 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
    "EPSG:2111": [
        "EPSG:2111",
        "+proj=tmerc +lat_0=-40.24194444444444 +lon_0=175.4880555555555 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
    ],
};

export default proj4List;
